const productTable = `<table border="1" id="productEOLTable" class="product-table__data" style="display: none">
  <thead>
    <tr>
      <th style="text-align: center; padding: 10px">SKU Number</th>
      <th style="text-align: center; padding: 10px">Description</th>
      <th style="text-align: center; padding: 10px">Model Number</th>
      <th style="text-align: center; padding: 10px">SKU Region</th>
      <th style="text-align: center; padding: 10px">Lifecycle Phase</th>
      <th style="text-align: center; padding: 10px">End of Life Date</th>
      <th style="text-align: center; padding: 10px">End of Support Date</th>
    </tr>
  </thead>
  <tbody id="productEOLTableBody">
    <tr>
      <td>A0101</td>
      <td>LINKSYS VELOP A0101 AC1300 1PK</td>
      <td>A01</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>A0101-AH</td>
      <td>LINKSYS VELOP A0101 AC1300 1PK</td>
      <td>A01</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0101-AU</td>
      <td>LINKSYS VELOP A0101 AC1300 1PK</td>
      <td>A01</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0101-CA</td>
      <td>LINKSYS VELOP A0101 AC1300 1PK</td>
      <td>A01</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>A0101-CA1</td>
      <td>LINKSYS VELOP A0101 AC1300 1PK</td>
      <td>A01</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>A0101-CN</td>
      <td>LINKSYS VELOP A0101 AC1300 1PK</td>
      <td>A01</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0101-EU</td>
      <td>LINKSYS VELOP A0101 AC1300 1PK</td>
      <td>A01</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0101-JP</td>
      <td>LINKSYS VELOP A0101 AC1300 1PK</td>
      <td>A01</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0101-KR</td>
      <td>LINKSYS VELOP A0101 AC1300 1PK</td>
      <td>A01</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0101-ME</td>
      <td>LINKSYS VELOP A0101 AC1300 1PK</td>
      <td>A01</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0101-UK</td>
      <td>LINKSYS VELOP A0101 AC1300 1PK</td>
      <td>A01</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0101-US</td>
      <td>LINKSYS VELOP A0101 AC1300 1PK</td>
      <td>A01</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>A0301</td>
      <td>LINKSYS VELOP A0301 AC2200 1PK - APPLE</td>
      <td>A03</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>A0301-AH</td>
      <td>LINKSYS VELOP A0301 AC2200 1PK - APPLE</td>
      <td>A03</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0301-AU</td>
      <td>LINKSYS VELOP A0301 AC2200 1PK - APPLE</td>
      <td>A03</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0301-CA</td>
      <td>LINKSYS VELOP A0301 AC2200 1PK - APPLE</td>
      <td>A03</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0301-CA1</td>
      <td>LINKSYS VELOP A0301 AC2200 1PK - APPLE</td>
      <td>A03</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0301-CN</td>
      <td>LINKSYS VELOP A0301 AC2200 1PK - APPLE</td>
      <td>A03</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0301-EU</td>
      <td>LINKSYS VELOP A0301 AC2200 1PK - APPLE</td>
      <td>A03</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0301-HK</td>
      <td>LINKSYS VELOP A0301 AC2200 1PK - APPLE</td>
      <td>A03</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0301-JP</td>
      <td>LINKSYS VELOP A0301 AC2200 1PK - APPLE</td>
      <td>A03</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0301-KR</td>
      <td>LINKSYS VELOP A0301 AC2200 1PK - APPLE</td>
      <td>A03</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0301-ME</td>
      <td>LINKSYS VELOP A0301 AC2200 1PK - APPLE</td>
      <td>A03</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0301-UK</td>
      <td>LINKSYS VELOP A0301 AC2200 1PK - APPLE</td>
      <td>A03</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>A0301-US</td>
      <td>LINKSYS VELOP A0301 AC2200 1PK - APPLE</td>
      <td>A03</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>AE1200-CA</td>
      <td>LINKSYS AE1200 WIFI ADAPTER,N300</td>
      <td>AE1200</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>AE1200-EU</td>
      <td>LINKSYS AE1200 WIFI ADAPTER,N300</td>
      <td>AE1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>AE1200-LA</td>
      <td>LINKSYS AE1200 WIFI ADAPTER,N300</td>
      <td>AE1200</td>
      <td>Latin America and South America</td>
      <td>End of Life</td>
      <td>12-Oct-2021</td>
      <td>11-Oct-2026</td>
    </tr>
    <tr>
      <td>AE6000</td>
      <td>LINKSYS AE6000 WIFI ADAPTER,AC600</td>
      <td>AE6000</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>12-Oct-2021</td>
      <td>11-Oct-2026</td>
    </tr>
    <tr>
      <td>AE6000-CA</td>
      <td>LINKSYS AE6000 WIFI ADAPTER,AC600</td>
      <td>AE6000</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>AE6000-EE</td>
      <td>LINKSYS AE6000 WIFI ADAPTER,AC600</td>
      <td>AE6000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>19-Aug-2019</td>
      <td>17-Aug-2024</td>
    </tr>
    <tr>
      <td>AE6000-EU</td>
      <td>LINKSYS AE6000 WIFI ADAPTER,AC600</td>
      <td>AE6000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>19-Aug-2019</td>
      <td>17-Aug-2024</td>
    </tr>
    <tr>
      <td>CG6350</td>
      <td>LINKSYS CG6350 CABLE GATEWAY, AC1200, 16X4</td>
      <td>CG6350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>13-Aug-2019</td>
      <td>11-Aug-2024</td>
    </tr>
    <tr>
      <td>CM3008</td>
      <td>LINKSYS CM3008 MODEM,DOCSIS 3.0,8x4</td>
      <td>CM3008</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>13-Aug-2019</td>
      <td>11-Aug-2024</td>
    </tr>
    <tr>
      <td>CM3024</td>
      <td>DOCSIS 3.0 24X8 CABLE MODEM</td>
      <td>CM3024</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>13-Aug-2019</td>
      <td>11-Aug-2024</td>
    </tr>
    <tr>
      <td>CM3132</td>
      <td>LINKSYS CM3132 MODEM, DOCSIS 3.1,32X8</td>
      <td>CM3132</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>13-Aug-2019</td>
      <td>11-Aug-2024</td>
    </tr>
    <tr>
      <td>E1200-AP</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300</td>
      <td>E1200</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>E1200-AR</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300</td>
      <td>E1200</td>
      <td>Latin America and South America</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>E1200-CA</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300</td>
      <td>E1200</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>E1200-EE</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300</td>
      <td>E1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>E1200-EN</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300</td>
      <td>E1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>E1200-EW</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300</td>
      <td>E1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>E1200-EZ</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300</td>
      <td>E1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>E1200-LA</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300</td>
      <td>E1200</td>
      <td>Latin America and South America</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>E1200-ME</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300</td>
      <td>E1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>E1200-UK</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300</td>
      <td>E1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>E1500-FS</td>
      <td>Wireless-N Router with SpeedBoost</td>
      <td>E1500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>E1700-AP</td>
      <td>LINKSYS E1700 WIFI ROUTER,N300,GIGABIT</td>
      <td>E1700</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>E1700-AU</td>
      <td>LINKSYS E1700 WIFI ROUTER,N300,GIGABIT</td>
      <td>E1700</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>E1700-EJ</td>
      <td>LINKSYS E1700 WIFI ROUTER,N300,GIGABIT</td>
      <td>E1700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>E1700-EK</td>
      <td>LINKSYS E1700 WIFI ROUTER,N300,GIGABIT</td>
      <td>E1700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>E1700-ME</td>
      <td>LINKSYS E1700 WIFI ROUTER,N300,GIGABIT</td>
      <td>E1700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>E1700-UK</td>
      <td>LINKSYS E1700 WIFI ROUTER,N300,GIGABIT</td>
      <td>E1700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>E2500-4B</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>E2500-AP</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>E2500-AR</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>Latin America and South America</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>E2500-CA</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>E2500-EE</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>E2500-EN</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>E2500-EW</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>E2500-EZ</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>E2500-LA</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>Latin America and South America</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>E2500-ME</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>E2500-UK</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>E2500V4-EU</td>
      <td>LINKSYS E2500 WIFI ROUTER, N600</td>
      <td>E2500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>E2500V4-ME</td>
      <td>LINKSYS E2500 WIFI ROUTER, N600</td>
      <td>E2500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>E5600-CA</td>
      <td>LINKSYS MAX-STREAM AC1200 MU-MIMO GIGABIT ROUTER</td>
      <td>E5600</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>E5600-CN</td>
      <td>LINKSYS MAX-STREAM AC1200 MU-MIMO GIGABIT ROUTER</td>
      <td>E5600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>E5600-JP</td>
      <td>LINKSYS MAX-STREAM AC1200 MU-MIMO GIGABIT ROUTER</td>
      <td>E5600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>E5600-KR</td>
      <td>LINKSYS MAX-STREAM AC1200 MU-MIMO GIGABIT ROUTER</td>
      <td>E5600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>E5750-AIS</td>
      <td>LINKSYS E5750 DUAL-BAND MESH WIFI 6 ROUTER, AX5400</td>
      <td>E5750</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>4-Dec-2023</td>
      <td>2-Dec-2028</td>
    </tr>
    <tr>
      <td>E7350-CN</td>
      <td>LINKSYS, E7350-CN, WIFI ROUTER, AX1800, GIGABIT</td>
      <td>E7350</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>E8350</td>
      <td>LINKSYS E8350 WIFI ROUTER,AC2400</td>
      <td>E8350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>E8350-CA</td>
      <td>LINKSYS E8350 WIFI ROUTER,AC2400</td>
      <td>E8350</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>E8350-FFP</td>
      <td>LINKSYS E8350 WIFI ROUTER,AC2400</td>
      <td>E8350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>E8350-ME</td>
      <td>LINKSYS E8350 WIFI ROUTER,AC2400</td>
      <td>E8350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>E8400</td>
      <td>LINKSYS E8400 WIFI ROUTER,AC2400</td>
      <td>E8400</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>E8450-AH</td>
      <td>LINKSYS E8450 AX3200 DUAL BAND GIGABIT WIFI 6 ROUTER</td>
      <td>E8450</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>E8450-AMZ</td>
      <td>LINKSYS E8450 AX3200 DUAL BAND GIGABIT WIFI 6 ROUTER</td>
      <td>E8450</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>E8450-CA</td>
      <td>LINKSYS E8450 AX3200 DUAL BAND GIGABIT WIFI 6 ROUTER</td>
      <td>E8450</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>E8450-CN</td>
      <td>LINKSYS E8450 AX3200 DUAL BAND GIGABIT WIFI 6 ROUTER</td>
      <td>E8450</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>E8450-EU</td>
      <td>LINKSYS E8450 AX3200 DUAL BAND GIGABIT WIFI 6 ROUTER</td>
      <td>E8450</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>E8450-JP</td>
      <td>LINKSYS E8450 AX3200 DUAL BAND GIGABIT WIFI 6 ROUTER</td>
      <td>E8450</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>E8450-KR</td>
      <td>LINKSYS E8450 AX3200 DUAL BAND GIGABIT WIFI 6 ROUTER</td>
      <td>E8450</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>E8450-ME</td>
      <td>LINKSYS E8450 AX3200 DUAL BAND GIGABIT WIFI 6 ROUTER</td>
      <td>E8450</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>E900-AR</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Latin America and South America</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>E900-EE</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>E900-EU</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>E900-LA</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Latin America and South America</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>E900-ME</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>E900-UK</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>E9450</td>
      <td>LINKSYS E9450 DUAL-BAND MESH WIFI 6 ROUTER, AX5400</td>
      <td>E9450</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>E9450-JP</td>
      <td>LINKSYS E9450 DUAL-BAND MESH WIFI 6 ROUTER, AX5400</td>
      <td>E9450</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>E9450-KR</td>
      <td>LINKSYS E9450 DUAL-BAND MESH WIFI 6 ROUTER, AX5400</td>
      <td>E9450</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>E9450ST-AH</td>
      <td>LINKSYS E9450 DUAL-BAND MESH WIFI 6 ROUTER, AX5400</td>
      <td>E9450</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>E9450W-AMZ</td>
      <td>LINKSYS E9450 DUAL-BAND MESH WIFI 6 + WUSB6100M</td>
      <td>E9450</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA2700-LA</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Latin America and South America</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA2750</td>
      <td>LINKSYS, EA2750 DUAL-BAND N600 ROUTER WITH GIGABIT</td>
      <td>EA2750</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA2750-AP</td>
      <td>LINKSYS, EA2750 DUAL-BAND N600 ROUTER WITH GIGABIT</td>
      <td>EA2750</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA2750-EU</td>
      <td>LINKSYS, EA2750 DUAL-BAND N600 ROUTER WITH GIGABIT</td>
      <td>EA2750</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA2750-ME</td>
      <td>LINKSYS, EA2750 DUAL-BAND N600 ROUTER WITH GIGABIT</td>
      <td>EA2750</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA4500-AP</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA5800</td>
      <td>LINKSYS, EA5800 WIRELESS ROUTER, AC1000</td>
      <td>EA5800</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA5800-CA</td>
      <td>LINKSYS, EA5800 WIRELESS ROUTER, AC1000</td>
      <td>EA5800</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA6100</td>
      <td>LINKSYS EA6100 WIFI ROUTER,AC1200,FE</td>
      <td>EA6100</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA6100-CA</td>
      <td>LINKSYS EA6100 WIFI ROUTER,AC1200,FE</td>
      <td>EA6100</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>EA6100-EK</td>
      <td>LINKSYS EA6100 WIFI ROUTER,AC1200,FE</td>
      <td>EA6100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>EA6100-ME</td>
      <td>LINKSYS EA6100 WIFI ROUTER,AC1200,FE</td>
      <td>EA6100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>EA6100-VV</td>
      <td>LINKSYS, EA6100 WIFI ROUTER, AC1200, FE</td>
      <td>EA6100</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA6350</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>EA6350-2P</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA6350-4B</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA6350-4B-AMZ</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA6350-AH</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA6350-AP</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA6350-AU</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>7-Aug-2020</td>
      <td>6-Aug-2025</td>
    </tr>
    <tr>
      <td>EA6350-CA</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>EA6350-EJ</td>
      <td>LINKSYS, EA6350, SMART WI-FI ROUTER AC1200</td>
      <td>EA6350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>EA6350-EU</td>
      <td>LINKSYS, EA6350, SMART WI-FI ROUTER AC1200</td>
      <td>EA6350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>EA6350-ME</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>EA6350-MX</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>Latin America and South America</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>EA6350-UK</td>
      <td>LINKSYS, EA6350, SMART WI-FI ROUTER AC1200</td>
      <td>EA6350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>EA6350V4-CA</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA6350V4-EU</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>EA6350V4-ME</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA6350V4-UK</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA6400</td>
      <td>LINKSYS EA6400 WIFI ROUTER,AC1600</td>
      <td>EA6400</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA6400-3T</td>
      <td>LINKSYS EA6400 PDQ TRAY</td>
      <td>EA6400</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA6400-AP</td>
      <td>LINKSYS EA6400 WIFI ROUTER,AC1600</td>
      <td>EA6400</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA6400-CA</td>
      <td>LINKSYS EA6400 WIFI ROUTER,AC1600</td>
      <td>EA6400</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA6400x</td>
      <td>LINKSYS EA6400 WIFI ROUTER,AC1600</td>
      <td>EA6400</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA6500-CA</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA6700-CA</td>
      <td>LINKSYS EA6700 WIFI ROUTER,AC1750</td>
      <td>EA6700</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA6700-EN</td>
      <td>LINKSYS EA6700 WIFI ROUTER,AC1750</td>
      <td>EA6700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA6700-EZ</td>
      <td>LINKSYS EA6700 WIFI ROUTER,AC1750</td>
      <td>EA6700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA6700-HK</td>
      <td>LINKSYS EA6700 WIFI ROUTER,AC1750</td>
      <td>EA6700</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA6700x</td>
      <td>LINKSYS EA6700 WIFI ROUTER,AC1750</td>
      <td>EA6700</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA6900</td>
      <td>LINKSYS EA6900 WIFI ROUTER,AC1900</td>
      <td>EA6900</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA6900-AP</td>
      <td>LINKSYS EA6900 WIFI ROUTER,AC1900</td>
      <td>EA6900</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA6900-AU</td>
      <td>LINKSYS EA6900 WIFI ROUTER,AC1900</td>
      <td>EA6900</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA6900-CA</td>
      <td>LINKSYS EA6900 WIFI ROUTER,AC1900</td>
      <td>EA6900</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA6900-EJ</td>
      <td>LINKSYS EA6900 WIFI ROUTER,AC1900</td>
      <td>EA6900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA6900-HK</td>
      <td>LINKSYS EA6900 WIFI ROUTER,AC1900</td>
      <td>EA6900</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA6900-ME</td>
      <td>LINKSYS EA6900 WIFI ROUTER,AC1900</td>
      <td>EA6900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>EA6900-UK</td>
      <td>LINKSYS EA6900 WIFI ROUTER,AC1900</td>
      <td>EA6900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA7200</td>
      <td>LINKSYS MAX-STREAM AC1750 MU-MIMO WiFi 5 ROUTER</td>
      <td>EA7200</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA7250</td>
      <td>LINKSYS MAX-STREAM AC1750 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7250</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA7300</td>
      <td>LINKSYS EA7300 WIFI ROUTER,AC1750,MU-MIMO</td>
      <td>EA7300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA7300-AMZ</td>
      <td>LINKSYS EA7300 WIFI ROUTER,AC1750,MU-MIMO</td>
      <td>EA7300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA7300-CA</td>
      <td>LINKSYS EA7300 WIFI ROUTER,AC1750,MU-MIMO</td>
      <td>EA7300</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA7300-EU</td>
      <td>LINKSYS EA7300 WIFI ROUTER,AC1750,MU-MIMO</td>
      <td>EA7300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA7300-ME</td>
      <td>LINKSYS EA7300 WIFI ROUTER,AC1750,MU-MIMO</td>
      <td>EA7300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA7300-UK</td>
      <td>LINKSYS EA7300 WIFI ROUTER,AC1750,MU-MIMO</td>
      <td>EA7300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA7400</td>
      <td>LINKSYS EA7400 WIFI ROUTER,AC1750,MUMIMO</td>
      <td>EA7400</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA7430</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7430</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA7450</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO WiFi 5 ROUTER</td>
      <td>EA7450</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA7500</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>EA7500-4B</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA7500-4B-AMZ</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA7500-AH</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>14-May-2021</td>
      <td>13-May-2026</td>
    </tr>
    <tr>
      <td>EA7500-CA</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>EA7500-CN</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>EA7500-EU</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>EA7500-HK</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>14-May-2021</td>
      <td>13-May-2026</td>
    </tr>
    <tr>
      <td>EA7500-ME</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>EA7500-UK</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>EA7500-WM</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>EA7500S-AH</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA7500S-CN</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA7500V3-CA</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA7500V3-ME</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA7500V3-UK</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA8100-AH</td>
      <td>LINKSYS MAX-STREAM AC2600 MU-MIMO GIGABIT ROUTER</td>
      <td>EA8100</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA8100-CA</td>
      <td>LINKSYS MAX-STREAM AC2600 MU-MIMO GIGABIT ROUTER</td>
      <td>EA8100</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA8100-CN</td>
      <td>LINKSYS MAX-STREAM AC2600 MU-MIMO GIGABIT ROUTER</td>
      <td>EA8100</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA8250</td>
      <td>LINKSYS EA8250 WIFI ROUTER,AC2150,MU-MIMO</td>
      <td>EA8250</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>EA8300</td>
      <td>LINKSYS EA8300 WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>EA8300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA8300-AH</td>
      <td>LINKSYS EA8300 WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>EA8300</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA8300-AMZ</td>
      <td>LINKSYS EA8300 WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>EA8300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA8300-CA</td>
      <td>LINKSYS EA8300 WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>EA8300</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>EA8300-EU</td>
      <td>LINKSYS EA8300 WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>EA8300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA8300-GF</td>
      <td>LINKSYS EA8300 WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>EA8300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>22-Nov-2023</td>
      <td>20-Nov-2028</td>
    </tr>
    <tr>
      <td>EA8300-GO</td>
      <td>LINKSYS EA8300 WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>EA8300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>22-Nov-2023</td>
      <td>20-Nov-2028</td>
    </tr>
    <tr>
      <td>EA8300-GU</td>
      <td>LINKSYS EA8300 WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>EA8300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA8300-HK</td>
      <td>LINKSYS EA8300 WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>EA8300</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Nov-2023</td>
      <td>13-Nov-2028</td>
    </tr>
    <tr>
      <td>EA8300-ME</td>
      <td>LINKSYS EA8300 WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>EA8300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>EA8300-UK</td>
      <td>LINKSYS EA8300 WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>EA8300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>EA8500</td>
      <td>LINKSYS EA8500 WIFI ROUTER,AC2600,MU-MIMO</td>
      <td>EA8500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA8500-2A</td>
      <td>LINKSYS EA8500 WIFI ROUTER,AC2600,MU-MIMO</td>
      <td>EA8500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA8500-AH</td>
      <td>LINKSYS EA8500 WIFI ROUTER,AC2600,MU-MIMO</td>
      <td>EA8500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA8500-CA</td>
      <td>LINKSYS EA8500 WIFI ROUTER,AC2600,MU-MIMO</td>
      <td>EA8500</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA8500-EB</td>
      <td>LINKSYS DUAL-BAND SMART WI-FI RTR AC2600-ETISALAT</td>
      <td>EA8500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA8500-EU</td>
      <td>LINKSYS EA8500 WIFI ROUTER,AC2600,MU-MIMO</td>
      <td>EA8500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA8500-HK</td>
      <td>LINKSYS EA8500 WIFI ROUTER,AC2600,MU-MIMO</td>
      <td>EA8500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA8500-ME</td>
      <td>LINKSYS EA8500 WIFI ROUTER,AC2600,MU-MIMO</td>
      <td>EA8500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA8500-UK</td>
      <td>LINKSYS EA8500 WIFI ROUTER,AC2600,MU-MIMO</td>
      <td>EA8500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA8500-WM</td>
      <td>LINKSYS EA8500 WIFI ROUTER,AC2600,MU-MIMO</td>
      <td>EA8500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA9200-AP</td>
      <td>LINKSYS EA9200 WIFI ROUTER,AC3200,TB</td>
      <td>EA9200</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA9300</td>
      <td>LINKSYS EA9300 WI-FI ROUTER, TB, AC4000, MU-MIMO</td>
      <td>EA9300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA9300-AH</td>
      <td>LINKSYS EA9300 WI-FI ROUTER, TB, AC4000, MU-MIMO</td>
      <td>EA9300</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA9300-CA</td>
      <td>LINKSYS EA9300 WI-FI ROUTER, TB, AC4000, MU-MIMO</td>
      <td>EA9300</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>EA9300-HK</td>
      <td>LINKSYS EA9300 WI-FI ROUTER, TB, AC4000, MU-MIMO</td>
      <td>EA9300</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA9500</td>
      <td>LINKSYS EA9500 WI-FI ROUTER, AC5400, MU-MIMO</td>
      <td>EA9500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>EA9500-AH</td>
      <td>LINKSYS EA9500 WI-FI ROUTER, AC5400, MU-MIMO</td>
      <td>EA9500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA9500-AU</td>
      <td>LINKSYS EA9500 WI-FI ROUTER, AC5400, MU-MIMO</td>
      <td>EA9500</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>7-Aug-2020</td>
      <td>6-Aug-2025</td>
    </tr>
    <tr>
      <td>EA9500-CA</td>
      <td>LINKSYS EA9500 WI-FI ROUTER, AC5400, MU-MIMO</td>
      <td>EA9500</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>EA9500-EU</td>
      <td>LINKSYS EA9500 WI-FI ROUTER, AC5400, MU-MIMO</td>
      <td>EA9500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>EA9500-HK</td>
      <td>LINKSYS EA9500 WI-FI ROUTER, AC5400, MU-MIMO</td>
      <td>EA9500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>EA9500-ME</td>
      <td>LINKSYS EA9500 WI-FI ROUTER, AC5400, MU-MIMO</td>
      <td>EA9500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>EA9500-MX</td>
      <td>LINKSYS EA9500 WI-FI ROUTER, AC5400, MU-MIMO</td>
      <td>EA9500</td>
      <td>Latin America and South America</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA9500-UK</td>
      <td>LINKSYS EA9500 WI-FI ROUTER, AC5400, MU-MIMO</td>
      <td>EA9500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>EA9500S-AH</td>
      <td>LINKSYS EA9500S WI-FI ROUTER, TB, AC5400, MU-MIMO</td>
      <td>EA9500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA9500S-HK</td>
      <td>LINKSYS EA9500S WI-FI ROUTER, TB, AC5400, MU-MIMO</td>
      <td>EA9500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA9600</td>
      <td>LINKSYS EA9600 WI-FI ROUTER, DB, AX6000, MU-MIMO</td>
      <td>EA9600</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>EA9600-AH</td>
      <td>LINKSYS EA9600 WI-FI ROUTER, DB, AX6000, MU-MIMO</td>
      <td>EA9600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA9600-AU</td>
      <td>LINKSYS EA9600 WI-FI ROUTER, DB, AX6000, MU-MIMO</td>
      <td>EA9600</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA9600-CA</td>
      <td>LINKSYS EA9600 WI-FI ROUTER, DB, AX6000, MU-MIMO</td>
      <td>EA9600</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA9600-EU</td>
      <td>LINKSYS EA9600 WI-FI ROUTER, DB, AX6000, MU-MIMO</td>
      <td>EA9600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA9600-HK</td>
      <td>LINKSYS EA9600 WI-FI ROUTER, DB, AX6000, MU-MIMO</td>
      <td>EA9600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA9600-ME</td>
      <td>LINKSYS EA9600 WI-FI ROUTER, DB, AX6000, MU-MIMO</td>
      <td>EA9600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA9600-UK</td>
      <td>LINKSYS EA9600 WI-FI ROUTER, DB, AX6000, MU-MIMO</td>
      <td>EA9600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>EA9700</td>
      <td>LINKSYS EA9700 WI-FI ROUTER, DB, AX6000, 5GBE</td>
      <td>EA9700</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>FGW5500-AP</td>
      <td>LINKSYS FGW5500, 5G GATEWAY, LTE 5G, AX5400</td>
      <td>FGW5500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>20-Sep-2022</td>
      <td>19-Sep-2027</td>
    </tr>
    <tr>
      <td>FGW5500-ME</td>
      <td>LINKSYS FGW5500, 5G GATEWAY, LTE 5G, AX5400</td>
      <td>FGW5500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>20-Sep-2022</td>
      <td>19-Sep-2027</td>
    </tr>
    <tr>
      <td>LACGLX</td>
      <td>TRANSCEIVER MODULE, SFP, 1000BASE-LX</td>
      <td>LACGLX</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LACGSX</td>
      <td>TRANSCEIVER MODULE, SFP, 1000BASE-SX</td>
      <td>LACGSX</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LACPI30</td>
      <td>POE INJECTOR, GIGABIT, HIGH POWER,</td>
      <td>LACPI</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LACPI30-AP</td>
      <td>POE INJECTOR, GIGABIT, HIGH POWER</td>
      <td>LACPI</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LACPI30-AU</td>
      <td>POE INJECTOR, GIGABIT, HIGH POWER</td>
      <td>LACPI</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>11-Jun-2020</td>
      <td>10-Jun-2025</td>
    </tr>
    <tr>
      <td>LACPI30-EU</td>
      <td>POE INJECTOR, GIGABIT, HIGH POWER</td>
      <td>LACPI</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LACPI30-JP</td>
      <td>POE INJECTOR, GIGABIT, HIGH POWER,</td>
      <td>LACPI30</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LACPI30-UK</td>
      <td>POE INJECTOR, GIGABIT, HIGH POWER</td>
      <td>LACPI30</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LACXGLR</td>
      <td>TRANSCEIVER MODULE, SFP+, 1000BASE-LR</td>
      <td>LACXGLR</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LACXGSR</td>
      <td>TRANSCEIVER MODULE, SFP+, 1000BASE-SR</td>
      <td>LACXGSR</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LAPAC1200</td>
      <td>AC1200 DUAL BAND ACCESS POINT</td>
      <td>LAPAC1200</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LAPAC1200-AP</td>
      <td>AC1200 DUAL BAND ACCESS POINT</td>
      <td>LAPAC1200</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LAPAC1200-AU</td>
      <td>AC1200 DUAL BAND ACCESS POINT</td>
      <td>LAPAC1200</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>11-Jun-2020</td>
      <td>10-Jun-2025</td>
    </tr>
    <tr>
      <td>LAPAC1200-EU</td>
      <td>AC1200 DUAL BAND ACCESS POINT</td>
      <td>LAPAC1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Mar-2020</td>
      <td>15-Mar-2025</td>
    </tr>
    <tr>
      <td>LAPAC1200-UK</td>
      <td>AC1200 DUAL BAND ACCESS POINT</td>
      <td>LAPAC1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>20-Mar-2020</td>
      <td>19-Mar-2025</td>
    </tr>
    <tr>
      <td>LAPAC1200C</td>
      <td>LINKSYS AC1200 DUAL BAND CLOUD ACCESS POINT</td>
      <td>LAPAC1200C</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPAC1200C-AH</td>
      <td>LINKSYS AC1200 DUAL BAND CLOUD ACCESS POINT</td>
      <td>LAPAC1200C</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPAC1200C-AU</td>
      <td>LINKSYS AC1200 DUAL BAND CLOUD ACCESS POINT</td>
      <td>LAPAC1200C</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPAC1200C-CA</td>
      <td>LINKSYS AC1200 DUAL BAND CLOUD ACCESS POINT</td>
      <td>LAPAC1200C</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPAC1200C-EU</td>
      <td>LINKSYS AC1200 DUAL BAND CLOUD ACCESS POINT</td>
      <td>LAPAC1200C</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPAC1300C</td>
      <td>AC1300 MU-MIMO CLOUD MANAGED INDOOR AP TAA</td>
      <td>LAPAC1300C</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>9-Oct-2023</td>
      <td>7-Oct-2028</td>
    </tr>
    <tr>
      <td>LAPAC1300C-AH</td>
      <td>LINKSYS AC1300 DUAL BAND CLOUD ACCESS POINT</td>
      <td>LAPAC1300C</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>26-Oct-2020</td>
      <td>25-Oct-2025</td>
    </tr>
    <tr>
      <td>LAPAC1300C-AU</td>
      <td>LINKSYS AC1300 DUAL BAND CLOUD ACCESS POINT</td>
      <td>LAPAC1300C</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>26-Oct-2020</td>
      <td>25-Oct-2025</td>
    </tr>
    <tr>
      <td>LAPAC1300C-CA</td>
      <td>LINKSYS AC1300 DUAL BAND CLOUD ACCESS POINT</td>
      <td>LAPAC1300C</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>26-Oct-2020</td>
      <td>25-Oct-2025</td>
    </tr>
    <tr>
      <td>LAPAC1300C-EU</td>
      <td>LINKSYS AC1300 DUAL BAND CLOUD ACCESS POINT</td>
      <td>LAPAC1300C</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>26-Oct-2020</td>
      <td>25-Oct-2025</td>
    </tr>
    <tr>
      <td>LAPAC1300CE</td>
      <td>AC1300 MU-MIMO CLOUD MANAGED OUTDOOR AP IP67 TAA</td>
      <td>LAPAC1300CE</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>9-Oct-2023</td>
      <td>7-Oct-2028</td>
    </tr>
    <tr>
      <td>LAPAC1300CW</td>
      <td>AC1300 MU-MIMO CLOUD MANAGED IN-WALL AP TAA</td>
      <td>LAPAC1300CW</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>9-Oct-2023</td>
      <td>7-Oct-2028</td>
    </tr>
    <tr>
      <td>LAPAC1300CWSTD</td>
      <td>LINKSYS ACCESS POINT DESKTOP STAND FOR LAPAC1300CW</td>
      <td>LAPAC1300CWSTD</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>9-Oct-2023</td>
      <td>7-Oct-2028</td>
    </tr>
    <tr>
      <td>LAPAC1750</td>
      <td>AC1750 DUAL BAND ACCESS POINT</td>
      <td>LAPAC1750</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LAPAC1750-AP</td>
      <td>AC1750 DUAL BAND ACCESS POINT</td>
      <td>LAPAC1750</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LAPAC1750-AU</td>
      <td>AC1750 DUAL BAND ACCESS POINT</td>
      <td>LAPAC1750</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>11-Jun-2020</td>
      <td>10-Jun-2025</td>
    </tr>
    <tr>
      <td>LAPAC1750-EU</td>
      <td>AC1750 DUAL BAND ACCESS POINT</td>
      <td>LAPAC1750</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>17-Jul-2019</td>
      <td>15-Jul-2024</td>
    </tr>
    <tr>
      <td>LAPAC1750-UK</td>
      <td>AC1750 DUAL BAND ACCESS POINT</td>
      <td>LAPAC1750</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>17-Jul-2019</td>
      <td>15-Jul-2024</td>
    </tr>
    <tr>
      <td>LAPAC1750C</td>
      <td>LINKSYS AC1750 DUAL BAND CLOUD ACCESS POINT</td>
      <td>LAPAC1750C</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPAC1750C-AH</td>
      <td>LINKSYS AC1750 DUAL BAND CLOUD ACCESS POINT</td>
      <td>LAPAC1750C</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPAC1750C-AU</td>
      <td>LINKSYS AC1750 DUAL BAND CLOUD ACCESS POINT</td>
      <td>LAPAC1750C</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPAC1750C-EU</td>
      <td>LINKSYS AC1750 DUAL BAND CLOUD ACCESS POINT</td>
      <td>LAPAC1750C</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPAC1750PRO</td>
      <td>AC1750 PRO DUAL BAND ACCESS POINT</td>
      <td>LAPAC1750PRO</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LAPAC1750PRO-AP</td>
      <td>AC1750 PRO DUAL BAND ACCESS POINT</td>
      <td>LAPAC1750PRO</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LAPAC1750PRO-AU</td>
      <td>AC1750 PRO DUAL BAND ACCESS POINT</td>
      <td>LAPAC1750PRO</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>LAPAC1750PRO-EU</td>
      <td>AC1750 PRO DUAL BAND ACCESS POINT</td>
      <td>LAPAC1750PRO</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LAPAC1750PRO-UK</td>
      <td>AC1750 PRO DUAL BAND ACCESS POINT</td>
      <td>LAPAC1750PRO</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LAPAC2600</td>
      <td>LINKSYS BUSINESS DUAL-BAND ACCESS POINT AC2600</td>
      <td>LAPAC2600</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LAPAC2600-AH</td>
      <td>LINKSYS BUSINESS DUAL-BAND ACCESS POINT AC2600</td>
      <td>LAPAC2600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Aug-2022</td>
      <td>14-Aug-2027</td>
    </tr>
    <tr>
      <td>LAPAC2600-AU</td>
      <td>LINKSYS BUSINESS DUAL-BAND ACCESS POINT AC2600</td>
      <td>LAPAC2600</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>15-Aug-2022</td>
      <td>14-Aug-2027</td>
    </tr>
    <tr>
      <td>LAPAC2600-EU</td>
      <td>LINKSYS LAPAC2600 ACCESS POINT,AC2600</td>
      <td>LAPAC2600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LAPAC2600C</td>
      <td>LINKSYS AC2600 DUAL BAND CLOUD ACCESS POINT</td>
      <td>LAPAC2600C</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPAC2600C-AH</td>
      <td>LINKSYS AC2600 DUAL BAND CLOUD ACCESS POINT</td>
      <td>LAPAC2600C</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPAC2600C-EU</td>
      <td>LINKSYS AC2600 DUAL BAND CLOUD ACCESS POINT</td>
      <td>LAPAC2600C</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPAX3000C</td>
      <td>AX3000 CLOUD MANAGED INDOOR AP TAA</td>
      <td>LAPAX3000C</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>3-Jan-2023</td>
      <td>2-Jan-2028</td>
    </tr>
    <tr>
      <td>LAPAX3000CE</td>
      <td>AX3000 CLOUD MANAGED OUTDOOR AP IP67 TAA</td>
      <td>LAPAX3000CE</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>3-Jan-2023</td>
      <td>2-Jan-2028</td>
    </tr>
    <tr>
      <td>LAPAX3000CW</td>
      <td>AX3000 CLOUD MANAGED IN-WALL AP TAA</td>
      <td>LAPAX3000CW</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>3-Jan-2023</td>
      <td>2-Jan-2028</td>
    </tr>
    <tr>
      <td>LAPAX3600C</td>
      <td>AX3600 MU-MIMO CLOUD MANAGED INDOOR AP TAA</td>
      <td>LAPAX3600C</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>9-Oct-2023</td>
      <td>7-Oct-2028</td>
    </tr>
    <tr>
      <td>LAPAX5400C</td>
      <td>AX5400 CLOUD MANAGED INDOOR AP TAA</td>
      <td>LAPAX5400C</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>3-Jan-2023</td>
      <td>2-Jan-2028</td>
    </tr>
    <tr>
      <td>LAPN300</td>
      <td>WIRELESS-N300 ACCESS POINT WITH POE</td>
      <td>LAPN300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPN300-AP</td>
      <td>WIRELESS-N300 ACCESS POINT WITH POE</td>
      <td>LAPN300</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPN300-AU</td>
      <td>WIRELESS-N300 ACCESS POINT WITH POE</td>
      <td>LAPN300</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>LAPN300-EU</td>
      <td>WIRELESS-N300 ACCESS POINT WITH POE</td>
      <td>LAPN300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPN300-UK</td>
      <td>WIRELESS-N300 ACCESS POINT WITH POE</td>
      <td>LAPN300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPN600</td>
      <td>WIRELESS-N600 ACCESS POINT WITH POE</td>
      <td>LAPN600</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPN600-AP</td>
      <td>WIRELESS-N600 ACCESS POINT WITH POE</td>
      <td>LAPN600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPN600-AU</td>
      <td>WIRELESS-N600 ACCESS POINT WITH POE</td>
      <td>LAPN600</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>LAPN600-EU</td>
      <td>WIRELESS-N600 ACCESS POINT WITH POE</td>
      <td>LAPN600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPN600-UK</td>
      <td>WIRELESS-N600 ACCESS POINT WITH POE</td>
      <td>LAPN600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LAPPI30W</td>
      <td>POE INJECTOR, GIGABIT, HIGH POWER,</td>
      <td>LAPPI30W</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>9-Oct-2023</td>
      <td>7-Oct-2028</td>
    </tr>
    <tr>
      <td>LAPPI30W-EU</td>
      <td>POE INJECTOR, GIGABIT, HIGH POWER</td>
      <td>LACPI30W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>9-Oct-2023</td>
      <td>7-Oct-2028</td>
    </tr>
    <tr>
      <td>LAPPI30W-UK</td>
      <td>POE INJECTOR, GIGABIT, HIGH POWER</td>
      <td>LACPI30W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>9-Oct-2023</td>
      <td>7-Oct-2028</td>
    </tr>
    <tr>
      <td>LCAB03VLNOD</td>
      <td>1080P 3MP OUTDOOR NIGHT VISION BULLET CAMERA</td>
      <td>LCAB03VLNOD</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>LCAB03VLNOD-AU</td>
      <td>1080P 3MP OUTDOOR NIGHT VISION BULLET CAMERA</td>
      <td>LCAB03VLNOD</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>LCAB03VLNOD-EU</td>
      <td>1080P 3MP OUTDOOR NIGHT VISION BULLET CAMERA</td>
      <td>LCAB03VLNOD</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>LCAB03VLNOD-UK</td>
      <td>1080P 3MP OUTDOOR NIGHT VISION BULLET CAMERA</td>
      <td>LCAB03VLNOD</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>LCAD03FLN</td>
      <td>1080P 3MP INDOOR NIGHT VISION DOME CAMERA</td>
      <td>LCAD03FLN</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>LCAD03FLN-AU</td>
      <td>1080P 3MP INDOOR NIGHT VISION DOME CAMERA</td>
      <td>LCAD03FLN</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>LCAD03FLN-EU</td>
      <td>1080P 3MP INDOOR NIGHT VISION DOME CAMERA</td>
      <td>LCAD03FLN</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>LCAD03FLN-UK</td>
      <td>1080P 3MP INDOOR NIGHT VISION DOME CAMERA</td>
      <td>LCAD03FLN</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>LCAD03VLNOD</td>
      <td>1080P 3MP OUTDOOR NIGHT VISION DOME CAMERA</td>
      <td>LCAD03VLNOD</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>LCAM0336OD-EU</td>
      <td>1080P 3MP INDOOR/OUTDOOR 360 MINI-DOME CAMERA</td>
      <td>LCAM0336OD</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>LCAM0336OD-UK</td>
      <td>1080P 3MP INDOOR/OUTDOOR 360 MINI-DOME CAMERA</td>
      <td>LCAM0336OD</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>LGS105-VT</td>
      <td>SWITCH, GIGABIT, UNMANAGED,5-PORT</td>
      <td>LGS105</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>1-Aug-2022</td>
      <td>31-Jul-2027</td>
    </tr>
    <tr>
      <td>LGS308</td>
      <td>SWITCH, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS308-AP</td>
      <td>SWITCH, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS308-AU</td>
      <td>SWITCH, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS308-EU</td>
      <td>SWITCH, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS308-ME</td>
      <td>SWITCH, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS308-UK</td>
      <td>SWITCH, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS308MP</td>
      <td>SWITCH, POE+, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308MP</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS308MP-AP</td>
      <td>SWITCH, POE+, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308MP</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS308MP-AU</td>
      <td>SWITCH, POE+, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308MP</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS308MP-EU</td>
      <td>SWITCH, POE+, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308MP</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS308MP-UK</td>
      <td>SWITCH, POE+, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308MP</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS308P</td>
      <td>SWITCH, POE, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308P</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS308P-AP</td>
      <td>SWITCH, POE, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308P</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS308P-AU</td>
      <td>SWITCH, POE, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308P</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS308P-EU</td>
      <td>SWITCH, POE, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS308P-ME</td>
      <td>SWITCH, POE, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS308P-UK</td>
      <td>SWITCH, POE, GIGABIT,SMART, 8-PORT</td>
      <td>LGS308P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS318</td>
      <td>SWITCH, GIGABIT,SMART, 18-PORT</td>
      <td>LGS318</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS318-AP</td>
      <td>SWITCH, GIGABIT,SMART, 18-PORT</td>
      <td>LGS318</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS318-AU</td>
      <td>SWITCH, GIGABIT,SMART, 18-PORT</td>
      <td>LGS318</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>11-Jun-2020</td>
      <td>10-Jun-2025</td>
    </tr>
    <tr>
      <td>LGS318-EU</td>
      <td>SWITCH, GIGABIT,SMART, 18-PORT</td>
      <td>LGS318</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS318-ME</td>
      <td>SWITCH, GIGABIT,SMART, 18-PORT</td>
      <td>LGS318</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS318-UK</td>
      <td>SWITCH, GIGABIT,SMART, 18-PORT</td>
      <td>LGS318</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS318P</td>
      <td>SWITCH, POE, GIGABIT,SMART, 18-PORT</td>
      <td>LGS318P</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS318P-AP</td>
      <td>SWITCH, POE, GIGABIT,SMART, 18-PORT</td>
      <td>LGS318P</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS318P-AU</td>
      <td>SWITCH, POE, GIGABIT,SMART, 18-PORT</td>
      <td>LGS318P</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS318P-EU</td>
      <td>SWITCH, POE, GIGABIT,SMART, 18-PORT</td>
      <td>LGS318P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS318P-ME</td>
      <td>SWITCH, POE, GIGABIT,SMART, 18-PORT</td>
      <td>LGS318P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS318P-UK</td>
      <td>SWITCH, POE, GIGABIT,SMART, 18-PORT</td>
      <td>LGS318P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS326</td>
      <td>SWITCH, GIGABIT,SMART, 26-PORT</td>
      <td>LGS326</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS326-AP</td>
      <td>SWITCH, GIGABIT,SMART, 26-PORT</td>
      <td>LGS326</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Jun-2020</td>
      <td>10-Jun-2025</td>
    </tr>
    <tr>
      <td>LGS326-AU</td>
      <td>SWITCH, GIGABIT,SMART, 26-PORT</td>
      <td>LGS326</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>11-Jun-2020</td>
      <td>10-Jun-2025</td>
    </tr>
    <tr>
      <td>LGS326-EU</td>
      <td>SWITCH, GIGABIT,SMART, 26-PORT</td>
      <td>LGS326</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS326-ME</td>
      <td>SWITCH, GIGABIT,SMART, 26-PORT</td>
      <td>LGS326</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS326-UK</td>
      <td>SWITCH, GIGABIT,SMART, 26-PORT</td>
      <td>LGS326</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS326MP</td>
      <td>SWITCH, POE+, GIGABIT,SMART,26-PORT</td>
      <td>LGS326MP</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS326MP-AP</td>
      <td>SWITCH, POE+, GIGABIT,SMART,26-PORT</td>
      <td>LGS326MP</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS326MP-AU</td>
      <td>SWITCH, POE+, GIGABIT,SMART,26-PORT</td>
      <td>LGS326MP</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS326MP-EU</td>
      <td>SWITCH, POE+, GIGABIT,SMART,26-PORT</td>
      <td>LGS326MP</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS326MP-UK</td>
      <td>SWITCH, POE+, GIGABIT,SMART,26-PORT</td>
      <td>LGS326MP</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS326P</td>
      <td>SWITCH, POE, GIGABIT,SMART, 26-PORT</td>
      <td>LGS326P</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS326P-AP</td>
      <td>SWITCH, POE, GIGABIT,SMART, 26-PORT</td>
      <td>LGS326P</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS326P-AU</td>
      <td>SWITCH, POE, GIGABIT,SMART, 26-PORT</td>
      <td>LGS326P</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS326P-EU</td>
      <td>SWITCH, POE, GIGABIT,SMART, 26-PORT</td>
      <td>LGS326P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS326P-ME</td>
      <td>SWITCH, POE, GIGABIT,SMART, 26-PORT</td>
      <td>LGS326P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS326P-UK</td>
      <td>SWITCH, POE, GIGABIT,SMART, 26-PORT</td>
      <td>LGS326P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS528</td>
      <td>SWITCH, GIGABIT,MANAGED, 28-PORT</td>
      <td>LGS528</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS528-AP</td>
      <td>SWITCH, GIGABIT,MANAGED, 28-PORT</td>
      <td>LGS528</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Jun-2020</td>
      <td>10-Jun-2025</td>
    </tr>
    <tr>
      <td>LGS528-AU</td>
      <td>SWITCH, GIGABIT,MANAGED, 28-PORT</td>
      <td>LGS528</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>11-Jun-2020</td>
      <td>10-Jun-2025</td>
    </tr>
    <tr>
      <td>LGS528-EU</td>
      <td>SWITCH, GIGABIT,MANAGED, 28-PORT</td>
      <td>LGS528</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS528-ME</td>
      <td>SWITCH, GIGABIT,MANAGED, 28-PORT</td>
      <td>LGS528</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS528-UK</td>
      <td>SWITCH, GIGABIT,MANAGED, 28-PORT</td>
      <td>LGS528</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS528P</td>
      <td>SWITCH, POE, GIGABIT,MANAGED, 28-PORT</td>
      <td>LGS528P</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS528P-AP</td>
      <td>SWITCH, POE, GIGABIT,MANAGED, 28-PORT</td>
      <td>LGS528P</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS528P-AU</td>
      <td>SWITCH, POE, GIGABIT,MANAGED, 28-PORT</td>
      <td>LGS528P</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>11-Jun-2020</td>
      <td>10-Jun-2025</td>
    </tr>
    <tr>
      <td>LGS528P-EU</td>
      <td>SWITCH, POE, GIGABIT,MANAGED, 28-PORT</td>
      <td>LGS528P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS528P-ME</td>
      <td>SWITCH, POE, GIGABIT,MANAGED, 28-PORT</td>
      <td>LGS528P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS528P-UK</td>
      <td>SWITCH, POE, GIGABIT,MANAGED, 28-PORT</td>
      <td>LGS528P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LGS552-AP</td>
      <td>SWITCH, GIGABIT,MANAGED, 52-PORT</td>
      <td>LGS552</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>LGS552-AU</td>
      <td>SWITCH, GIGABIT,MANAGED, 52-PORT</td>
      <td>LGS552</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>11-Jun-2020</td>
      <td>10-Jun-2025</td>
    </tr>
    <tr>
      <td>LGS552-EU</td>
      <td>SWITCH, GIGABIT,MANAGED, 52-PORT</td>
      <td>LGS552</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LGS552-ME</td>
      <td>SWITCH, GIGABIT,MANAGED, 52-PORT</td>
      <td>LGS552</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>LGS552-UK</td>
      <td>SWITCH, GIGABIT,MANAGED, 52-PORT</td>
      <td>LGS552</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LGS552P-AP</td>
      <td>SWITCH, POE, GIGABIT,MANAGED, 52-PORT</td>
      <td>LGS552P</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>LGS552P-AU</td>
      <td>SWITCH, POE, GIGABIT,MANAGED, 52-PORT</td>
      <td>LGS552P</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>19-Aug-2019</td>
      <td>17-Aug-2024</td>
    </tr>
    <tr>
      <td>LGS552P-EU</td>
      <td>SWITCH, POE, GIGABIT,MANAGED, 52-PORT</td>
      <td>LGS552P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>19-Aug-2019</td>
      <td>17-Aug-2024</td>
    </tr>
    <tr>
      <td>LGS552P-ME</td>
      <td>SWITCH, POE, GIGABIT,MANAGED, 52-PORT</td>
      <td>LGS552P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>LGS552P-UK</td>
      <td>SWITCH, POE, GIGABIT,MANAGED, 52-PORT</td>
      <td>LGS552P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>LGSM310C</td>
      <td>8-PORT MANAGED 2.5 GE SWITCH 2 10G SFP+</td>
      <td>LGSM310C</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>4-Jan-2023</td>
      <td>3-Jan-2028</td>
    </tr>
    <tr>
      <td>LGSM310C-EU</td>
      <td>8-PORT MANAGED 2.5 GE SWITCH 2 10G SFP+</td>
      <td>LGSM310C</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>4-Jan-2023</td>
      <td>3-Jan-2028</td>
    </tr>
    <tr>
      <td>LGSM310MPC</td>
      <td>8-PORT MANAGED POE+ 2.5 GE SWITCH 2 10G SFP+ 240W</td>
      <td>LGSM310MPC</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>4-Jan-2023</td>
      <td>3-Jan-2028</td>
    </tr>
    <tr>
      <td>LGSM310MPC-EU</td>
      <td>8-PORT MANAGED POE+ 2.5 GE SWITCH 2 10G SFP+ 240W</td>
      <td>LGSM310MPC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>4-Jan-2023</td>
      <td>3-Jan-2028</td>
    </tr>
    <tr>
      <td>LGSX312C</td>
      <td>8-PORT MANAGED 10 GE SWITCH 4 10G SFP+</td>
      <td>LGSM310C</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>3-Jan-2023</td>
      <td>2-Jan-2028</td>
    </tr>
    <tr>
      <td>LGSX312C-EU</td>
      <td>8-PORT MANAGED 10 GE SWITCH 4 10G SFP+</td>
      <td>LGSM310C</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>3-Jan-2023</td>
      <td>2-Jan-2028</td>
    </tr>
    <tr>
      <td>LGSX312MPC</td>
      <td>8-PORT MANAGED POE+ 10 GE SWITCH 4 10G SFP+ 410W</td>
      <td>LGSM310MPC</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>3-Jan-2023</td>
      <td>2-Jan-2028</td>
    </tr>
    <tr>
      <td>LGSX312MPC-EU</td>
      <td>8-PORT MANAGED POE+ 10 GE SWITCH 4 10G SFP+ 410W</td>
      <td>LGSM310MPC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>3-Jan-2023</td>
      <td>2-Jan-2028</td>
    </tr>
    <tr>
      <td>LNR0208C</td>
      <td>2-BAY NETWORK VIDEO RECORDER</td>
      <td>LNR0208C</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>LNR0208C-AP</td>
      <td>2-BAY NETWORK VIDEO RECORDER</td>
      <td>LNR0208C</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>LNR0208C-AU</td>
      <td>2-BAY NETWORK VIDEO RECORDER</td>
      <td>LNR0208C</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>LNR0208C-EU</td>
      <td>2-BAY NETWORK VIDEO RECORDER</td>
      <td>LNR0208C</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>LNR0208C-UK</td>
      <td>2-BAY NETWORK VIDEO RECORDER</td>
      <td>LNR0208C</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>LRT214</td>
      <td>SMB, VPN Router, Gigabit</td>
      <td>LRT214</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>28-Oct-2020</td>
      <td>27-Oct-2025</td>
    </tr>
    <tr>
      <td>LRT214-AP</td>
      <td>SMB, VPN Router, Gigabit</td>
      <td>LRT214</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LRT214-AU</td>
      <td>SMB, VPN Router, Gigabit</td>
      <td>LRT214</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>11-Jun-2020</td>
      <td>10-Jun-2025</td>
    </tr>
    <tr>
      <td>LRT214-EU</td>
      <td>SMB, VPN Router, Gigabit</td>
      <td>LRT214</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LRT214-UK</td>
      <td>SMB, VPN Router, Gigabit</td>
      <td>LRT214</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LRT224</td>
      <td>SMB, VPN Router, Gigabit, Dual WAN</td>
      <td>LRT224</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>28-Oct-2020</td>
      <td>27-Oct-2025</td>
    </tr>
    <tr>
      <td>LRT224-AP</td>
      <td>SMB, VPN Router, Gigabit, Dual WAN</td>
      <td>LRT224</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Jun-2020</td>
      <td>10-Jun-2025</td>
    </tr>
    <tr>
      <td>LRT224-AU</td>
      <td>SMB, VPN Router, Gigabit, Dual WAN</td>
      <td>LRT224</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>11-Jun-2020</td>
      <td>10-Jun-2025</td>
    </tr>
    <tr>
      <td>LRT224-EU</td>
      <td>SMB, VPN Router, Gigabit, Dual WAN</td>
      <td>LRT224</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LRT224-UK</td>
      <td>SMB, VPN Router, Gigabit, Dual WAN</td>
      <td>LRT224</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>LUSBAC600PK3</td>
      <td>LINKSYS, AC600 MU-MIMO WI-FI USB ADAPTER, 3 PACK</td>
      <td>WUSB6100M</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>MC2400</td>
      <td>2PK VELOP AC1200 BLACK - AMAZON BF</td>
      <td>VLP01</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>MC3600</td>
      <td>3PK VELOP AC1200 BLACK - AMAZON BF</td>
      <td>VLP01</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>MR2000-AH</td>
      <td>LINKSYS MR2000 DUAL-BAND MESH WIFI 6 ROUTER,AX3000</td>
      <td>MR2000</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>MR5500-EU</td>
      <td>LINKSYS MR5500 MESH WIFI ROUTER, DB, AX5400</td>
      <td>MR5500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>27-Jul-2021</td>
      <td>26-Jul-2026</td>
    </tr>
    <tr>
      <td>MR6350</td>
      <td>LINKSYS MR6350 DUAL-BAND MESH WIFI 5 ROUTER,AC1300</td>
      <td>MR6350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR6350-2A</td>
      <td>LINKSYS MR6350 DUAL-BAND MESH WIFI 5 ROUTER,AC1300</td>
      <td>MR6350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR6350-AH</td>
      <td>LINKSYS MR6350 DUAL-BAND MESH WIFI 5 ROUTER,AC1300</td>
      <td>MR6350</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR6350-AMZ</td>
      <td>LINKSYS MR6350 DUAL-BAND MESH WIFI 5 ROUTER,AC1300</td>
      <td>MR6350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR6350-CA</td>
      <td>LINKSYS MR6350 DUAL-BAND MESH WIFI 5 ROUTER,AC1300</td>
      <td>MR6350</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR6350-CN</td>
      <td>LINKSYS MR6350 DUAL-BAND MESH WIFI 5 ROUTER,AC1300</td>
      <td>MR6350</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR6350-EU</td>
      <td>LINKSYS MR6350 DUAL-BAND MESH WIFI 5 ROUTER,AC1300</td>
      <td>MR6350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR6350-ME</td>
      <td>LINKSYS MR6350 DUAL-BAND MESH WIFI 5 ROUTER,AC1300</td>
      <td>MR6350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR6350-UK</td>
      <td>LINKSYS MR6350 DUAL-BAND MESH WIFI 5 ROUTER,AC1300</td>
      <td>MR6350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR7320</td>
      <td>LINKSYS MR7320 DUAL-BAND MESH WIFI 6 ROUTER,AX1800</td>
      <td>MR7320</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>27-Jul-2021</td>
      <td>26-Jul-2026</td>
    </tr>
    <tr>
      <td>MR7340</td>
      <td>LINKSYS MR7340 DUAL-BAND MESH WIFI 6 ROUTER,AX1500</td>
      <td>MR7340</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>MR7350-CN</td>
      <td>LINKSYS MR7350 DUAL-BAND MESH WIFI 6 ROUTER,AX1800</td>
      <td>MR7350</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR7350-KR</td>
      <td>LINKSYS MR7350 DUAL-BAND MESH WIFI 6 ROUTER,AX1800</td>
      <td>MR7350</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR750</td>
      <td>LINKSYS MR750 TRI-BAND MESH WIFI 6E ROUTER, AX6600</td>
      <td>MR7500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>27-Jul-2021</td>
      <td>26-Jul-2026</td>
    </tr>
    <tr>
      <td>MR8250</td>
      <td>LINKSYS MR8250 TRI-BAND MESH WIFI 5 ROUTER, AC2200</td>
      <td>MR8250</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>27-Jul-2021</td>
      <td>26-Jul-2026</td>
    </tr>
    <tr>
      <td>MR8300</td>
      <td>LINKSYS MR8300 MESH WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>MR8300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR8300-AH</td>
      <td>LINKSYS MR8300 MESH WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>MR8300</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>MR8300-CA</td>
      <td>LINKSYS MR8300 MESH WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>MR8300</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR8300-CN</td>
      <td>LINKSYS MR8300 MESH WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>MR8300</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>MR8300-EU</td>
      <td>LINKSYS MR8300 MESH WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>MR8300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR8300-ME</td>
      <td>LINKSYS MR8300 MESH WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>MR8300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>MR8300-UK</td>
      <td>LINKSYS MR8300 MESH WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>MR8300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR8300GC-UK</td>
      <td>LINKSYS MR8300 MESH WIFI ROUTER,AC2200,MU-MIMO, GIGACLEAR</td>
      <td>MR8300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>27-Jul-2021</td>
      <td>26-Jul-2026</td>
    </tr>
    <tr>
      <td>MR9000</td>
      <td>LINKSYS MR9000 TRI-BAND MESH WIFI 5 ROUTER,AC3000,MU-MIMO</td>
      <td>MR9000</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR9000-CA</td>
      <td>LINKSYS MR9000 TRI-BAND MESH WIFI 5 ROUTER,AC3000,MU-MIMO</td>
      <td>MR9000</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR9000-EU</td>
      <td>LINKSYS MR9000 TRI-BAND MESH WIFI 5 ROUTER,AC3000, MU-MIMO</td>
      <td>MR9000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR9000-ME</td>
      <td>LINKSYS MR9000 TRI-BAND MESH WIFI 5 ROUTER,AC3000, MU-MIMO</td>
      <td>MR9000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>MR9000-UK</td>
      <td>LINKSYS MR9000 TRI-BAND MESH WIFI 5 ROUTER,AC3000, MU-MIMO</td>
      <td>MR9000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>MR9000X</td>
      <td>LINKSYS MR9000 TRI-BAND MESH WIFI 5 ROUTER,AC3000, MU-MIMO</td>
      <td>MR9000</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>27-Jul-2021</td>
      <td>26-Jul-2026</td>
    </tr>
    <tr>
      <td>MR9000X-AH</td>
      <td>LINKSYS MR9000 TRI-BAND MESH WIFI 5 ROUTER,AC3000, MU-MIMO</td>
      <td>MR9000</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>MR9000X-CN</td>
      <td>LINKSYS MR9000 TRI-BAND MESH WIFI 5 ROUTER,AC3000, MU-MIMO</td>
      <td>MR9000</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>MR9000X-JP</td>
      <td>LINKSYS MR9000 TRI-BAND MESH WIFI 5 ROUTER,AC3000, MU-MIMO</td>
      <td>MR9000</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>MR9000X-KR</td>
      <td>LINKSYS MR9000 TRI-BAND MESH WIFI 5 ROUTER,AC3000, MU-MIMO</td>
      <td>MR9000</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>MR9000X-SH</td>
      <td>LINKSYS MR9000 TRI-BAND MESH WIFI 5 ROUTER,AC3000,MU-MIMO</td>
      <td>MR9000</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>MR9550</td>
      <td>LINKSYS MR9550 MESH WIFI ROUTER, DB, AX6000</td>
      <td>MR9550</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>27-Jul-2021</td>
      <td>26-Jul-2026</td>
    </tr>
    <tr>
      <td>MR9600</td>
      <td>LINKSYS MR9600 MESH WIFI ROUTER, DB, AX6000</td>
      <td>MR9600</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR9600-AH</td>
      <td>LINKSYS MR9600 MESH WIFI ROUTER, DB, AX6000</td>
      <td>MR9600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>MR9600-AMZ</td>
      <td>LINKSYS MR9600 MESH WIFI ROUTER, DB, AX6000</td>
      <td>MR9600</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR9600-CA</td>
      <td>LINKSYS MR9600 MESH WIFI ROUTER, DB, AX6000</td>
      <td>MR9600</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MR9600-CN</td>
      <td>LINKSYS MR9600 MESH WIFI ROUTER, DB, AX6000</td>
      <td>MR9600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>MR9600-EU</td>
      <td>LINKSYS MR9600 MESH WIFI ROUTER, DB, AX6000</td>
      <td>MR9600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>MR9600-ME</td>
      <td>LINKSYS MR9600 MESH WIFI ROUTER, DB, AX6000</td>
      <td>MR9600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>MR9600-UK</td>
      <td>LINKSYS MR9600 MESH WIFI ROUTER, DB, AX6000</td>
      <td>MR9600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>MR9610</td>
      <td>LINKSYS AX6000 MESH WIFI6 ROUTER</td>
      <td>MR9600</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2023</td>
      <td>9-Dec-2028</td>
    </tr>
    <tr>
      <td>MX4052-HK</td>
      <td>LINKSYS VELOP MX4050 PCCW 2PK</td>
      <td>MX4200</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>MX4053-HK</td>
      <td>LINKSYS VELOP MX4050 PCCW 3PK</td>
      <td>MX4200</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>MX4200-CA-APL</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>4-May-2021</td>
      <td>3-May-2026</td>
    </tr>
    <tr>
      <td>MX4200CF-UK</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>4-Dec-2023</td>
      <td>2-Dec-2028</td>
    </tr>
    <tr>
      <td>MX4200FM-UK</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>4-Dec-2023</td>
      <td>2-Dec-2028</td>
    </tr>
    <tr>
      <td>MX4200SF-UK</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>4-Dec-2023</td>
      <td>2-Dec-2028</td>
    </tr>
    <tr>
      <td>MX4200SH-SG</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>MX4300</td>
      <td>LINKSYS ATLAS PRO 6 AX4200 WIFI 6 MESH SYSTEM</td>
      <td>MX4300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>20-May-2021</td>
      <td>19-May-2026</td>
    </tr>
    <tr>
      <td>MX5300</td>
      <td>LINKSYS VELOP MX5300 AX5300 1PK</td>
      <td>MX5300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>MX5300-AH</td>
      <td>LINKSYS VELOP MX5300 AX5300 1PK</td>
      <td>MX5300</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>MX5300-AU</td>
      <td>LINKSYS VELOP MX5300 AX5300 1PK</td>
      <td>MX5300</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>MX5300-CA</td>
      <td>LINKSYS VELOP MX5300 AX5300 1PK</td>
      <td>MX5300</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>MX5300-CN</td>
      <td>LINKSYS VELOP MX5300 AX5300 1PK</td>
      <td>MX5300</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>MX5300-EU</td>
      <td>LINKSYS VELOP MX5300 AX5300 1PK</td>
      <td>MX5300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>MX5300-JP</td>
      <td>LINKSYS VELOP MX5300 AX5300 1PK</td>
      <td>MX5300</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>MX5300-KR</td>
      <td>LINKSYS VELOP MX5300 AX5300 1PK</td>
      <td>MX5300</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>MX5300-ME</td>
      <td>LINKSYS VELOP MX5300 AX5300 1PK</td>
      <td>MX5300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>MX5300-UK</td>
      <td>LINKSYS VELOP MX5300 AX5300 1PK</td>
      <td>MX5300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>MX5330</td>
      <td>LINKSYS VELOP MX5300 AX5300 1PK</td>
      <td>MX5300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>RE3000W-AG</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>RE3000W-AR</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>Latin America and South America</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>RE3000W-AU</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>RE3000W-CA</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>RE3000W-EJ</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>RE3000W-LA</td>
      <td>LINKSYS, 11N, 2x2, SINGLE BAND RANGE EXTENDER</td>
      <td>RE3000W</td>
      <td>Latin America and South America</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>RE3000W-ME</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>RE3000W-SG</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>RE3000W-TH</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>RE3000W-UK</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>RE4100W-2A</td>
      <td>LINKSYS RE4100W WIFI RANGE EXTENDER,N600</td>
      <td>RE4100W</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>RE4100W-AR</td>
      <td>LINKSYS RE4100W WIFI RANGE EXTENDER,N600</td>
      <td>RE4100W</td>
      <td>Latin America and South America</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>RE4100W-AU</td>
      <td>LINKSYS RE4100W WIFI RANGE EXTENDER,N600</td>
      <td>RE4100W</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>RE4100W-CA</td>
      <td>LINKSYS RE4100W WIFI RANGE EXTENDER,N600</td>
      <td>RE4100W</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>RE4100W-EU</td>
      <td>LINKSYS RE4100W WIFI RANGE EXTENDER,N600</td>
      <td>RE4100W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>RE4100W-LA</td>
      <td>LINKSYS RE4100W WIFI RANGE EXTENDER,N600</td>
      <td>RE4100W</td>
      <td>Latin America and South America</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>RE4100W-ME</td>
      <td>LINKSYS RE4100W WIFI RANGE EXTENDER,N600</td>
      <td>RE4100W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>RE4100W-TG2</td>
      <td>LINKSYS RE4100W WIFI RANGE EXTENDER,N600</td>
      <td>RE4100W</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>RE6250</td>
      <td>LINKSYS RE6250 WIFI RANGE EXTENDER, AC750</td>
      <td>RE6250</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE6300</td>
      <td>LINKSYS, WIFI RANGE EXTENDER, RE6300, DB AC750</td>
      <td>RE6300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE6300-AMZ</td>
      <td>LINKSYS, WIFI RANGE EXTENDER, RE6300, DB AC750</td>
      <td>RE6300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE6300-AU</td>
      <td>LINKSYS, WIFI RANGE EXTENDER, RE6300, DB AC750</td>
      <td>RE6300</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>RE6300-CA</td>
      <td>LINKSYS, WIFI RANGE EXTENDER, RE6300, DB AC750</td>
      <td>RE6300</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>RE6300-EU</td>
      <td>LINKSYS, WIFI RANGE EXTENDER, RE6300, DB AC750</td>
      <td>RE6300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>RE6300-ME</td>
      <td>LINKSYS, WIFI RANGE EXTENDER, RE6300, DB AC750</td>
      <td>RE6300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>23-Jun-2022</td>
      <td>22-Jun-2027</td>
    </tr>
    <tr>
      <td>RE6300-TH</td>
      <td>LINKSYS, WIFI RANGE EXTENDER, RE6300, DB AC750</td>
      <td>RE6300</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>RE6300-UK</td>
      <td>LINKSYS, WIFI RANGE EXTENDER, RE6300, DB AC750</td>
      <td>RE6300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>RE6350</td>
      <td>LINKSYS RE6350 WIFI RANGE EXTENDER, AC1200</td>
      <td>RE6350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE6350-2A</td>
      <td>LINKSYS RE6350 WIFI RANGE EXTENDER, AC1200</td>
      <td>RE6350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE6350-AMZ</td>
      <td>LINKSYS RE6350 WIFI RANGE EXTENDER, AC1200</td>
      <td>RE6350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE6350-CA</td>
      <td>LINKSYS AC1200 WIRELESS RANGE EXTENDER</td>
      <td>RE6350</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE6400</td>
      <td>LINKSYS, AC1200 DUAL BAND WI-FI RANGE EXTENDER</td>
      <td>RE6400</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE6400-AG</td>
      <td>LINKSYS, AC1200 DUAL BAND WI-FI RANGE EXTENDER</td>
      <td>RE6400</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>RE6400-AMZ</td>
      <td>LINKSYS, AC1200 DUAL BAND WI-FI RANGE EXTENDER</td>
      <td>RE6400</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE6400-CA</td>
      <td>LINKSYS, AC1200 DUAL BAND WI-FI RANGE EXTENDER</td>
      <td>RE6400</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>RE6400-EU</td>
      <td>LINKSYS, AC1200 DUAL BAND WI-FI RANGE EXTENDER</td>
      <td>RE6400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>RE6400-ME</td>
      <td>LINKSYS, AC1200 DUAL BAND WI-FI RANGE EXTENDER</td>
      <td>RE6400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>23-Jun-2022</td>
      <td>22-Jun-2027</td>
    </tr>
    <tr>
      <td>RE6400-UK</td>
      <td>LINKSYS, AC1200 DUAL BAND WI-FI RANGE EXTENDER</td>
      <td>RE6400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>RE6400x</td>
      <td>LINKSYS RE6400 WI-FI RANGE EXTENDER,AC1200</td>
      <td>RE6400</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>RE6500</td>
      <td>LINKSYS RE6500 WIFI RANGE EXTENDER,AC1200,DESKTOP</td>
      <td>RE6500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE6500-AU</td>
      <td>LINKSYS RE6500 WIFI RANGE EXTENDER,AC1200,DESKTOP</td>
      <td>RE6500</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>RE6500-CA</td>
      <td>LINKSYS RE6500 WIFI RANGE EXTENDER,AC1200,DESKTOP</td>
      <td>RE6500</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>RE6500-ME</td>
      <td>LINKSYS RE6500 WIFI RANGE EXTENDER,AC1200,DESKTOP</td>
      <td>RE6500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>23-Jun-2022</td>
      <td>22-Jun-2027</td>
    </tr>
    <tr>
      <td>RE6500-UK</td>
      <td>LINKSYS RE6500 WIFI RANGE EXTENDER,AC1200,DESKTOP</td>
      <td>RE6500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>23-Jun-2022</td>
      <td>22-Jun-2027</td>
    </tr>
    <tr>
      <td>RE6500HG</td>
      <td>LINKSYS 2x2 11AC RANGE EXTENDER WITH HIGH GAIN ANTENNA</td>
      <td>RE6500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>23-Jun-2022</td>
      <td>22-Jun-2027</td>
    </tr>
    <tr>
      <td>RE6500HG-AP</td>
      <td>LINKSYS 2x2 11AC RANGE EXTENDER WITH HIGH GAIN ANTENNA</td>
      <td>RE6500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>23-Jun-2022</td>
      <td>22-Jun-2027</td>
    </tr>
    <tr>
      <td>RE6500HG-FFP</td>
      <td>LINKSYS 2x2 11AC RANGE EXTENDER WITH HIGH GAIN ANTENNA</td>
      <td>RE6500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE6500HG-ME</td>
      <td>LINKSYS 2x2 11AC RANGE EXTENDER WITH HIGH GAIN ANTENNA</td>
      <td>RE6500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>RE6700</td>
      <td>LINKSYS RE6700 WIFI RANGE EXTENDER,AC1200,PT</td>
      <td>RE6700</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>23-Jun-2022</td>
      <td>22-Jun-2027</td>
    </tr>
    <tr>
      <td>RE6700-AU</td>
      <td>LINKSYS RE6700 WIFI RANGE EXTENDER,AC1200,PT</td>
      <td>RE6700</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>RE6700-CA</td>
      <td>LINKSYS RE6700 WIFI RANGE EXTENDER,AC1200,PT</td>
      <td>RE6700</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>RE6700-EF</td>
      <td>LINKSYS RE6700 WIFI RANGE EXTENDER,AC1200,PT</td>
      <td>RE6700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>RE6700-EG</td>
      <td>LINKSYS RE6700 WIFI RANGE EXTENDER,AC1200,PT</td>
      <td>RE6700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>23-Jun-2022</td>
      <td>22-Jun-2027</td>
    </tr>
    <tr>
      <td>RE6700-ME</td>
      <td>LINKSYS RE6700 WIFI RANGE EXTENDER,AC1200,PT</td>
      <td>RE6700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>23-Jun-2022</td>
      <td>22-Jun-2027</td>
    </tr>
    <tr>
      <td>RE6700-SG</td>
      <td>LINKSYS RE6700 WIFI RANGE EXTENDER,AC1200,PT</td>
      <td>RE6700</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>RE6700-UK</td>
      <td>LINKSYS RE6700 WIFI RANGE EXTENDER,AC1200,PT</td>
      <td>RE6700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>RE6800</td>
      <td>LINKSYS RE6800 WIFI RANGE EXTENDER, AC1750</td>
      <td>RE6800</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>RE7000</td>
      <td>LINKSYS RE7000 WIFI RANGE EXTENDER, AC1900+</td>
      <td>RE7000</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE7000-AH</td>
      <td>LINKSYS RE7000 WIFI RANGE EXTENDER,AC1900</td>
      <td>RE7000</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>23-Jun-2022</td>
      <td>22-Jun-2027</td>
    </tr>
    <tr>
      <td>RE7000-AMZ</td>
      <td>LINKSYS RE7000 WIFI RANGE EXTENDER, AC1900+</td>
      <td>RE7000</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE7000-AU</td>
      <td>LINKSYS RE7000 WIFI RANGE EXTENDER, AC1900+</td>
      <td>RE7000</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>RE7000-CA</td>
      <td>LINKSYS RE7000 WIFI RANGE EXTENDER, AC1900+</td>
      <td>RE7000</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE7000-EU</td>
      <td>LINKSYS RE7000 WIFI RANGE EXTENDER, AC1900+</td>
      <td>RE7000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>RE7000-ME</td>
      <td>LINKSYS RE7000 WIFI RANGE EXTENDER, AC1900+</td>
      <td>RE7000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>23-Jun-2022</td>
      <td>22-Jun-2027</td>
    </tr>
    <tr>
      <td>RE7000-UK</td>
      <td>LINKSYS RE7000 WIFI RANGE EXTENDER, AC1900+</td>
      <td>RE7000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>RE7310</td>
      <td>LINKSYS RE7310 WIFI RANGE EXTENDER, AX1800</td>
      <td>RE7310</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE7310-AMZ</td>
      <td>LINKSYS RE7310 WIFI RANGE EXTENDER, AX1800</td>
      <td>RE7310</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE9000</td>
      <td>LINKSYS RE9000 WIFI RANGE EXTENDER, AC3000</td>
      <td>RE9000</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>RE9000-AMZ</td>
      <td>LINKSYS RE9000 WIFI RANGE EXTENDER, AC3000</td>
      <td>RE9000</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>23-Jun-2022</td>
      <td>22-Jun-2027</td>
    </tr>
    <tr>
      <td>RE9000-CA</td>
      <td>LINKSYS RE9000 WIFI RANGE EXTENDER, AC3000</td>
      <td>RE9000</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>REK3000W-ME</td>
      <td>LINKSYS, 11N, 2x2, SINGLE BAND RANGE EXTENDER, TWIN PACK</td>
      <td>RE3000W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>18-Feb-2022</td>
      <td>17-Feb-2027</td>
    </tr>
    <tr>
      <td>SE2500-AU</td>
      <td>LINKSYS SE2500 WIRED SWITCH,5PORT,GIGABIT</td>
      <td>SE2500</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>11-Jun-2020</td>
      <td>10-Jun-2025</td>
    </tr>
    <tr>
      <td>SE2500-EU</td>
      <td>LINKSYS SE2500 WIRED SWITCH,5PORT,GIGABIT</td>
      <td>SE2500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>SE2500-ME</td>
      <td>LINKSYS SE2500 WIRED SWITCH,5PORT,GIGABIT</td>
      <td>SE2500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>SE2500-UK</td>
      <td>LINKSYS SE2500 WIRED SWITCH,5PORT,GIGABIT</td>
      <td>SE2500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>SE2800-AU</td>
      <td>LINKSYS SE2800 WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE2800</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>11-Jun-2020</td>
      <td>10-Jun-2025</td>
    </tr>
    <tr>
      <td>SE2800-EU</td>
      <td>LINKSYS SE2800 WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE2800</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>SE2800-ME</td>
      <td>LINKSYS SE2800 WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE2800</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>SE2800-UK</td>
      <td>LINKSYS SE2800 WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE2800</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>SE3016</td>
      <td>LINKSYS SE3016 WIRED SWITCH,16PORT,GIGABIT,METAL</td>
      <td>SE3016</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>SE3024</td>
      <td>LINKSYS SE3024 WIRED SWITCH,24PORT,GIGABIT,METAL</td>
      <td>SE3024</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>16-Dec-2020</td>
      <td>15-Dec-2025</td>
    </tr>
    <tr>
      <td>SE4008-AP</td>
      <td>LINKSYS SE4008 WRT WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE4008</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>SE4008-EJ</td>
      <td>LINKSYS SE4008 WRT WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE4008</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>SE4008-EK</td>
      <td>LINKSYS SE4008 WRT WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE4008</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>SE4008-ME</td>
      <td>LINKSYS SE4008 WRT WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE4008</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>SE4008-UK</td>
      <td>LINKSYS SE4008 WRT WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE4008</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>SPNMX85CF-UK</td>
      <td>LINKSYS VELOP MX8500 AX8400 1PK</td>
      <td>MX8500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>5-Dec-2022</td>
      <td>4-Dec-2027</td>
    </tr>
    <tr>
      <td>SPNMX85SF-UK</td>
      <td>LINKSYS VELOP MX8500 AX8400 1PK</td>
      <td>MX8500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>5-Dec-2022</td>
      <td>4-Dec-2027</td>
    </tr>
    <tr>
      <td>USB3GIG</td>
      <td>LINSKYS USB3GIG ETHERNET ADAPTER,GIGABIT</td>
      <td>USB3GIG</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>USB3GIG-EJ</td>
      <td>LINSKYS USB3GIG ETHERNET ADAPTER,GIGABIT</td>
      <td>USB3GIG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>USB3GIG-US</td>
      <td>LINSKYS USB3GIG ETHERNET ADAPTER,GIGABIT</td>
      <td>USB3GIG</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>VLP0101</td>
      <td>LINKSYS VELOP VLP0101 AC1200 1PK</td>
      <td>VLP01</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>VLP0101-EU</td>
      <td>LINKSYS VELOP VLP0101 AC1200 1PK</td>
      <td>VLP01</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>VLP0101-ME</td>
      <td>LINKSYS VELOP VLP0101 AC1200 1PK</td>
      <td>VLP01</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>VLP0101-UK</td>
      <td>LINKSYS VELOP VLP0101 AC1200 1PK</td>
      <td>VLP01</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>VLP0101B</td>
      <td>LINKSYS VELOP VLP0101B AC1200 1PK BLACK</td>
      <td>VLP01</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>WAP1200AC-ME</td>
      <td>LINKSYS WAP1200AC ACCESS POINT,AC1200</td>
      <td>WAP1200AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>WAP300N</td>
      <td>LINKSYS WAP300N WIFI ACCESS POINT,N300</td>
      <td>WAP300N</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>WAP300N-AP</td>
      <td>LINKSYS WAP300N WIFI ACCESS POINT,N300</td>
      <td>WAP300N</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>6-Aug-2019</td>
      <td>4-Aug-2024</td>
    </tr>
    <tr>
      <td>WAP300N-AR</td>
      <td>LINKSYS WAP300N WIFI ACCESS POINT,N300</td>
      <td>WAP300N</td>
      <td>Latin America and South America</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>WAP300N-CA</td>
      <td>LINKSYS WAP300N WIFI ACCESS POINT,N300</td>
      <td>WAP300N</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>WAP300N-EE</td>
      <td>LINKSYS WAP300N WIFI ACCESS POINT,N300</td>
      <td>WAP300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>WAP300N-EU</td>
      <td>LINKSYS WAP300N WIFI ACCESS POINT,N300</td>
      <td>WAP300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>WAP300N-LA</td>
      <td>LINKSYS WAP300N WIFI ACCESS POINT,N300</td>
      <td>WAP300N</td>
      <td>Latin America and South America</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>WAP300N-ME</td>
      <td>LINKSYS WAP300N WIFI ACCESS POINT,N300</td>
      <td>WAP300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>WAP300N-UK</td>
      <td>LINKSYS WAP300N WIFI ACCESS POINT,N300</td>
      <td>WAP300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Aug-2019</td>
      <td>10-Aug-2024</td>
    </tr>
    <tr>
      <td>WAP54GX-DE</td>
      <td>Wireless-G Access Point with SRX</td>
      <td>WAP54GX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>WAP54GX-FR</td>
      <td>Wireless-G Access Point with SRX</td>
      <td>WAP54GX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>WAP750AC-ME</td>
      <td>LINKSYS WAP750AC ACCESS POINT,AC750</td>
      <td>WAP750AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>WAPT1200AC-ME</td>
      <td>LINKSYS WAP1200AC ACCESS POINT,AC1200</td>
      <td>WAPT1200AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>WHA0301</td>
      <td>LINKSYS VELOP WALLMOUNT WHA0301 1 PK</td>
      <td>WHA0301</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHA0301-AMZ</td>
      <td>LINKSYS VELOP WALLMOUNT WHA0301 1 PK</td>
      <td>WHA0301</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>29-Jun-2022</td>
      <td>28-Jun-2027</td>
    </tr>
    <tr>
      <td>WHA0301B</td>
      <td>LINKSYS VELOP WHA0301B 1PK WALL MOUNT BRACKET</td>
      <td>WHA0301</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>29-Jul-2021</td>
      <td>28-Jul-2026</td>
    </tr>
    <tr>
      <td>WHW0101</td>
      <td>LINKSYS VELOP WHW0101 AC1300 1PK</td>
      <td>WHW01</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0101-1P-AMZ</td>
      <td>LINKSYS VELOP WHW0101 AC1300 1PK + WHW0101P</td>
      <td>WHW01</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>9-Aug-2021</td>
      <td>8-Aug-2026</td>
    </tr>
    <tr>
      <td>WHW0101-AH</td>
      <td>LINKSYS VELOP WHW0101 AC1300 1PK</td>
      <td>WHW01</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0101-AMZ</td>
      <td>LINKSYS VELOP WHW0101 AC1300 1PK</td>
      <td>WHW01</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>WHW0101-AU</td>
      <td>LINKSYS VELOP WHW0101 AC1300 1PK</td>
      <td>WHW01</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>WHW0101-CA</td>
      <td>LINKSYS VELOP WHW0101 AC1300 1PK</td>
      <td>WHW01</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0101-CN</td>
      <td>LINKSYS VELOP WHW0101 AC1300 1PK</td>
      <td>WHW01</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0101-DISH</td>
      <td>LINKSYS MESH ROUTER AC1300 VELOP NEW DB 1PK SHS</td>
      <td>WHW01</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>WHW0101-EU</td>
      <td>LINKSYS VELOP WHW0101 AC1300 1PK</td>
      <td>WHW01</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0101-JP</td>
      <td>LINKSYS VELOP WHW0101 AC1300 1PK</td>
      <td>WHW01</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0101-KR</td>
      <td>LINKSYS VELOP WHW0101 AC1300 1PK</td>
      <td>WHW01</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0101-ME</td>
      <td>LINKSYS VELOP WHW0101 AC1300 1PK</td>
      <td>WHW01</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0101-UK</td>
      <td>LINKSYS VELOP WHW0101 AC1300 1PK</td>
      <td>WHW01</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0101-WB</td>
      <td>LINKSYS VELOP JR 1-PACK BLANK BOX FOR SP</td>
      <td>WHW01</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>WHW0101CF-UK</td>
      <td>LINKSYS VELOP WHW0101 AC1300 1PK</td>
      <td>WHW01</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>4-Dec-2023</td>
      <td>2-Dec-2028</td>
    </tr>
    <tr>
      <td>WHW0101P</td>
      <td>LINKSYS VELOP PLUG-IN WHW0101P AC1300 1PK</td>
      <td>WHW01P</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>WHW0101P-AMZ</td>
      <td>LINKSYS VELOP PLUG-IN WHW0101P AC1300 1PK</td>
      <td>WHW01P</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0101P-CA</td>
      <td>LINKSYS VELOP PLUG-IN WHW0101P AC1300 1PK</td>
      <td>WHW01P</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>WHW0101P-DISH</td>
      <td>LINKSYS VELOP PLUG-IN WHW0101P AC1300, 1PK, DISH NETWORKS</td>
      <td>WHW01P</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>WHW0101P-EU</td>
      <td>LINKSYS VELOP PLUG-IN WHW0101P AC1300 1PK</td>
      <td>WHW01P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>WHW0101P-ME</td>
      <td>LINKSYS VELOP PLUG-IN WHW0101P AC1300 1PK</td>
      <td>WHW01P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>WHW0101P-UK</td>
      <td>LINKSYS VELOP PLUG-IN WHW0101P AC1300 1PK</td>
      <td>WHW01P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>WHW0101UV-CN</td>
      <td>LINKSYS VELOP JR WHW0101 AC1300 1PK</td>
      <td>WHW01</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>WHW03-VV</td>
      <td>LINKSYS VELOP WHW03 AC2200 1PK, VIVINT</td>
      <td>WHW03</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>WHW0301</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0301-AH</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0301-AMZ</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0301-AU</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>WHW0301-CA</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0301-CN</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0301-DISH</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK, DISH</td>
      <td>WHW03</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0301-EU</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0301-HK</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>WHW0301-JP</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0301-KR</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0301-ME</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>29-Aug-2022</td>
      <td>28-Aug-2027</td>
    </tr>
    <tr>
      <td>WHW0301-NL</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>4-Dec-2023</td>
      <td>2-Dec-2028</td>
    </tr>
    <tr>
      <td>WHW0301-UK</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>6-Nov-2023</td>
      <td>4-Nov-2028</td>
    </tr>
    <tr>
      <td>WHW0301B</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>22-Jan-2021</td>
      <td>21-Jan-2026</td>
    </tr>
    <tr>
      <td>WHW0301B-CA</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>WHW0301CF-UK</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>4-Dec-2023</td>
      <td>2-Dec-2028</td>
    </tr>
    <tr>
      <td>WHW0301GC-UK</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>4-Dec-2023</td>
      <td>2-Dec-2028</td>
    </tr>
    <tr>
      <td>WHW0301HB-UK</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>4-Dec-2023</td>
      <td>2-Dec-2028</td>
    </tr>
    <tr>
      <td>WHW0301PF-UK</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>4-Dec-2023</td>
      <td>2-Dec-2028</td>
    </tr>
    <tr>
      <td>WHW0301UV-CN</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>WHW0301YF-UK</td>
      <td>LINKSYS VELOP WHW0301 AC2200 1PK</td>
      <td>WHW03</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>WRT1200AC-AP</td>
      <td>LINKSYS WRT1200AC WIFI ROUTER,AC1200</td>
      <td>WRT1200AC</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>WRT1200AC-EU</td>
      <td>LINKSYS WRT1200AC WIFI ROUTER,AC1200</td>
      <td>WRT1200AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>WRT1200AC-ME</td>
      <td>LINKSYS WRT1200AC WIFI ROUTER,AC1200</td>
      <td>WRT1200AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>WRT1200AC-UK</td>
      <td>LINKSYS WRT1200AC WIFI ROUTER,AC1200</td>
      <td>WRT1200AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>WRT1900ACS</td>
      <td>LINKSYS WRT1900ACS WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>WRT1900ACS-AP</td>
      <td>LINKSYS WRT1900ACS WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>WRT1900ACS-AU</td>
      <td>LINKSYS WRT1900ACS WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>WRT1900ACS-CA</td>
      <td>LINKSYS WRT1900ACS WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>WRT1900ACS-EU</td>
      <td>LINKSYS WRT1900ACS WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>WRT1900ACS-ME</td>
      <td>LINKSYS WRT1900ACS WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>WRT1900ACS-UK</td>
      <td>LINKSYS WRT1900ACS WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>WRT3200ACM</td>
      <td>LINKSYS WRT3200ACM WIFI ROUTER DB 160MHZ MU-MIMO</td>
      <td>WRT3200ACM</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>WRT3200ACM-AMZ</td>
      <td>LINKSYS WRT3200ACM WIFI ROUTER DB 160MHZ MU-MIMO</td>
      <td>WRT3200ACM</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>WRT3200ACM-CA</td>
      <td>LINKSYS WRT3200ACM WIFI ROUTER DB 160MHZ MU-MIMO</td>
      <td>WRT3200ACM</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>WRT3200ACM-EU</td>
      <td>LINKSYS WRT3200ACM WIFI ROUTER DB 160MHZ MU-MIMO</td>
      <td>WRT3200ACM</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>WRT3200ACM-ME</td>
      <td>LINKSYS WRT3200ACM WIFI ROUTER DB 160MHZ MU-MIMO</td>
      <td>WRT3200ACM</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>WRT3200ACM-UK</td>
      <td>LINKSYS WRT3200ACM WIFI ROUTER DB 160MHZ MU-MIMO</td>
      <td>WRT3200ACM</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>WRT32X</td>
      <td>LINKSYS WRT32X WIFI ROUTER,AC3200</td>
      <td>WRT32X</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>WRT32X-AH</td>
      <td>LINKSYS WRT32X WIFI ROUTER,AC3200</td>
      <td>WRT32X</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>WRT32X-AU</td>
      <td>LINKSYS WRT32X WIFI ROUTER,AC3200</td>
      <td>WRT32X</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>WRT32X-CA</td>
      <td>LINKSYS WRT32X WIFI ROUTER,AC3200</td>
      <td>WRT32X</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>WRT32X-CN</td>
      <td>LINKSYS WRT32X WIFI ROUTER,AC3200</td>
      <td>WRT32X</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>WRT32X-EU</td>
      <td>LINKSYS WRT32X WIFI ROUTER,AC3200</td>
      <td>WRT32X</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>WRT32X-HK</td>
      <td>LINKSYS WRT32X WIFI ROUTER,AC3200</td>
      <td>WRT32X</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>WRT32X-ME</td>
      <td>LINKSYS WRT32X WIFI ROUTER,AC3200</td>
      <td>WRT32X</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>WRT32X-PLT</td>
      <td>LINKSYS WRT32X WIFI ROUTER,AC3200</td>
      <td>WRT32X</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>WRT32X-UK</td>
      <td>LINKSYS WRT32X WIFI ROUTER,AC3200</td>
      <td>WRT32X</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>15-Apr-2020</td>
      <td>14-Apr-2025</td>
    </tr>
    <tr>
      <td>WRT32XB</td>
      <td>LINKSYS WRT32X WIFI ROUTER,AC3200,XBOX</td>
      <td>WRT32XB</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>WRT54GL</td>
      <td>LINKSYS WRT54GL WIFI ROUTER,G</td>
      <td>WRT54GL</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>WRT54GL-ME</td>
      <td>LINKSYS WRT54GL WIFI ROUTER,G</td>
      <td>WRT54GL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>26-Aug-2019</td>
      <td>24-Aug-2024</td>
    </tr>
    <tr>
      <td>WUSB6100M</td>
      <td>LINKSYS WUSB6100M USB ADAPTER,AC600,MU-MIMO</td>
      <td>WUSB6100M</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>12-Oct-2023</td>
      <td>10-Oct-2028</td>
    </tr>
    <tr>
      <td>WUSB6100M-AS</td>
      <td>LINKSYS WUSB6100M WIFI USB ADAPTER,AC600,MU-MIMO</td>
      <td>WUSB6100M</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>WUSB6100M-CA</td>
      <td>LINKSYS WUSB6100M WIFI USB ADAPTER,AC600,MU-MIMO</td>
      <td>WUSB6100M</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>21-Sep-2022</td>
      <td>20-Sep-2027</td>
    </tr>
    <tr>
      <td>WUSB6100M-EU</td>
      <td>LINKSYS WUSB6100M WIFI USB ADAPTER,AC600,MU-MIMO</td>
      <td>WUSB6100M</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Jul-2021</td>
      <td>29-Jul-2026</td>
    </tr>
    <tr>
      <td>WUSB6100Mx</td>
      <td>LINKSYS WUSB6100M USB ADAPTER,AC600,MU-MIMO</td>
      <td>WUSB6100M</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>WUSB6300-AS</td>
      <td>LINKSYS WUSB6300 WIFI ADAPTER,AC1200</td>
      <td>WUSB6300</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>12-Oct-2023</td>
      <td>10-Oct-2028</td>
    </tr>
    <tr>
      <td>WUSB6300-EK</td>
      <td>LINKSYS WUSB6300 WIFI ADAPTER,AC1200</td>
      <td>WUSB6300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>10-Aug-2020</td>
      <td>9-Aug-2025</td>
    </tr>
    <tr>
      <td>WUSB6400M</td>
      <td>LINKSYS, WUSB6400M, USB ADAPTER, AC1200, MU-MIMO</td>
      <td>WUSB6400M</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>28-Jul-2021</td>
      <td>27-Jul-2026</td>
    </tr>
    <tr>
      <td>WUSB6400M-AS</td>
      <td>LINKSYS, WUSB6400M, USB ADAPTER, AC1200, MU-MIM</td>
      <td>WUSB6400M</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>19-Aug-2019</td>
      <td>17-Aug-2024</td>
    </tr>
    <tr>
      <td>WUSB6400M-CA</td>
      <td>LINKSYS, WUSB6400M, USB ADAPTER, AC1200, MU-MIMO</td>
      <td>WUSB6400M</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>WUSB6400M-EU</td>
      <td>LINKSYS, WUSB6400M, USB ADAPTER, AC1200, MU-MIMO</td>
      <td>WUSB6400M</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>12-Mar-2021</td>
      <td>11-Mar-2026</td>
    </tr>
    <tr>
      <td>X1000-ME</td>
      <td>LINKSYS X1000 MODEM ROUTER,DSL,N300</td>
      <td>X1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>13-Aug-2019</td>
      <td>11-Aug-2024</td>
    </tr>
    <tr>
      <td>X1000-UK</td>
      <td>LINKSYS X1000 MODEM ROUTER,DSL,N300</td>
      <td>X1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>13-Aug-2019</td>
      <td>11-Aug-2024</td>
    </tr>
    <tr>
      <td>X6200-AP</td>
      <td>LINKSYS X6200 MODEM ROUTER, VDSL, AC750</td>
      <td>X6200</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>13-Aug-2019</td>
      <td>11-Aug-2024</td>
    </tr>
    <tr>
      <td>X6200-AU</td>
      <td>LINKSYS X6200 MODEM ROUTER, VDSL, AC750</td>
      <td>X6200</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>13-Aug-2019</td>
      <td>11-Aug-2024</td>
    </tr>
    <tr>
      <td>X6200-EU</td>
      <td>LINKSYS X6200 MODEM ROUTER, VDSL, AC750</td>
      <td>X6200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>13-Aug-2019</td>
      <td>11-Aug-2024</td>
    </tr>
    <tr>
      <td>X6200-ME</td>
      <td>LINKSYS X6200 MODEM ROUTER, VDSL, AC750</td>
      <td>X6200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>13-Aug-2019</td>
      <td>11-Aug-2024</td>
    </tr>
    <tr>
      <td>X6200-UK</td>
      <td>LINKSYS X6200 MODEM ROUTER, VDSL, AC750</td>
      <td>X6200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>13-Aug-2019</td>
      <td>11-Aug-2024</td>
    </tr>
    <tr>
      <td>XAC1900-ME</td>
      <td>LINKSYS XAC1900 MODEM ROUTER,DSL,AC1900</td>
      <td>XAC1900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>13-Aug-2019</td>
      <td>11-Aug-2024</td>
    </tr>
    <tr>
      <td>2F2HST</td>
      <td>EtherFast II Hub 100BaseFX ST Module</td>
      <td>2F2HST</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>9BEFCMU10</td>
      <td>EFast Cable Modem with USB &amp; Ethernet Connection</td>
      <td>BEFCMU10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>9BEFW11S4-VN</td>
      <td>EFast WLess AP/Cable/DSLRtr w/4-Port Switch</td>
      <td>BEFW11S4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>9LNE100TX</td>
      <td>EtherFast 10/100 LAN Card</td>
      <td>LNE100TX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>9WAP11</td>
      <td>Wireless Network Access Point</td>
      <td>WAP11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>9WPC11</td>
      <td>Wireless Network PC Card</td>
      <td>WPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>9WPC11-VN</td>
      <td>Wireless Network PC Card (for Verizon)</td>
      <td>WPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>9WRT54G</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>9WRT54G-EU</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>9WUSB11</td>
      <td>Wireless USB Network Adapter</td>
      <td>WUSB11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>AC9SMA-EU</td>
      <td>Antenna Cable for R-SMA Connectors</td>
      <td>AC9SMA</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AC9TNC-EU</td>
      <td>Antenna Cable for R-TNC Connectors</td>
      <td>AC9TNC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>ACK65W710</td>
      <td>AC Smart Wifi Rtr and Universal Media Connect Kit</td>
      <td>ACK65W710</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>ADSL2MUE</td>
      <td>ADSL2 Modem with USB and Ethernet</td>
      <td>ADSL2MUE</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>ADSL2MUE-AS</td>
      <td>ADSL2 Modem with USB and Ethernet</td>
      <td>ADSL2MUE</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>ADSL2MUE-AU</td>
      <td>ADSL2 Modem with USB and Ethernet</td>
      <td>ADSL2MUE</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>ADSL2MUE-EU</td>
      <td>ADSL2 Modem with USB and Ethernet</td>
      <td>ADSL2MUE</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>ADSL2MUE-FR</td>
      <td>ADSL2 Modem with USB and Ethernet</td>
      <td>ADSL2MUE</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>ADSL2MUE-NZ</td>
      <td>ADSL2 Modem with USB and Ethernet</td>
      <td>ADSL2MUE</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>ADSL2MUE-SG</td>
      <td>ADSL2 Modem with USB and Ethernet</td>
      <td>ADSL2MUE</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>ADSL2MUE-UK</td>
      <td>ADSL2 Modem with USB and Ethernet</td>
      <td>ADSL2MUE</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>ADSLME1</td>
      <td>ADSL Ethernet Modem (with Q-Media Kit)</td>
      <td>ADSLME1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>ADSLME1Q</td>
      <td>ADSL Ethernet Modem (without Q-Media kit)</td>
      <td>ADSLME1Q</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>ADSLME3</td>
      <td>ADSL Ethernet Modem</td>
      <td>ADSLME3</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>ADSLMUE1</td>
      <td>ADSL External Modem (w/USB/Ethernet Bridged Port)</td>
      <td>ADSLMUE1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>ADSLMUE1-EL</td>
      <td>ADSL External Modem (w/USB/Ethernet Bridged Port)</td>
      <td>ADSLMUE1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>ADSLMUE1-ML</td>
      <td>ADSL External Modem (w/USB/Ethernet Bridged Port)</td>
      <td>ADSLMUE1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AE1000</td>
      <td>LINKSYS AE1000</td>
      <td>AE1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AE1000-4A</td>
      <td>LINKSYS AE1000</td>
      <td>AE1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AE1000-4T</td>
      <td>LINKSYS AE1000</td>
      <td>AE1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AE1000-AS</td>
      <td>LINKSYS AE1000</td>
      <td>AE1000</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AE1000-CA</td>
      <td>LINKSYS AE1000</td>
      <td>AE1000</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AE1000-EU</td>
      <td>LINKSYS AE1000</td>
      <td>AE1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AE1200</td>
      <td>LINKSYS AE1200 WIFI ADAPTER,N300</td>
      <td>AE1200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AE1200-AS</td>
      <td>LINKSYS AE1200 WIFI ADAPTER,N300</td>
      <td>AE1200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AE1200-EE</td>
      <td>LINKSYS AE1200 WIFI ADAPTER,N300</td>
      <td>AE1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AE1200-NT</td>
      <td>LINKSYS AE1200 WIFI ADAPTER,N300</td>
      <td>AE1200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AE2500</td>
      <td>LINKSYS AE2500 WIFI ADAPTER,N600</td>
      <td>AE2500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AE2500-AS</td>
      <td>LINKSYS AE2500 WIFI ADAPTER,N600</td>
      <td>AE2500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AE2500-CA</td>
      <td>LINKSYS AE2500 WIFI ADAPTER,N600</td>
      <td>AE2500</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AE2500-EE</td>
      <td>LINKSYS AE2500 WIFI ADAPTER,N600</td>
      <td>AE2500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AE2500-EU</td>
      <td>LINKSYS AE2500 WIFI ADAPTER,N600</td>
      <td>AE2500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AE2500-LA</td>
      <td>LINKSYS AE2500 WIFI ADAPTER,N600</td>
      <td>AE2500</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AE3000</td>
      <td>LINKSYS AE3000 WIFI ADAPTER,N900</td>
      <td>AE3000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AE3000-AS</td>
      <td>LINKSYS AE3000 WIFI ADAPTER,N900</td>
      <td>AE3000</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AE3000-CA</td>
      <td>LINKSYS AE3000 WIFI ADAPTER,N900</td>
      <td>AE3000</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AE3000-EE</td>
      <td>LINKSYS AE3000 WIFI ADAPTER,N900</td>
      <td>AE3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AE3000-EU</td>
      <td>LINKSYS AE3000 WIFI ADAPTER,N900</td>
      <td>AE3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AE6000-AS</td>
      <td>LINKSYS AE6000 WIFI ADAPTER,AC600</td>
      <td>AE6000</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AG041</td>
      <td>ADSL Gateway with 4-Port Switch</td>
      <td>AG041</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG041-AU</td>
      <td>ADSL Gateway with 4-Port Switch</td>
      <td>AG041</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG041-DE</td>
      <td>ADSL Gateway with 4-Port Switch</td>
      <td>AG041</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG041-E1</td>
      <td>ADSL Gateway with 4-Port Switch</td>
      <td>AG041</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG041-EU</td>
      <td>ADSL Gateway with 4-Port Switch</td>
      <td>AG041</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG041-FR</td>
      <td>ADSL Gateway with 4-Port Switch</td>
      <td>AG041</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG041-SE</td>
      <td>ADSL Gateway with 4-Port Switch</td>
      <td>AG041</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG041-UK</td>
      <td>ADSL Gateway with 4-Port Switch</td>
      <td>AG041</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG241</td>
      <td>ADSL2 Gateway with 4-Port Switch</td>
      <td>AG241</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG241-AS</td>
      <td>AG241-AS, ADSL2 Gateway with 4-Port Switch</td>
      <td>AG241</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG241-AU</td>
      <td>AG241-AU, ADSL2 Gateway with 4-Port Switch</td>
      <td>AG241</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG241-DE</td>
      <td>AG241-DE, ADSL2 Gateway with 4-Port Switch</td>
      <td>AG241</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG241-E1</td>
      <td>AG241-E1, ADSL2 Gateway with 4-Port Switch</td>
      <td>AG241</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG241-EU</td>
      <td>AG241-EU, ADSL2 Gateway with 4-Port Switch</td>
      <td>AG241</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG241-FR</td>
      <td>AG241-FR, ADSL2 Gateway with 4-Port Switch</td>
      <td>AG241</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG241-NZ</td>
      <td>AG241-NZ, ADSL2 Gateway with 4-Port Switch</td>
      <td>AG241</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG241-SG</td>
      <td>AG241-SG, ADSL2 Gateway with 4-Port Switch</td>
      <td>AG241</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG241-UK</td>
      <td>AG241-UK, ADSL2 Gateway with 4-Port Switch</td>
      <td>AG241</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG300</td>
      <td>ADSL Gateway</td>
      <td>AG300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AG300-9C</td>
      <td>ADSL Gateway</td>
      <td>AG300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG300-AU</td>
      <td>ADSL Gateway</td>
      <td>AG300</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG300-E2</td>
      <td>ADSL Gateway</td>
      <td>AG300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG300-E3</td>
      <td>ADSL Gateway (Annex B)</td>
      <td>AG300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG300-NZ</td>
      <td>ADSL Gateway</td>
      <td>AG300</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG300-U2</td>
      <td>ADSL Gateway</td>
      <td>AG300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG310-AU</td>
      <td>ADSL2+ Gateway with VoIP</td>
      <td>AG310</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG310-E2</td>
      <td>ADSL2+ Gateway with VoIP</td>
      <td>AG310</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG310-E3</td>
      <td>ADSL2+ Gateway with VoIP</td>
      <td>AG310</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG310-NA</td>
      <td>ADSL2+ Gateway with VoIP</td>
      <td>AG310</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AG310-S4</td>
      <td>ADSL2+ Gateway with VoIP</td>
      <td>AG310</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>AG310-U2</td>
      <td>ADSL2+ Gateway with VoIP</td>
      <td>AG310</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AM10</td>
      <td>Linksys AM10</td>
      <td>AM10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AM10-4A</td>
      <td>Linksys AM10</td>
      <td>AM10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AM10-4T</td>
      <td>Cisco AM10</td>
      <td>AM10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AM10-CA</td>
      <td>Cisco AM10</td>
      <td>AM10</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AM200</td>
      <td>ADSL Modem</td>
      <td>AM200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AM200-AU</td>
      <td>ADSL Modem</td>
      <td>AM200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AM200-EU</td>
      <td>ADSL Modem</td>
      <td>AM200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AM200-FR</td>
      <td>ADSL Modem</td>
      <td>AM200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AM200-UK</td>
      <td>ADSL Modem</td>
      <td>AM200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AM300</td>
      <td>ADSL Modem</td>
      <td>AM300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AM300-AS</td>
      <td>AM300-AS, ADSL2+ Modem</td>
      <td>AM300</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AM300-AU</td>
      <td>AM300-AU, ADSL2+ Modem</td>
      <td>AM300</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AM300-DE</td>
      <td>AM300-DE, ADSL2+ Modem</td>
      <td>AM300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AM300-E2</td>
      <td>ADSL Modem</td>
      <td>AM300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AM300-E3</td>
      <td>ADSL Modem</td>
      <td>AM300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AM300-NZ</td>
      <td>AM300-NZ, ADSL2+ Modem</td>
      <td>AM300</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AM300-S4</td>
      <td>ADSL Modem</td>
      <td>AM300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AM300-SG</td>
      <td>AM300-SG, ADSL2+ Modem</td>
      <td>AM300</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AM300-TH</td>
      <td>ADSL Modem</td>
      <td>AM300</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AM300-U2</td>
      <td>ADSL Modem</td>
      <td>AM300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>APM103</td>
      <td>LINKSYS ADSL2+ POWER MODEM, V1</td>
      <td>APM103</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>APM103-AU</td>
      <td>LINKSYS ADSL2+ POWER MODEM, V1, ANNEX A AU</td>
      <td>APM103</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>APM103-E1</td>
      <td>LINKSYS ADSL2+ POWER MODEM, V1, ANNEX B EU</td>
      <td>APM103</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>APM103-EU</td>
      <td>LINKSYS ADSL2+ POWER MODEM, V1, ANNEX A EU</td>
      <td>APM103</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>APM103-UK</td>
      <td>LINKSYS ADSL2+ POWER MODEM, V1, ANNEX A UK</td>
      <td>APM103</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>APM105</td>
      <td>LINKSYS ADSL2+ POWER MODEM, V1</td>
      <td>APM105</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>APM105-AU</td>
      <td>LINKSYS APM105 ADSL2+ POWER MODEM, V1, ANNEX A AU</td>
      <td>APM105</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>APM105-E1</td>
      <td>LINKSYS APM105 ADSL2+ POWER MODEM, V1, ANNEX B</td>
      <td>APM105</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>APM105-EU</td>
      <td>LINKSYS APM105 ADSL2+ POWER MODEM, V1, ANNEX A EU</td>
      <td>APM105</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>APM105-UK</td>
      <td>LINKSYS APM105 ADSL2+ POWER MODEM, V1, ANNEX A UK</td>
      <td>APM105</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AS1SMA</td>
      <td>Antenna Stand for SMA Connectors</td>
      <td>AS1SMA</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AS1SMA-EU</td>
      <td>Antenna Stand for SMA Connectors</td>
      <td>AS1SMA</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AS2TNC</td>
      <td>Antenna Stand for TNC Connectors</td>
      <td>AS2TNC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AS2TNC-EU</td>
      <td>Antenna Stand for TNC Connectors</td>
      <td>AS2TNC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AT-NT1210</td>
      <td>ATIVA N WRLESS USB ADPTR</td>
      <td>AT-NT1210</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>AT-NT1220</td>
      <td>ATIVA N WRLS NTBK CARD</td>
      <td>AT-NT1220</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>ATTWRP02</td>
      <td>BEFW11S4-AT + WPC11 3.0 + UTP510</td>
      <td>ATTWRP02</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>ATTWRU01</td>
      <td>BEFW11S4-AT + WUSB11 2.6 + UTP510</td>
      <td>ATTWRU01</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>AWGNA54</td>
      <td>ATIVA WIRELESS G NTBK CRD * 54Mbps 802.11g</td>
      <td>AWGNA54</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>AWGUA54</td>
      <td>ATIVA WIRELESS G USB ADPT * 802.11g</td>
      <td>AWGUA54</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>B2B109</td>
      <td>WIRELESS VIDEO DONGLE</td>
      <td>B2B109</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>B2N001eu</td>
      <td>ROUTER, TRAVEL, DUAL-BAND</td>
      <td>B2N001</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>B2N002eu</td>
      <td>USB,NIC,WIRELESS,N750 DUAL BAND</td>
      <td>B2N002</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>B2N003eu</td>
      <td>USB,NIC,MICRO,WIRELESS,N300</td>
      <td>B2N003</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>BA2LF</td>
      <td>ADSL In-line Phone Filter</td>
      <td>BA2LF</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BA2WF</td>
      <td>ADSL Wall-Mount Dual Phone Filter</td>
      <td>BA2WF</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFCMU10</td>
      <td>EtherFast Cable Modem w/USB &amp; Ethernet Connection</td>
      <td>BEFCMU10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFCMU10-4A</td>
      <td>EtherFast Cable Modem</td>
      <td>BEFCMU10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFCMU10-AS</td>
      <td>Cable Modem with USB and Ethernet Connections</td>
      <td>BEFCMU10</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>BEFCMU10-AU</td>
      <td>EFast Cable Modem with USB &amp; Ethernet Connection</td>
      <td>BEFCMU10</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFCMU10-CA</td>
      <td>EFast Cable Modem with USB &amp; Ethernet Connection</td>
      <td>BEFCMU10</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFCMU10-CK</td>
      <td>Cable Modem</td>
      <td>BEFCMU10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFCMU10-EU</td>
      <td>EFast Cable Modem w/USB &amp; Ethernet Connection (EU)</td>
      <td>BEFCMU10</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFCMU10-SG</td>
      <td>Cable Modem with USB and Ethernet Connections</td>
      <td>BEFCMU10</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>BEFCMU10-T1</td>
      <td>Cable Modem with USB and Ethernet Connections</td>
      <td>BEFCMU10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFCMU10-WM</td>
      <td>EtherFast Cable Modem w/USB &amp; Ethernet Connection</td>
      <td>BEFCMU10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFCMUH4</td>
      <td>Cable Modem + Rtr w/USB, Phoneline,/4-Port Switch</td>
      <td>BEFCMUH4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFCMUH4-00</td>
      <td>Cable Modem + Router with USB, &amp; 4-Port Switch</td>
      <td>BEFCMUH4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFCMUH4-01</td>
      <td>Cable Modem + Rtr with USB+ HPNA, &amp; 4-Port Switch</td>
      <td>BEFCMUH4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFCMUH4-02</td>
      <td>Cable Modem + Rtr with USB,/4-Port Switch w/ Card</td>
      <td>BEFCMUH4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFCMUH4-03</td>
      <td>Cable Modem/Rtr w/USB, Phone/4-Port Switch W/ Card</td>
      <td>BEFCMUH4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFCMUH4-CC</td>
      <td>Cable Gateway</td>
      <td>BEFCMUH4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFDSR41W</td>
      <td>ADSL Gateway</td>
      <td>BEFDSR41W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFDSR41W-E1</td>
      <td>Wireless ADSL Gateway</td>
      <td>BEFDSR41W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFDSR41W-EU</td>
      <td>ADSL Gateway</td>
      <td>BEFDSR41W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFDSR41W-F1</td>
      <td>Wireless ADSL Gateway</td>
      <td>BEFDSR41W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFDSR41W-FR</td>
      <td>ADSL Gateway</td>
      <td>BEFDSR41W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFDSR41W-TH</td>
      <td>ADSL Gateway</td>
      <td>BEFDSR41W</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFDSR41W-U1</td>
      <td>Wireless ADSL Gateway</td>
      <td>BEFDSR41W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFDSR41W-UK</td>
      <td>ADSL Gateway</td>
      <td>BEFDSR41W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFN2PE</td>
      <td>EFast Cable/DSL Voice Enabler-powered by Net2Phone</td>
      <td>BEFN2PE</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFN2PS4</td>
      <td>EFast Cable/DSL Voice Rtr (power by Net2Phone)</td>
      <td>BEFN2PS4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFN2PS4-CN</td>
      <td>EFast Cable/DSL Voice Rtr (power by Net2Phone)</td>
      <td>BEFN2PS4</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFN2PS4-EU</td>
      <td>EFast Cable/DSL Voice Rtr (power by Net2Phone)</td>
      <td>BEFN2PS4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFN2PS4-UK</td>
      <td>EFast Cable/DSL Voice Rtr (power by Net2Phone)</td>
      <td>BEFN2PS4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFS207</td>
      <td>EtherFast GigaDrive Cable/DSL Router</td>
      <td>BEFS207</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR11</td>
      <td>EtherFast Cable/DSL Rotuer</td>
      <td>BEFSR11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR11-CA</td>
      <td>EtherFast Cable/DSL Rotuer (Canada)</td>
      <td>BEFSR11</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR11-CN</td>
      <td>EtherFast Cable/DSL Rotuer</td>
      <td>BEFSR11</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR11-EU</td>
      <td>EtherFast Cable/DSL Router</td>
      <td>BEFSR11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR11-LA</td>
      <td>EtherFast Cable/DSL Rotuer</td>
      <td>BEFSR11</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR11-UK</td>
      <td>EtherFast Cable/DSL Router</td>
      <td>BEFSR11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41</td>
      <td>EFast Cable/DSL Rtr with 10/100 4-Port Switch</td>
      <td>BEFSR41</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41-4A</td>
      <td>EtherFast Broadband Router</td>
      <td>BEFSR41</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41-AS</td>
      <td>EtherFast Cable/DSL Router with 10/100 4-Port Swit</td>
      <td>BEFSR41</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>BEFSR41-AU</td>
      <td>EtherFast Cable/DSL Router with 4 port switch</td>
      <td>BEFSR41</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41-BP</td>
      <td>EFast Cable/DSL Rtr with 10/100 4-Port Switch</td>
      <td>BEFSR41</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41-CA</td>
      <td>EFast Cable/DSL Rtr with 10/100 4-Port Switch (CA)</td>
      <td>BEFSR41</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41-CN</td>
      <td>EFast Cable/DSL Rtr with 10/100 4-Port Switch</td>
      <td>BEFSR41</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41-CX</td>
      <td>EFast Cable/DSL Rtr with 10/100 4-Port Switch</td>
      <td>BEFSR41</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41-DE</td>
      <td>EFast Cable/DSL Rtr with 10/100 4-Port Switch</td>
      <td>BEFSR41</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41-EU</td>
      <td>EFast Cable/DSL Rtr with 10/100 4-Port Switch</td>
      <td>BEFSR41</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41-FR</td>
      <td>EFast Cable/DSL Rtr with 10/100 4-Port Switch</td>
      <td>BEFSR41</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41-JP</td>
      <td>EFast Cable/DSL Rtr with 10/100 4-Port Switch</td>
      <td>BEFSR41</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41-LA</td>
      <td>EFast Cable/DSL Rtr with 10/100 4-Port Switch</td>
      <td>BEFSR41</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41-SG</td>
      <td>EtherFast Cable/DSL Router with 10/100 4-Port Swit</td>
      <td>BEFSR41</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td>10-Oct-2017</td>
      <td>9-Oct-2022</td>
    </tr>
    <tr>
      <td>BEFSR41-UK</td>
      <td>EFast Cable/DSL Rtr with 10/100 4-Port Switch</td>
      <td>BEFSR41</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41-VN</td>
      <td>EFast Cable/DSL Rtr with 10/100 4-Port Switch (VZ)</td>
      <td>BEFSR41</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41-VZ</td>
      <td>EFast Cable/DSL Rtr w/10/100 4-Port Switch (VZ)</td>
      <td>BEFSR41</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41-WM</td>
      <td>EFast Cable/DSL Rtr with 10/100 4-Port Switch</td>
      <td>BEFSR41</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41C-JP</td>
      <td>FTTH/ADSL Firewall Router version 2</td>
      <td>BEFSR41C</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41W</td>
      <td>EFast Cable/DSL WLess-Ready Rtr with 4-port switch</td>
      <td>BEFSR41W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41W-AU</td>
      <td>EFast Cable/DSL WLess-Ready Rtr with 4-port switch</td>
      <td>BEFSR41W</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41W-CA</td>
      <td>EFast Cable/DSL WLess-Ready Rtr w/4-port switch</td>
      <td>BEFSR41W</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41W-EU</td>
      <td>EFast Cable/DSL WLess-Ready Rtr with 4-port switch</td>
      <td>BEFSR41W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41W-RN</td>
      <td>EFast Cable/DSL Ricochet-Ready Rtr w/4-port switch</td>
      <td>BEFSR41W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR41W-UK</td>
      <td>EFast Cable/DSL WLess-Ready Rtr with 4-port switch</td>
      <td>BEFSR41W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR81</td>
      <td>EFast Cable/DSL Rtr with 8-Port 10/100 Switch</td>
      <td>BEFSR81</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR81-AS</td>
      <td>EFast Cable/DSL Rtr with 10/100 8-Port Switch</td>
      <td>BEFSR81</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR81-AU</td>
      <td>EtherFast Cable/DSL Router with 8 port switch</td>
      <td>BEFSR81</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR81-CA</td>
      <td>EFast Cable/DSL Rtr w/8-Port 10/100 Switch (CA))</td>
      <td>BEFSR81</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR81-CN</td>
      <td>EFast Cable/DSL Rtr with 8-Port 10/100 Switch</td>
      <td>BEFSR81</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR81-EU</td>
      <td>EFast Cable/DSL Rtr with 10/100 8-Port Switch</td>
      <td>BEFSR81</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR81-LA</td>
      <td>EFast Cable/DSL Rtr with 8-Port 10/100 Switch</td>
      <td>BEFSR81</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR81-SG</td>
      <td>EFast Cable/DSL Rtr with 10/100 8-Port Switch</td>
      <td>BEFSR81</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR81-UK</td>
      <td>EFast Cable/DSL Rtr with 10/100 8-Port Switch</td>
      <td>BEFSR81</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR81-VN</td>
      <td>EFast Cable/DSL Rtr with 8-Port 10/100 Switch (VZ)</td>
      <td>BEFSR81</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSR81-VZ</td>
      <td>EFast Cable/DSL Rtr with 8-Port 10/100 Switch (VZ)</td>
      <td>BEFSR81</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSRU31</td>
      <td>EFast Cable/DSL Rtr with USB/3-Port 10/100 Switch</td>
      <td>BEFSRU31</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSRU31-EU</td>
      <td>EFast Cable/DSL Rtr with USB/3-Port 10/100 Switch</td>
      <td>BEFSRU31</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSRU31-UK</td>
      <td>EFast Cable/DSL Rtr with USB/3-Port 10/100 Switch</td>
      <td>BEFSRU31</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSX41</td>
      <td>EFast Cable/DSL Firewall Rtr-4-Port Switch/VPN</td>
      <td>BEFSX41</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSX41-AS</td>
      <td>EtherFast Cable/DSL Firewall Router (4-Port Switch</td>
      <td>BEFSX41</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td>10-Oct-2017</td>
      <td>9-Oct-2022</td>
    </tr>
    <tr>
      <td>BEFSX41-AU</td>
      <td>EtherFast Cable/DSL Firewall Router</td>
      <td>BEFSX41</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSX41-CA</td>
      <td>B9 EFast Cable/DSL Firewall Rtr- 4-Port Switch/VPN</td>
      <td>BEFSX41</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSX41-CN</td>
      <td>EFast Cable/DSL Firewall Rtr (4-Port Switch/VPN)</td>
      <td>BEFSX41</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSX41-DE</td>
      <td>EFast Cable/DSL Firewall Rtr (4-Port Switch/VPN)</td>
      <td>BEFSX41</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSX41-EU</td>
      <td>EFast Cable/DSL Firewall Rtr (4-Port Switch/VPN)</td>
      <td>BEFSX41</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSX41-FR</td>
      <td>EFast Cable/DSL Firewall Rtr (4-Port Switch/VPN)</td>
      <td>BEFSX41</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSX41-LA</td>
      <td>EFast Cable/DSL Firewall Rtr (4-Port Switch/VPN)</td>
      <td>BEFSX41</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFSX41-SG</td>
      <td>EtherFast Cable/DSL Firewall Router (4-Port Switch</td>
      <td>BEFSX41</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>BEFSX41-UK</td>
      <td>EFast Cable/DSL Firewall Rtr (4-Port Switch/VPN)</td>
      <td>BEFSX41</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFVP41</td>
      <td>EFast Cable/DSL VPN Rtr with 4-Port 10/100 Switch</td>
      <td>BEFVP41</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFVP41-AU</td>
      <td>EtherFast Cable/DSL VPN Router with 4 port switch</td>
      <td>BEFVP41</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFVP41-CA</td>
      <td>EFast Cable/DSL VPN Rtr with 4-Port 10/100 Switch</td>
      <td>BEFVP41</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFVP41-CN</td>
      <td>EFast Cable/DSL VPN Rtr with 4-Port 10/100 Switch</td>
      <td>BEFVP41</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFVP41-EU</td>
      <td>EFast Cable/DSL VPN Rtr with 4-Port 10/100 Switch</td>
      <td>BEFVP41</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFVP41-JP</td>
      <td>EFast Cable/DSL VPN Rtr with 4-Port 10/100 Switch</td>
      <td>BEFVP41</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFVP41-LA</td>
      <td>EFast Cable/DSL VPN Rtr with 4-Port 10/100 Switch</td>
      <td>BEFVP41</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFVP41-SG</td>
      <td>EFast Cable/DSL Firewall Rtr (4-Port Switch/VPN)</td>
      <td>BEFVP41</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>BEFVP41-UK</td>
      <td>EFast Cable/DSL VPN Rtr with 4-Port 10/100 Switch</td>
      <td>BEFVP41</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11P1</td>
      <td>EFast Wireless AP + Cable/DSL Rtr with PrintServer</td>
      <td>BEFW11P1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11P1-EU</td>
      <td>EFast Wireless AP + Cable/DSL Rtr with PrintServer</td>
      <td>BEFW11P1</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11P1-UK</td>
      <td>EFast Wireless AP + Cable/DSL Rtr with PrintServer</td>
      <td>BEFW11P1</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4</td>
      <td>EFast WLess AP + Cable/DSLRtr with 4-Port Switch</td>
      <td>BEFW11S4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-AT</td>
      <td>EFast WLess AP/Cable/DSLRtr w/4-Port Switch</td>
      <td>BEFW11S4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-AU</td>
      <td>Etherfast Wireless AP + Cable/DSL Router w/4 Port</td>
      <td>BEFW11S4</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-BG</td>
      <td>EFast WLess AP + Cable/DSLRtr with 4-Port Switch</td>
      <td>BEFW11S4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-BP</td>
      <td>EFast WLess AP + Cable/DSLRtr with 4-Port Switch</td>
      <td>BEFW11S4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-CA</td>
      <td>EFast WLess AP + Cable/DSLRtr w/4-Port Switch (CA)</td>
      <td>BEFW11S4</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-CB</td>
      <td>EFast WLess AP + Cable/DSLRtr with 4-Port Switch</td>
      <td>BEFW11S4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-CN</td>
      <td>EFast WLess AP + Cable/DSLRtr with 4-Port Switch</td>
      <td>BEFW11S4</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-CX</td>
      <td>EFast WLess AP + Cable/DSLRtr with 4-Port Switch</td>
      <td>BEFW11S4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-DE</td>
      <td>EFast WLess AP + Cable/DSLRtr with 4-Port Switch</td>
      <td>BEFW11S4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-EU</td>
      <td>EFast WLess AP + Cable/DSLRtr with 4-Port Switch</td>
      <td>BEFW11S4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-FR</td>
      <td>EFast WLess AP + Cable/DSLRtr with 4-Port Switch</td>
      <td>BEFW11S4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-KR</td>
      <td>Etherfast Wireless AP + Cable/DSL Router w/4 Port</td>
      <td>BEFW11S4</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-LA</td>
      <td>EFast WLess AP + Cable/DSLRtr with 4-Port Switch</td>
      <td>BEFW11S4</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-UK</td>
      <td>EFast WLess AP + Cable/DSLRtr with 4-Port Switch</td>
      <td>BEFW11S4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-VN</td>
      <td>EFast WLess AP/Cable/DSLRtr w/4-Port Switch</td>
      <td>BEFW11S4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-VZ</td>
      <td>EFast WLess AP/Cable/DSLRtr w/4-Port Switch</td>
      <td>BEFW11S4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BEFW11S4-WM</td>
      <td>EFast WLess AP + Cable/DSLRtr with 4-Port Switch</td>
      <td>BEFW11S4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>BR41U100M</td>
      <td>Broadband in a Box</td>
      <td>BR41U100M</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>CBRO-2005-01</td>
      <td>Linksys Corporate Brochure 2005</td>
      <td>PROMO</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>CCCMOBILE</td>
      <td>Cisco Connect Cloud Mobile</td>
      <td>CCCMOBILE</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>CCEAN</td>
      <td>Cisco Connect Express Android</td>
      <td>CCMOBILE</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CCEIOS</td>
      <td>Cisco Connect Express iOS</td>
      <td>CCMOBILE</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CCGAN</td>
      <td>Cisco Connect Gatekeeper Android</td>
      <td>CCMOBILE</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>CCGIOS</td>
      <td>Cisco Connect Gatekeeper iOS</td>
      <td>CCMOBILE</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CG2P2W</td>
      <td>Wireless-G Cable Gateway with 2 Phone Ports</td>
      <td>CG2P2W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CG2P2W-NA</td>
      <td>Wireless-G Cable Gateway with 2 Phone Ports</td>
      <td>CG2P2W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CG2P2WB</td>
      <td>WLess-G Cable Gateway w/2 Phone Ports/Batt Backup</td>
      <td>CG2P2WB</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CG7500</td>
      <td>LINKSYS CG7500 CABLE GATEWAY, AC1900, 24X8</td>
      <td>CG7500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td>24-Sep-2018</td>
      <td>23-Sep-2023</td>
    </tr>
    <tr>
      <td>CG8300</td>
      <td>LINKSYS CG8300 CABLE GATEWAY, AC2200, MU-MIMO,24X8</td>
      <td>CG8300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>CGV2W</td>
      <td>Wireless-G Cable Gateway with VPN</td>
      <td>CGV2W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIP200</td>
      <td>Cordless IP Phone</td>
      <td>CIP200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIP300-NA</td>
      <td>DECT Cordless Phone w/VoIP and Landline (NAM)</td>
      <td>CIP300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT200</td>
      <td>Cordelss Internet Telphone Kit</td>
      <td>CIT200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT200-AS</td>
      <td>Cordelss Internet Telphone Kit</td>
      <td>CIT200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT200-AU</td>
      <td>Cordelss Internet Telphone Kit</td>
      <td>CIT200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT200-EU</td>
      <td>Cordelss Internet Telphone Kit</td>
      <td>CIT200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT200-SG</td>
      <td>Cordelss Internet Telphone Kit</td>
      <td>CIT200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT200-TA</td>
      <td>Cordelss Internet Telphone Kit</td>
      <td>CIT200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT200-UK</td>
      <td>Cordelss Internet Telphone Kit</td>
      <td>CIT200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT300</td>
      <td>Dual-Mode Internet Telephony Kit</td>
      <td>CIT300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT300-AS</td>
      <td>Dual-Mode Internet Telephony Kit</td>
      <td>CIT300</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT300-AU</td>
      <td>Dual-Mode Internet Telephony Kit</td>
      <td>CIT300</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT300-EE</td>
      <td>Dual-Mode Internet Telephony Kit</td>
      <td>CIT300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT300-EN</td>
      <td>Dual-Mode Internet Telephony Kit</td>
      <td>CIT300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT300-EU</td>
      <td>Dual-Mode Internet Telephony Kit</td>
      <td>CIT300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT300-NA</td>
      <td>Dual-Mode Internet Telephony Kit</td>
      <td>CIT300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT300-SG</td>
      <td>Dual-Mode Internet Telephony Kit</td>
      <td>CIT300</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT300-UK</td>
      <td>Dual-Mode Internet Telephony Kit</td>
      <td>CIT300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT310</td>
      <td>DualMode CordlessPhone for Yahoo Messenger w/Voice</td>
      <td>CIT310</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT310-AS</td>
      <td>DualMode CordlessPhone for Yahoo Messenger w/Voice</td>
      <td>CIT310</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT310-AU</td>
      <td>DualMode CordlessPhone for Yahoo Messenger w/Voice</td>
      <td>CIT310</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>CIT310-EE</td>
      <td>DualMode Cordless for Yahoo! Messenger w/ Voice</td>
      <td>CIT310</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT310-EN</td>
      <td>DualMode Cordless for Yahoo! Messenger w/ Voice</td>
      <td>CIT310</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT310-NA</td>
      <td>DualMode Cordless for Yahoo! Messenger w/ Voice</td>
      <td>CIT310</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT310-SG</td>
      <td>DualMode CordlessPhone for Yahoo Messenger w/Voice</td>
      <td>CIT310</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT310-UK</td>
      <td>DualMode Cordless for Yahoo! Messenger w/ Voice</td>
      <td>CIT310</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT400</td>
      <td>DualMode Internet Telephony Kit w/Integrated Skype</td>
      <td>CIT400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT400-AS</td>
      <td>DualMode Internet Telephony Kit w/Integrated Skype</td>
      <td>CIT400</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT400-AU</td>
      <td>DualMode Internet Telephony Kit w/Integrated Skype</td>
      <td>CIT400</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT400-EE</td>
      <td>DualMode Internet Telephony Kit w/Integrated Skype</td>
      <td>CIT400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT400-EN</td>
      <td>DualMode Internet Telephony Kit w/Integrated Skype</td>
      <td>CIT400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT400-EU</td>
      <td>Dual-Mode Telephony Handset Accessory with Integra</td>
      <td>CIT400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>CIT400-KR</td>
      <td>DualMode Internet Telephony Kit w/Integrated Skype</td>
      <td>CIT400</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>CIT400-NA</td>
      <td>DualMode Internet Telephony Kit w/Integrated Skype</td>
      <td>CIT400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT400-SG</td>
      <td>DualMode Internet Telephony Kit w/Integrated Skype</td>
      <td>CIT400</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT400-TA</td>
      <td>DualMode Internet Telephony Kit w/Integrated Skype</td>
      <td>CIT400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT400-UK</td>
      <td>DualMode Internet Telephony Kit w/Integrated Skype</td>
      <td>CIT400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT400H</td>
      <td>CIT400 DualMode Expansion Handset w/Skype</td>
      <td>CIT400H</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CIT400H-EU</td>
      <td>CIT400 DualMode Expansion Handset w/Skype</td>
      <td>CIT400H</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CM100</td>
      <td>Cable Modem with USB and Ethernet Connections</td>
      <td>CM100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CM100-4A</td>
      <td>Cable Modem with USB and Ethernet Connections</td>
      <td>CM100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CM100-T1</td>
      <td>Cable Modem with USB and Ethernet Connections</td>
      <td>CM100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CM2P2</td>
      <td>Cable Modem with 2 Phone Ports</td>
      <td>CM2P2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CM2P2-NA</td>
      <td>Cable Modem with 2 Phone Ports</td>
      <td>CM2P2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CM2P2B</td>
      <td>Cable Modem with 2 Phone Ports and Battery Backup</td>
      <td>CM2P2B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CM2P2B-NA</td>
      <td>Cable Modem with 2 Phone Ports and Battery Backup</td>
      <td>CM2P2B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CM2P2E</td>
      <td>Cable Modem with 2 Phone Ports</td>
      <td>CM2P2E</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CM2P2E-CN</td>
      <td>Cable Modem with 2 Phone Ports</td>
      <td>CM2P2E</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CM3008x</td>
      <td>LINKSYS CM3008 MODEM,DOCSIS 3.0,8x4</td>
      <td>CM3008</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>CM3016</td>
      <td>LINKSYS CM3016 MODEM, DOCSIS 3.0, 16X4</td>
      <td>CM3016</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>CM3016SC-4T</td>
      <td>LINKSYS CM3016 MODEM,DOCSIS 3.0,16X4,W/ COAX CABLE</td>
      <td>CM3016</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>CMP200B-NA</td>
      <td>Cable Modem with 2 Phone Ports</td>
      <td>CMP200B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CMP300B</td>
      <td>CMP300B is a TI based eMTA with 1 battery</td>
      <td>CMP300B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>CMV2P</td>
      <td>Cable Modem with 2 Phone Ports</td>
      <td>CMV2P</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CPGIFT25-BU</td>
      <td>Consumer Product Gift Card, Best Buy $25</td>
      <td>E4200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>CRB300</td>
      <td>Carbonite We distribute license keys to end users</td>
      <td>CRB300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>CRG5810</td>
      <td>Coax LAN Cable (RG58), 10-Feet</td>
      <td>CRG5810</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CRG5825</td>
      <td>Coax LAN Cable (RG58), 25-Feet</td>
      <td>CRG5825</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>CXEBR10</td>
      <td>Coax to Ethernet Bridge</td>
      <td>CXEBR10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DBAG-2004-01</td>
      <td>Customize Document Bag</td>
      <td>DBAG-2004-01</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DCAS221</td>
      <td>Bidirectional Auto Switch, 2-to-1</td>
      <td>DCAS221</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DCASR12</td>
      <td>Reversible Bidirect 1/2 &amp; 2/1 AutoSwitch</td>
      <td>DCASR12</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMA2100</td>
      <td>Dual-Band Wireless-N Vista Media Extender</td>
      <td>DMA2100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMA2100-AU</td>
      <td>Dual-Band Wireless-N Vista Media Extender</td>
      <td>DMA2100</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMA2100-CA</td>
      <td>Dual-Band Wireless-N Vista Media Extender</td>
      <td>DMA2100</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMA2100-EU</td>
      <td>Dual-Band Wireless-N Vista Media Extender</td>
      <td>DMA2100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMA2100-SG</td>
      <td>Dual-Band Wireless-N Vista Media Extender</td>
      <td>DMA2100</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMA2100-UK</td>
      <td>Dual-Band Wireless-N Vista Media Extender</td>
      <td>DMA2100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMA2200</td>
      <td>DualBand WlessN Vista Media Extender w/CD/DVD</td>
      <td>DMA2200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMA2200-AU</td>
      <td>DualBand WlessN Vista Media Extender w/CD/DVD</td>
      <td>DMA2200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMA2200-CA</td>
      <td>DualBand WlessN Vista Media Extender w/CD/DVD</td>
      <td>DMA2200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMA2200-EU</td>
      <td>DualBand WlessN Vista Media Extender w/CD/DVD</td>
      <td>DMA2200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMA2200-PARENT</td>
      <td>Dual-Band Wireless-N Vista Media Extender with CD/</td>
      <td>DMA2200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>DMA2200-SG</td>
      <td>DualBand WlessN Vista Media Extender w/CD/DVD</td>
      <td>DMA2200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMA2200-UK</td>
      <td>DualBand WLess-N Vista Media Exten w/CD/DVD player</td>
      <td>DMA2200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMC250</td>
      <td>WLess Home Aud-Director-WlessN Music Player w/Amp</td>
      <td>DMC250</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMC250-AU</td>
      <td>Digital Media Controller 250</td>
      <td>DMC250</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMC250-CA</td>
      <td>WLessN Home Aud-Director-Music Player w/ Amp</td>
      <td>DMC250</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMC250-EU</td>
      <td>WLess Home Aud-Director-WlessN Music Player w/ Amp</td>
      <td>DMC250</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMC250-SG</td>
      <td>Digital Media Controller 250</td>
      <td>DMC250</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMC350</td>
      <td>WLess Home Aud-Conductor-WlessN Digital Music</td>
      <td>DMC350</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMC350-AU</td>
      <td>Digital Media Controller 350</td>
      <td>DMC350</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td>25-Mar-2015</td>
      <td>23-Mar-2020</td>
    </tr>
    <tr>
      <td>DMC350-CA</td>
      <td>WLessN Home Aud-Conductor-Digital Music Center</td>
      <td>DMC350</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMC350-EU</td>
      <td>WLess Home Aud-Conductor-WlessN Digital Music</td>
      <td>DMC350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMC350-SG</td>
      <td>Digital Media Controller 350</td>
      <td>DMC350</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td>25-Mar-2015</td>
      <td>23-Mar-2020</td>
    </tr>
    <tr>
      <td>DMP100</td>
      <td>WLess Home Audio - Player - WLess-N Music Extender</td>
      <td>DMP100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMP100-AU</td>
      <td>Digital Media Player 100</td>
      <td>DMP100</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMP100-CA</td>
      <td>WLess Home Audio - Player - WLess-N Music Extender</td>
      <td>DMP100</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMP100-EU</td>
      <td>WLess Home Aud-Player-WlessN Music Extender</td>
      <td>DMP100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMP100-SG</td>
      <td>Digital Media Player 100</td>
      <td>DMP100</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMR-IR500</td>
      <td>Digital Media Remote - IR</td>
      <td>DMR-IR500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMR-IR500-AU</td>
      <td>Digital Media Remote - IR</td>
      <td>DMR-IR500</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMR-IR500-CA</td>
      <td>Digital Media Remote - IR</td>
      <td>DMR-IR500</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMR-IR500-EU</td>
      <td>Digital Media Remote - IR</td>
      <td>DMR-IR500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMR-IR500-SG</td>
      <td>Digital Media Remote - IR</td>
      <td>DMR-IR500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMR-W1000</td>
      <td>Digital Media Remote - Wireless Display</td>
      <td>DMR-W1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMR-W1000-AU</td>
      <td>Digital Media Remote - Wireless Display</td>
      <td>DMR-W1000</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMR-W1000-CA</td>
      <td>Digital Media Remote - Wireless Display</td>
      <td>DMR-W1000</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMR-W1000-EU</td>
      <td>Digital Media Remote - Wireless Display</td>
      <td>DMR-W1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMR-W1000-SG</td>
      <td>Digital Media Remote - Wireless Display</td>
      <td>DMR-W1000</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMRIR500</td>
      <td>Wireless Home Audio - Remote Control</td>
      <td>DMRIR500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMRIR500-CA</td>
      <td>Wireless Home Audio - Remote Control</td>
      <td>DMRIR500</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMRIR500-EU</td>
      <td>Wireless Home Audio - Remote Control</td>
      <td>DMRIR500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMRW1000</td>
      <td>WLess Home Aud-Controller-WlessN Touchscreen Remot</td>
      <td>DMRW1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMRW1000-CA</td>
      <td>WLessN Home Aud-Controller-Touchscreen Remote</td>
      <td>DMRW1000</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMRW1000-EU</td>
      <td>WLess Home Aud-Controller-WlessN Touchscreen Remot</td>
      <td>DMRW1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMS620</td>
      <td>A/V Server/DVD-Player. HC ZUI, Ring remote</td>
      <td>DMS620</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMS620-EU</td>
      <td>A/V Server/DVD-Player. HC ZUI, Ring remote</td>
      <td>DMS620</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMSPK-50</td>
      <td>Digital Media System Speakers</td>
      <td>DMSPK-50</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMSPK-50-AU</td>
      <td>Digital Media System Speakers</td>
      <td>DMSPK-50</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMSPK-50-CA</td>
      <td>Digital Media System Speakers</td>
      <td>DMSPK-50</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMSPK-50-EU</td>
      <td>Digital Media System Speakers</td>
      <td>DMSPK-50</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMSPK-50-SG</td>
      <td>Digital Media System Speakers</td>
      <td>DMSPK-50</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMSPK50</td>
      <td>Wireless Home Audio - Stereo Speaker Kit</td>
      <td>DMSPK50</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DMSPK50-CA</td>
      <td>Wireless Home Audio - Stereo Speaker Kit</td>
      <td>DMSPK50</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DMSPK50-EU</td>
      <td>Wireless Home Audio - Stereo Speaker Kit</td>
      <td>DMSPK50</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP1000</td>
      <td>DVD and DivX Player</td>
      <td>DP1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DP1000-AU</td>
      <td>DVD and DivX Player</td>
      <td>DP1000</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP1000-EU</td>
      <td>DVD and DivX Player</td>
      <td>DP1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP1000-UK</td>
      <td>DVD and DivX Player</td>
      <td>DP1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP1100</td>
      <td>DVD and DivX Player w/High Resolution</td>
      <td>DP1100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DP1100-AU</td>
      <td>DVD and DivX Player with High Resolution</td>
      <td>DP1100</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP1100-EU</td>
      <td>DP-1100 EU, DVD and DivX Player with High R</td>
      <td>DP1100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP1100-UK</td>
      <td>DVD and DivX Player with High Resolution</td>
      <td>DP1100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP1500</td>
      <td>DVD and DivX Player w/Ethernet</td>
      <td>DP1500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DP1500-EU</td>
      <td>DVD Player with Ethernet</td>
      <td>DP1500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP1500-UK</td>
      <td>DVD Player with Ethernet</td>
      <td>DP1500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP1500CARD-EU</td>
      <td>DVD Player w/Enet and WLess w/802.11B Card</td>
      <td>DP1500CARD</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP1500CARD-UK</td>
      <td>DVD Player w/Ethernet and WLessw/802.11B Card</td>
      <td>DP1500CARD</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP1504</td>
      <td>DVD/DivX Playerw/40GB HDDand Ethernet</td>
      <td>DP1504</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DP1504-EU</td>
      <td>DVD Player with Ethernet and Wireless</td>
      <td>DP1504</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP1504-UK</td>
      <td>DVD Player with Ethernet and Wireless</td>
      <td>DP1504</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP330-EU</td>
      <td>KiSS DVD Player</td>
      <td>DP330</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP330-UK</td>
      <td>KiSS DVD Player</td>
      <td>DP330</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP450</td>
      <td>DVD and DivX Player for Refurb</td>
      <td>DP450</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DP450-EU</td>
      <td>DVD and DivX Player for Refurb</td>
      <td>DP450</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP450-UK</td>
      <td>DVD and DivX Player for Refurb</td>
      <td>DP450</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP470</td>
      <td>DVD Reciever and DivX player</td>
      <td>DP470</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DP470-AU</td>
      <td>DVD Recieverand DivX player</td>
      <td>DP470</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP470-EU</td>
      <td>DVD Reciever</td>
      <td>DP470</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP470-UK</td>
      <td>DVD Reciever</td>
      <td>DP470</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP470-US</td>
      <td>DVD Receiver</td>
      <td>DP470</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP500</td>
      <td>DVD and DivX Player w/Ethernet for Refurb</td>
      <td>DP500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DP500-EU</td>
      <td>DVD and DivX Player with Ethernet for Refurb</td>
      <td>DP500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP500-UK</td>
      <td>DVD and DivX Player with Ethernet for Refurb</td>
      <td>DP500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP508</td>
      <td>DVD and DivX Player w/80GB HDD and Ethernet</td>
      <td>DP508</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DP508-EU</td>
      <td>DVD and DivX Player w/HDD and Ethernet for Refurb</td>
      <td>DP508</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP508-UK</td>
      <td>DVD and DivX Player w/HDD and Ethernet for Refurb</td>
      <td>DP508</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP558080</td>
      <td>Harddisk Recorder 80GB HDD w/DVD Player</td>
      <td>DP558080</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DP558080-AU</td>
      <td>Harddisk Recorder 80GB HDD w/Ethernetand DVD</td>
      <td>DP558080</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP558080-EU</td>
      <td>Harddisk Recorder 80GB HDD w/Enet and DVD Player</td>
      <td>DP558080</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP558080-UK</td>
      <td>Harddisk Recorder 80GB HDD w/Enet/DVD Player</td>
      <td>DP558080</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP558160</td>
      <td>Harddisk Recorder 160GB HDD w/DVD Player</td>
      <td>DP558160</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DP558160-AU</td>
      <td>Harddisk Recorder 160GB HDD w/DVD Player/ Enet</td>
      <td>DP558160</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP558160-EU</td>
      <td>Harddisk Recorder 160GB HDD w/DVD Player/ Enet</td>
      <td>DP558160</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP558160-UK</td>
      <td>Harddisk Recorder 160GB HDD w/DVD and Ethernet</td>
      <td>DP558160</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP558200</td>
      <td>HDD Recorder 200GB HDD w/DVD Player and Ethernet</td>
      <td>DP558200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DP558200-AU</td>
      <td>Harddisk Recorder 200GB w/Ethernet and DVD Player</td>
      <td>DP558200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP558200-EU</td>
      <td>Harddisk Recorder 200GB HDD w/Enet/DVD Player</td>
      <td>DP558200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP558200-UK</td>
      <td>Harddisk Recorder 200GB HDD w/Ethernet and DVD</td>
      <td>DP558200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP600</td>
      <td>High Def Media Player w DVD Player, Ethernet/Wless</td>
      <td>DP600</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DP600-AU</td>
      <td>High Def Media Player w/Ethernet and WLessG/DVD</td>
      <td>DP600</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP600-EU</td>
      <td>High Def Media Player w/Ethernet and WLessG/DVD</td>
      <td>DP600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP600-UK</td>
      <td>High Def Media Player w/Ethernet and WLessG/DVD</td>
      <td>DP600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP600-US</td>
      <td>High Def Media Player w/Ethernet and WLessG/DVD</td>
      <td>DP600</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP600NHC-AU</td>
      <td>High Def Mediaw/ENet andWLessG/DVD w/o HDMI</td>
      <td>DP600NHC</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP600NHC-EU</td>
      <td>High Def Mediaw/ENet andWLessG/DVD w/o HDMI</td>
      <td>DP600NHC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP600NHC-UK</td>
      <td>High Def Mediaw/ENet andWLessG/DVD w/o HDMI</td>
      <td>DP600NHC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP600NHC-US</td>
      <td>High Def Mediaw/ENet andWLessG/DVD w/o HDMI</td>
      <td>DP600NHC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP608</td>
      <td>High Def. Media Player w/DVD, Eth/WLessG w/HDD</td>
      <td>DP608</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DP608-EU</td>
      <td>High Def Media Player w/ 160GB HDD, Enet and WLess</td>
      <td>DP608</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DP608-UK</td>
      <td>High Def Media Player w/ 160GB HDD, Enet and WLess</td>
      <td>DP608</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DPC3008</td>
      <td>LINKSYS DPC3008 MODEM,DOCSIS 3.0,8x4</td>
      <td>DPC3008</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DPC3008-CC</td>
      <td>LINKSYS DPC3008 MODEM,DOCSIS 3.0,8x4</td>
      <td>DPC3008</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DPC3008-G1</td>
      <td>LINKSYS DPC3008 MODEM,DOCSIS 3.0,8x4</td>
      <td>DPC3008</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSGukGMRT-4A</td>
      <td>ADSL ROUTER W/MODEM * 802.11g</td>
      <td>DSG-GMRT</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSGukGUSB</td>
      <td>WIRELESS USB ADAPTER * 802.11g</td>
      <td>DSG-GUSB</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSGukNMRT-4A</td>
      <td>N WIRELESS MODEM ROUTER</td>
      <td>DSG-NMRT</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSGukNUSB</td>
      <td>N WIRELESS USB ADAPTER</td>
      <td>DSG-NUSB</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSHFXSC</td>
      <td>StackPro II 100BaseFX Distance Extender Module</td>
      <td>DSHFXSC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSHFXST</td>
      <td>StackPro II 100BaseFX Distance Extender Module</td>
      <td>DSHFXST</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSHSNMP</td>
      <td>StackPro II SNMP Module</td>
      <td>DSHSNMP</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSHUB16</td>
      <td>StackPro II Dual-Speed 16-Port Hub</td>
      <td>DSHUB16</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSHUB16-EU</td>
      <td>StackPro II Dual-Speed 16-Port Hub</td>
      <td>DSHUB16</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSHUB16-UK</td>
      <td>StackPro II Dual-Speed 16-Port Hub</td>
      <td>DSHUB16</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSHUB24</td>
      <td>StackPro II Dual-Speed 24-Port Hub</td>
      <td>DSHUB24</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSHUB24-EU</td>
      <td>StackPro II Dual-Speed 24-Port Hub</td>
      <td>DSHUB24</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSHUB24-UK</td>
      <td>StackPro II Dual-Speed 24-Port Hub</td>
      <td>DSHUB24</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSSX12</td>
      <td>EtherFast 10/100 12-Port Swtich</td>
      <td>DSSX12</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSSX12-UK</td>
      <td>EtherFast 10/100 12-Port Swtich</td>
      <td>DSSX12</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSSX16</td>
      <td>EtherFast 10/100 16-Port Swtich</td>
      <td>DSSX16</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSSX16-EU</td>
      <td>EtherFast 10/100 16-Port Swtich</td>
      <td>DSSX16</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSSX16-UK</td>
      <td>EtherFast 10/100 16-Port Switch</td>
      <td>DSSX16</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSSX16E</td>
      <td>EtherFast 10/100 16-Port Expandable Switch</td>
      <td>DSSX16E</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSSX16E-UK</td>
      <td>EtherFast 10/100 16-Port Expandable Switch</td>
      <td>DSSX16E</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSSX24</td>
      <td>EtherFast 10/100 24-Port Switch</td>
      <td>DSSX24</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSSX24-UK</td>
      <td>EtherFast 10/100 24-Port Switch</td>
      <td>DSSX24</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSSX2C2</td>
      <td>DSSX Module, 2 100TX &amp; 100FX-SC</td>
      <td>DSSX2C2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSSX2T2</td>
      <td>DSSX Module, 2 100TX &amp; 100FX-ST</td>
      <td>DSSX2T2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSSX4FC</td>
      <td>DSSX16E Module, 4-Port 100FX-SC</td>
      <td>DSSX4FC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSSX4FT</td>
      <td>DSSX4FT Module, 4-Port 100FX-ST</td>
      <td>DSSX4FT</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSSX4TX</td>
      <td>DSSX4TX Module, 4-Port 100TX</td>
      <td>DSSX4TX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSSXFXSC</td>
      <td>DSSX Module 1-Port 100FX-SC</td>
      <td>DSSXFXSC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DSSXFXST</td>
      <td>DSSX Module 1-Port 100FX-SG</td>
      <td>DSSXFXST</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DX-BGDTC</td>
      <td>DYNEX G DESKTOP CARD * 54Mbps 802.11g</td>
      <td>DX-BGDTC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DX-BNBC</td>
      <td>DYNEX NOTEBOOK CARD * 54Mbps 802.11g</td>
      <td>DX-BNBC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DX-BUSB</td>
      <td>WIRELESS USB ADAPTER * 802.11g</td>
      <td>DX-BUSB</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DX-MBGDTC</td>
      <td>DYNEX G DESKTOP CARD * 54Mbps 802.11g</td>
      <td>DX-BGDTC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DX-MBNBC</td>
      <td>DYNEX NOTEBOOK CARD * 54Mbps 802.11g</td>
      <td>DX-BNBC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DX-MBUSB</td>
      <td>WIRELESS USB ADAPTER * 802.11g</td>
      <td>DX-BUSB</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DX-MEBDTC</td>
      <td>DYNEX G+ DESKTOP CARD * 125Mbps 802.11g</td>
      <td>DX-EBDTC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DX-MEBNBC</td>
      <td>DYNEX G+ NOTEBOOK CARD * 125Mbps 802.11g</td>
      <td>DX-EBNBC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DX-MEBUSB</td>
      <td>DYNEX G+ USB ADAPTER * 125Mbps 802.11g</td>
      <td>DX-EBUSB</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>DX-NNBC</td>
      <td>DYNEX N NOTEBOOK CARD</td>
      <td>DX-NNBC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>DX-NUSB</td>
      <td>DYNEX N WIRELSS USB ADPTR</td>
      <td>DX-NUSB</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>E1000</td>
      <td>Linksys E1000</td>
      <td>E1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1000-4A</td>
      <td>Linksys E1000</td>
      <td>E1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1000-4T</td>
      <td>Linksys E1000</td>
      <td>E1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1000-AP</td>
      <td>Linksys E1000</td>
      <td>E1000</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1000-AU</td>
      <td>Linksys E1000</td>
      <td>E1000</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1000-CA</td>
      <td>Linksys E1000</td>
      <td>E1000</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1000-CE</td>
      <td>Linksys E1000-CE</td>
      <td>E1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1000-DE</td>
      <td>Linksys E1000</td>
      <td>E1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1000-EE</td>
      <td>Linksys E1000</td>
      <td>E1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1000-EN</td>
      <td>Linksys E1000</td>
      <td>E1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1000-EW</td>
      <td>Linksys E1000</td>
      <td>E1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1000-EZ</td>
      <td>Linksys E1000</td>
      <td>E1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1000-IP</td>
      <td>Linksys E1000</td>
      <td>E1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1000-ME</td>
      <td>Linksys E1000</td>
      <td>E1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1000-UK</td>
      <td>Linksys E1000</td>
      <td>E1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1200</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300</td>
      <td>E1200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1200-AU</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300</td>
      <td>E1200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1200-BR</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300</td>
      <td>E1200</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E1200-M2</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300</td>
      <td>E1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E1200-NT</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300</td>
      <td>E1200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E1200-RU</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300</td>
      <td>E1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E1200-VV</td>
      <td>LINKSYS E1200 WIFI ROUTER,N300, VIVINT</td>
      <td>E1200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E1500</td>
      <td>Wireless-N Router with SpeedBoost</td>
      <td>E1500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1500-AP</td>
      <td>Wireless-N Router with SpeedBoost</td>
      <td>E1500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1500-AR</td>
      <td>Wireless-N Router with SpeedBoost</td>
      <td>E1500</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1500-AU</td>
      <td>Wireless-N Router with SpeedBoost</td>
      <td>E1500</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1500-BR</td>
      <td>Wireless-N Router with SpeedBoost</td>
      <td>E1500</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E1500-CA</td>
      <td>Wireless-N Router with SpeedBoost</td>
      <td>E1500</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1500-EE</td>
      <td>Wireless-N Router with SpeedBoost</td>
      <td>E1500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1500-EN</td>
      <td>Wireless-N Router with SpeedBoost</td>
      <td>E1500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1500-EW</td>
      <td>Wireless-N Router with SpeedBoost</td>
      <td>E1500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1500-EZ</td>
      <td>Wireless-N Router with SpeedBoost</td>
      <td>E1500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1500-LA</td>
      <td>Wireless-N Router with SpeedBoost</td>
      <td>E1500</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1500-ME</td>
      <td>Wireless-N Router with SpeedBoost</td>
      <td>E1500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1500-PC</td>
      <td>Wireless-N Router with SpeedBoost, PCCW, Hong Kong</td>
      <td>E1500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1500-UK</td>
      <td>Wireless-N Router with SpeedBoost</td>
      <td>E1500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1500L</td>
      <td>Linksys E1500L</td>
      <td>E2100L</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1550</td>
      <td>Wireless-N Router with SpeedBoost (BBY Exclusive)</td>
      <td>E1550</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1550-CA</td>
      <td>Wireless-N Router with SpeedBoost</td>
      <td>E1550</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1550-ET</td>
      <td>Wireless-N Router with SpeedBoost</td>
      <td>E1550</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E1700</td>
      <td>LINKSYS E1700 WIFI ROUTER,N300,GIGABIT</td>
      <td>E1700</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E1700-FFP</td>
      <td>LINKSYS E1700 WIFI ROUTER,N300,GIGABIT</td>
      <td>E1700</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E2000</td>
      <td>Linksys E2000</td>
      <td>E2000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2000-4A</td>
      <td>Linksys E2000</td>
      <td>E2000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2000-AP</td>
      <td>Linksys E2000</td>
      <td>E2000</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2000-AU</td>
      <td>Linksys E2000</td>
      <td>E2000</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2000-CA</td>
      <td>Linksys E2000</td>
      <td>E2000</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2000-CE</td>
      <td>Linksys E2000-CE</td>
      <td>E2000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2000-DE</td>
      <td>Linksys E2000</td>
      <td>E2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2000-EE</td>
      <td>Linksys E2000</td>
      <td>E2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2000-EN</td>
      <td>Linksys E2000</td>
      <td>E2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2000-EW</td>
      <td>Linksys E2000</td>
      <td>E2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2000-EZ</td>
      <td>Linksys E2000</td>
      <td>E2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2000-ME</td>
      <td>Linksys E2000</td>
      <td>E2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2000-UK</td>
      <td>Linksys E2000</td>
      <td>E2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2100L</td>
      <td>Linksys E2100L</td>
      <td>E2100L</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2500</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2500-AU</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2500-BR</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E2500-FFP</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2500-FS</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2500-M2</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E2500-RU</td>
      <td>LINKSYS E2500 WIFI ROUTER,N600</td>
      <td>E2500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E2700</td>
      <td>Advanced Dual-Band N Router with Gigabit</td>
      <td>E2700</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2700-4A</td>
      <td>Advanced Dual-Band N Router with Gigabit</td>
      <td>E2700</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2700-AP</td>
      <td>Advanced Dual-Band N Router with Gigabit</td>
      <td>E2700</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2700-AU</td>
      <td>Advanced Dual-Band N Router with Gigabit</td>
      <td>E2700</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2700-CA</td>
      <td>Advanced Dual-Band N Router with Gigabit</td>
      <td>E2700</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2700-EE</td>
      <td>Advanced Dual-Band N Router with Gigabit</td>
      <td>E2700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2700-EN</td>
      <td>Advanced Dual-Band N Router with Gigabit</td>
      <td>E2700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2700-EW</td>
      <td>Advanced Dual-Band N Router with Gigabit</td>
      <td>E2700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2700-EZ</td>
      <td>Advanced Dual-Band N Router with Gigabit</td>
      <td>E2700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2700-ME</td>
      <td>Advanced Dual-Band N Router with Gigabit</td>
      <td>E2700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2700-QQ</td>
      <td>Advanced Dual-Band N Router with Gigabit</td>
      <td>E2700</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E2700-UK</td>
      <td>Advanced Dual-Band N Router with Gigabit</td>
      <td>E2700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E2D3500</td>
      <td>POWERLINE AV500</td>
      <td>E2D3500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>E3000</td>
      <td>Linksys E3000</td>
      <td>E3000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3000-4A</td>
      <td>Linksys E3000</td>
      <td>E3000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3000-AP</td>
      <td>Linksys E3000</td>
      <td>E3000</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3000-AU</td>
      <td>Linksys E3000</td>
      <td>E3000</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3000-CA</td>
      <td>Linksys E3000</td>
      <td>E3000</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3000-CE</td>
      <td>Linksys E3000-CE</td>
      <td>E3000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3000-DE</td>
      <td>Linksys E3000</td>
      <td>E3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3000-EE</td>
      <td>Linksys E3000</td>
      <td>E3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3000-EN</td>
      <td>Linksys E3000</td>
      <td>E3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3000-EW</td>
      <td>Linksys E3000</td>
      <td>E3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3000-EZ</td>
      <td>Linksys E3000</td>
      <td>E3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3000-KR</td>
      <td>Linksys E3000</td>
      <td>E3000</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E3000-ME</td>
      <td>Linksys E3000</td>
      <td>E3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3000-UK</td>
      <td>Linksys E3000</td>
      <td>E3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3200</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3200-4A</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3200-AP</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3200-AU</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3200-CA</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3200-EE</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3200-EN</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3200-EW</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3200-EZ</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3200-ME</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3200-UK</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3500</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3500-4A</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3500-AP</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3500-AU</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3500</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3500-CA</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3500</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3500-EE</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3500-EN</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3500-EW</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3500-EZ</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3500-ME</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E3500-UK</td>
      <td>High Performance Dual-Band N Router</td>
      <td>E3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200-4A</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200-4T</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200-AP</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200-AU</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200-CA</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200-DE</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200-EB</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200-EE</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200-EN</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200-EW</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200-EZ</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200-GF</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E4200-GO</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200-GU</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E4200-ME</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200-UK</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200V2</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200V2-CA</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4200V2-NP</td>
      <td>MAXIMUM PERFORMANCE DUAL-BAND N ROUTER</td>
      <td>E4200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4500</td>
      <td>Dual-Band N900 Router with Gigabit and USB</td>
      <td>E4500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4500-4A</td>
      <td>Dual-Band N900 Router with Gigabit and USB</td>
      <td>E4500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4500-AP</td>
      <td>Dual-Band N900 Router with Gigabit and USB</td>
      <td>E4500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4500-AU</td>
      <td>Dual-Band N900 Router with Gigabit and USB</td>
      <td>E4500</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4500-CA</td>
      <td>Dual-Band N900 Router with Gigabit and USB</td>
      <td>E4500</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4500-EE</td>
      <td>Dual-Band N900 Router with Gigabit and USB</td>
      <td>E4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4500-EN</td>
      <td>Dual-Band N900 Router with Gigabit and USB</td>
      <td>E4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4500-EW</td>
      <td>Dual-Band N900 Router with Gigabit and USB</td>
      <td>E4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4500-EZ</td>
      <td>Dual-Band N900 Router with Gigabit and USB</td>
      <td>E4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4500-ME</td>
      <td>Dual-Band N900 Router with Gigabit and USB</td>
      <td>E4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4500-UK</td>
      <td>Dual-Band N900 Router with Gigabit and USB</td>
      <td>E4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E4G0500</td>
      <td>5-PORT NETWORK SWITCH * NEW ENCLOSURE</td>
      <td>E4G0500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>E4G0510</td>
      <td>5-PORT GIGABIT SWITCH</td>
      <td>E4G0510</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>E4G0800</td>
      <td>8-PORT NETWORK SWITCH * NEW ENCLOSURE</td>
      <td>E4G0800</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>E4G0810</td>
      <td>8-PORT GIGABIT SWITCH</td>
      <td>E4G0810</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>E5750-AH</td>
      <td>LINKSYS E5750 DUAL-BAND MESH WIFI 6 ROUTER, AX5400</td>
      <td>E5750</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>21-Nov-2023</td>
    </tr>
    <tr>
      <td>E5750-CN</td>
      <td>LINKSYS E5750 DUAL-BAND MESH WIFI 6 ROUTER, AX5400</td>
      <td>E5750</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>21-Nov-2023</td>
    </tr>
    <tr>
      <td>E5750-HK</td>
      <td>LINKSYS E5750 DUAL-BAND MESH WIFI 6 ROUTER, AX5400</td>
      <td>E5750</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>21-Nov-2023</td>
    </tr>
    <tr>
      <td>E6200</td>
      <td>Linksys E6200, High Performance DualBand Rtr AC750</td>
      <td>E6200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E6200-4A</td>
      <td>Linksys E6200, High Performance DualBand Rtr AC750</td>
      <td>E6200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E6200-AP</td>
      <td>Linksys E6200, High Performance DualBand Rtr AC750</td>
      <td>E6200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E6200-AR</td>
      <td>Linksys E6200, High Performance DualBand Rtr AC750</td>
      <td>E6200</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E6200-AU</td>
      <td>Linksys E6200, High Performance DualBand Rtr AC750</td>
      <td>E6200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E6200-BR</td>
      <td>Linksys E6200, High Performance DualBand Rtr AC750</td>
      <td>E6200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E6200-CA</td>
      <td>Linksys E6200, High Performance DualBand Rtr AC750</td>
      <td>E6200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E6200-CE</td>
      <td>Linksys E6200, High Performance DualBand Rtr AC750</td>
      <td>E6200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E6200-EE</td>
      <td>Linksys E6200, High Performance DualBand Rtr AC750</td>
      <td>E6200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E6200-EN</td>
      <td>Linksys E6200, High Performance DualBand Rtr AC750</td>
      <td>E6200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E6200-EW</td>
      <td>Linksys E6200, High Performance DualBand Rtr AC750</td>
      <td>E6200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E6200-M2</td>
      <td>Linksys E6200, High Performance DualBand Rtr AC750</td>
      <td>E6200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E6200-ME</td>
      <td>Linksys E6200, High Performance DualBand Rtr AC750</td>
      <td>E6200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E6200-UK</td>
      <td>Linksys E6200, High Performance DualBand Rtr AC750</td>
      <td>E6200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E800</td>
      <td>Linksys, E800, Wi-Fi Router N150</td>
      <td>E800</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>E800-4A</td>
      <td>Linksys, E800, Wi-Fi Router N150</td>
      <td>E800</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E8350-AP</td>
      <td>LINKSYS E8350 WIFI ROUTER,AC2400</td>
      <td>E8350</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E8350-EJ</td>
      <td>LINKSYS E8350 WIFI ROUTER,AC2400</td>
      <td>E8350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E8350-EK</td>
      <td>LINKSYS E8350 WIFI ROUTER,AC2400</td>
      <td>E8350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E8350-UK</td>
      <td>LINKSYS E8350 WIFI ROUTER,AC2400</td>
      <td>E8350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E900</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E900-AP</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E900-AU</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E900-BR</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E900-CA</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E900-EN</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E900-EW</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E900-EZ</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E900-FM</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>E900-IP</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E900-RU</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E900-SVO</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E900-T2</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E900-T3</td>
      <td>LINKSYS E900 WIFI ROUTER,N300</td>
      <td>E900</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E9L1500</td>
      <td>USB,NIC,WIRELESS,N150</td>
      <td>E9L1500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>E9L3000</td>
      <td>USB,NIC,WIRELESS,N300</td>
      <td>E9L3000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>E9L6000</td>
      <td>USB,NIC,WIRELESS,N600 DUAL BAND</td>
      <td>E9L6000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>E9L7500</td>
      <td>USB,NIC,WIRELESS,N750 DUAL BAND</td>
      <td>E9L7500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EA2700</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA2700-AP</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA2700-AR</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA2700-AU</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA2700-BR</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA2700-CA</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA2700-CE</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA2700-EE</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA2700-EN</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA2700-ET</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA2700-EW</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA2700-EZ</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA2700-HE</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA2700-M2</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA2700-ME</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA2700-NT4</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA2700-OQ</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA2700-QT</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA2700-TV4</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA2700-UK</td>
      <td>LINKSYS EA2700 WIFI ROUTER,N600,GIGABIT</td>
      <td>EA2700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA2750-CA</td>
      <td>LINKSYS, EA2750-CA, DUAL-BAND N600 ROUTER WITH GIGABIT</td>
      <td>EA2750</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA2750-EJ</td>
      <td>LINKSYS, EA2750 DUAL-BAND N600 ROUTER WITH GIGABIT</td>
      <td>EA2750</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA2750-EK</td>
      <td>LINKSYS, EA2750 DUAL-BAND N600 ROUTER WITH GIGABIT</td>
      <td>EA2750</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA2750-PH</td>
      <td>LINKSYS, EA2750 DUAL-BAND N600 ROUTER WITH GIGABIT</td>
      <td>EA2750</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA2750-UK</td>
      <td>LINKSYS, EA2750 DUAL-BAND N600 ROUTER WITH GIGABIT</td>
      <td>EA2750</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA3500</td>
      <td>LINKSYS EA3500 WIFI ROUTER,N750</td>
      <td>EA3500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA3500-AP</td>
      <td>LINKSYS EA3500 WIFI ROUTER,N750</td>
      <td>EA3500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA3500-AU</td>
      <td>LINKSYS EA3500 WIFI ROUTER,N750</td>
      <td>EA3500</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA3500-CA</td>
      <td>LINKSYS EA3500 WIFI ROUTER,N750</td>
      <td>EA3500</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA3500-CE</td>
      <td>LINKSYS EA3500 WIFI ROUTER,N750</td>
      <td>EA3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA3500-EE</td>
      <td>LINKSYS EA3500 WIFI ROUTER,N750</td>
      <td>EA3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA3500-EN</td>
      <td>LINKSYS EA3500 WIFI ROUTER,N750</td>
      <td>EA3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA3500-EW</td>
      <td>LINKSYS EA3500 WIFI ROUTER,N750</td>
      <td>EA3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA3500-EZ</td>
      <td>LINKSYS EA3500 WIFI ROUTER,N750</td>
      <td>EA3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA3500-FFP</td>
      <td>LINKSYS EA3500 WIFI ROUTER,N750</td>
      <td>EA3500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA3500-M2</td>
      <td>LINKSYS EA3500 WIFI ROUTER,N750</td>
      <td>EA3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA3500-ME</td>
      <td>LINKSYS EA3500 WIFI ROUTER,N750</td>
      <td>EA3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA3500-UK</td>
      <td>LINKSYS EA3500 WIFI ROUTER,N750</td>
      <td>EA3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA3500-WM</td>
      <td>LINKSYS EA3500 WIFI ROUTER,N750</td>
      <td>EA3500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA4500</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA4500-AU</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA4500-BR</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA4500-CA</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA4500-CE</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA4500-EE</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA4500-EN</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA4500-EW</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA4500-EZ</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA4500-GF</td>
      <td>DUAL BAND N900 ROUTER WITH GIGABIT</td>
      <td>EA4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td>10-Oct-2017</td>
      <td>9-Oct-2022</td>
    </tr>
    <tr>
      <td>EA4500-GO</td>
      <td>Dual-Band N900 Router with Gigabit and USB</td>
      <td>EA4500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td>30-May-2017</td>
      <td>29-May-2022</td>
    </tr>
    <tr>
      <td>EA4500-GU</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA4500-M2</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA4500-ME</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA4500-NT</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA4500-OQ</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA4500-PH</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA4500-QT</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA4500-TG</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA4500-UK</td>
      <td>LINKSYS EA4500 WIFI ROUTER,N900</td>
      <td>EA4500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6100-EJ</td>
      <td>LINKSYS EA6100 WIFI ROUTER,AC1200,FE</td>
      <td>EA6100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6100-FFP</td>
      <td>LINKSYS EA6100 WIFI ROUTER,AC1200,FE</td>
      <td>EA6100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6100-TG</td>
      <td>LINKSYS EA6100 WIFI ROUTER,AC1200,FE</td>
      <td>EA6100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6100-TG2</td>
      <td>LINKSYS EA6100 WIFI ROUTER,AC1200,FE</td>
      <td>EA6100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6100-UK</td>
      <td>LINKSYS EA6100 WIFI ROUTER,AC1200,FE</td>
      <td>EA6100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200-4A</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200-AP</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6200-AR</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200-AU</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200-BR</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200-CA</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6200-CA-PLT</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200-CC</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200-CE</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200-EE</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200-EJ</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200-EK</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200-EN</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200-EW</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200-EZ</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200-M2</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200-ME</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6200-NT</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6200-UK</td>
      <td>LINKSYS EA6200 WIFI ROUTER,AC900</td>
      <td>EA6200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6300</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6300-4A</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6300-AP</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6300-AR</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6300-AU</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6300-BR</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6300-CA</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6300-CA-PLT</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6300-CE</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6300-EE</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6300-EJ</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6300-EK</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6300-EN</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6300-EW</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6300-EZ</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6300-HE</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6300-LA</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6300-M2</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6300-ME</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6300-NT</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6300-UK</td>
      <td>LINKSYS EA6300 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6350-EK</td>
      <td>LINKSYS, EA6350, SMART WI-FI ROUTER AC1200</td>
      <td>EA6350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6350-FFP</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6350-HK</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6350-ID</td>
      <td>LINKSYS EA6350 WIFI ROUTER,AC1200,GIGABIT</td>
      <td>EA6350</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6400-AU</td>
      <td>LINKSYS EA6400 WIFI ROUTER,AC1600</td>
      <td>EA6400</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6400-CE</td>
      <td>LINKSYS EA6400 WIFI ROUTER,AC1600</td>
      <td>EA6400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6400-EE</td>
      <td>LINKSYS EA6400 WIFI ROUTER,AC1600</td>
      <td>EA6400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6400-EN</td>
      <td>LINKSYS EA6400 WIFI ROUTER,AC1600</td>
      <td>EA6400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6400-EW</td>
      <td>LINKSYS EA6400 WIFI ROUTER,AC1600</td>
      <td>EA6400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6400-EZ</td>
      <td>LINKSYS EA6400 WIFI ROUTER,AC1600</td>
      <td>EA6400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6400-M2</td>
      <td>LINKSYS EA6400 WIFI ROUTER,AC1600</td>
      <td>EA6400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6400-ME</td>
      <td>LINKSYS EA6400 WIFI ROUTER,AC1600</td>
      <td>EA6400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6400-NT</td>
      <td>LINKSYS EA6400 WIFI ROUTER,AC1600</td>
      <td>EA6400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6400-UK</td>
      <td>LINKSYS EA6400 WIFI ROUTER,AC1600</td>
      <td>EA6400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6460-CA</td>
      <td>AC1600 SMART Wi-Fi RRT/AC580 MINI USB ADAPTER</td>
      <td>EA6460</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6500</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6500-AP</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6500-AU</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6500-BBY</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6500-CA-PLT</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6500-CA2</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6500-CC</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6500-CE</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6500-EE</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6500-EN</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6500-EW</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6500-EZ</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6500-HE</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6500-M2</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6500-ME</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6500-TG</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6500-UK</td>
      <td>LINKSYS EA6500 WIFI ROUTER,AC1750</td>
      <td>EA6500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6700</td>
      <td>LINKSYS EA6700 WIFI ROUTER,AC1750</td>
      <td>EA6700</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6700-AP</td>
      <td>LINKSYS EA6700 WIFI ROUTER,AC1750</td>
      <td>EA6700</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6700-AU</td>
      <td>LINKSYS EA6700 WIFI ROUTER,AC1750</td>
      <td>EA6700</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6700-CE</td>
      <td>LINKSYS EA6700 WIFI ROUTER,AC1750</td>
      <td>EA6700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6700-EE</td>
      <td>LINKSYS EA6700 WIFI ROUTER,AC1750</td>
      <td>EA6700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6700-EW</td>
      <td>LINKSYS EA6700 WIFI ROUTER,AC1750</td>
      <td>EA6700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6700-M2</td>
      <td>LINKSYS EA6700 WIFI ROUTER,AC1750</td>
      <td>EA6700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6700-ME</td>
      <td>LINKSYS EA6700 WIFI ROUTER,AC1750</td>
      <td>EA6700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6700-UK</td>
      <td>LINKSYS EA6700 WIFI ROUTER,AC1750</td>
      <td>EA6700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6900-EK</td>
      <td>LINKSYS EA6900 WIFI ROUTER,AC1900</td>
      <td>EA6900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6900-FFP</td>
      <td>LINKSYS EA6900 WIFI ROUTER,AC1900</td>
      <td>EA6900</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA6900-NT</td>
      <td>LINKSYS EA6900 WIFI ROUTER,AC1900</td>
      <td>EA6900</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6900-TG</td>
      <td>LINKSYS EA6900 WIFI ROUTER,AC1900</td>
      <td>EA6900</td>
      <td>USA</td>
      <td>End of Support</td>
      <td>11-Jul-2018</td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA6900-TG2</td>
      <td>LINKSYS EA6900 WIFI ROUTER,AC1900</td>
      <td>EA6900</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA7300-AH</td>
      <td>LINKSYS EA7300 WIFI ROUTER,AC1750,MU-MIMO</td>
      <td>EA7300</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA7500-AU</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA7500x-UK</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA8300-AU</td>
      <td>LINKSYS EA8300 WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>EA8300</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA8500-AP</td>
      <td>LINKSYS EA8500 WIFI ROUTER,AC2600,MU-MIMO</td>
      <td>EA8500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA8500-AU</td>
      <td>LINKSYS EA8500 WIFI ROUTER,AC2600,MU-MIMO</td>
      <td>EA8500</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA8500-PH</td>
      <td>LINKSYS EA8500 WIFI ROUTER,AC2600,MU-MIMO</td>
      <td>EA8500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA9200</td>
      <td>LINKSYS EA9200 WIFI ROUTER,AC3200,TB</td>
      <td>EA9200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA9200-4U</td>
      <td>LINKSYS EA9200 WIFI ROUTER,AC3200,TB</td>
      <td>EA9200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA9200-AU</td>
      <td>LINKSYS EA9200 WIFI ROUTER,AC3200,TB</td>
      <td>EA9200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA9200-CA</td>
      <td>LINKSYS EA9200 WIFI ROUTER,AC3200,TB</td>
      <td>EA9200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA9200-EU</td>
      <td>LINKSYS EA9200 WIFI ROUTER,AC3200,TB</td>
      <td>EA9200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA9200-HK</td>
      <td>LINKSYS EA9200 WIFI ROUTER,AC3200,TB</td>
      <td>EA9200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA9200-ME</td>
      <td>LINKSYS EA9200 WIFI ROUTER,AC3200,TB</td>
      <td>EA9200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA9200-UK</td>
      <td>LINKSYS EA9200 WIFI ROUTER,AC3200,TB</td>
      <td>EA9200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EA9300-EU</td>
      <td>LINKSYS EA9300 WI-FI ROUTER, TB, AC4000, MU-MIMO</td>
      <td>EA9300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA9300-ME</td>
      <td>LINKSYS EA9300 WI-FI ROUTER, TB, AC4000, MU-MIMO</td>
      <td>EA9300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA9300-UK</td>
      <td>LINKSYS EA9300 WI-FI ROUTER, TB, AC4000, MU-MIMO</td>
      <td>EA9300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA9400</td>
      <td>LINKSYS EA9400 WI-FI ROUTER, AC5000, MU-MIMO</td>
      <td>EA9400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EA9400-B1</td>
      <td>LINKSYS EA9400 WI-FI ROUTER, AC5000, MU-MIMO</td>
      <td>EA9400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EC1000</td>
      <td>Gigabit ExpressCard Adapter</td>
      <td>EC1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EC1000-EU</td>
      <td>Gigabit ExpressCard Adapter</td>
      <td>EC1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EC10T</td>
      <td>Integrated Ethernet PC Card</td>
      <td>EC10T</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EC2T</td>
      <td>Combo PCMCIA Ethernet LAN Card; BNC//RJ-45 Ports</td>
      <td>EC2T</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EC2T-CA</td>
      <td>Combo PCMCIA Ethernet LAN Card; BNC//RJ-45 Ports</td>
      <td>EC2T</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EC2T-CARD</td>
      <td>Combo PCMCIA Ethernet LAN Card; BNC//RJ-45 Ports</td>
      <td>EC2T</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EEHUB16</td>
      <td>Enterprise Ethernet 16-port Hub</td>
      <td>EEHUB16</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF1324</td>
      <td>EFast Lyr 3 Mgmt 24-Port 10/100/2-Port Giga Switch</td>
      <td>EF1324</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF1324-EU</td>
      <td>EFast Lyr 3 Mgmt 24-Port 10/100/2-Port Giga Switch</td>
      <td>EF1324</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF1324-UK</td>
      <td>EFast Lyr 3 Mgmt 24-Port 10/100/2-Port Giga Switch</td>
      <td>EF1324</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF1704</td>
      <td>EtherFast 1704 Gigabit Ethernet Switch</td>
      <td>EF1704</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF1704-EU</td>
      <td>EtherFast 1704 Gigabit Ethernet Switch</td>
      <td>EF1704</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF1704-UK</td>
      <td>EtherFast 1704 Gigabit Ethernet Switch</td>
      <td>EF1704</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF24G2</td>
      <td>EtherFast Dual Gigabit with 24-Port 10/100 Switch</td>
      <td>EF24G2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF24G2-AU</td>
      <td>EtherFast Dual Gigabit with 24-Port 10/100 Switch</td>
      <td>EF24G2</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF24G2-EU</td>
      <td>EtherFast Dual Gigabit with 24-Port 10/100 Switch</td>
      <td>EF24G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF24G2M-EU</td>
      <td>EtherFast Managed 24-Port with Dual Gigabit Switch</td>
      <td>EF24G2M</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF24G2M-UK</td>
      <td>EtherFast Managed 24-Port with Dual Gigabit Switch</td>
      <td>EF24G2M</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF2H16</td>
      <td>EtherFast II 10/100 16-Port Hub</td>
      <td>EF2H16</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF2H16-EU</td>
      <td>EtherFast II 10/100 16-Port Hub</td>
      <td>EF2H16</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF2H16-UK</td>
      <td>EtherFast II 10/100 16-Port Hub</td>
      <td>EF2H16</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF2H24</td>
      <td>EtherFast II 10/100 24-Port Hub</td>
      <td>EF2H24</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF2H24-EU</td>
      <td>EtherFast II 10/100 24-Port Hub</td>
      <td>EF2H24</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF2H24-UK</td>
      <td>EtherFast II 10/100 24-Port Hub</td>
      <td>EF2H24</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF2HSC</td>
      <td>EtherFast II Hub 100BaseFX SC Module</td>
      <td>EF2HSC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF2HSC-EU</td>
      <td>EtherFast II Hub 100BaseFX SC Module</td>
      <td>EF2HSC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF2HST</td>
      <td>EtherFast II Hub 100BaseFX ST Module</td>
      <td>EF2HST</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF2S16</td>
      <td>EtherFast II 10/100 16-Port Switch</td>
      <td>EF2S16</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF2S16-EU</td>
      <td>EtherFast II 16-Port 10/100 Switch</td>
      <td>EF2S16</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF2S16-UK</td>
      <td>EtherFast II 16-Port 10/100 Switch</td>
      <td>EF2S16</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF2S24</td>
      <td>EtherFast II 10/100 24-Port Switch</td>
      <td>EF2S24</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF2S24-AU</td>
      <td>EtherFast II 10/100 24-Port Switch</td>
      <td>EF2S24</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>EF2S24-EU</td>
      <td>EtherFast II 24-Port 10/100 Switch</td>
      <td>EF2S24</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF2S24-UK</td>
      <td>EtherFast II 24-Port 10/100 Switch</td>
      <td>EF2S24</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF2SSC</td>
      <td>EtherFast II Switch 100BaseFX SC Module</td>
      <td>EF2SSC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF2SST</td>
      <td>EtherFast II Switch 100BaseFX ST Module</td>
      <td>EF2SST</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3116</td>
      <td>EtherFast 3116 16-Port 10/100 Ethernet Switch</td>
      <td>EF3116</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3116-AS</td>
      <td>EtherFast 3116 16-Port 10/100 Ethernet Switch</td>
      <td>EF3116</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EF3116-AU</td>
      <td>EtherFast 3116 16-Port 10/100 Ethernet Switch</td>
      <td>EF3116</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3116-EU</td>
      <td>EtherFast 3116 16-Port 10/100 Ethernet Switch</td>
      <td>EF3116</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3116-KR</td>
      <td>EtherFast 3116 16-Port 10/100 Ethernet Switch</td>
      <td>EF3116</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3116-SG</td>
      <td>EtherFast 3116 16-Port 10/100 Ethernet Switch</td>
      <td>EF3116</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EF3116-TH</td>
      <td>EtherFast 3116 16-Port 10/100 Ethernet Switch</td>
      <td>EF3116</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3116-UK</td>
      <td>EtherFast 3116 16-Port 10/100 Ethernet Switch</td>
      <td>EF3116</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3124</td>
      <td>EtherFast 3124 24-Port 10/100 Ethernet Switch</td>
      <td>EF3124</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3124-AS</td>
      <td>EtherFast 3124 24-Port 10/100 Ethernet Switch</td>
      <td>EF3124</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EF3124-AU</td>
      <td>EtherFast 3124 24-Port 10/100 Ethernet Switch</td>
      <td>EF3124</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3124-EU</td>
      <td>EtherFast 3124 24-Port 10/100 Ethernet Switch</td>
      <td>EF3124</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3124-KR</td>
      <td>EtherFast 3124 24-Port 10/100 Ethernet Switch</td>
      <td>EF3124</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3124-UK</td>
      <td>EtherFast 3124 24-Port 10/100 Ethernet Switch</td>
      <td>EF3124</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF31SC</td>
      <td>100BaseFX SC Fiber Module</td>
      <td>EF31SC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF31ST</td>
      <td>100BaseFX ST Fiber Module</td>
      <td>EF31ST</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3508</td>
      <td>EtherFast 3508 8-Port Gigabit Ethernet Switch</td>
      <td>EF3508</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3508-EU</td>
      <td>EtherFast 3508 8-Port Gigabit Ethernet Switch</td>
      <td>EF3508</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3508-UK</td>
      <td>EtherFast 3508 8-Port Gigabit Ethernet Switch</td>
      <td>EF3508</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3512</td>
      <td>EtherFast 3512 12-Port Gigabit Ethernet Switch</td>
      <td>EF3512</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3512-EU</td>
      <td>EtherFast 3512 12-Port Gigabit Ethernet Switch</td>
      <td>EF3512</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF3512-UK</td>
      <td>EtherFast 3512 12-Port Gigabit Ethernet Switch</td>
      <td>EF3512</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF4116</td>
      <td>EtherFast 4116 16-Port 10/100 Ethernet Switch</td>
      <td>EF4116</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF4116-AS</td>
      <td>EtherFast 4116 16-Port 10/100 Ethernet Switch</td>
      <td>EF4116</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EF4116-AU</td>
      <td>EtherFast 4116 16-Port 10/100 Ethernet Switch</td>
      <td>EF4116</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF4116-CA</td>
      <td>EtherFast 4116 16-Port 10/100 Ethernet Switch</td>
      <td>EF4116</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF4116-EU</td>
      <td>EtherFast 4116 16-Port 10/100 Ethernet Switch</td>
      <td>EF4116</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF4116-SG</td>
      <td>EtherFast 4116 16-Port 10/100 Ethernet Switch</td>
      <td>EF4116</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EF4116-UK</td>
      <td>EtherFast 4116 16-Port 10/100 Ethernet Switch</td>
      <td>EF4116</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF4124</td>
      <td>EtherFast 4124 24-Port 10/100 Ethernet Switch</td>
      <td>EF4124</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF4124-AU</td>
      <td>EtherFast 4124 24-Port 10/100 Ethernet Switch</td>
      <td>EF4124</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF4124-CA</td>
      <td>EtherFast 4124 24-Port 10/100 Ethernet Switch</td>
      <td>EF4124</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF4124-CN</td>
      <td>EtherFast 4124 24-Port 10/100 Ethernet Switch</td>
      <td>EF4124</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF4124-EU</td>
      <td>EtherFast 4124 24-Port 10/100 Ethernet Switch</td>
      <td>EF4124</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EF4124-UK</td>
      <td>EtherFast 4124 24-Port 10/100 Ethernet Switch</td>
      <td>EF4124</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFA16-UK</td>
      <td>EtherFast 10/100 Auto-Sensing 16-Port W. Hub</td>
      <td>EFA16</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFAH05W</td>
      <td>Etherfast 5 Port 10/100 Desktop Hub</td>
      <td>EFAH05W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFAH05W-AT</td>
      <td>EtherFast 10/100 Auto-Sensing 5-Port W. Hub</td>
      <td>EFAH05W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFAH05W-CA</td>
      <td>Etherfast 5 Port 10/100 Desktop Hub (Canada)</td>
      <td>EFAH05W</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFAH05W-EU</td>
      <td>Etherfast 5 Port 10/100 Desktop Hub,</td>
      <td>EFAH05W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFAH05W-UK</td>
      <td>Etherfast 5 Port 10/100 Desktop Hub,</td>
      <td>EFAH05W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFAH08W</td>
      <td>EtherFast 10/100 Auto-Sensing 8-Port W. Hub</td>
      <td>EFAH08W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFAH08W-EU</td>
      <td>EtherFast 10/100 Auto-Sensing 8-Port W. Hub</td>
      <td>EFAH08W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFAH08W-UK</td>
      <td>EtherFast 10/100 Auto-Sensing 8-Port W. Hub</td>
      <td>EFAH08W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFAH16</td>
      <td>EtherFast 10/100 Auto-Sensing 16-Port W. Hub</td>
      <td>EFAH16</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFAH16-EU</td>
      <td>EtherFast 10/100 Auto-Sensing 16-Port W. Hub</td>
      <td>EFAH16</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFAH16W</td>
      <td>EtherFast 10/100 Auto-Sensing 16-Port W. Hub</td>
      <td>EFAH16W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFAH16W-EU</td>
      <td>EtherFast 10/100 Auto-Sensing 16-Port W. Hub</td>
      <td>EFAH16W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFAH16W-UK</td>
      <td>EtherFast 10/100 Auto-Sensing 16-Port W. Hub</td>
      <td>EFAH16W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFAH24</td>
      <td>EtherFast 10/100 Auto-Sensing 24-Port Hub</td>
      <td>EFAH24</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFAH24-EU</td>
      <td>EtherFast 10/100 Auto-Sensing 24-Port Hub</td>
      <td>EFAH24</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFAH24-UK</td>
      <td>EtherFast 10/100 Auto-Sensing 24-Port Hub</td>
      <td>EFAH24</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFFETXDE</td>
      <td>100Base TX Distance Extender</td>
      <td>EFFETXDE</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFG20</td>
      <td>EtherFast 10/100 Instant GigaDrive (20GB)</td>
      <td>EFG20</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFG20-EU</td>
      <td>EtherFast 10/100 Instant GigaDrive (20GB)</td>
      <td>EFG20</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFG20-TH</td>
      <td>EtherFast 10/100 Instant GigaDrive (20GB)</td>
      <td>EFG20</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFG20-UK</td>
      <td>EtherFast 10/100 Instant GigaDrive (20GB)</td>
      <td>EFG20</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFG40</td>
      <td>EtherFast 10/100 Instant GigaDrive (40GB)</td>
      <td>EFG40</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFG40-EU</td>
      <td>EtherFast 10/100 Instant GigaDrive (40GB)</td>
      <td>EFG40</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFG40-UK</td>
      <td>EtherFast 10/100 Instant GigaDrive (40GB)</td>
      <td>EFG40</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFG80</td>
      <td>EFast Network Attached Storage (80GB/PrintServer)</td>
      <td>EFG80</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFG80-CN</td>
      <td>EFast Network Attached Storage (80GB/PrintServer)</td>
      <td>EFG80</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFG80-EU</td>
      <td>EFast Network Attached Storage (80GB/PrintServer)</td>
      <td>EFG80</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFG80-UK</td>
      <td>EFast Network Attached Storage (80GB/PrintServer)</td>
      <td>EFG80</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFGHDT</td>
      <td>EtherFast Network Attached Storage Hard Drive Tray</td>
      <td>EFGHDT</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFGHDT2</td>
      <td>NAS Hard Drive Tray (for EFG120)</td>
      <td>EFGHDT2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFPC2GE</td>
      <td>1000BaseT Gigabit Ethernet Module</td>
      <td>EFPC2GE</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFPC2SC</td>
      <td>1000BaseSX SC Fiber Module</td>
      <td>EFPC2SC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFPC2SC-EU</td>
      <td>1000BaseSX SC Fiber Module</td>
      <td>EFPC2SC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFR240</td>
      <td>EtherFast Instant RAID</td>
      <td>EFR240</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFR240-EU</td>
      <td>EtherFast Instant RAID</td>
      <td>EFR240</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFR240-UK</td>
      <td>EtherFast Instant RAID</td>
      <td>EFR240</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFROU44-EU</td>
      <td>EtherFast 10/100 4-Port Analog Router</td>
      <td>EFROU44</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>EFSP42</td>
      <td>EtherFast 10/100 2-Port Switched PrintServer</td>
      <td>EFSP42</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFSP42-AU</td>
      <td>EtherFast Switched 2-Port Print Server</td>
      <td>EFSP42</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFSP42-CN</td>
      <td>EtherFast 10/100 2-Port Switched PrintServer</td>
      <td>EFSP42</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFSP42-EU</td>
      <td>EtherFast 10/100 2-Port Switched PrintServer</td>
      <td>EFSP42</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFSP42-UK</td>
      <td>EtherFast 10/100 2-Port Switched PrintServer</td>
      <td>EFSP42</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFVCD20</td>
      <td>EtherFast Instant GigaCD Server</td>
      <td>EFVCD20</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFVCD20-EU</td>
      <td>EtherFast Instant GigaCD Server</td>
      <td>EFVCD20</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EFVCD20-UK</td>
      <td>EtherFast Instant GigaCD Server</td>
      <td>EFVCD20</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG0008</td>
      <td>EtherFast 10/100/1000 8-Port Workgroup GigaSwitch</td>
      <td>EG0008</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG0008-EU</td>
      <td>EtherFast 10/100/1000 8-Port GigaSwitch</td>
      <td>EG0008</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG0008-UK</td>
      <td>Etherfast 10/100/1000 8-port Giga Switch</td>
      <td>EG0008</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG005W</td>
      <td>Gigabit 5-Port Workgroup Switch</td>
      <td>EG005W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG005W-AU</td>
      <td>Gigabit 5-Port Workgroup Switch</td>
      <td>EG005W</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG005W-EU</td>
      <td>Gigabit 5-Port Workgroup Switch</td>
      <td>EG005W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG005W-UK</td>
      <td>Gigabit 5-Port Workgroup Switch</td>
      <td>EG005W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG008W</td>
      <td>GIGABIT 8-PORT WORKGROUP SWITCH</td>
      <td>EG008W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG008W-AU</td>
      <td>GIGABIT 8-PORT WORKGROUP SWITCH</td>
      <td>EG008W</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG008W-EU</td>
      <td>GIGABIT 8-PORT WORKGROUP SWITCH</td>
      <td>EG008W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG008W-UK</td>
      <td>GIGABIT 8-PORT WORKGROUP SWITCH</td>
      <td>EG008W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG0801SK</td>
      <td>EtherFast 10/100/1000 8-Port Gigabit Starter Kit</td>
      <td>EG0801SK</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG0801SK-EU</td>
      <td>EtherFast 10/100/1000 8-Port Gigabit Starter Kit</td>
      <td>EG0801SK</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG0801SK-UK</td>
      <td>EtherFast 10/100/1000 8-Port Gigabit Starter Kit</td>
      <td>EG0801SK</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG0801W</td>
      <td>EtherFast 10/100/1000 8+1 Workgroup GigaSwitch</td>
      <td>EG0801W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG0801W-EU</td>
      <td>EtherFast 10/100/1000 8+1 Workgroup GigaSwitch</td>
      <td>EG0801W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG0801W-UK</td>
      <td>EtherFast 10/100/1000 8+1 Workgroup GigaSwitch</td>
      <td>EG0801W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG1032</td>
      <td>Instant Gigabit Network Adapter (32-bit)</td>
      <td>EG1032</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG1032-AS</td>
      <td>Instant Gigabit Network Adapter (32-bit)</td>
      <td>EG1032</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EG1032-AU</td>
      <td>Instant Gigabit Network Adapter (32-bit)</td>
      <td>EG1032</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td>19-Oct-2017</td>
      <td>18-Oct-2022</td>
    </tr>
    <tr>
      <td>EG1032-CN</td>
      <td>Instant Gigabit Network Adapter (32-bit)</td>
      <td>EG1032</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG1064</td>
      <td>Instant Gigabit Network Adapter (64-bit)</td>
      <td>EG1064</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG1064-AS</td>
      <td>Instant Gigabit Network Adapter (64-bit)</td>
      <td>EG1064</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>EG24M</td>
      <td>EtherFast II Gigabit 1000Base-T Module</td>
      <td>EG24M</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG24M-AU</td>
      <td>EtherFast II Gigabit 1000Base-T Module</td>
      <td>EG24M</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG24M-EU</td>
      <td>EtherFast II 10/100 Managed 24-Port GigaSwitch</td>
      <td>EG24M</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG24M-UK</td>
      <td>EtherFast II 10/100 Managed 24-Port GigaSwitch</td>
      <td>EG24M</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EG24M1</td>
      <td>EtherFast II Gigabit SX Fiber Module</td>
      <td>EG24M1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EPSX3</td>
      <td>EtherFast 10/100 3-port PrintServer</td>
      <td>EPSX3</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EPSX3-AU</td>
      <td>EtherFast 3-Port 10/100 PrintServer</td>
      <td>EPSX3</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EPSX3-EU</td>
      <td>EtherFast 10/100 3-port PrintServer</td>
      <td>EPSX3</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EPSX3-UK</td>
      <td>EtherFast 10/100 3-port PrintServer</td>
      <td>EPSX3</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EW10HUB</td>
      <td>10-port Ethernet Workgroup Hub</td>
      <td>EW10HUB</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EW10HUB-EU</td>
      <td>10-port Ethernet Workgroup Hub</td>
      <td>EW10HUB</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EW20HUB</td>
      <td>Ethernet 10BaseT 20-Port Desktop Hub</td>
      <td>EW20HUB</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EW20HUB-EU</td>
      <td>20-port Ethernet Workgroup Hub</td>
      <td>EW20HUB</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EW5HUB</td>
      <td>Ethernet 5-port Workgroup Hub</td>
      <td>EW5HUB</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EW5HUB-CA</td>
      <td>Ethernet 5-port Workgroup Hub (Canada)</td>
      <td>EW5HUB</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EW5HUB-EU</td>
      <td>Ethernet 5-port Workgroup Hub</td>
      <td>EW5HUB</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EW5HUB-UK</td>
      <td>Ethernet 5-port Workgroup Hub</td>
      <td>EW5HUB</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EW5PCISK</td>
      <td>Network starter Kit (PCI)</td>
      <td>EW5PCISK</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EW5PCISK-EU</td>
      <td>Network starter Kit (PCI)</td>
      <td>EW5PCISK</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EW5PCISK-UK</td>
      <td>Network starter Kit (PCI)</td>
      <td>EW5PCISK</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EWHUB</td>
      <td>Ethernet 8 port Hub + 1 BNC</td>
      <td>EWHUB</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EWHUB-EU</td>
      <td>Ethernet 8 port Hub + 1 BNC</td>
      <td>EWHUB</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EWHUB-UK</td>
      <td>Ethernet 8 port Hub + 1 BNC</td>
      <td>EWHUB</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZHUB04</td>
      <td>EtherFast 10/100 16-Port Workgroup Switch</td>
      <td>EZHUB04</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS12</td>
      <td>EFast 2-Port 10/100 Auto-Sense Switch; Full Duplex</td>
      <td>EZXS12</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS16W</td>
      <td>EtherFast 10/100 16-Port Workgroup Switch</td>
      <td>EZXS16W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS16W-AU</td>
      <td>EtherFast 10/100 16-Port Workgroup Switch</td>
      <td>EZXS16W</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS16W-EU</td>
      <td>EtherFast 10/100 16-Port Workgroup Switch</td>
      <td>EZXS16W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS16W-LA</td>
      <td>EtherFast 10/100 16-Port Workgroup Switch</td>
      <td>EZXS16W</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS16W-UK</td>
      <td>EtherFast 16-Port 10/100 Workgroup Switch</td>
      <td>EZXS16W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS44</td>
      <td>EtherFast 10/100 4-Port Desktop Switch</td>
      <td>EZXS44</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS55W</td>
      <td>EFast 10/100 Dual-Speed 5-Port Workgroup Switch</td>
      <td>EZXS55W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS55W-4A</td>
      <td>EFast 10/100 Dual-Speed 5-Port Workgroup Switch</td>
      <td>EZXS55W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS55W-AT</td>
      <td>EFast 10/100 Dual-Speed 5-Port Workgroup Switch</td>
      <td>EZXS55W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS55W-AU</td>
      <td>10/100 5-Port Workgroup Switch</td>
      <td>EZXS55W</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS55W-CA</td>
      <td>EtherFast 10/100 5-Port Workgroup Switch (Canada)</td>
      <td>EZXS55W</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS55W-DE</td>
      <td>EFast 10/100 Dual-Speed 5-Port Workgroup Switch</td>
      <td>EZXS55W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS55W-EU</td>
      <td>EFast 10/100 Dual-Speed 5-Port Workgroup Switch</td>
      <td>EZXS55W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS55W-FR</td>
      <td>EFast 10/100 Dual-Speed 5-Port Workgroup Switch</td>
      <td>EZXS55W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS55W-LA</td>
      <td>EFast 10/100 Dual-Speed 5-Port Workgroup Switch</td>
      <td>EZXS55W</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS55W-UK</td>
      <td>EFast 10/100 Dual-Speed 5-Port Workgroup Switch</td>
      <td>EZXS55W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS88</td>
      <td>EtherFast 10/100 8-Port Rackmount Switch</td>
      <td>EZXS88</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS88R</td>
      <td>EtherFast 10/100 Dual-Speed 8-Port Switch</td>
      <td>EZXS88R</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS88R-AU</td>
      <td>EtherFast 10/100 Dual-Speed 8-Port Switch</td>
      <td>EZXS88R</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS88W</td>
      <td>EFast 10/100 Dual-Speed 8-Port Workgroup Switch</td>
      <td>EZXS88W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS88W-AU</td>
      <td>10/100 8-Port Workgroup Switch</td>
      <td>EZXS88W</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS88W-CA</td>
      <td>EFast 10/100 Dual-Speed 8-Port Workgroup Switch</td>
      <td>EZXS88W</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS88W-EU</td>
      <td>EFast 10/100 Dual-Speed 8-Port Workgroup Switch</td>
      <td>EZXS88W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS88W-LA</td>
      <td>EFast 10/100 Dual-Speed 8-Port Workgroup Switch</td>
      <td>EZXS88W</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS88W-UK</td>
      <td>EFast 10/100 Dual-Speed 8-Port Workgroup Switch</td>
      <td>EZXS88W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXS88W-WM</td>
      <td>EFast 10/100 Dual-Speed 8-Port Workgroup Switch</td>
      <td>EZXS88W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXSA2</td>
      <td>EtherFast 10/100 10-port 8+2 Switch</td>
      <td>EZXSA2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>EZXSA2-UK</td>
      <td>EtherFast 10/100 10-port 8+2 Switch</td>
      <td>EZXSA2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>FGHSAX1800-KT</td>
      <td>LINKSYS FGHSAX1800-KT PORTABLE HOTSPOT, LTE 5G, AX1800</td>
      <td>FGHSAX1800</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>21-Nov-2023</td>
    </tr>
    <tr>
      <td>HA1000</td>
      <td>Home Automation Hub</td>
      <td>HA1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HD-NMH-1TB</td>
      <td>HD-NMH-1TB Hard Drive for the NMH**05, 1TB</td>
      <td>NMH410</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>HD-NMH-500G</td>
      <td>HD-NMH-500G Hard Drive for the NMH**05, 500 G</td>
      <td>NMH305</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HG200-TS</td>
      <td>Home Wireless-G Gateway</td>
      <td>HG200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>HGA7T</td>
      <td>High Gain Antenna Kit for TNC Connectors</td>
      <td>HGA7T</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HGA7T-CA</td>
      <td>High Gain Antenna Kit for TNC Connectors</td>
      <td>HGA7T</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HGA7T-EU</td>
      <td>High Gain Antenna Kit for TNC Connectors</td>
      <td>HGA7T</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HGA7T-WM</td>
      <td>High Gain Antenna Kit for TNC Connectors</td>
      <td>HGA7T</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HN200E</td>
      <td>HP Eithernet Router</td>
      <td>HN200E</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>HN200P</td>
      <td>HP Phone Line Gateway</td>
      <td>HN200P</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>HN200W</td>
      <td>HP Wireless Ethernet Router</td>
      <td>HN200W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>HN210E</td>
      <td>HP Ethernet Adapter</td>
      <td>HN210E</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HN210P</td>
      <td>HP Phone Line USB Network Adapter</td>
      <td>HN210P</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HN210W</td>
      <td>HP Ethernet USB Wireless Network Adapter</td>
      <td>HN210W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HN220E</td>
      <td>HP 5-Port Ethernet Switch</td>
      <td>HN220E</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HP200-TS</td>
      <td>Home Wireless-G PC Card</td>
      <td>HP200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HP4050</td>
      <td>WIRELESS USB ADAPTER * 54Mbps 802.11g</td>
      <td>HP4050</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HP4050ea</td>
      <td>WIRELESS USB ADAPTER * 54Mbps 802.11g</td>
      <td>HP4050</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HPB200</td>
      <td>HomeLink Phoneline 10M Ethernet Bridge</td>
      <td>HPB200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HPB200-EU</td>
      <td>HomeLink Phoneline 10M Ethernet Bridge</td>
      <td>HPB200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HPES03</td>
      <td>HomeLink Broadband Network Bridge</td>
      <td>HPES03</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HPES03-EU</td>
      <td>HomeLink Broadband Network Bridge</td>
      <td>HPES03</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HPES71</td>
      <td>HomeLink Broadband 8-Port Network Bridge</td>
      <td>HPES71</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HPN100</td>
      <td>HomeLink Phoneline Network Card</td>
      <td>HPN100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HPN100SK</td>
      <td>HomeLink Phoneline Network-in-the-Box</td>
      <td>HPN100SK</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>HPN200</td>
      <td>HomeLink Phoneline 10M Network Card</td>
      <td>HPN200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HPN200SK</td>
      <td>HomeLink Phoneline 10M Network-in-the-Box</td>
      <td>HPN200SK</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>HPRO200</td>
      <td>HomeLink Phoneline 10M Cable/DSL Router</td>
      <td>HPRO200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>HPRO200-EU</td>
      <td>HomeLink Phoneline 10M Cable/DSL Router</td>
      <td>HPRO200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>HR200-TS</td>
      <td>Home Wireless-G Router</td>
      <td>HR200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>HRNG1</td>
      <td>Instant HomeRF Network Gateway</td>
      <td>HRNG1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>HRPCM1</td>
      <td>Instant HomeRF Network PC Card</td>
      <td>HRPCM1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HRUSB1</td>
      <td>Instant HomeRF USB Network Adapter</td>
      <td>HRUSB1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>HU200-TS</td>
      <td>Home Wireless-G USB Adaptor</td>
      <td>HU200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>INW-1000</td>
      <td>5-PORT NETWORK SWITCH * NEW ENCLOSURE</td>
      <td>INW-1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>INW-1100</td>
      <td>5-PORT NETWORK SWITCH * NEW ENCLOSURE</td>
      <td>INW-1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>INW-2000</td>
      <td>8-PORT NETWORK SWITCH * NEW ENCLOSURE</td>
      <td>INW-1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>INW-2100</td>
      <td>8-PORT NETWORK SWITCH * NEW ENCLOSURE</td>
      <td>INW-1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>INW-3000</td>
      <td>5 PORT GIGABIT NETWORK SWITCH - ISY</td>
      <td>INW-3000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>INW-4000</td>
      <td>8 PORT GIGABIT NETWORK SWITCH - ISY</td>
      <td>INW-3000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>INW-5000</td>
      <td>EXTENDER, WIRELESS, RANGE, SINGLE-BAND, N300</td>
      <td>INW-5000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>ISM300</td>
      <td>System Mechanic 8 distribute license to end users</td>
      <td>ISM300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>IWL-1000</td>
      <td>USB,NIC,WIRELESS,BASIC/CONNECT</td>
      <td>IWL-1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>IWL-2000</td>
      <td>NIC,MICRO USB,WIRELESS,BASIC</td>
      <td>IWL-2000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>IWL-3000</td>
      <td>USB,NIC,WIRELESS,SURF&amp;SHARE</td>
      <td>IWL-3000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>IWL-4000</td>
      <td>USB,NIC,MICRO,WIRELESS,N300</td>
      <td>IWL-4000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>K3750-AU</td>
      <td>SKU, K3750-AU, POWER AC COMPUTER CORD * AC PLUG/COMPUTER FEM; 2M</td>
      <td>K3750</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>KISS1600</td>
      <td>High Def Media Player w/DVD Player, Eth and WLessG</td>
      <td>KISS1600</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>KISS1600-AU</td>
      <td>High Definition Media Player with DVD Player</td>
      <td>KISS1600</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>KISS1600-EU</td>
      <td>High Def Media Player w/DVD, Ethernet and WLessG</td>
      <td>KISS1600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KISS1600-UK</td>
      <td>High Def Media Player w/DVD, Ethernet and WLessG</td>
      <td>KISS1600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KISS568160-EU</td>
      <td>Harddisk &amp; DVD Recorder. 160GB HDD with DVD Player</td>
      <td>KISS568160</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td>26-Mar-2015</td>
      <td>24-Mar-2020</td>
    </tr>
    <tr>
      <td>KISS568160-UK</td>
      <td>Harddisk &amp; DVD Recorder. 160GB HDD with DVD Player</td>
      <td>KISS568160</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td>26-Mar-2015</td>
      <td>24-Mar-2020</td>
    </tr>
    <tr>
      <td>KISS568300-EU</td>
      <td>Harddisk &amp; DVD Recorder. 300GB HDD with DVD Player</td>
      <td>KISS568300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td>26-Mar-2015</td>
      <td>24-Mar-2020</td>
    </tr>
    <tr>
      <td>KISS568300-UK</td>
      <td>Harddisk &amp; DVD Recorder. 300GB HDD with DVD Player</td>
      <td>KISS568300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td>26-Mar-2015</td>
      <td>24-Mar-2020</td>
    </tr>
    <tr>
      <td>KMM3000-DK</td>
      <td>K6000 TDC Microsoft MSTV set-top box</td>
      <td>KMM3100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KMM3010-DK</td>
      <td>Model K6160 TDC Microsoft MSTV set-top box</td>
      <td>KMM3010</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KMM3010-SZ</td>
      <td>Swisscom Microsoft MSTV set-top box KMM3010-SC</td>
      <td>KMM3010</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KMM3100-ES</td>
      <td>T-Online Spain X 300T Microsoft MSTV set-top box</td>
      <td>KMM3100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KMM3210-DE</td>
      <td>T-Home Germany X 300T Microsoft MSTV set-top box</td>
      <td>KMM3210</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KMM3210-FR</td>
      <td>ClubInternet France K8006 MSFT MSTV set-top box</td>
      <td>KMM3210</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KMM3210-HU</td>
      <td>T-Online Hungary X 300T Microsoft MSTV set-top box</td>
      <td>KMM3210</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KMM3210-IT</td>
      <td>Telecom Italia Microsoft MSTV set-top box</td>
      <td>KMM3210</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KMM3210-S5</td>
      <td>T-Online Slovakia X 300T MSFT MSTV set-top box</td>
      <td>KMM3210</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KMM3210-WI</td>
      <td>WIND Microsoft MSTV set-top box</td>
      <td>KMM3210</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KMMXMSTV11</td>
      <td>MSFT TV IPTV Edition Client Version 1.1</td>
      <td>KMMXMSTV11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KST17W</td>
      <td>"KiSS Coolview3 17"" TFT LCD Display and TV"</td>
      <td>KST17W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>KST17W-EU</td>
      <td>"KiSS Coolview3 17"" TFT LCD Display and TV"</td>
      <td>KST17W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KST17W-UK</td>
      <td>"KiSS Coolview3 17"" TFT LCD Display and TV"</td>
      <td>KST17W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KVM100SK</td>
      <td>ProConnect 2-Port Compact KVM Switch Kit (AT/PS2)</td>
      <td>KVM100SK</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KVM2KIT</td>
      <td>ProConnect Integrated KVM 2-Port Switch</td>
      <td>KVM2KIT</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>KVM2KIT-CA</td>
      <td>ProConnect Integrated KVM 2-Port Switch</td>
      <td>KVM2KIT</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KVM2KIT-EU</td>
      <td>ProConnect Integrated KVM 2-Port Switch</td>
      <td>KVM2KIT</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KVM2KIT-JP</td>
      <td>ProConnect Integrated KVM 2-Port Switch</td>
      <td>KVM2KIT</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KVM2KIT-UK</td>
      <td>ProConnect Integrated KVM 2-Port Switch</td>
      <td>KVM2KIT</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KWHA400</td>
      <td>Wireless Home Audio - Executive Kit</td>
      <td>KWHA400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KWHA400-CA</td>
      <td>Wireless Home Audio - Executive Kit</td>
      <td>KWHA400</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>KWHA400-EU</td>
      <td>Wireless Home Audio - Executive Kit</td>
      <td>KWHA400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KWHA500</td>
      <td>Wireless Home Audio - Conductor Kit</td>
      <td>KWHA500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>KWHA500-CA</td>
      <td>KWHA500, Wireless Home Audio - Conductor Kit</td>
      <td>KWHA500</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>KWHA500-EU</td>
      <td>KWHA500, Wireless Home Audio - Conductor Kit</td>
      <td>KWHA500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>KWHA600</td>
      <td>Wireless Home Audio - Trio Kit</td>
      <td>KWHA600</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KWHA600-CA</td>
      <td>Wireless Home Audio - Trio Kit</td>
      <td>KWHA600</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>KWHA600-EU</td>
      <td>Wireless Home Audio - Trio Kit</td>
      <td>KWHA600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KWHA700</td>
      <td>Wireless Home Audio - Premier Kit</td>
      <td>KWHA700</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KWHA700-CA</td>
      <td>Wireless Home Audio - Premier Kit</td>
      <td>KWHA700</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>KWHA700-EU</td>
      <td>Wireless Home Audio - Premier Kit</td>
      <td>KWHA700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>KWHA800</td>
      <td>Wireless Home Audio - Premium Kit</td>
      <td>KWHA800</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>KWHA800-CA</td>
      <td>KWHA800, Wireless Home Audio - Mainstream Kit</td>
      <td>KWHA800</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>KWHA800-EU</td>
      <td>KWHA800, Wireless Home Audio - Premium Kit</td>
      <td>KWHA800</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>L03000</td>
      <td>Modular Adapter, DB9m/RJ11 6 Conductor</td>
      <td>L03000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>L03001</td>
      <td>Modular Adapter, DB9f/RJ11 6 Conductor</td>
      <td>L03001</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>L03002</td>
      <td>Modular Adapter, DB9m/RJ45 8 Conductor</td>
      <td>L03002</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>L03003</td>
      <td>Modular Adapter, DB9f/RJ45 8 Conductor</td>
      <td>L03003</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>L03004</td>
      <td>Modular Adapter, DB25m/RJ11 6 Conductor</td>
      <td>L03004</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>L03005</td>
      <td>Modular Adapter, DB25fRJ11 6 Conductor</td>
      <td>L03005</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>L03006</td>
      <td>Modular Adapter, DB25m/RJ45 8 Conductor</td>
      <td>L03006</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>L03007</td>
      <td>Modular Adapter, DB25f/RJ45 8 Conductor</td>
      <td>L03007</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>L03009</td>
      <td>Modular Adapter, DB25f/RJ45 2-Piece</td>
      <td>L03009</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>L03010</td>
      <td>PS/2 Keyboard Adapter Din5F/Din6M</td>
      <td>L03010</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>L03011</td>
      <td>PS/2 Keyboard Adapter, Din6F/Din5M</td>
      <td>L03011</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>L03040</td>
      <td>Power2GO Inverter (EVA)</td>
      <td>L03040</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LACPSU12V1A</td>
      <td>LINKSYS 12VDC 1A POWER SUPPLY UNIT</td>
      <td>LACPSU12V1A</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Apr-2023</td>
    </tr>
    <tr>
      <td>LAPAC1200C-AP</td>
      <td>SKU, LINKSYS, AC1200 DUAL BAND ACCESS POINT CLOUD</td>
      <td>LAPAC1200C</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>LAPAC1750C-AP</td>
      <td>SKU, LINKSYS, AC1750 DUAL BAND ACCESS POINT CLOUD</td>
      <td>LAPAC1750C</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>LAPAC1750FP</td>
      <td>WIRELESS-AC1750 ACCESS POINT WITH POE PRO SERIES</td>
      <td>LAPAC1750FP</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>LAPAC1750FP-AP</td>
      <td>WIRELESS-AC1750 ACCESS POINT WITH POE PRO SERIES</td>
      <td>LAPAC1750FP</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>LAPAC1750FP-AU</td>
      <td>WIRELESS-AC1750 ACCESS POINT WITH POE PRO SERIES</td>
      <td>LAPAC1750FP</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>LAPAC1750FP-EU</td>
      <td>WIRELESS-AC1750 ACCESS POINT WITH POE PRO SERIES</td>
      <td>LAPAC1750FP</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>LAPAC1750FP-UK</td>
      <td>WIRELESS-AC1750 ACCESS POINT WITH POE PRO SERIES</td>
      <td>LAPAC1750FP</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>LAPAC2600-AP</td>
      <td>LINKSYS LAPAC2600 ACCESS POINT,AC2600</td>
      <td>LAPAC2600</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>LCAB02VLNOD</td>
      <td>2M Outdoor Bullet Camera with night vision. (Vari-</td>
      <td>LCAB02VLNOD</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>LCAB03VLNOD-AP</td>
      <td>1080P 3MP OUTDOOR NIGHT VISION BULLET CAMERA</td>
      <td>LCAB03VLNOD</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>LCAD02FLN</td>
      <td>2M Indoor Dome Camera with night vision. (Fixed Le</td>
      <td>LCAD02FLN</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>LCAD02VLNOD</td>
      <td>2M Outdoor Dome Camera with night vision. (Vari-Fo</td>
      <td>LCAD02VLNOD</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>LCAD03FLN-AP</td>
      <td>1080P 3MP INDOOR NIGHT VISION DOME CAMERA</td>
      <td>LCAD03FLN</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>LCAD03VLNOD-AP</td>
      <td>1080P 3MP OUTDOOR NIGHT VISION DOME CAMERA</td>
      <td>LCAD03VLNOD</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>LCAD03VLNOD-AU</td>
      <td>1080P 3MP OUTDOOR NIGHT VISION DOME CAMERA</td>
      <td>LCAD03VLNOD</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td>9-Dec-2015</td>
      <td>7-Dec-2020</td>
    </tr>
    <tr>
      <td>LCAD03VLNOD-EU</td>
      <td>1080P 3MP OUTDOOR NIGHT VISION DOME CAMERA</td>
      <td>LCAD03VLNOD</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>LCAD03VLNOD-UK</td>
      <td>1080P 3MP OUTDOOR NIGHT VISION DOME CAMERA</td>
      <td>LCAD03VLNOD</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>LCAM0236OD</td>
      <td>2M 360 Mini-Dome Outdoor/Indoor Camera</td>
      <td>LCAM0236OD</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>LCAM0336OD</td>
      <td>1080P 3MP INDOOR/OUTDOOR 360 MINI-DOME CAMERA</td>
      <td>LCAM0336OD</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>LCAM0336OD-AP</td>
      <td>1080P 3MP INDOOR/OUTDOOR 360 MINI-DOME CAMERA</td>
      <td>LCAM0336OD</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>LCAM0336OD-AU</td>
      <td>1080P 3MP INDOOR/OUTDOOR 360 MINI-DOME CAMERA</td>
      <td>LCAM0336OD</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td>9-Dec-2015</td>
      <td>7-Dec-2020</td>
    </tr>
    <tr>
      <td>LGC36FF</td>
      <td>Compact Gender Changer, Centronics 36 F/F</td>
      <td>LGC36FF</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LGC36MM</td>
      <td>Compact Gender Changer, Centronics 36 M/M</td>
      <td>LGC36MM</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LGC50FF</td>
      <td>Compact Gender Changer, Centronics 50 F/F</td>
      <td>LGC50FF</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LGC50MM</td>
      <td>Compact Gender Changer, Centronics 50 M/M</td>
      <td>LGC50MM</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LGD09FF</td>
      <td>Compact Gender Changer, DB9 F/F</td>
      <td>LGD09FF</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LGD09MM</td>
      <td>Compact Gender Changer, DB9 M/M</td>
      <td>LGD09MM</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LGD15FF</td>
      <td>Compact Gender Changer, DB15 F/F</td>
      <td>LGD15FF</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LGD15MM</td>
      <td>Compact Gender Changer, DB15 M/M</td>
      <td>LGD15MM</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LGD25FF</td>
      <td>Compact Gender Changer, DB25 F/F</td>
      <td>LGD25FF</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LGD25MF</td>
      <td>Compact Gender Changer, DB25 M/F</td>
      <td>LGD25MF</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LGD25MM</td>
      <td>Compact Gender Changer, DB25 M/M</td>
      <td>LGD25MM</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LGD37FF</td>
      <td>Compact Gender Changer, DB37 F/F</td>
      <td>LGD37FF</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LGD37MM</td>
      <td>Compact Gender Changer, DB37 M/M</td>
      <td>LGD37MM</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LGH15FF</td>
      <td>Compact Gender Changer, DB15 F/F</td>
      <td>LGH15FF</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LGH15MF</td>
      <td>Compact Gender Changer, HD15 M/F</td>
      <td>LGH15MF</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LGH15MM</td>
      <td>Compact Gender Changer, HD15 M/M</td>
      <td>LGH15MM</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LGS105-UK-RTL</td>
      <td>SWITCH, GIGABIT, UNMANAGED,5-PORT, RETAIL</td>
      <td>LGS105</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>21-Nov-2023</td>
    </tr>
    <tr>
      <td>LGS108-UK-RTL</td>
      <td>SWITCH, GIGABIT, UNMANAGED, 8-PORT, RETAIL</td>
      <td>LGS108</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>21-Nov-2023</td>
    </tr>
    <tr>
      <td>LGS552</td>
      <td>SWITCH, GIGABIT,MANAGED, 52-PORT</td>
      <td>LGS552</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>LGS552P</td>
      <td>SWITCH, POE, GIGABIT,MANAGED, 52-PORT</td>
      <td>LGS552P</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>LH100B5</td>
      <td>(@Home Ready) EtherFast 10/100 Network Starter Kit</td>
      <td>LH100B5</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LH100C</td>
      <td>@Home Ready) EtherFast 10/100 Network Card</td>
      <td>LH100C</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LH100H5</td>
      <td>@Home EtherFast 10/100 5-Port Hub</td>
      <td>LH100H5</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LH100P</td>
      <td>@Home EtherFast 10/100 PCMCIA Card</td>
      <td>LH100P</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LH10U</td>
      <td>@Home USB to 10BaseT Adapter</td>
      <td>LH10U</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE10005</td>
      <td>Etherfast 100BaseTX LAN card 5-Pack</td>
      <td>LNE10005</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE10010</td>
      <td>EtherFast 100BaseTX LAN Card 10-pack</td>
      <td>LNE10010</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE10020</td>
      <td>EtherFast 10/100 LAN Card 20-Pack</td>
      <td>LNE10020</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE10060</td>
      <td>EtherFast 10/100 LAN Card 60-Pack</td>
      <td>LNE10060</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100A0</td>
      <td>EtherFast 10/100 LAN Card 100-Pack</td>
      <td>LNE100A0</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100A0-CN</td>
      <td>EtherFast 10/100 LAN Card 100-Pack</td>
      <td>LNE100A0</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100A0-L</td>
      <td>Etherfast 10/100 LAN Card ; loose pack</td>
      <td>LNE100A0</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100M</td>
      <td>EtherFast 10/100 Managed Network Adapter</td>
      <td>LNE100M</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100TX</td>
      <td>EtherFast 10/100 LAN Card</td>
      <td>LNE100TX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100TX-4A</td>
      <td>10/100 PCI Adapter</td>
      <td>LNE100TX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100TX-AT</td>
      <td>EtherFast 10/100 LAN Card (AT&amp;T)</td>
      <td>LNE100TX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100TX-BP</td>
      <td>EtherFast 10/100 LAN Card</td>
      <td>LNE100TX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100TX-CA</td>
      <td>EtherFast 10/100 LAN Card (Canada)</td>
      <td>LNE100TX</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100TX-CX</td>
      <td>EtherFast 10/100 LAN Card</td>
      <td>LNE100TX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100TX-DE</td>
      <td>EtherFast 10/100 LAN Card</td>
      <td>LNE100TX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100TX-EU</td>
      <td>EtherFast 10/100 LAN Card</td>
      <td>LNE100TX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100TX-FR</td>
      <td>EtherFast 10/100 LAN Card</td>
      <td>LNE100TX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100TX-LA</td>
      <td>EtherFast 10/100 LAN Card</td>
      <td>LNE100TX</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100TX-UK</td>
      <td>EtherFast 10/100 LAN Card (UK)</td>
      <td>LNE100TX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100TX-V1</td>
      <td>EtherFast 10/100 LAN Card V1</td>
      <td>LNE100TX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE100TXC</td>
      <td>EtherFast 10/100 LAN Card with Cable</td>
      <td>LNE100TXC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>LNE100TXU</td>
      <td>EtherFast 10/100 LAN Card (with Cable)</td>
      <td>LNE100TXU</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE2000</td>
      <td>Ethernet 10BaseT &amp; Thin Coax NE2000 card</td>
      <td>LNE2000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE2000T</td>
      <td>Ether16 10BaseT LAN Card</td>
      <td>LNE2000T</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNE200SK</td>
      <td>Network-in-a-Box, ISA</td>
      <td>LNE200SK</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNEPCI</td>
      <td>EtherPCI LAN Card</td>
      <td>LNEPCI</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNEPCI2</td>
      <td>EtherPCI LAN Card II</td>
      <td>LNEPCI2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNEPCI2T</td>
      <td>EtherPCI LAN Card II (10BaseT)</td>
      <td>LNEPCI2T</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNEPCISK</td>
      <td>Network-in-a-Box, PCI</td>
      <td>LNEPCISK</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>LNR0204C</td>
      <td>NVR with 2Bay and 4Channel</td>
      <td>LNR0204C</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>M10</td>
      <td>Cisco Valet</td>
      <td>M10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>M10-4A</td>
      <td>Cisco Valet</td>
      <td>M10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>M10-4T</td>
      <td>Cisco Valet</td>
      <td>M10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>M10-CA</td>
      <td>Cisco Valet</td>
      <td>M10</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>M1FX</td>
      <td>One-Port 10/100 FX Module</td>
      <td>M1FX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>M1GTFX</td>
      <td>1-Port 10/100/1000 Giga and1-Port 10/100 FX Module</td>
      <td>M1GTFX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>M20</td>
      <td>Cisco Valet Plus</td>
      <td>M20</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>M20-4A</td>
      <td>Cisco Valet Plus</td>
      <td>M20</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>M20-4T</td>
      <td>Cisco Valet Plus</td>
      <td>M20</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>M20-CA</td>
      <td>Cisco Valet Plus</td>
      <td>M20</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>M2FX</td>
      <td>Two-Port 10/100 FX Module</td>
      <td>M2FX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>M2GT</td>
      <td>Two-Port 10/100/1000 Gigabit w/2 mini-GBIC Module</td>
      <td>M2GT</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MACT2T</td>
      <td>Combo Mac Transceiver</td>
      <td>MACT2T</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MBE7001B-AU</td>
      <td>LINKSYS VELOP WRT 7 MBE7000 BLACK</td>
      <td>MBE7000</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>22-Jan-2024</td>
    </tr>
    <tr>
      <td>MCC-I40</td>
      <td>iPod Media Connect Cradle</td>
      <td>MCC-I40</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>MCC-I40-AU</td>
      <td>iPod Media Connect Cradle</td>
      <td>MCC-I40</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>MCC-I40-CA</td>
      <td>iPod Media Connect Cradle</td>
      <td>MCC-I40</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>MCC-I40-EU</td>
      <td>iPod Media Connect Cradle</td>
      <td>MCC-I40</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>MCC-I40-SG</td>
      <td>iPod Media Connect Cradle</td>
      <td>MCC-I40</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>MCCI40</td>
      <td>Wireless Home Audio, Docking Station for iPod</td>
      <td>MCCI40</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MCCI40-CA</td>
      <td>Wireless Home Audio, Docking Station for iPod</td>
      <td>MCC-I40</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>MCCI40-EU</td>
      <td>Wireless Home Audio, Docking Station for iPod</td>
      <td>MCCI40</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MEB200</td>
      <td>MoCA Ethernet Bridge</td>
      <td>MEB200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>MEB200-NA</td>
      <td>MoCA Ethernet Bridge (North America)</td>
      <td>MEB200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>MF-072A</td>
      <td>Twinaxial Cable, DB15</td>
      <td>MF</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MF-072B</td>
      <td>Twinaxial Cable, Twinaxial</td>
      <td>MF</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MGBF-1M</td>
      <td>1MB MegaBuffer</td>
      <td>MGBF</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MGBF-2M</td>
      <td>2MB MegaBuffer</td>
      <td>MGBF</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MM4010H</td>
      <td>MediaMate IPTV Streaming box w/HDMI</td>
      <td>MM4010H</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>MM4010H-EU</td>
      <td>MediaMate IPTV Streaming box with HDMI</td>
      <td>MM4010H</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MM4010H-UK</td>
      <td>MediaMate IPTV Streaming box with HDMI</td>
      <td>MM4010H</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MM4010S</td>
      <td>MediaMate IPTV Streaming box w/SCART</td>
      <td>MM4010S</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>MM4010S-EU</td>
      <td>MediaMate IPTV Streaming box with SCART</td>
      <td>MM4010S</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MM4010S-UK</td>
      <td>MediaMate IPTV Streaming box with SCART</td>
      <td>MM4010S</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MR7500-AH</td>
      <td>LINKSYS MR7500 MESH WIFI 6E ROUTER, AX6600</td>
      <td>MR7500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>21-Nov-2023</td>
    </tr>
    <tr>
      <td>MR7500-CA</td>
      <td>LINKSYS MR7500 MESH WIFI 6E ROUTER, AX6600</td>
      <td>MR7500</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>21-Nov-2023</td>
    </tr>
    <tr>
      <td>MR7500-CN</td>
      <td>LINKSYS MR7500 MESH WIFI 6E ROUTER, AX6600</td>
      <td>MR7500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>21-Nov-2023</td>
    </tr>
    <tr>
      <td>MSHARE</td>
      <td>Dummy SKU, MultiShare Starter Kit</td>
      <td>MSHARE</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>MSHARE-RX</td>
      <td>MultiShare Receiver</td>
      <td>MSHARE</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MSHARE-SK</td>
      <td>MultiShare Starter Kit</td>
      <td>MSHARE</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MSHARE-SL</td>
      <td>MultiShare Selector</td>
      <td>MSHARE</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MSHARE-TX</td>
      <td>MultiShare Transmitter</td>
      <td>MSHARE</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MTM-2004-02</td>
      <td>Mat-Table Mat (Speedbooster)</td>
      <td>MTM</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>MWA200</td>
      <td>Metro Wireless Internet Adapter</td>
      <td>MWA200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MWA200-EL</td>
      <td>Metro Wireless Internet Adapter (Earthlink)</td>
      <td>MWA200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>MWA200-EW</td>
      <td>MWA200-EW, Metro Wireless Internet Adapter</td>
      <td>MWA200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>MX4200FN</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Nov-2023</td>
    </tr>
    <tr>
      <td>MX4200SH-AH</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Nov-2023</td>
    </tr>
    <tr>
      <td>MX5501-EU</td>
      <td>LINKSYS VELOP AX5400 1PK</td>
      <td>MX5501</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Nov-2023</td>
    </tr>
    <tr>
      <td>MX5501-UK</td>
      <td>LINKSYS VELOP AX5400 1PK</td>
      <td>MX5501</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Nov-2023</td>
    </tr>
    <tr>
      <td>MX8501-AH</td>
      <td>LINKSYS VELOP MX8500 AX8400 1PK</td>
      <td>MX8500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Nov-2023</td>
    </tr>
    <tr>
      <td>MX8501-CA</td>
      <td>LINKSYS VELOP MX8500 AX8400 1PK</td>
      <td>MX8500</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Nov-2023</td>
    </tr>
    <tr>
      <td>MX8501-CN</td>
      <td>LINKSYS VELOP MX8500 AX8400 1PK</td>
      <td>MX8500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Nov-2023</td>
    </tr>
    <tr>
      <td>MX8501-EU</td>
      <td>LINKSYS VELOP MX8500 AX8400 1PK</td>
      <td>MX8500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Nov-2023</td>
    </tr>
    <tr>
      <td>MX8501-JP</td>
      <td>LINKSYS VELOP MX8500 AX8400 1PK</td>
      <td>MX8500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Nov-2023</td>
    </tr>
    <tr>
      <td>MX8501-KR</td>
      <td>LINKSYS VELOP MX8500 AX8400 1PK</td>
      <td>MX8500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Nov-2023</td>
    </tr>
    <tr>
      <td>MX8501-ME</td>
      <td>LINKSYS VELOP MX8500 AX8400 1PK</td>
      <td>MX8500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Nov-2023</td>
    </tr>
    <tr>
      <td>MX8501-UK</td>
      <td>LINKSYS VELOP MX8500 AX8400 1PK</td>
      <td>MX8500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Nov-2023</td>
    </tr>
    <tr>
      <td>NAS200</td>
      <td>Network Storage System with 2 Bays</td>
      <td>NAS200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NAS200-AU</td>
      <td>Network Storage System with 2 Bays</td>
      <td>NAS200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NAS200-CA</td>
      <td>Network Storage System with 2 Bays</td>
      <td>NAS200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NAS200-EU</td>
      <td>Network Storage System with 2 Bays</td>
      <td>NAS200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NAS200-SG</td>
      <td>Network Storage System with 2 Bays</td>
      <td>NAS200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NAS200-UK</td>
      <td>Network Storage System with 2 Bays</td>
      <td>NAS200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>NC100</td>
      <td>Fast Ethernet 10/100 Network Card</td>
      <td>NC100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NC100U</td>
      <td>Fast Enet 10/100 Network Card and Network Cable</td>
      <td>NC100U</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NC100U-WM</td>
      <td>Fast Enet 10/100 Network Card and Network Cable</td>
      <td>NC100U</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NC100U-WMT</td>
      <td>Fast Ethernet 10/100 Net Card and Network Cable</td>
      <td>NC100U</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NCI00UWM</td>
      <td>Fast Ethernet 10/100 Net Card and Network Cable</td>
      <td>NCI00UWM</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NH1005</td>
      <td>Fast Ethernet 10/100 5-Port Hub</td>
      <td>NH1005</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NH1005-WM</td>
      <td>Fast Ethernet 10/100 5-Port Hub</td>
      <td>NH1005</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NH1008</td>
      <td>Fast Ethernet 10/100 8-Port Hub</td>
      <td>NH1008</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NH105</td>
      <td>Ethernet 10BaseT 5-Port Hub</td>
      <td>NH105</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NH108</td>
      <td>Ethernet 10BaseT 8-Port Hub</td>
      <td>NH108</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NHB1005</td>
      <td>Fast Ethernet 10/100 5-Port Starter Kit</td>
      <td>NHB1005</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NHB105</td>
      <td>Ethernet 10BaseT 5-Port Starter Kit</td>
      <td>NHB105</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NM200</td>
      <td>Network Magic Essentials</td>
      <td>NM200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NM300</td>
      <td>Network Magic Pro</td>
      <td>NM300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NM300CD</td>
      <td>Network Magic Backup CD</td>
      <td>NM300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NM500</td>
      <td>Network Magic 5.5</td>
      <td>NM500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH200</td>
      <td>Media Hub with 2 Bays</td>
      <td>NMH200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH200-AS</td>
      <td>Media Hub with 2 Bays</td>
      <td>NMH200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH200-AU</td>
      <td>Media Hub with 2 Bays</td>
      <td>NMH200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH200-CA</td>
      <td>Media Hub with 2 Bays</td>
      <td>NMH200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH200-EU</td>
      <td>Media Hub with 2 Bays</td>
      <td>NMH200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH300</td>
      <td>Media Hub with 2 Bays</td>
      <td>NMH300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH300-AS</td>
      <td>Media Hub with 2 Bays</td>
      <td>NMH300</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH300-AU</td>
      <td>Media Hub with 2 Bays</td>
      <td>NMH300</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH300-CA</td>
      <td>Media Hub with 2 Bays</td>
      <td>NMH300</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH300-EU</td>
      <td>Media Hub with 2 Bays</td>
      <td>NMH300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH300-UK</td>
      <td>Media Hub with 500 GB Drive</td>
      <td>NMH300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH305</td>
      <td>Media Hub with 500 GB Drive</td>
      <td>NMH305</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH305-AS</td>
      <td>Media Hub with 500 GB Drive</td>
      <td>NMH305</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH305-AU</td>
      <td>Media Hub with 500 GB Drive</td>
      <td>NMH305</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH305-CA</td>
      <td>Media Hub with 500 GB Drive</td>
      <td>NMH305</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH305-EU</td>
      <td>Media Hub with 500 GB Drive</td>
      <td>NMH305</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH310</td>
      <td>Media Hub w/500 GB Drive and Flash Card Reader</td>
      <td>NMH310</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH310-AS</td>
      <td>Media Hub w/500 GB Drive and Flash Card Reader</td>
      <td>NMH310</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH310-AU</td>
      <td>Media Hub w/500 GB Drive and Flash Card Reader</td>
      <td>NMH310</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH310-CA</td>
      <td>Media Hub w/500 GB Drive and Flash Card Reader</td>
      <td>NMH310</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH310-EU</td>
      <td>Media Hub w/500 GB Drive and Flash Card Reader</td>
      <td>NMH310</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH310-UK</td>
      <td>Media Hub w/500 GB Drive and Flash Card Reader</td>
      <td>NMH310</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH405</td>
      <td>Media Hub w/500 GB Drive, LCD/Flash Card Reader</td>
      <td>NMH405</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH405-AS</td>
      <td>Media Hub w/500 GB Drive, LCD/Flash Card Reader</td>
      <td>NMH405</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH405-AU</td>
      <td>Media Hub w/500 GB Drive, LCD/Flash Card Reader</td>
      <td>NMH405</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH405-CA</td>
      <td>Media Hub w/500 GB Drive, LCD/Flash Card Reader</td>
      <td>NMH405</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH405-EU</td>
      <td>Media Hub w/500 GB Drive, LCD/Flash Card Reader</td>
      <td>NMH405</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH410</td>
      <td>Media Hub with 1 TB Drive, LCD &amp; Flash Card Reader</td>
      <td>NMH410</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH410-AS</td>
      <td>Media Hub with 1 TB Drive, LCD &amp; Flash Card Reader</td>
      <td>NMH410</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH410-AU</td>
      <td>Media Hub with 1 TB Drive, LCD &amp; Flash Card Reader</td>
      <td>NMH410</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH410-CA</td>
      <td>Media Hub with 1 TB Drive, LCD &amp; Flash Card Reader</td>
      <td>NMH410</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH410-EU</td>
      <td>Media Hub with 1 TB Drive, LCD &amp; Flash Card Reader</td>
      <td>NMH410</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMH510</td>
      <td>Media Hub SX with LCD and 1TB HDD</td>
      <td>NMH510</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH510-AS</td>
      <td>Media Hub SX with LCD and 1TB HDD</td>
      <td>NMH510</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH510-AU</td>
      <td>Media Hub SX with LCD and 1TB HDD</td>
      <td>NMH510</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH510-CA</td>
      <td>Media Hub SX with LCD and 1TB HDD</td>
      <td>NMH510</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH510-EU</td>
      <td>Media Hub SX with LCD and 1TB HDD</td>
      <td>NMH510</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH520</td>
      <td>Media Hub SX with LCD and 2TB HDD</td>
      <td>NMH520</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH520-AS</td>
      <td>Media Hub SX with LCD and 2TB HDD</td>
      <td>NMH520</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH520-AU</td>
      <td>Media Hub SX with LCD and 2TB HDD</td>
      <td>NMH520</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH520-CA</td>
      <td>Media Hub SX with LCD and 2TB HDD</td>
      <td>NMH520</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMH520-EU</td>
      <td>Media Hub SX with LCD and 2TB HDD</td>
      <td>NMH520</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMK210</td>
      <td>Net Mag Essentials Net Mag for Mac Special Offer</td>
      <td>NM200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMK220</td>
      <td>Net Mag Essentials System Mechanic 8 Special Offer</td>
      <td>NM200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMK300</td>
      <td>Net Mag Pro PLUS Net Mag for Mac Special Offer</td>
      <td>NM300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMK320</td>
      <td>Net Mag Pro PLUS Speed Meter Pro Special Offer</td>
      <td>NM300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMK330</td>
      <td>Net Mag Pro PLUS System Mechanic 8 Special Offer</td>
      <td>NM300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMM200</td>
      <td>Network Magic for Mac</td>
      <td>NMM200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMP500</td>
      <td>Network Magic Retail</td>
      <td>NMP500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NMS300</td>
      <td>Network Media Server w/2 bays and 1 500-GB drive</td>
      <td>NMS300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMS300-AS</td>
      <td>Network Media Server w/2 bays and 1 500-GB drive</td>
      <td>NMS300</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMS300-AU</td>
      <td>Network Media Server w/2 bays and 1 500-GB drive</td>
      <td>NMS300</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMS300-CA</td>
      <td>Network Media Server w/2 bays and 1 500-GB drive</td>
      <td>NMS300</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMS300-EU</td>
      <td>Network Media Server w/2 bays and 1 500-GB drive</td>
      <td>NMS300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMS300-UK</td>
      <td>Network Media Server w/2 bays and 1 500-GB drive</td>
      <td>NMS300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMS310</td>
      <td>Media Server w/LCD, 2 bays, and 1 500-GB drive</td>
      <td>NMS310</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMS310-AS</td>
      <td>Media Server w/LCD, 2 bays, and 1 500-GB drive</td>
      <td>NMS310</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMS310-AU</td>
      <td>Media Server w/LCD, 2 bays, and 1 500-GB drive</td>
      <td>NMS310</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMS310-CA</td>
      <td>Media Server w/LCD, 2 bays, and 1 500-GB drive</td>
      <td>NMS310</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMS310-EU</td>
      <td>Media Server w/LCD, 2 bays, and 1 500-GB drive</td>
      <td>NMS310</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMS310-UK</td>
      <td>Media Server w/LCD, 2 bays, and 1 500-GB drive</td>
      <td>NMS310</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NMU300</td>
      <td>Network Magic Pro Upgrade</td>
      <td>NMU300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NP100</td>
      <td>Fast Ethernet 10/100 PC Card</td>
      <td>NP100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NP100-CARD</td>
      <td>Card for NP100</td>
      <td>NP100</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NP100-WM</td>
      <td>Fast Ethernet 10/100 PC Card</td>
      <td>NP100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NP100C</td>
      <td>Coupler for NP100</td>
      <td>NP100C</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NP10T</td>
      <td>Ethernet 10BaseT PC Card</td>
      <td>NP10T</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NP10T-CARD</td>
      <td>Card for NP10T</td>
      <td>NP10T</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NP10TC</td>
      <td>Coupler for NP10T</td>
      <td>NP10TC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NR041</td>
      <td>Cable/DSL 4-Port Router</td>
      <td>NR041</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>NR041-CA</td>
      <td>Cable/DSL 4-Port Router</td>
      <td>NR041</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>NR041-WM</td>
      <td>Cable/DSL 4-Port Router</td>
      <td>NR041</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>NSLU2</td>
      <td>Network Storage Link for USB 2.0 Disk Drives</td>
      <td>NSLU2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NSLU2-AS</td>
      <td>Network Storage Link for USB 2.0 Disk Drives</td>
      <td>NSLU2</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NSLU2-AU</td>
      <td>Network Storage Link for USB 2.0 Disk Drives</td>
      <td>NSLU2</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NSLU2-CA</td>
      <td>Network Storage Link for USB 2.0 Disk Drives</td>
      <td>NSLU2</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NSLU2-DE</td>
      <td>Network Storage Link for USB 2.0 Disk Drives</td>
      <td>NSLU2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NSLU2-EU</td>
      <td>Network Storage Link for USB 2.0 Disk Drives</td>
      <td>NSLU2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NSLU2-FR</td>
      <td>Network Storage Link for USB 2.0 Disk Drives</td>
      <td>NSLU2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NSLU2-SG</td>
      <td>Network Storage Link for USB 2.0 Disk Drives</td>
      <td>NSLU2</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NSLU2-UK</td>
      <td>Network Storage Link for USB 2.0 Disk Drives</td>
      <td>NSLU2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NSLU2-WM</td>
      <td>Network Storage Link for USB 2.0 Disk Drives</td>
      <td>NSLU2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NSLUS-AS</td>
      <td>Network Storage Link for USB 2.0 Disk Drives</td>
      <td>NSLUS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NSUL2-CA</td>
      <td>Network Storage Link for USB 2.0 Disk Drives</td>
      <td>NSUL2</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NWK11B</td>
      <td>Dummy SKU, Wireless-B Broadband Kit</td>
      <td>NWK11B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>NWK11B-WM</td>
      <td>Wireless-B Broadband Kit</td>
      <td>NWK11B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NWM11B</td>
      <td>Wireless PCI Adapter</td>
      <td>NWM11B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NWP11B</td>
      <td>Wireless Notebook Adapter</td>
      <td>NWP11B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NWP11B-CA</td>
      <td>Wireless Notebook Adapter</td>
      <td>NWP11B</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NWR04B</td>
      <td>Wireless Cable/DSL Router</td>
      <td>NWR04B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NWR04B-CA</td>
      <td>Wireless Cable/DSL Router (Canada)</td>
      <td>NWR04B</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NWR11B</td>
      <td>Wireless B Broadband Router</td>
      <td>NWR11B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NWU11B</td>
      <td>Wireless USB Adapter</td>
      <td>NWU11B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>NWU11B-CA</td>
      <td>Wireless USB Adapter (Canada)</td>
      <td>NWU11B</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>OE-NET002au</td>
      <td>DESKTOP NETWORK PCI CARD * OFFICE ESSENTIALS</td>
      <td>OE-NET002</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>OGV200</td>
      <td>Network Optimizer for Gaming and VoIP</td>
      <td>OGV200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>OGV200-CA</td>
      <td>Network Optimizer for Gaming and VoIP</td>
      <td>OGV200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>P10</td>
      <td>Lego Wireless-N Dual Band Router</td>
      <td>P10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>P20</td>
      <td>Lego+</td>
      <td>P20</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PACEPP002</td>
      <td>ENHANCED PARALLEL PORT * (PCI CARD)</td>
      <td>PACEPP002</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PAP2-RB</td>
      <td>Phone Adapter with 2 Ports for Voice-over-IP</td>
      <td>PAP2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PASB221</td>
      <td>Auto Switch, Reversible 2-to-1</td>
      <td>PASB221</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PASB421</td>
      <td>Auto Switch, Reversible 4-to-1</td>
      <td>PASB421</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PASU221</td>
      <td>Auto Switch, 2-to-1 Parallel</td>
      <td>PASU221</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PASU421</td>
      <td>Auto Switch, 4-to-1 Parallel</td>
      <td>PASU421</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PC22224</td>
      <td>ProConnect II 2224</td>
      <td>PC22224</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PC22224-AU</td>
      <td>ProConnect II Lyr 2 Mgmt 24-Port 10/100 Ethernet</td>
      <td>PC22224</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PC22224-CN</td>
      <td>ProConnect II 2224</td>
      <td>PC22224</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PC22224-EU</td>
      <td>ProConnect II 2224</td>
      <td>PC22224</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PC22224-UK</td>
      <td>ProConnect II 2224</td>
      <td>PC22224</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PC22604</td>
      <td>ProConnect II Layer 2 Mgmt 4-Port Giga Ethernet</td>
      <td>PC22604</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PC22604-EU</td>
      <td>ProConnect II Layer 2 Mgmt 4-Port Giga Ethernet</td>
      <td>PC22604</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PC22604-UK</td>
      <td>ProConnect II Layer 2 Mgmt 4-Port Giga Ethernet</td>
      <td>PC22604</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PCM100</td>
      <td>EtherFast 10/100 Intergrated PC Card</td>
      <td>PCM100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCM100-AT</td>
      <td>EtherFast 10/100 Integrated PC Card (AT&amp;T)</td>
      <td>PCM100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCM100-CA</td>
      <td>EtherFast 10/100 Intergrated PC Card (Canada)</td>
      <td>PCM100</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCM100-CN</td>
      <td>EtherFast 10/100 Intergrated PC Card</td>
      <td>PCM100</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PCM100-CX</td>
      <td>EtherFast 10/100 Intergrated PC Card</td>
      <td>PCM100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCM1000</td>
      <td>Gigabit Notebook Adapter</td>
      <td>PCM1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCM1000-AS</td>
      <td>Gigabit Notebook Adapter</td>
      <td>PCM1000</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCM1000-EU</td>
      <td>Gigabit Notebook Adapter</td>
      <td>PCM1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCM100H1</td>
      <td>HoneLink Phoneline + 10/100 Network PC Card</td>
      <td>PCM100H1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCM100H1-CARD</td>
      <td>Card for PCM100H1</td>
      <td>PCM100H1</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCM100H1C</td>
      <td>Coupler of PCM100H1</td>
      <td>PCM100H1C</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCM200</td>
      <td>EtherFast 10/100 Intergrated CardBus Card</td>
      <td>PCM200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCM200-AS</td>
      <td>EtherFast 10/100 Intergrated CardBus Card</td>
      <td>PCM200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PCM200-CA</td>
      <td>EtherFast 10/100 Intergrated CardBus Card</td>
      <td>PCM200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCM200-CN</td>
      <td>EtherFast 10/100 Intergrated CardBus Card</td>
      <td>PCM200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCM200-DE</td>
      <td>EtherFast 10/100 Integrated CardBus PC Card</td>
      <td>PCM200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCM200HA</td>
      <td>Phoneline 10M Intergrated PC Card</td>
      <td>PCM200HA</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCMLM56</td>
      <td>EtherFast 10/100 56K LANmodem PC Card</td>
      <td>PCMLM56</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCMPC100</td>
      <td>EFast 10/100 PCMCIA Card; Auto-sensing 10/100 port</td>
      <td>PCMPC100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCMPC100-CA</td>
      <td>EFast 10/100 PCMCIA Card; Auto-sensing 10/100 port</td>
      <td>PCMPC100</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCMPC100-CARD</td>
      <td>EFast 10/100 PCMCIA Card; Auto-sensing 10/100 port</td>
      <td>PCMPC100</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCMPC100C</td>
      <td>Coupler for PCMPC100/PCMPC200</td>
      <td>PCMPC100C</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCMPC100U</td>
      <td>EtherFast 10/100 PC Card (with Cable)</td>
      <td>PCMPC100U</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCMPC200</td>
      <td>EFast 10/100 CardBus PC Card; Auto-Sensing 10/100</td>
      <td>PCMPC200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCMPC200-CA</td>
      <td>EhterFast 10/100 CarBus PC: Auto-Sense 10/100 port</td>
      <td>PCMPC200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCMPC200-CARD</td>
      <td>Card of PCMPC200</td>
      <td>PCMPC200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PCMRDWR</td>
      <td>Desktop PCMPCIA Card Slots</td>
      <td>PCMRDWR</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PE10</td>
      <td>Dual-Band Selectable WiFi Extender</td>
      <td>PE10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLE200</td>
      <td>Powerline AV Ethernet Adapter</td>
      <td>PLE200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLE200-AS</td>
      <td>Powerline AV Ethernet Adapter</td>
      <td>PLE200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLE200-AU</td>
      <td>Powerline AV Ethernet Adapter</td>
      <td>PLE200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLE200-CA</td>
      <td>Powerline AV Ethernet Adapter</td>
      <td>PLE200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLE200-EU</td>
      <td>Powerline AV Ethernet Adapter</td>
      <td>PLE200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLE200-SG</td>
      <td>Powerline AV Ethernet Adapter</td>
      <td>PLE200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLE200-UK</td>
      <td>Powerline AV Ethernet Adapter</td>
      <td>PLE200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLE300</td>
      <td>Powerline AV Ethernet Adapter</td>
      <td>PLE300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLE300-DE</td>
      <td>Powerline AV Ethernet Adapter</td>
      <td>PLE300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLE300-EU</td>
      <td>Powerline AV Ethernet Adapter</td>
      <td>PLE300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLE300-UK</td>
      <td>Powerline AV Ethernet Adapter</td>
      <td>PLE300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLE400</td>
      <td>PLE400, V1, POWERLINE 1-PORT FAST ETHERNET</td>
      <td>PLEK400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLE500</td>
      <td>PLE500, SKU for assigning unique product code</td>
      <td>PLE500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLE650</td>
      <td>POWERLINE 1-PORT HOMEPLUG AV2 600 MBPS</td>
      <td>PLEK650</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>PLEBR10</td>
      <td>Powerline EtherFast 10/100 Bridge</td>
      <td>PLEBR10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLEBR10-TH</td>
      <td>Powerline EtherFast 10/100 Bridge</td>
      <td>PLEBR10</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLEK400</td>
      <td>Powerline 1-port Kit (1-port FE/1-port FE)</td>
      <td>PLEK400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLEK400-4T</td>
      <td>Powerline 1-port Kit (1-port FE/1-port FE)</td>
      <td>PLEK400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLEK400-CA</td>
      <td>Powerline 1-port Kit (1-port FE/1-port FE)</td>
      <td>PLEK400</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLEK400-NP</td>
      <td>Powerline 1-port Kit (1-port FE/1-port FE)</td>
      <td>PLEK400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLEK400-NT</td>
      <td>Powerline 1-port Kit (1-port FE/1-port FE)</td>
      <td>PLEK400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLEK500</td>
      <td>Powerline 1-port HomePlug AV2 Kit (2 1-port Giga)</td>
      <td>PLEK500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td>31-May-2017</td>
      <td>30-May-2022</td>
    </tr>
    <tr>
      <td>PLEK500-AU</td>
      <td>Powerline 1-port HomePlug AV2 Kit-2X 1-port Giga</td>
      <td>PLEK500</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLEK500-CA</td>
      <td>Powerline 1-port HomePlug AV2 Kit (2 1-port Giga)</td>
      <td>PLEK500</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLEK500-EE</td>
      <td>Powerline 1-port HomePlug AV2 Kit (2 1-port Giga)</td>
      <td>PLEK500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLEK500-EU</td>
      <td>Powerline 1-port HomePlug AV2 Kit (2 1-port Giga)</td>
      <td>PLEK500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLEK500-M2</td>
      <td>Powerline 1-port HomePlug AV2 Kit (2 1-port Giga)</td>
      <td>PLEK500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLEK500-ME</td>
      <td>Powerline 1-port HomePlug AV2 Kit (2 1-port Giga)</td>
      <td>PLEK500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLEK500-UK</td>
      <td>Powerline 1-port HomePlug AV2 Kit (2 1-port Giga)</td>
      <td>PLEK500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLEK650</td>
      <td>POWERLINE 1-PORT HOMEPLUG AV2 600 MBPS KIT</td>
      <td>PLEK650</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLEK650-EJ</td>
      <td>POWERLINE 1-PORT HOMEPLUG AV2 600 MBPS KIT</td>
      <td>PLEK650</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLEK650-EK</td>
      <td>POWERLINE 1-PORT HOMEPLUG AV2 600 MBPS KIT</td>
      <td>PLEK650</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLEK650-EU</td>
      <td>POWERLINE 1-PORT HOMEPLUG AV2 600 MBPS KIT</td>
      <td>PLEK650</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLEK650-ME</td>
      <td>POWERLINE 1-PORT HOMEPLUG AV2 600 MBPS KIT</td>
      <td>PLEK650</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLEK650-UK</td>
      <td>POWERLINE 1-PORT HOMEPLUG AV2 600 MBPS KIT</td>
      <td>PLEK650</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLERT10</td>
      <td>Powerline EtherFast 10/100 Router</td>
      <td>PLERT10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLK200</td>
      <td>PowerLine AV Ethernet Adapter Kit</td>
      <td>PLK200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLK200-AS</td>
      <td>PowerLine AV Ethernet Adapter Kit</td>
      <td>PLK200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLK200-AU</td>
      <td>PowerLine AV Ethernet Adapter Kit</td>
      <td>PLK200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLK200-CA</td>
      <td>PowerLine AV Ethernet Adapter Kit</td>
      <td>PLK200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLK200-DE</td>
      <td>PowerLine AV Ethernet Adapter Kit</td>
      <td>PLK200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLK200-EU</td>
      <td>PowerLine AV Ethernet Adapter Kit</td>
      <td>PLK200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLK200-SG</td>
      <td>PowerLine AV Ethernet Adapter Kit</td>
      <td>PLK200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLK200-UK</td>
      <td>PowerLine AV Ethernet Adapter Kit</td>
      <td>PLK200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLK300</td>
      <td>PowerLine AV Ethernet Adapter Kit</td>
      <td>PLK300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLK300-4A</td>
      <td>PowerLine AV Ethernet Adapter Kit</td>
      <td>PLK300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLK300-DE</td>
      <td>PowerLine AV Ethernet Adapter Kit</td>
      <td>PLK300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLK300-EU</td>
      <td>PowerLine AV Ethernet Adapter Kit</td>
      <td>PLK300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLK300-UK</td>
      <td>PowerLine AV Ethernet Adapter Kit</td>
      <td>PLK300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLS300</td>
      <td>Powerline AV 4-Port Ethernet Adapter</td>
      <td>PLS300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLS300-DE</td>
      <td>Powerline AV 4-Port Ethernet Adapter</td>
      <td>PLS300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLS300-EU</td>
      <td>Powerline AV 4-Port Ethernet Adapter</td>
      <td>PLS300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLS300-UK</td>
      <td>Powerline AV 4-Port Ethernet Adapter</td>
      <td>PLS300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLS400</td>
      <td>PLS400, V1, POWERLINE 4-PORT FAST ETHERENT</td>
      <td>PLSK400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLSK400</td>
      <td>Powerline 4-port Kit (1-port FE/4-port FE)</td>
      <td>PLSK400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLSK400-CA</td>
      <td>Powerline 4-port Kit (1-port FE/4-port FE)</td>
      <td>PLSK400</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLSK400-EU</td>
      <td>Powerline 4-port Kit (1-port FE/4-port FE)</td>
      <td>PLSK400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLSK400-ME</td>
      <td>Powerline 4-port Kit (1-port FE/4-port FE)</td>
      <td>PLSK400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLSK400-NP</td>
      <td>Powerline 4-port Kit (1-port FE/4-port FE)</td>
      <td>PLSK400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLSK400-UK</td>
      <td>Powerline 4-port Kit (1-port FE/4-port FE)</td>
      <td>PLSK400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLTE200</td>
      <td>PowerLine Turbo Ethernet Adapter</td>
      <td>PLTE200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLTE200-AU</td>
      <td>PowerLine Turbo Ethernet Adapter</td>
      <td>PLTE200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLTE200-CA</td>
      <td>PowerLine Turbo Ethernet Adapter</td>
      <td>PLTE200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLTE200-DE</td>
      <td>PowerLine Turbo Ethernet Adapter</td>
      <td>PLTE200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLTE200-EU</td>
      <td>PowerLine Turbo Ethernet Adapter</td>
      <td>PLTE200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLTE200-SG</td>
      <td>PowerLine Turbo Ethernet Adapter</td>
      <td>PLTE200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLTE200-UK</td>
      <td>PowerLine Turbo Ethernet Adapter</td>
      <td>PLTE200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLTK300</td>
      <td>PowerLine Turbo Ethernet Adapter Kit</td>
      <td>PLTK300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLTK300-AU</td>
      <td>PowerLine Turbo Ethernet Adapter Kit</td>
      <td>PLTK300</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLTK300-CA</td>
      <td>PowerLine Turbo Ethernet Adapter Kit</td>
      <td>PLTK300</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLTK300-DE</td>
      <td>PowerLine Turbo Ethernet Adapter Kit</td>
      <td>PLTK300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLTK300-EU</td>
      <td>PowerLine Turbo Ethernet Adapter Kit</td>
      <td>PLTK300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLTK300-SG</td>
      <td>PowerLine Turbo Ethernet Adapter Kit</td>
      <td>PLTK300</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLTK300-UK</td>
      <td>PowerLine Turbo Ethernet Adapter Kit</td>
      <td>PLTK300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLTS200</td>
      <td>PowerLine Turbo 4-Port Ethernet Adapter</td>
      <td>PLTS200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLTS200-AU</td>
      <td>PowerLine Turbo 4-Port Ethernet Adapter</td>
      <td>PLTS200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLTS200-CA</td>
      <td>PowerLine Turbo 4-Port Ethernet Adapter</td>
      <td>PLTS200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLTS200-DE</td>
      <td>PowerLine Turbo 4-Port Ethernet Adapter</td>
      <td>PLTS200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLTS200-EU</td>
      <td>PowerLine Turbo 4-Port Ethernet Adapter</td>
      <td>PLTS200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLTS200-SG</td>
      <td>PowerLine Turbo 4-Port Ethernet Adapter</td>
      <td>PLTS200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLTS200-UK</td>
      <td>PowerLine Turbo 4-Port Ethernet Adapter</td>
      <td>PLTS200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLUSB10</td>
      <td>POWERLINE USB ADAPTER</td>
      <td>PLUSB10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLUSB10-TH</td>
      <td>POWERLINE USB ADAPTER</td>
      <td>PLUSB10</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLW400</td>
      <td>Powerline Wireless Network Extender</td>
      <td>PLW400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLW400-CA</td>
      <td>Powerline Wireless Network Extender</td>
      <td>PLW400</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLW400-NP</td>
      <td>POWERLINE WIRELESS NETWORK EXTENDER</td>
      <td>PLW400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLWK400</td>
      <td>LINKSYS PLWK400 WIFI PWL KIT,N300</td>
      <td>PLWK400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLWK400-4C</td>
      <td>LINKSYS PLWK400 WIFI PWL KIT,N300</td>
      <td>PLWK400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLWK400-CA</td>
      <td>LINKSYS PLWK400 WIFI PWL KIT,N300</td>
      <td>PLWK400</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLWK400-EU</td>
      <td>LINKSYS PLWK400 WIFI PWL KIT,N300</td>
      <td>PLWK400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLWK400-ME</td>
      <td>LINKSYS PLWK400 WIFI PWL KIT,N300</td>
      <td>PLWK400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PLWK400-NP</td>
      <td>LINKSYS PLWK400 WIFI PWL KIT,N300</td>
      <td>PLWK400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PLWK400-UK</td>
      <td>LINKSYS PLWK400 WIFI PWL KIT,N300</td>
      <td>PLWK400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PNET8P010</td>
      <td>8 PORT 10MBPS HUB</td>
      <td>PNET8P010</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PNETCI100</td>
      <td>PCMCIA 10/100MBPS CARD</td>
      <td>PNETCI100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PNETCIAD1</td>
      <td>10 PCMCIA DONGLE</td>
      <td>PNETCIAD1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PNETCIAD2</td>
      <td>10/100 PCMCIA DONGLE * SIDE PLUG</td>
      <td>PNETCIAD2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PNETCIAD3</td>
      <td>10/100 PCMCIA DONGLE * CENTER PLUG</td>
      <td>PNETCIAD3</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PNETISA10</td>
      <td>ISA COMBO CARD 10MBPS</td>
      <td>PNETISA10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PNETPC210</td>
      <td>PCI CARD 10MBPS (NO BNC)</td>
      <td>PNETPC210</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PNH04HPCI</td>
      <td>COMBIN.4PORT HUB &amp; PCI * CARD</td>
      <td>PNH04HPCI</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PPS1</td>
      <td>Pocket Print server</td>
      <td>PPS1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PPS1UW</td>
      <td>EtherFast Wireless-Ready USB PrintServer</td>
      <td>PPS1UW</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PPS1UW-EU</td>
      <td>EtherFast Wireless-Ready USB PrintServer (EU)</td>
      <td>PPS1UW</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PPS1UW-UK</td>
      <td>EtherFast Wireless-Ready USB PrintServer (UK)</td>
      <td>PPS1UW</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PPSX1</td>
      <td>EtherFast 10/100 1-Port PrintServer</td>
      <td>PPSX1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PPSX1-AU</td>
      <td>EtherFast 10/100 1-Port PrintServer</td>
      <td>PPSX1</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PPSX1-EU</td>
      <td>EtherFast 10/100 1-Port PrintServer</td>
      <td>PPSX1</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PPSX1-UK</td>
      <td>EtherFast 10/100 1-Port PrintServer</td>
      <td>PPSX1</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PS-WRT160N-V3</td>
      <td>WRT160N V3 12 volt 1 amp 5 mm barrel power adapter</td>
      <td>WRT160N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PS-WRT160NL-V1</td>
      <td>12 volt, 1.5 AMP, 5 mm Barrel PA</td>
      <td>WRT160NL</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PS2KVM2</td>
      <td>ProConnect 2-Port Compact KVM Switch (PS2)</td>
      <td>PS2KVM2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PS2KVM4</td>
      <td>ProConnect 4-Port Compact KVM Switch (PS2)</td>
      <td>PS2KVM4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PS2KVMSK</td>
      <td>ProConnect 2-Port Compact KVM Switch Kit (PS2)</td>
      <td>PS2KVMSK</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PSUS4</td>
      <td>PrintServer for USB with 4 port Switch</td>
      <td>PSUS4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PSUS4-AS</td>
      <td>PrintServer for USB with 4 port Switch</td>
      <td>PSUS4</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PSUS4-AU</td>
      <td>Print Server for USD with 4-Port Switch</td>
      <td>PSUS4</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PSUS4-CA</td>
      <td>PrintServer for USB with 4 port Switch</td>
      <td>PSUS4</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PSUS4-EU</td>
      <td>PrintServer for USB with 4 port Switch</td>
      <td>PSUS4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PSUS4-SG</td>
      <td>PrintServer for USB with 4 port Switch</td>
      <td>PSUS4</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>PSUS4-TH</td>
      <td>PrintServer for USB with 4 port Switch</td>
      <td>PSUS4</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PSUS4-UK</td>
      <td>PrintServer for USB with 4 port Switch</td>
      <td>PSUS4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>PSUS4-WM</td>
      <td>PrintServer for USB with 4 port Switch</td>
      <td>PSUS4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>R5D6050</td>
      <td>F5D6050 CHIPSET</td>
      <td>R5D6050</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>R5D8000</td>
      <td>PRE-N PCI ADAPTER</td>
      <td>R5D8000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>R5D8010-1</td>
      <td>F5D8010 RALTRON CHIPSET * COM2303-40.000-T-TR</td>
      <td>R5D8010</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>R5D8010-2</td>
      <td>AIRGO CHIPSET * BGN103BB-00-00-MBP</td>
      <td>R5D8010</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>R5D8010-3</td>
      <td>F5D8010 AIRGO CHIPSET * HGN100RF-00-00-PNT</td>
      <td>R5D8010</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>R5D9230-4</td>
      <td>F5D9230-4 CHIPSET - AIRGO * 2X2; AGN102BB-01-00-MBT</td>
      <td>R5D9230</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>RE1000</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE1000-4C</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE1000-4T</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE1000-6A</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE1000-AP</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE1000-AR</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE1000-AU</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE1000-BR</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE1000-CA</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE1000-EE</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE1000-EU</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE1000-LA</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE1000-ME</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE1000-N4</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE1000-NP</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE1000-NT</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE1000-UK</td>
      <td>LINKSYS RE1000 WIFI RANGE EXTENDER,N300</td>
      <td>RE1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE2000</td>
      <td>LINKSYS RE2000 WIFI RANGE EXTENDER,N600</td>
      <td>RE2000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE2000-4A</td>
      <td>LINKSYS RE2000 WIFI RANGE EXTENDER,N600</td>
      <td>RE2000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE2000-AP</td>
      <td>LINKSYS RE2000 WIFI RANGE EXTENDER,N600</td>
      <td>RE2000</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE2000-AU</td>
      <td>LINKSYS RE2000 WIFI RANGE EXTENDER,N600</td>
      <td>RE2000</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE2000-CA</td>
      <td>LINKSYS RE2000 WIFI RANGE EXTENDER,N600</td>
      <td>RE2000</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE2000-CC</td>
      <td>LINKSYS RE2000 WIFI RANGE EXTENDER,N600</td>
      <td>RE2000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE2000-CC-PLT</td>
      <td>LINKSYS RE2000 WIFI RANGE EXTENDER,N600</td>
      <td>RE2000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE2000-EE</td>
      <td>LINKSYS RE2000 WIFI RANGE EXTENDER,N600</td>
      <td>RE2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE2000-EU</td>
      <td>LINKSYS RE2000 WIFI RANGE EXTENDER,N600</td>
      <td>RE2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE2000-HE</td>
      <td>LINKSYS RE2000 WIFI RANGE EXTENDER,N600</td>
      <td>RE2000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE2000-ME</td>
      <td>LINKSYS RE2000 WIFI RANGE EXTENDER,N600</td>
      <td>RE2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE2000-N4</td>
      <td>LINKSYS RE2000 WIFI RANGE EXTENDER,N600</td>
      <td>RE2000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE2000-UK</td>
      <td>LINKSYS RE2000 WIFI RANGE EXTENDER,N600</td>
      <td>RE2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE3000W</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE3000W-AP</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE3000W-BR</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE3000W-EK</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE3000W-FFP</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE3000W-ID</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE3000W-NT</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE3000W-TG</td>
      <td>LINKSYS RE3000W WIFI RANGE EXTENDER,N300</td>
      <td>RE3000W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE4000W</td>
      <td>LINKSYS RE4000W WIFI RANGE EXTENDER,N600</td>
      <td>RE4000W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE4000W-4A</td>
      <td>LINKSYS RE4000W WIFI RANGE EXTENDER,N600</td>
      <td>RE4000W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE4000W-AP</td>
      <td>LINKSYS RE4000W WIFI RANGE EXTENDER,N600</td>
      <td>RE4000W</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE4000W-AR</td>
      <td>LINKSYS RE4000W WIFI RANGE EXTENDER,N600</td>
      <td>RE4000W</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE4000W-AU</td>
      <td>LINKSYS RE4000W WIFI RANGE EXTENDER,N600</td>
      <td>RE4000W</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE4000W-BR</td>
      <td>LINKSYS RE4000W WIFI RANGE EXTENDER,N600</td>
      <td>RE4000W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE4000W-CA</td>
      <td>LINKSYS RE4000W WIFI RANGE EXTENDER,N600</td>
      <td>RE4000W</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE4000W-EJ</td>
      <td>LINKSYS RE4000W WIFI RANGE EXTENDER,N600</td>
      <td>RE4000W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE4000W-EK</td>
      <td>LINKSYS RE4000W WIFI RANGE EXTENDER,N600</td>
      <td>RE4000W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE4000W-FFP</td>
      <td>LINKSYS RE4000W WIFI RANGE EXTENDER,N600</td>
      <td>RE4000W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE4000W-ID</td>
      <td>LINKSYS RE4000W WIFI RANGE EXTENDER,N600</td>
      <td>RE4000W</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE4000W-LA</td>
      <td>LINKSYS RE4000W WIFI RANGE EXTENDER,N600</td>
      <td>RE4000W</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE4000W-ME</td>
      <td>LINKSYS RE4000W WIFI RANGE EXTENDER,N600</td>
      <td>RE4000W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE4000W-UK</td>
      <td>LINKSYS RE4000W WIFI RANGE EXTENDER,N600</td>
      <td>RE4000W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE4100W</td>
      <td>LINKSYS RE4100W WIFI RANGE EXTENDER,N600</td>
      <td>RE4100W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE4100W-AG</td>
      <td>LINKSYS RE4100W WIFI RANGE EXTENDER,N600</td>
      <td>RE4100W</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td>7-Mar-2019</td>
      <td>5-Mar-2024</td>
    </tr>
    <tr>
      <td>RE4100W-AP</td>
      <td>LINKSYS RE4100W WIFI RANGE EXTENDER,N600</td>
      <td>RE4100W</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE4100W-AS</td>
      <td>LINKSYS RE4100W WIFI RANGE EXTENDER,N600</td>
      <td>RE4100W</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE4100W-BR</td>
      <td>LINKSYS RE4100W WIFI RANGE EXTENDER,N600</td>
      <td>RE4100W</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE4100W-SG</td>
      <td>LINKSYS RE4100W WIFI RANGE EXTENDER,N600</td>
      <td>RE4100W</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td>7-Mar-2019</td>
      <td>5-Mar-2024</td>
    </tr>
    <tr>
      <td>RE4100W-TH</td>
      <td>LINKSYS RE4100W WIFI RANGE EXTENDER,N600</td>
      <td>RE4100W</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td>7-Mar-2019</td>
      <td>5-Mar-2024</td>
    </tr>
    <tr>
      <td>RE4100W-UK</td>
      <td>LINKSYS RE4100W WIFI RANGE EXTENDER,N600</td>
      <td>RE4100W</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE6300-TG</td>
      <td>LINKSYS, WIFI RANGE EXTENDER, RE6300, DB AC750</td>
      <td>RE6300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE6500-AP</td>
      <td>LINKSYS RE6500 WIFI RANGE EXTENDER,AC1200,DESKTOP</td>
      <td>RE6500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE6500-AR</td>
      <td>LINKSYS RE6500 WIFI RANGE EXTENDER,AC1200,DESKTOP</td>
      <td>RE6501</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE6500-BR</td>
      <td>LINKSYS RE6500 WIFI RANGE EXTENDER,AC1200,DESKTOP</td>
      <td>RE6500</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE6500-EJ</td>
      <td>LINKSYS RE6500 WIFI RANGE EXTENDER,AC1200,DESKTOP</td>
      <td>RE6500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE6500-EK</td>
      <td>LINKSYS RE6500 WIFI RANGE EXTENDER,AC1200,DESKTOP</td>
      <td>RE6500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE6500-FFP</td>
      <td>LINKSYS RE6500 WIFI RANGE EXTENDER,AC1200,DESKTOP</td>
      <td>RE6500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE6500-LA</td>
      <td>LINKSYS RE6500 WIFI RANGE EXTENDER,AC1200,DESKTOP</td>
      <td>RE6500</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE6500-TG</td>
      <td>LINKSYS RE6500 WIFI RANGE EXTENDER,AC1200,DESKTOP</td>
      <td>RE6500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE6500-TG2</td>
      <td>LINKSYS RE6500 WIFI RANGE EXTENDER,AC1200,DESKTOP</td>
      <td>RE6500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE6500HG-EU</td>
      <td>LINKSYS 2x2 11AC RANGE EXTENDER WITH HIGH GAIN ANTENNA</td>
      <td>RE6700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE6500HG-ID</td>
      <td>LINKSYS 2x2 11AC RANGE EXTENDER WITH HIGH GAIN ANTENNA</td>
      <td>RE6500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE6500HG-TTB</td>
      <td>LINKSYS 2x2 11AC RANGE EXTENDER WITH HIGH GAIN ANTENNA</td>
      <td>RE6500HG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE6500HG-UK</td>
      <td>LINKSYS 2x2 11AC RANGE EXTENDER WITH HIGH GAIN ANTENNA</td>
      <td>RE6700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE6700-AG</td>
      <td>LINKSYS RE6700 WIFI RANGE EXTENDER,AC1200,PT</td>
      <td>RE6700</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE6700-AR</td>
      <td>LINKSYS RE6700 WIFI RANGE EXTENDER,AC1200,PT</td>
      <td>RE6700</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE6700-BR</td>
      <td>LINKSYS RE6700 WIFI RANGE EXTENDER,AC1200,PT</td>
      <td>RE6700</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE6700-EU</td>
      <td>LINKSYS RE6700 WIFI RANGE EXTENDER,AC1200,PT</td>
      <td>RE6700</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE6700-LA</td>
      <td>LINKSYS RE6700 WIFI RANGE EXTENDER,AC1200,PT</td>
      <td>RE6700</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE6700-TG</td>
      <td>LINKSYS RE6700 WIFI RANGE EXTENDER,AC1200,PT</td>
      <td>RE6700</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE6700-TH</td>
      <td>LINKSYS RE6700 WIFI RANGE EXTENDER,AC1200,PT</td>
      <td>RE6700</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>RE6800-8T</td>
      <td>LINKSYS RE6800 WIFI RANGE EXTENDER, AC1750</td>
      <td>RE6800</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE7000-AP</td>
      <td>LINKSYS RE7000 WIFI RANGE EXTENDER, AC1900+</td>
      <td>RE7000</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RE7000x-UK</td>
      <td>LINKSYS RE7000 WIFI RANGE EXTENDER, AC1900+</td>
      <td>RE7000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>REK4000-3T</td>
      <td>COMBO BLISTER PK, RE4000 ASSTD, 3-PK PDQ TRAY</td>
      <td>RE4000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>REK4000-BP</td>
      <td>2-PACK COMBO BLISTER PACK CONTAINING RE4000</td>
      <td>RE4000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>RJ11BT</td>
      <td>Telephone Jack Adapter</td>
      <td>RJ11BT</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>RP10</td>
      <td>Extender</td>
      <td>RP10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SBW0303B</td>
      <td>LINKSYS VELOP SBW0303B AC6600 3PK</td>
      <td>SBW0303B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>SCSI122</td>
      <td>Adapt. Cent.50 Female to HD50 Male</td>
      <td>SCSI122</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SDP204</td>
      <td>1-Port In-line Power + 4-Port 10/100 Switch</td>
      <td>SDP204</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SE1500</td>
      <td>LINKSYS SE1500 WIRED SWITCH,5PORT,FE</td>
      <td>SE1500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>SE1500-AP</td>
      <td>LINKSYS SE1500 WIRED SWITCH,5PORT,FE</td>
      <td>SE1500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>SE1500-AU</td>
      <td>LINKSYS SE1500 WIRED SWITCH,5PORT,FE</td>
      <td>SE1500</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SE1500-CA</td>
      <td>LINKSYS SE1500 WIRED SWITCH,5PORT,FE</td>
      <td>SE1500</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SE1500-EE</td>
      <td>LINKSYS SE1500 WIRED SWITCH,5PORT,FE</td>
      <td>SE1500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>SE1500-ME</td>
      <td>LINKSYS SE1500 WIRED SWITCH,5PORT,FE</td>
      <td>SE1500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>SE2500</td>
      <td>LINKSYS SE2500 WIRED SWITCH,5PORT,GIGABIT</td>
      <td>SE2500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>SE2500-AP</td>
      <td>LINKSYS SE2500 WIRED SWITCH,5PORT,GIGABIT</td>
      <td>SE2500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>SE2500-CA</td>
      <td>LINKSYS SE2500 WIRED SWITCH,5PORT,GIGABIT</td>
      <td>SE2500</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SE2500-EE</td>
      <td>LINKSYS SE2500 WIRED SWITCH,5PORT,GIGABIT</td>
      <td>SE2500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SE2800</td>
      <td>LINKSYS SE2800 WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE2800</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SE2800-AP</td>
      <td>LINKSYS SE2800 WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE2800</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>SE2800-CA</td>
      <td>LINKSYS SE2800 WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE2800</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SE2800-EE</td>
      <td>LINKSYS SE2800 WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE2800</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SE3016-CA</td>
      <td>LINKSYS SE3016 WIRED SWITCH,16PORT,GIGABIT,METAL</td>
      <td>SE3016</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SE3024-CA</td>
      <td>LINKSYS SE3024 WIRED SWITCH,24PORT,GIGABIT,METAL</td>
      <td>SE3024</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SE4008</td>
      <td>LINKSYS SE4008 WRT WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE4008</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SE4008-AU</td>
      <td>LINKSYS SE4008 WRT WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE4008</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SE4008-CA</td>
      <td>LINKSYS SE4008 WRT WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE4008</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SE4008-FFP</td>
      <td>LINKSYS SE4008 WRT WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE4008</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SE4008-TTB</td>
      <td>LINKSYS SE4008 WRT WIRED SWITCH,8PORT,GIGABIT</td>
      <td>SE4008</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SM300</td>
      <td>Speed Meter Pro</td>
      <td>SM300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SPA8000-EU</td>
      <td>8-Port IP Telephony Gateway</td>
      <td>SPA8000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>SPA8000-NA</td>
      <td>8-Port IP Telephony Gateway</td>
      <td>SPA8000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>SPA922-KR</td>
      <td>1-Line IP Telephone with 2-Port Ethernet Switch, P</td>
      <td>SPA922</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>SPA922-UK</td>
      <td>1-Line IP Telephone with 2-Port Enet Switch</td>
      <td>SPA922</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SPHUB05W</td>
      <td>5 Port Hub</td>
      <td>SPHUB05W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SPHUB08S</td>
      <td>StackPro 100BaseT 8-Port Rackmount Hub</td>
      <td>SPHUB08S</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SPHUB08W</td>
      <td>8 Port Hub</td>
      <td>SPHUB08W</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SPHUB10S</td>
      <td>StackPro 100 10-port Hub</td>
      <td>SPHUB10S</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SPHUB16S</td>
      <td>StackPro 100 16-port Hub</td>
      <td>SPHUB16S</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SPHUB24S</td>
      <td>StackPro 100 24-Port Hub</td>
      <td>SPHUB24S</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SR0224G</td>
      <td>24-Port 10/100 + 1-Port Gigabit Switch + 1miniGBIC</td>
      <td>SR0224G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SR316</td>
      <td>Layer 2 Mgmt 16-Port 10/100 Switch w/1 Extensible</td>
      <td>SR316</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SR316-CN</td>
      <td>Lyr 2 Mgmt 16-Port 10/100 Switch w/1-Extensible</td>
      <td>SR316</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SR316-CS</td>
      <td>Lyr 2 Mgmt 16-Port 10/100 Switch w/1-Extensible</td>
      <td>SR316</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SR324</td>
      <td>Layer 2 Mgmt 24-Port 10/100 Switch w/1 Extensible</td>
      <td>SR324</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SR324-CN</td>
      <td>Layer 2 Mgmt 24-Port 10/100 Switch w/1-Extensible</td>
      <td>SR324</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SR324-CS</td>
      <td>Layer 2 Mgmt 24-Port 10/100 Switch w/1-Extensible</td>
      <td>SR324</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SRM224</td>
      <td>24 Fast Ether /2 SFP GE ports/2 copper GE ports</td>
      <td>SRM224</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SRM3024X</td>
      <td>24 giga Ethernet ports,1 XFP/2 HyperGStack ports</td>
      <td>SRM3024</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SRM3024XP</td>
      <td>24 giga Ethernet ports 1XFP/2HyperGStack ports PoE</td>
      <td>SRM3024</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SRM3048X</td>
      <td>48 giga Ethernet ports, 1 XFP/2HyperGStack ports</td>
      <td>SRM3048X</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SRM3048XP</td>
      <td>48 Giga Ethernet, 1 XFP/2 HyperGStack w/PoE</td>
      <td>SRM3048X</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>SS100</td>
      <td>Simple Setup</td>
      <td>SS100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SS300</td>
      <td>Linksys by Cisco Setup Service</td>
      <td>SS300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SS300-6A</td>
      <td>Linksys by Cisco Setup Service</td>
      <td>SS300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SS300-CA</td>
      <td>Linksys by Cisco Setup Service</td>
      <td>SS300</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SV300-EU</td>
      <td>SV300-EU</td>
      <td>SV300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SV300-UK</td>
      <td>SV300-EU</td>
      <td>SV300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SV300-US</td>
      <td>SV300-US</td>
      <td>SV300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SVAT06</td>
      <td>ProConnect CPU Switch AT/Serial Cable Kit</td>
      <td>SVAT06</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SVPAT10</td>
      <td>ProConnect CPU Switch Premium Cable Kit (AT)</td>
      <td>SVPAT10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SVPPS10</td>
      <td>ProConnect CPU Switch Premium Cable Kit (PS/2)</td>
      <td>SVPPS10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>SVPS06</td>
      <td>ProConnect CPU Switch PS/2 Cable Kit</td>
      <td>SVPS06</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>TBDCARRERA</td>
      <td>Dual-Band Wireless N1750 Router</td>
      <td>TBDCARRERA</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>TBDCARRERA-AP</td>
      <td>Dual-Band Wireless N1750 Router</td>
      <td>TBDCARRERA</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>TBDCARRERA-AU</td>
      <td>Dual-Band Wireless N1750 Router</td>
      <td>TBDCARRERA</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>TBDCARRERA-CA</td>
      <td>Dual-Band Wireless N1750 Router</td>
      <td>TBDCARRERA</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>TBDCARRERA-CE</td>
      <td>Dual-Band Wireless N1750 Router</td>
      <td>TBDCARRERA</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>TBDCARRERA-EE</td>
      <td>Dual-Band Wireless N1750 Router</td>
      <td>TBDCARRERA</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>TBDCARRERA-EN</td>
      <td>Dual-Band Wireless N1750 Router</td>
      <td>TBDCARRERA</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>TBDCARRERA-EW</td>
      <td>Dual-Band Wireless N1750 Router</td>
      <td>TBDCARRERA</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>TBDCARRERA-EZ</td>
      <td>Dual-Band Wireless N1750 Router</td>
      <td>TBDCARRERA</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>TBDCARRERA-ME</td>
      <td>Dual-Band Wireless N1750 Router</td>
      <td>TBDCARRERA</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>TBDCARRERA-UK</td>
      <td>Dual-Band Wireless N1750 Router</td>
      <td>TBDCARRERA</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>TERM02</td>
      <td>50 ohm Twin-Pack Terminator</td>
      <td>TERM02</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>U5D384</td>
      <td>5 PORT 10 MBPS HUB</td>
      <td>U5D384</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>UP10</td>
      <td>Mediator</td>
      <td>UP10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>UPA200-NA</td>
      <td>USB Phone Adapter for AOL Instant Messenger</td>
      <td>UPA200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td>23-Mar-2015</td>
      <td>21-Mar-2020</td>
    </tr>
    <tr>
      <td>USB-NMP500</td>
      <td>NMP500 USB 512K Memory stick without Network Magic</td>
      <td>USB-NMP500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td>30-Mar-2015</td>
      <td>28-Mar-2020</td>
    </tr>
    <tr>
      <td>USB1000</td>
      <td>Gigabit USB Adapter</td>
      <td>USB1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB1000-AS</td>
      <td>Gigabit USB Adapter</td>
      <td>USB1000</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB1000-EU</td>
      <td>Gigabit USB Adapter</td>
      <td>USB1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB100H1</td>
      <td>HomeLink Phoneline + 10/100 USB Network Adapter</td>
      <td>USB100H1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB100M</td>
      <td>EtherFast 10/100 Compact USB Network Adapter</td>
      <td>USB100M</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB100M-CA</td>
      <td>EFast 10/100 Compact USB Network Adapter (Canada))</td>
      <td>USB100M</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB100M-CX</td>
      <td>EtherFast 10/100 Compact USB Network Adapter</td>
      <td>USB100M</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB100M-EU</td>
      <td>EtherFast 10/100 Compact USB Network Adapter</td>
      <td>USB100M</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB100TX</td>
      <td>EtherFast 10/100 USB Network Adapter</td>
      <td>USB100TX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB100TX-AT</td>
      <td>EtherFast 10/100 USB Network Adapter (AT&amp;T)</td>
      <td>USB100TX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB100TX-CA</td>
      <td>EtherFast 10/100 USB Network Adapter (Canada)</td>
      <td>USB100TX</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB10T</td>
      <td>USB Network Adapter; USB to 10Base or 10/100 Net</td>
      <td>USB10T</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB10T-V1</td>
      <td>USB to 10BastT Network Adapter-V1</td>
      <td>USB10T</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB200HA</td>
      <td>HomeLink Phoneline 10M USB Adapter</td>
      <td>USB200HA</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB200M</td>
      <td>EtherFast USB 2.0 10/100 Network Adapter</td>
      <td>USB200M</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB200M-CA</td>
      <td>EtherFast USB 2.0 10/100 Network Adapter</td>
      <td>USB200M</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB200M-DE</td>
      <td>EtherFast USB 2.0 10/100 Network Adapter</td>
      <td>USB200M</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB200M-EU</td>
      <td>EtherFast USB 2.0 10/100 Network Adapter</td>
      <td>USB200M</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB200M-FR</td>
      <td>EtherFast USB 2.0 10/100 Network Adapter</td>
      <td>USB200M</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB200M-UK</td>
      <td>EtherFast USB 2.0 10/100 Network Adapter</td>
      <td>USB200M</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB2128M</td>
      <td>Instant USB 2.0 Disk 128MB</td>
      <td>USB2128M</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB2128M-JP</td>
      <td>USB 2.0 Disk 128MB</td>
      <td>USB2128M</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB2HUB4</td>
      <td>USB 4-Port Hub (Version2.0)</td>
      <td>USB2HUB4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB2HUB4-CN</td>
      <td>USB 4-Port Hub (Version2.0)</td>
      <td>USB2HUB4</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>USB2HUB4-EU</td>
      <td>USB 4-Port Hub (Version2.0)</td>
      <td>USB2HUB4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB2HUB4-UK</td>
      <td>USB 4-Port Hub (Version2.0)</td>
      <td>USB2HUB4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB2MCR</td>
      <td>Universal Memory Card Reader w/USB 2.0 Hub</td>
      <td>USB2MCR</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>USB300G</td>
      <td>LINKSYS, USB3.0 GIGABIT ETHERNET ADAPTER</td>
      <td>USB300G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>USB300G-AP</td>
      <td>LINKSYS, USB3.0 GIGABIT ETHERNET ADAPTER</td>
      <td>USB300G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>USB300M</td>
      <td>USB Ethernet Adapter</td>
      <td>USB300M</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB300M-EU</td>
      <td>USB Ethernet Adapter</td>
      <td>USB300M</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>USB3GIG-AP</td>
      <td>LINSKYS USB3GIG ETHERNET ADAPTER,GIGABIT</td>
      <td>USB3GIG</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>USB3GIG-EE</td>
      <td>LINSKYS USB3GIG ETHERNET ADAPTER,GIGABIT</td>
      <td>USB3GIG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USB3GIG-EK</td>
      <td>LINSKYS USB3GIG ETHERNET ADAPTER,GIGABIT</td>
      <td>USB3GIG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>USB3GIG-EU</td>
      <td>LINSKYS USB3GIG ETHERNET ADAPTER,GIGABIT</td>
      <td>USB3GIG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBBT100</td>
      <td>Bluetooth USB Adapter</td>
      <td>USBBT100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>USBBT100-CA</td>
      <td>Bluetooth USB Adapter</td>
      <td>USBBT100</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBBT100-EU</td>
      <td>Bluetooth USB Adapter</td>
      <td>USBBT100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBBT100-UK</td>
      <td>Bluetooth USB Adapter</td>
      <td>USBBT100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBDSL1</td>
      <td>ADSL USB Modem</td>
      <td>USBDSL1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBHUB04</td>
      <td>USB 4-port Hub</td>
      <td>USBHUB04</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBHUB04-EU</td>
      <td>USB 4-port Hub</td>
      <td>USBHUB04</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBHUB04-UK</td>
      <td>USB 4-port Hub</td>
      <td>USBHUB04</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBHUB4C</td>
      <td>ProConnect Compact USB 4-Port Hub</td>
      <td>USBHUB4C</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBHUB4C-CA</td>
      <td>ProConnect Compact USB 4-Port Hub</td>
      <td>USBHUB4C</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBHUB4C-EU</td>
      <td>ProConnect Compact USB 4-Port Hub</td>
      <td>USBHUB4C</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBHUB4C-UK</td>
      <td>ProConnect Compact USB 4-Port Hub</td>
      <td>USBHUB4C</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBHUB4CP</td>
      <td>ProConnect Compact USB 4-Port Hub Power Adapter</td>
      <td>USBHUB4CP</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>USBKVM4</td>
      <td>Dummy SKU, USB KVM Switch</td>
      <td>USBKVM4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>USBM128M</td>
      <td>Instant USB Disk 128MB</td>
      <td>USBM128M</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBM128M-CA</td>
      <td>Instant USB Disk 128MB</td>
      <td>USBM128M</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBM32M</td>
      <td>Instant USB Disk 32MB</td>
      <td>USBM32M</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBM64M</td>
      <td>Instant USB Disk 64MB</td>
      <td>USBM64M</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBM64M-CA</td>
      <td>Instant USB Disk 64MB (Canada)</td>
      <td>USBM64M</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBVPN1</td>
      <td>USB VPN &amp; Firewall Adapter</td>
      <td>USBVPN1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBVPN1-CN</td>
      <td>USB VPN &amp; Firewall Adapter</td>
      <td>USBVPN1</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBVPN1-EU</td>
      <td>USB VPN &amp; Firewall Adapter</td>
      <td>USBVPN1</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>USBX1</td>
      <td>USB Extension Base</td>
      <td>USBX1</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>UTA200</td>
      <td>UMA Telephone Adapter w/1 Phone Port</td>
      <td>UTA200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>UTA200-TM</td>
      <td>UMA Telephone Adapter with 1 Phone Port</td>
      <td>UTA200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>UTP510</td>
      <td>UTP Network Cable, Cat 5, 10 Feet</td>
      <td>UTP510</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>UTP510-VN</td>
      <td>UTP Network Cable, Cat 5, 10 Feet</td>
      <td>UTP510</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>UTP525</td>
      <td>UTP Network Cable, Cat 5, 25 Feet</td>
      <td>UTP525</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>UTP550</td>
      <td>UTP Network Cable, Cat 5, 50 Feet</td>
      <td>UTP550</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>UTPX10</td>
      <td>10 UTP Cross-Over Cable</td>
      <td>UTPX10</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>VR558300</td>
      <td>HDD Recorder 300GB HDD w DVD</td>
      <td>VR558300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>VR558300-AU</td>
      <td>Harddisk Recorder 300GB HDD with Ethernet</td>
      <td>VR558300</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>VR558300-EU</td>
      <td>Harddisk Recorder 300GB HDD with Ethernet</td>
      <td>VR558300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>VR558300-UK</td>
      <td>Harddisk Recorder 300GB HDD with Ethernet</td>
      <td>VR558300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>VR558400</td>
      <td>Harddisk Recorder 400GB HDD w/ DVD Player and Eth</td>
      <td>VR558400</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>VR558400-EU</td>
      <td>Harddisk Recorder 400GB HDD w/Enet and DVD Player</td>
      <td>VR558400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>VR558400-UK</td>
      <td>Harddisk Recorder 400GB HDD w/Ethernet and DVD</td>
      <td>VR558400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>VZ4000</td>
      <td>WIRELESS DSKTOP NTWK CARD * 54Mbps 802.11g</td>
      <td>VZ4000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>VZ4001</td>
      <td>WIRELESS DSKTOP NTWK CARD * 125Mbps 802.11g</td>
      <td>VZ4001</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>VZ4010</td>
      <td>WIRELESS NOTEBOOK ADAPTER * 54Mbps 802.11g</td>
      <td>VZ4010</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>VZ4011</td>
      <td>WIRELESS NOTEBOOK ADAPTER * 125Mbps 802.11g</td>
      <td>VZ4011</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>VZ4050</td>
      <td>WIRELESS USB ADAPTER * 54Mbps 802.11g</td>
      <td>VZ4050</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>VZ4051</td>
      <td>WIRELESS USB ADAPTER * 125Mbps 802.11g</td>
      <td>VZ4051</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>W11S4PC11</td>
      <td>Wireless-B Network Kit Router + Notebook Adapter</td>
      <td>W11S4PC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>W11S4PC11-CA</td>
      <td>Wireless-B Network Kit Router + Notebook Adapter</td>
      <td>W11S4PC11</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>W11S4PC11-CN</td>
      <td>Wireless-B Network Kit Router + Notebook Adapter</td>
      <td>W11S4PC11</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>W11S4PC11-EU</td>
      <td>WPC11+EFast Wireless AP+Cable/DSLRtr w/(BEFW11S4</td>
      <td>W11S4PC11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>W11S4PC11-LA</td>
      <td>Wireless-B Network Kit Router + Notebook Adapter</td>
      <td>W11S4PC11</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>W11S4PC11-TH</td>
      <td>Wireless-B Network Kit</td>
      <td>W11S4PC11</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>W11S4PC11-UK</td>
      <td>WPC11+EFast Wireless AP+Cable/DSLRtr w/(BEFW11S4</td>
      <td>W11S4PC11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>W11S4U11</td>
      <td>Dummy Sku, Wireless Broadband Network in a Box</td>
      <td>W11S4U11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>W11S4U11-DE</td>
      <td>Wireless Broadband Network in a Box</td>
      <td>W11S4U11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>W11S4U11-FR</td>
      <td>Wireless Broadband Network in a Box</td>
      <td>W11S4U11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAG100-DE</td>
      <td>Wireless ADSL2+ Gateway</td>
      <td>WAG100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG100-E1</td>
      <td>Wireless ADSL2+ Gateway</td>
      <td>WAG100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG100-EU</td>
      <td>Wireless ADSL2+ Gateway</td>
      <td>WAG100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG100-UK</td>
      <td>Wireless ADSL2+ Gateway</td>
      <td>WAG100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG110-DE</td>
      <td>RangePlus Wireless ADSL2+ Gateway</td>
      <td>WAG110</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG110-E1</td>
      <td>RangePlus Wireless ADSL2+ Gateway</td>
      <td>WAG110</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG110-EU</td>
      <td>RangePlus Wireless ADSL2+ Gateway</td>
      <td>WAG110</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG110-UK</td>
      <td>RangePlus Wireless ADSL2+ Gateway</td>
      <td>WAG110</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG120N</td>
      <td>WlessN Home ADSL2+ Modem Rtr</td>
      <td>WAG120N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG120N-AP</td>
      <td>Wireless-N Home ADSL2+ Modem Router</td>
      <td>WAG120N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG120N-AU</td>
      <td>Wireless-N Home ADSL2+ Modem Router</td>
      <td>WAG120N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG120N-BR</td>
      <td>Wireless-N Home ADSL2+ Modem Router</td>
      <td>WAG120N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG120N-DE</td>
      <td>Wireless-N Home ADSL2+ Modem Router</td>
      <td>WAG120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG120N-E1</td>
      <td>Wireless-N Home ADSL2+ Modem Router</td>
      <td>WAG120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG120N-EE</td>
      <td>Wireless-N Home ADSL2+ Modem Router</td>
      <td>WAG120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG120N-EW</td>
      <td>Wireless-N Home ADSL2+ Modem Router</td>
      <td>WAG120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG120N-EZ</td>
      <td>Wireless-N Home ADSL2+ Modem Router</td>
      <td>WAG120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG120N-ID</td>
      <td>Wireless-N Home ADSL2+ Modem Router</td>
      <td>WAG120N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td>23-Mar-2015</td>
      <td>21-Mar-2020</td>
    </tr>
    <tr>
      <td>WAG120N-IN</td>
      <td>Wireless-N Home ADSL2+ Modem Router</td>
      <td>WAG120N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WAG120N-LA</td>
      <td>Wireless-N Home ADSL2+ Modem Router</td>
      <td>WAG120N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG120N-ME</td>
      <td>Wireless-N Home ADSL2+ Modem Router</td>
      <td>WAG120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG120N-PV</td>
      <td>Wireless-N Home ADSL2+ Modem Router</td>
      <td>WAG120N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WAG120N-SG</td>
      <td>Wireless-N Home ADSL2+ Modem Router</td>
      <td>WAG120N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WAG120N-TH</td>
      <td>Wireless-N Home ADSL2+ Modem Router</td>
      <td>WAG120N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WAG120N-UK</td>
      <td>Wireless-N Home ADSL2+ Modem Router</td>
      <td>WAG120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG150N-AU</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG150N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG150N-DE</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG150N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG150N-E1</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG150N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG150N-EU</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG150N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG150N-SG</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG150N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG150N-UK</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG150N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG160N-AS</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG160N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG160N-AU</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG160N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG160N-DE</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG160N-E1</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG160N-EE</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG160N-EU</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG160N-EW</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG160N-EZ</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG160N-ID</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG160N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WAG160N-IN</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG160N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WAG160N-PV</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG160N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WAG160N-SG</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG160N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG160N-TH</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG160N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WAG160N-UK</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG200G</td>
      <td>Wireless-G ADSL Home Gateway</td>
      <td>WAG200G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG200G-AS</td>
      <td>Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG200G-AU</td>
      <td>Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG200G-DE</td>
      <td>WAG200G-DE, Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG200G-E1</td>
      <td>WAG200G-E1, Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG200G-EU</td>
      <td>WAG200G-EU, Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG200G-FR</td>
      <td>WAG200G-FR, Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG200G-LA</td>
      <td>Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG200G-SE</td>
      <td>WAG200G-SE, Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG200G-SG</td>
      <td>Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG200G-UK</td>
      <td>WAG200G-UK, Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG210G</td>
      <td>Wireless-G ADSL2+ Gateway with VoIP and ISDN</td>
      <td>WAG210G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG210G-E1</td>
      <td>Wireless-G ADSL2+ Gateway with VoIP and ISDN</td>
      <td>WAG210G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG210G-E3</td>
      <td>Wireless-G ADSL2+ Gateway with VoIP and ISDN</td>
      <td>WAG210G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG250G-AU</td>
      <td>Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG250G-DE</td>
      <td>Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG250G-E1</td>
      <td>Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG250G-EU</td>
      <td>Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG250G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG250G-FR</td>
      <td>Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG250G-LA</td>
      <td>Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG250G-SG</td>
      <td>Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG250G-UK</td>
      <td>Wireless-G ADSL2+ Home Gateway</td>
      <td>WAG200G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG300N-AS</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG300N-AU</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG300N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG300N-DE</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG300N-E1</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG300N-EU</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG300N-FR</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG300N-NZ</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG300N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG300N-SE</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG300N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG300N-SG</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG300N-UK</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG310G-AU</td>
      <td>Wireless-G ADSL2+ Gateway with VoIP</td>
      <td>WAG310G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG310G-E2</td>
      <td>Wireless-G ADSL2+ Gateway with VoIP</td>
      <td>WAG310G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG310G-E3</td>
      <td>Wireless-G ADSL2+ Gateway with VoIP</td>
      <td>WAG310G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td>23-Mar-2015</td>
      <td>21-Mar-2020</td>
    </tr>
    <tr>
      <td>WAG310G-NA</td>
      <td>Wireless-G ADSL2+ Gateway with VoIP</td>
      <td>WAG310G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG310G-PT</td>
      <td>Wireless-G ADSL2+ Gateway with VoIP</td>
      <td>WAG310G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG310G-U2</td>
      <td>Wireless-G ADSL2+ Gateway with VoIP</td>
      <td>WAG310G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG310G-U4</td>
      <td>Wireless-G ADSL2+ Gateway with VoIP</td>
      <td>WAG310G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG310N</td>
      <td>Wireless-N ADSL2+ Gateway with VoIP</td>
      <td>WAG310N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WAG320N</td>
      <td>DualBand WlessN ADSL2+ Modem Rtr w/Gigabit</td>
      <td>WAG320N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG320N-AU</td>
      <td>Dual-Band Wireless-N ADSL2+ Modem Rtr with Gigabit</td>
      <td>WAG320N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG320N-DE</td>
      <td>Cancel</td>
      <td>WAG320N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WAG320N-EE</td>
      <td>Cancel</td>
      <td>WAG320N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WAG320N-EU</td>
      <td>Dual-Band Wireless-N ADSL2+ Modem Rtr with Gigabit</td>
      <td>WAG320N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG320N-EW</td>
      <td>Cancel</td>
      <td>WAG320N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WAG320N-EZ</td>
      <td>Cancel</td>
      <td>WAG320N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WAG320N-ME</td>
      <td>Dual-Band Wireless-N ADSL2+ Modem Rtr with Gigabit</td>
      <td>WAG320N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG320N-UK</td>
      <td>Dual-Band Wireless-N ADSL2+ Modem Rtr with Gigabit</td>
      <td>WAG320N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG325N-AS</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG325N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG325N-AU</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG325N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG325N-DE</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG325N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG325N-E1</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG325N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG325N-EU</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG325N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG325N-FR</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG325N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG325N-NZ</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG325N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG325N-SE</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG325N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG325N-SG</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG325N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG325N-UK</td>
      <td>Wireless-N ADSL2+ Gateway</td>
      <td>WAG325N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG350N</td>
      <td>Wireless N ADSL2+ Gateway</td>
      <td>WAG350N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG354G</td>
      <td>Wireless-G ADSL Home Gateway</td>
      <td>WAG354G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG354G-AS</td>
      <td>Wireless-G ADSL Home Gateway</td>
      <td>WAG354G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG354G-AU</td>
      <td>Wireless-G ADSL Home Gateway</td>
      <td>WAG354G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG354G-DE</td>
      <td>Wireless-G ADSL Home Gateway</td>
      <td>WAG354G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG354G-E1</td>
      <td>Wireless-G ADSL Home Gateway</td>
      <td>WAG354G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG354G-EU</td>
      <td>Wireless-G ADSL Home Gateway</td>
      <td>WAG354G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG354G-FR</td>
      <td>Wireless-G ADSL Home Gateway</td>
      <td>WAG354G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG354G-SE</td>
      <td>Wireless-G ADSL Home Gateway</td>
      <td>WAG354G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG354G-SG</td>
      <td>Wireless-G ADSL Home Gateway</td>
      <td>WAG354G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG354G-UK</td>
      <td>Wireless-G ADSL Home Gateway</td>
      <td>WAG354G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G</td>
      <td>Wireless-G ADSL Gateway</td>
      <td>WAG54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G-AU</td>
      <td>Wireless-G ADSL Gateway</td>
      <td>WAG54G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G-CN</td>
      <td>Wireless-G ADSL Gateway</td>
      <td>WAG54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G-D1</td>
      <td>Wireless-G ADSL Gateway (Annex B UR-2)</td>
      <td>WAG54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G-DE</td>
      <td>Wireless-G ADSL Gateway</td>
      <td>WAG54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G-E1</td>
      <td>Wireless-G ADSL Gateway (Annex B)</td>
      <td>WAG54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G-E2</td>
      <td>WAG54G-E2, Wireless-G ADSL2+ Gateway (Annex A)</td>
      <td>WAG54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G-E3</td>
      <td>WAG54G-E3, Wireless-G ADSL2+ Gateway Annex B</td>
      <td>WAG54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G-EU</td>
      <td>Wireless-G ADSL Gateway</td>
      <td>WAG54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G-FR</td>
      <td>Wireless-G ADSL Gateway</td>
      <td>WAG54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G-ML</td>
      <td>Wireless-G ADSL Gateway</td>
      <td>WAG54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G-NA</td>
      <td>Wireless-G ADSL2+ Gateway (Annex A)</td>
      <td>WAG54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG54G-NZ</td>
      <td>Wireless-G ADSL Gateway</td>
      <td>WAG54G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G-SE</td>
      <td>Wireless-G ADSL Gateway</td>
      <td>WAG54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G-ST</td>
      <td>Wireless-G ADSL Gateway</td>
      <td>WAG54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G-U2</td>
      <td>WAG54G-U2, Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G-UK</td>
      <td>Wireless-G ADSL Gateway</td>
      <td>WAG54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G-XW</td>
      <td>ADSL Gateway with 4 Port Switch</td>
      <td>WAG54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G2-AU</td>
      <td>Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G2</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G2-BR</td>
      <td>Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG54G2-DE</td>
      <td>Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G2-E1</td>
      <td>Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G2-EE</td>
      <td>Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G2-EU</td>
      <td>Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG54G2-EW</td>
      <td>Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G2-EZ</td>
      <td>Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G2-FR</td>
      <td>Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG54G2-ID</td>
      <td>Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G2</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG54G2-IN</td>
      <td>Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G2-LA</td>
      <td>Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G2</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG54G2-PV</td>
      <td>Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G2-SG</td>
      <td>Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G2</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G2-TH</td>
      <td>Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G2</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54G2-UK</td>
      <td>Wireless-G ADSL2+ Gateway</td>
      <td>WAG54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GP2</td>
      <td>Wireless-G ADSL Gateway with 2 Phone Ports</td>
      <td>WAG54GP2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GP2-AS</td>
      <td>WAG54GP2-AS, WlessG ADSL2+ Gateway w/2 Phone Ports</td>
      <td>WAG54GP2</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GP2-AU</td>
      <td>WAG54GP2-AU, WlessG ADSL2+ Gateway w/2 Phone Ports</td>
      <td>WAG54GP2</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GP2-DE</td>
      <td>WAG54GP2-DE, WlessG ADSL2+ Gateway w/2 Phone Ports</td>
      <td>WAG54GP2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GP2-E2</td>
      <td>Wireless-G ADSL2+ Gateway with 2 Phone Ports</td>
      <td>WAG54GP2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GP2-E3</td>
      <td>Wireless-G ADSL2+ Gateway with 2 Phone Ports</td>
      <td>WAG54GP2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GP2-EU</td>
      <td>WAG54GP2-EU, WlessG ADSL2+ Gateway w/2 Phone Ports</td>
      <td>WAG54GP2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GP2-FR</td>
      <td>WAG54GP2-FR, WlessG ADSL2+ Gateway w/2 Phone Ports</td>
      <td>WAG54GP2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GP2-NZ</td>
      <td>Wireless-G ADSL2+ Gateway with 2 Phone Ports</td>
      <td>WAG54GP2</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GP2-S4</td>
      <td>Wireless-G ADSL2+ Gateway with 2 Phone Ports</td>
      <td>WAG54GP2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GP2-SG</td>
      <td>WAG54GP2-SG, WlessG ADSL2+ Gateway w/2 Phone Ports</td>
      <td>WAG54GP2</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GP2-U2</td>
      <td>Wireless-G ADSL2+ Gateway with 2 Phone Ports</td>
      <td>WAG54GP2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GP2-UK</td>
      <td>WAG54GP2-UK, WlessG ADSL2+ Gateway w/2 Phone Ports</td>
      <td>WAG54GP2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GP2-ZJ</td>
      <td>Wireless-G ADSL2+ Gateway with 2 Phone Ports</td>
      <td>WAG54GP2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GS</td>
      <td>Wireless-G ADSL Gateway with SpeedBooster</td>
      <td>WAG54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG54GS-DE</td>
      <td>Wireless-G ADSL Gateway with SpeedBooster</td>
      <td>WAG54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GS-E1</td>
      <td>Wireless-G ADSL Gateway with SpeedBooster</td>
      <td>WAG54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GS-EU</td>
      <td>Wireless-G ADSL Gateway with SpeedBooster</td>
      <td>WAG54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GS-FR</td>
      <td>Wireless-G ADSL Gateway with SpeedBooster</td>
      <td>WAG54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GS-UK</td>
      <td>Wireless-G ADSL Gateway with SpeedBooster</td>
      <td>WAG54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GX</td>
      <td>Dummy SKU, Wireless-G ADSL Gateway with SRX</td>
      <td>WAG54GX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG54GX2</td>
      <td>Dummy SKU, Wireless-G ADSL Gateway with SRX200</td>
      <td>WAG54GX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAG54GX2-AU</td>
      <td>Wireless-G ADSL Gateway with SRX200</td>
      <td>WAG54GX2</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GX2-DE</td>
      <td>Wireless-G ADSL Gateway with SRX200</td>
      <td>WAG54GX2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GX2-E1</td>
      <td>Wireless-G ADSL Gateway with SRX200</td>
      <td>WAG54GX2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GX2-EU</td>
      <td>Wireless-G ADSL Gateway with SRX200</td>
      <td>WAG54GX2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GX2-FR</td>
      <td>Wireless-G ADSL Gateway with SRX200</td>
      <td>WAG54GX2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAG54GX2-UK</td>
      <td>Wireless-G ADSL Gateway with SRX200</td>
      <td>WAG54GX2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAP11</td>
      <td>Wireless Network Access Point</td>
      <td>WAP11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP11-AT</td>
      <td>Wireless Network Access Point (AT&amp;T)</td>
      <td>WAP11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP11-AU</td>
      <td>Instant Wireless Network Access Point</td>
      <td>WAP11</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP11-BT</td>
      <td>WLess Network Access Point (w/10 foot Cat 5 cable)</td>
      <td>WAP11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP11-CA</td>
      <td>Wireless Network Access Point (Canada)</td>
      <td>WAP11</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP11-CN</td>
      <td>Wireless Network Access Point</td>
      <td>WAP11</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP11-DE</td>
      <td>Wireless Network Access Point</td>
      <td>WAP11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP11-EF</td>
      <td>Wireless Network Access Point</td>
      <td>WAP11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP11-EU</td>
      <td>Wireless Network Access Point</td>
      <td>WAP11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP11-FR</td>
      <td>Wireless Network Access Point</td>
      <td>WAP11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP11-LA</td>
      <td>Wireless Network Access Point</td>
      <td>WAP11</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP11-UK</td>
      <td>Wireless Network Access Point</td>
      <td>WAP11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP11-VN</td>
      <td>WLess Network Access Point (w/10 foot Cat 5 cable)</td>
      <td>WAP11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP1200AC-EU</td>
      <td>LINKSYS WAP1200AC ACCESS POINT,AC1200</td>
      <td>WAP1200AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAP1200AC-UK</td>
      <td>LINKSYS WAP1200AC ACCESS POINT,AC1200</td>
      <td>WAP1200AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAP300N-AU</td>
      <td>LINKSYS WAP300N WIFI ACCESS POINT,N300</td>
      <td>WAP300N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAP300N-BR</td>
      <td>LINKSYS WAP300N WIFI ACCESS POINT,N300</td>
      <td>WAP300N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAP51AB</td>
      <td>Dual-Band Wireless Access Point (a+b)</td>
      <td>WAP51AB</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP51AB-CA</td>
      <td>Dual-Band Wirless Access Point (a+b)</td>
      <td>WAP51AB</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP51AB-TH</td>
      <td>Dual-Band Wireless Access Point</td>
      <td>WAP51AB</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54A</td>
      <td>Wireless Network Access Point (IEEE802.11a)</td>
      <td>WAP54A</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54A-TH</td>
      <td>Wireless Network Access Point (IEEE802.11a)</td>
      <td>WAP54A</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54A-UK</td>
      <td>Wireless Network Access Point (IEEE802.11a)</td>
      <td>WAP54A</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54G</td>
      <td>Wireless-G Access Point</td>
      <td>WAP54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54G-AU</td>
      <td>Wireless-G Access Point</td>
      <td>WAP54G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54G-BR</td>
      <td>Wireless-G Access Point</td>
      <td>WAP54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54G-CA</td>
      <td>Wireless-G Access Point (Canada)</td>
      <td>WAP54G</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54G-CN</td>
      <td>Wireless-G Access Point</td>
      <td>WAP54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54G-DE</td>
      <td>Wireless-G Access Point</td>
      <td>WAP54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54G-EU</td>
      <td>Wireless-G Access Point</td>
      <td>WAP54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54G-FR</td>
      <td>Wireless-G Access Point</td>
      <td>WAP54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54G-IN</td>
      <td>Wireless-G Access Point</td>
      <td>WAP54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54G-JP</td>
      <td>Wireless-G Access Point</td>
      <td>WAP54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54G-KR</td>
      <td>Wireless-G ADSL Gateway</td>
      <td>WAP54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WAP54G-LA</td>
      <td>Wireless-G Access Point</td>
      <td>WAP54G</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54G-SG</td>
      <td>Wireless-G Access Point</td>
      <td>WAP54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAP54G-TA</td>
      <td>Wireless-G Access Point</td>
      <td>WAP54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54G-UK</td>
      <td>Wireless-G Access Point</td>
      <td>WAP54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54GP-TA</td>
      <td>Wireless-G Access Point with Power Over Ethernet</td>
      <td>WAP54GP</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54GX</td>
      <td>Wireless-G Access Point with SRX</td>
      <td>WAP54GX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54GX-AS</td>
      <td>Wireless-G Access Point with SRX</td>
      <td>WAP54GX</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54GX-AU</td>
      <td>Wireless-G Access Point with SRX</td>
      <td>WAP54GX</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54GX-CA</td>
      <td>WAP54GX-CA PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WAP54GX</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAP54GX-EU</td>
      <td>Wireless-G Access Point with SRX</td>
      <td>WAP54GX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54GX-SG</td>
      <td>Wireless-G Access Point with SRX</td>
      <td>WAP54GX</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP54GX-UK</td>
      <td>Wireless-G Access Point with SRX</td>
      <td>WAP54GX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP55A</td>
      <td>WAP55A PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WAP55AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAP55AG</td>
      <td>Dual-Band Wireless A+G Access Point</td>
      <td>WAP55AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP55AG-AU</td>
      <td>Dual-Band Wireless A+G Access Point</td>
      <td>WAP55AG</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP55AG-CA</td>
      <td>WAP55AG-CA PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WAP55AG</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAP55AG-CN</td>
      <td>Dual-Band Wireless A+G Access Point</td>
      <td>WAP55AG</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP55AG-EU</td>
      <td>Dual-Band Wireless A+G Access Point</td>
      <td>WAP55AG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP55AG-KR</td>
      <td>Dual-Band Wireless A+G Access Point</td>
      <td>WAP55AG</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP55AG-TA</td>
      <td>Dual-Band Wireless A+G Access Point</td>
      <td>WAP55AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP55AG-TH</td>
      <td>Dual-Band Wireless A+G Access Point</td>
      <td>WAP55AG</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP55AG-UK</td>
      <td>Dual-Band Wireless A+G Access Point</td>
      <td>WAP55AG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP610N</td>
      <td>Wireless-N Access Point with Dual-Band</td>
      <td>WAP610N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP610N-AS</td>
      <td>Wireless-N Access Point with Dual-Band</td>
      <td>WAP610N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAP610N-AU</td>
      <td>Wireless-N Access Point with Dual-Band</td>
      <td>WAP610N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAP610N-EE</td>
      <td>Wireless-N Access Point with Dual-Band</td>
      <td>WAP610N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP610N-EU</td>
      <td>Wireless-N Access Point with Dual-Band</td>
      <td>WAP610N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP610N-ME</td>
      <td>Wireless-N Access Point with Dual-Band</td>
      <td>WAP610N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP610N-NP</td>
      <td>Wireless-N Access Point with Dual-Band</td>
      <td>WAP610N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP610N-SG</td>
      <td>Wireless-N Access Point with Dual-Band</td>
      <td>WAP610N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP610N-UK</td>
      <td>Wireless-N Access Point with Dual-Band</td>
      <td>WAP610N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAP750AC-EU</td>
      <td>LINKSYS WAP750AC ACCESS POINT AC750</td>
      <td>WAP750AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAP750AC-UK</td>
      <td>LINKSYS WAP750AC ACCESS POINT AC750</td>
      <td>WAP750AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAPPOE</td>
      <td>Power over Ethernet Adapter Kit</td>
      <td>WAPPOE</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAPPOE-AS</td>
      <td>Power over Ethernet Adapter Kit</td>
      <td>WAPPOE</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAPPOE-AU</td>
      <td>Power over Ethernet Adapter Kit</td>
      <td>WAPPOE</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAPPOE-CN</td>
      <td>Power over Ethernet Adapter Kit</td>
      <td>WAPPOE</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAPPOE-EU</td>
      <td>Power over Ethernet Adapter Kit</td>
      <td>WAPPOE</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAPPOE-JP</td>
      <td>WAPPOE-JP PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WAPPOE</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAPPOE-SG</td>
      <td>Power over Ethernet Adapter Kit</td>
      <td>WAPPOE</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAPPOE-UK</td>
      <td>Power over Ethernet Adapter Kit</td>
      <td>WAPPOE</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAPPOE12</td>
      <td>12 Volt Power Over Ethernet Adapter Kit</td>
      <td>WAPPOE12</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAPPOE12-AS</td>
      <td>12 Volt Power Over Ethernet Adapter Kit</td>
      <td>WAPPOE12</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAPPOE12-AU</td>
      <td>12 Volt Power Over Ethernet Adapter Kit</td>
      <td>WAPPOE12</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAPPOE12-CN</td>
      <td>12 Volt Power Over Ethernet Adapter Kit</td>
      <td>WAPPOE12</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAPPOE12-E</td>
      <td>WAPPOE12-E PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WAPPOE12</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAPPOE12-EU</td>
      <td>12 Volt Power Over Ethernet Adapter Kit</td>
      <td>WAPPOE12</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAPPOE12-KR</td>
      <td>12 Volt Power Over Ethernet Adapter Kit</td>
      <td>WAPPOE12</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAPPOE12-SG</td>
      <td>12 Volt Power Over Ethernet Adapter Kit</td>
      <td>WAPPOE12</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAPPOE12-U</td>
      <td>WAPPOE12-U PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WAPPOE12</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAPPOE12-UK</td>
      <td>12 Volt Power Over Ethernet Adapter Kit</td>
      <td>WAPPOE12</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WAPT1200AC-EF</td>
      <td>LINKSYS, WAPT1200AC ACCESS POINT, AC1200</td>
      <td>WAP1200AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAPT1200AC-EG</td>
      <td>LINKSYS, WAPT1200AC ACCESS POINT, AC1200</td>
      <td>WAP1200AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAPT1200AC-EU</td>
      <td>LINKSYS WAPT1200AC ACCESS POINT,AC1200</td>
      <td>WAP1200AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WAPT1200AC-UK</td>
      <td>LINKSYS WAPT1200AC ACCESS POINT,AC1200</td>
      <td>WAP1200AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WBP54G-NA</td>
      <td>Wireless-G Bridge for Phone Adapters</td>
      <td>WBP54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WCF11</td>
      <td>Wireless Network CF Card</td>
      <td>WCF11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WCF12</td>
      <td>Wireless Network CompactFlash Card (Type I)</td>
      <td>WCF12</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WCF12-CA</td>
      <td>WCF12-CA PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WCF12</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WCF12-CN</td>
      <td>Wireless Network CompactFlash Card (Type I)</td>
      <td>WCF12</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WCF12-EU</td>
      <td>Wireless Network CompactFlash Card (Type I)</td>
      <td>WCF12</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WCF12-UK</td>
      <td>Wireless Network CompactFlash Card (Type I)</td>
      <td>WCF12</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WCF54G</td>
      <td>Wireless-G Compact Flash Card</td>
      <td>WCF54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WCF54G-AU</td>
      <td>WCF54G-AU PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WCF54G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WCF54G-CA</td>
      <td>WCF54G-CA PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WCF54G</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WCF54G-EU</td>
      <td>Wireless-G Compact Flash Card</td>
      <td>WCF54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WCF54G-SG</td>
      <td>WCF54G-SG PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WCF54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WCF54G-UK</td>
      <td>Wireless-G Compact Flash Card</td>
      <td>WCF54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WCG104</td>
      <td>Wireless-G Cable Gateway</td>
      <td>WCG104</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG104-CX</td>
      <td>Wireless-G Cable Gateway</td>
      <td>WCG104</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG104-NA</td>
      <td>Wireless-G Cable Gateway</td>
      <td>WCG104</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200</td>
      <td>Wireless-G Cable Gateway (DOCSIS 1.1 &amp; 2.0)</td>
      <td>WCG200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200-AS</td>
      <td>Wireless-G Cable Gateway (DOCSIS 1.1 &amp; 2.0)</td>
      <td>WCG200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200-CA</td>
      <td>Wireless-G Cable Gateway (DOCSIS 1.1 &amp; 2.0)</td>
      <td>WCG200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200-CB</td>
      <td>Wireless-G Cable Gateway (DOCSIS 1.1 &amp; 2.0)</td>
      <td>WCG200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200-CC</td>
      <td>Wireless-G Cable Gateway (DOCSIS 1.1 &amp; 2.0)</td>
      <td>WCG200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200-CN</td>
      <td>Wireless-G Cable Gateway (DOCSIS 1.1 &amp; 2.0)</td>
      <td>WCG200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200-CX</td>
      <td>Wireless-G Cable Gateway (DOCSIS 1.1 &amp; 2.0)</td>
      <td>WCG200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200-EU</td>
      <td>Wireless Cable Gateway</td>
      <td>WCG200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200-JP</td>
      <td>Wireless-G Cable Gateway (DOCSIS 1.1 &amp; 2.0)</td>
      <td>WCG200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200-JP-JC</td>
      <td>Wireless-G Cable Modem Gateway (for JCOM)</td>
      <td>WCG200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200-KR</td>
      <td>Wireless-G Cable Gateway (DOCSIS 1.1 &amp; 2.0)</td>
      <td>WCG200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200-NA</td>
      <td>Wireless-G Cable Gateway (DOCSIS 1.1 &amp; 2.0)</td>
      <td>WCG200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200-SG</td>
      <td>Wireless-G Cable Gateway (DOCSIS 1.1 &amp; 2.0)</td>
      <td>WCG200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200-TW</td>
      <td>WCG200-TW PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WCG200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WCG200-TW-CG</td>
      <td>Wireless-G Cable Gateway with Comcast Self-Install</td>
      <td>WCG200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WCG200-UK</td>
      <td>Wireless-G Cable Gateway (DOCSIS 1.1 &amp; 2.0)</td>
      <td>WCG200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200E</td>
      <td>Wireless-G Cable Gateway (DOCSIS 1.1 &amp; 2.0)</td>
      <td>WCG200E</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200E-CN</td>
      <td>Wireless G Gateway</td>
      <td>WCG200E</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200E-EU</td>
      <td>Wireless-G Cable Gateway (DOCSIS 1.1 &amp; 2.0)</td>
      <td>WCG200E</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200E-UK</td>
      <td>CATV Gateway</td>
      <td>WCG200E</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG200V2-CC</td>
      <td>WlessG Cable Gateway version 2, Comcast</td>
      <td>WCG200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WCG300</td>
      <td>Wireless Cable Gateway</td>
      <td>WCG300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WCGP200B2</td>
      <td>WlessG Cable Gateway w/2 Phone Ports + 2 Batteries</td>
      <td>WCGP200B2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WCM300</td>
      <td>Wideband Cable Modem, DOCSIS</td>
      <td>WCM300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WCM300-EU</td>
      <td>Wideband Cable Modem, Euro-DOCSIS</td>
      <td>WCM300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WCM300-JP</td>
      <td>Wideband Cable Modem, Japan-DOCSIS</td>
      <td>WCM300</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WCM300-NA</td>
      <td>Wideband Cable Modem, DOCSIS</td>
      <td>WCM300</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WCP11-FR</td>
      <td>Wireless Network PC Card</td>
      <td>WCP11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WDT11</td>
      <td>Instant Wireless PCI Adapter</td>
      <td>WDT11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WDT11-AT</td>
      <td>Instant Wireless PCI Adapter (AT&amp;T)</td>
      <td>WDT11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WDT11-CA</td>
      <td>Instant Wireless PCI Adapter (Canada)</td>
      <td>WDT11</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WEBHUB04</td>
      <td>Internet Workgroup Hub</td>
      <td>WEBHUB04</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WEC300N</td>
      <td>Wireless-N PCI ExpressCard (Project Canceled)</td>
      <td>WEC300N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WEC600N</td>
      <td>Dual-Band Wireless-N ExpressCard</td>
      <td>WEC600N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WEC600N-AS</td>
      <td>Dual-Band Wireless-N ExpressCard</td>
      <td>WEC600N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WEC600N-CA</td>
      <td>Dual-Band Wireless-N ExpressCard</td>
      <td>WEC600N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WEC600N-EU</td>
      <td>Dual-Band Wireless-N ExpressCard</td>
      <td>WEC600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WEEE-FEE</td>
      <td>WEEE FEE FOR EMEA</td>
      <td>WEEE-FEE</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WES610N</td>
      <td>WLess Universal Media Connector N600 Dual Band</td>
      <td>WES610N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WES610N-4C</td>
      <td>WLess Universal Media Connector N600 Dual Band</td>
      <td>WES610N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WES610N-6A</td>
      <td>WLess Universal Media Connector N600 Dual Band</td>
      <td>WES610N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WES610N-AP</td>
      <td>4-Port Dual-Band N Ethernet Bridge</td>
      <td>WES610N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WES610N-AU</td>
      <td>4-Port Dual-Band N Ethernet Bridge</td>
      <td>WES610N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WES610N-CA</td>
      <td>WLess Universal Media Connector N600 Dual Band</td>
      <td>WES610N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WES610N-EE</td>
      <td>4-Port Dual-Band N Ethernet Bridge</td>
      <td>WES610N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WES610N-EU</td>
      <td>4-Port Dual-Band N Ethernet Bridge</td>
      <td>WES610N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WES610N-ME</td>
      <td>4-Port Dual-Band N Ethernet Bridge</td>
      <td>WES610N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WES610N-N4</td>
      <td>WLess Universal Media Connector N600 Dual Band</td>
      <td>WES610N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WES610N-NP</td>
      <td>WLess Universal Media Connector N600 Dual Band</td>
      <td>WES610N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WES610N-UK</td>
      <td>4-Port Dual-Band N Ethernet Bridge</td>
      <td>WES610N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET11</td>
      <td>Wireless Ethernet Bridge</td>
      <td>WET11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET11-AR</td>
      <td>WET11-AR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WET11</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WET11-AU</td>
      <td>Wireless Ethernet Bridge</td>
      <td>WET11</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET11-CA</td>
      <td>CT Wireless Ethernet Bridge (Canda)</td>
      <td>WET11</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET11-CN</td>
      <td>Wireless Ethernet Bridge</td>
      <td>WET11</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET11-DE</td>
      <td>Wireless Gaming Adapter</td>
      <td>WET11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET11-EU</td>
      <td>Wireless Ethernet Bridge</td>
      <td>WET11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET11-FR</td>
      <td>Wireless Ethernet Bridge</td>
      <td>WET11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET11-LA</td>
      <td>Wireless Ethernet Bridge</td>
      <td>WET11</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET11-UK</td>
      <td>Wireless Ethernet Bridge</td>
      <td>WET11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET54AG</td>
      <td>Dummy SKU, Dual Band Wireless Ethernet Bridge</td>
      <td>WET54AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WET54G</td>
      <td>Wireless-G Ethernet Bridge</td>
      <td>WET54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET54G-AS</td>
      <td>Wireless-G Ethernet Bridge</td>
      <td>WET54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WET54G-AU</td>
      <td>Wireless-G Ethernet Bridge</td>
      <td>WET54G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET54G-CA</td>
      <td>Wireless-G Ethernet Bridge (Canada)</td>
      <td>WET54G</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET54G-CN</td>
      <td>Wireless-G Ethernet Bridge</td>
      <td>WET54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET54G-DE</td>
      <td>Wireless-G Ethernet Bridge</td>
      <td>WET54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET54G-EU</td>
      <td>Wireless-G Ethernet Bridge</td>
      <td>WET54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET54G-FR</td>
      <td>Wireless-G Ethernet Bridge</td>
      <td>WET54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET54G-KR</td>
      <td>Wireless-G Ethernet Bridge</td>
      <td>WET54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET54G-SG</td>
      <td>Wireless-G Ethernet Bridge</td>
      <td>WET54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WET54G-TH</td>
      <td>Wireless-G Ethernet Bridge</td>
      <td>WET54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET54G-TW</td>
      <td>WET54G-TW PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WET54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WET54G-UK</td>
      <td>Wireless-G Ethernet Bridge</td>
      <td>WET54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET54GS5</td>
      <td>Wireless-G Ethernet Bridge with 5-port Switch</td>
      <td>WET54GS5</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET54GS5-AS</td>
      <td>Wireless-G Ethernet Bridge with 5-port Switch</td>
      <td>WET54GS5</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET54GS5-AU</td>
      <td>Wireless-G Ethernet Bridge with 5-port Switch</td>
      <td>WET54GS5</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET54GS5-BR</td>
      <td>WET54GS5-BR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WET54GS5</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WET54GS5-CA</td>
      <td>WET54GS5-CA PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WET54GS5</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WET54GS5-EU</td>
      <td>Wireless-G Ethernet Bridge with 5-port Switch</td>
      <td>WET54GS5</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET54GS5-SG</td>
      <td>Wireless-G Ethernet Bridge with 5-port Switch</td>
      <td>WET54GS5</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET54GS5-UK</td>
      <td>Wireless-G Ethernet Bridge with 5-port Switch</td>
      <td>WET54GS5</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET610N</td>
      <td>Dual-Band N Entertainment Bridge</td>
      <td>WET610N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET610N-3T</td>
      <td>Dual-Band N Entertainment Bridge</td>
      <td>WET610N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET610N-AS</td>
      <td>Wireless-N Ethernet Bridge with Dual-Band</td>
      <td>WET610N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WET610N-EU</td>
      <td>Wireless-N Ethernet Bridge with Dual-Band</td>
      <td>WET610N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WET610N-ME</td>
      <td>Wireless-N Ethernet Bridge with Dual-Band</td>
      <td>WET610N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WET610N-UK</td>
      <td>Wireless-N Ethernet Bridge with Dual-Band</td>
      <td>WET610N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WFG500N-1E</td>
      <td>Wireless-N FTTH Gateway with VoIP</td>
      <td>WFG500N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WGA11B</td>
      <td>Wireless-B Game Adapter</td>
      <td>WGA11B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA11B-AU</td>
      <td>Wireless-B Game Adapter</td>
      <td>WGA11B</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA11B-CA</td>
      <td>Wireless-B Game Adapter</td>
      <td>WGA11B</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA11B-DE</td>
      <td>Wireless-B Game Adapter</td>
      <td>WGA11B</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA11B-EU</td>
      <td>Wireless-B Game Adapter</td>
      <td>WGA11B</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA11B-FR</td>
      <td>Wireless-B Game Adapter</td>
      <td>WGA11B</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA11B-KR</td>
      <td>WGA11B-KR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WGA11B</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WGA11B-UK</td>
      <td>Wireless-B Game Adapter</td>
      <td>WGA11B</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA11B-WM</td>
      <td>Wireless-B Game Adapter</td>
      <td>WGA11B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA54AG</td>
      <td>Dual-Band Wireless A/G Game Adapter</td>
      <td>WGA54AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA54AG-CA</td>
      <td>WGA54AG-CA PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WGA54AG</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WGA54AG-E</td>
      <td>WGA54AG-E PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WGA54AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WGA54AG-EU</td>
      <td>Dual-Band Wireless A/G Game Adapter</td>
      <td>WGA54AG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA54AG-UK</td>
      <td>Dual-Band Wireless A/G Game Adapter</td>
      <td>WGA54AG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA54G</td>
      <td>Wireless-G Game Adapter</td>
      <td>WGA54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA54G-AR</td>
      <td>WGA54G-AR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WGA54G</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WGA54G-AU</td>
      <td>Wireless-G Game Adapter</td>
      <td>WGA54G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA54G-BP</td>
      <td>WGA54G-BP PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WGA54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WGA54G-CA</td>
      <td>Wireless-G Game Adapter</td>
      <td>WGA54G</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA54G-DE</td>
      <td>Wireless-G Game Adapter</td>
      <td>WGA54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA54G-EU</td>
      <td>Wireless-G Game Adapter</td>
      <td>WGA54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA54G-FR</td>
      <td>Wireless-G Game Adapter</td>
      <td>WGA54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA54G-UK</td>
      <td>Wireless-G Game Adapter</td>
      <td>WGA54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA54G-WM</td>
      <td>Wireless-G Game Adapter</td>
      <td>WGA54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA600N</td>
      <td>Dual-Band Wireless-N Gaming Adapter</td>
      <td>WGA600N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA600N-AS</td>
      <td>Dual-Band Wireless-N Gaming Adapter</td>
      <td>WGA600N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WGA600N-BP</td>
      <td>Dual-Band Wireless-N Gaming Adapter</td>
      <td>WGA600N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA600N-CA</td>
      <td>Dual-Band Wireless-N Gaming Adapter</td>
      <td>WGA600N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WGA600N-EU</td>
      <td>Dual-Band Wireless-N Gaming Adapter</td>
      <td>WGA600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WGKPC354G</td>
      <td>Dummy Sku, WLess-G ADSL Gateway Kit for Notebooks</td>
      <td>WGKPC354G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKPC354G-DE</td>
      <td>Wireless-G ADSL Gateway Kit for Notebooks</td>
      <td>WGKPC354G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKPC354G-EU</td>
      <td>Wireless-G ADSL Gateway Kit for Notebooks</td>
      <td>WGKPC354G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKPC354G-UK</td>
      <td>Wireless-G ADSL Gateway Kit for Notebooks</td>
      <td>WGKPC354G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKPC54G</td>
      <td>Dummy Sku, WLess-G ADSL Gateway Kit for Notebooks</td>
      <td>WGKPC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKPC54G-DE</td>
      <td>WGKPC54G-DE PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WGKPC54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKPC54G-FR</td>
      <td>Wireless-G ADSL Gateway Kit for Notebooks</td>
      <td>WGKPC54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKPC54G-UK</td>
      <td>WGKPC54G-UK PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WGKPC54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKUSB120N</td>
      <td>WlessN Kit -- Home ADSL2+ Modem-Rtr w/USB Adapter</td>
      <td>WGKUSB120N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WGKUSB120N-DE</td>
      <td>WlessN Kit -- Home ADSL2+ Modem-Rtr w/USB Adapter</td>
      <td>WGKUSB120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKUSB120N-EU</td>
      <td>WlessN Kit -- Home ADSL2+ Modem-Rtr w/USB Adapter</td>
      <td>WGKUSB120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKUSB120N-UK</td>
      <td>WlessN Kit -- Home ADSL2+ Modem-Rtr w/USB Adapter</td>
      <td>WGKUSB120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKUSB160N</td>
      <td>WlessN ADSL2+ Gateway Kit w/USB adapter</td>
      <td>WGKUSB160N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WGKUSB160N-DE</td>
      <td>Wireless-N ADSL2+ Gateway Kit with USB adapter</td>
      <td>WGKUSB160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WGKUSB160N-EU</td>
      <td>Wireless-N ADSL2+ Gateway Kit with USB adapter</td>
      <td>WGKUSB160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKUSB160N-UK</td>
      <td>Wireless-N ADSL2+ Gateway Kit with USB adapter</td>
      <td>WGKUSB160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKUSB200G</td>
      <td>WlessG ADSL2+ Gateway Kit w/USB adapter</td>
      <td>WGKUSB200G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WGKUSB200G-DE</td>
      <td>Wireless-G ADSL2+ Gateway Kit with USB adapter</td>
      <td>WGKUSB200G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WGKUSB200G-EU</td>
      <td>Wireless-G ADSL2+ Gateway Kit with USB adapter</td>
      <td>WGKUSB200G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKUSB200G-UK</td>
      <td>Wireless-G ADSL2+ Gateway Kit with USB adapter</td>
      <td>WGKUSB200G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKUSB54G</td>
      <td>WGKUSB54G-UK PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WGKUSB54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKUSB54G-UK</td>
      <td>WGKUSB54G-UK PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WGKUSB54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKUSB54G2</td>
      <td>WlessG ADSL2+ Gateway Kit w/USB adapter</td>
      <td>WGKUSB54G2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WGKUSB54G2-DE</td>
      <td>Wireless-G ADSL2+ Gateway Kit with USB adapter</td>
      <td>WGKUSB54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WGKUSB54G2-EU</td>
      <td>Wireless-G ADSL2+ Gateway Kit with USB adapter</td>
      <td>WGKUSB54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WGKUSB54G2-UK</td>
      <td>Wireless-G ADSL2+ Gateway Kit with USB adapter</td>
      <td>WGKUSB54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WGKUSB54GP</td>
      <td>WGKUSB54GP PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WGKUSB54GP</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WGKUSB54GP-FR</td>
      <td>Wireless-G ADSL Gateway Kit for USB</td>
      <td>WGKUSB54GP</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WIP200-EU</td>
      <td>Wireless Internet Phone</td>
      <td>WIP200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WIP310-AS</td>
      <td>Wireless-G IP Phone (Asia)</td>
      <td>WIP310</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WIP310-AU</td>
      <td>Wireless-G IP Phone (Australia)</td>
      <td>WIP310</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WIP310-E2</td>
      <td>Wireless-G IP Phone</td>
      <td>WIP310</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WIP310-EU</td>
      <td>Wireless-G IP Phone (Europe)</td>
      <td>WIP310</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WIP310-KR</td>
      <td>Wireless-G IP Phone (Korea)</td>
      <td>WIP310</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WIP310-NA</td>
      <td>Wireless-G IP Phone (North America)</td>
      <td>WIP310</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WIP310-SG</td>
      <td>Wireless-G IP Phone (Singapore)</td>
      <td>WIP310</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WIP310-U2</td>
      <td>Wireless-G IP Phone</td>
      <td>WIP310</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WIP310-UK</td>
      <td>Wireless-G IP Phone (United Kingdom)</td>
      <td>WIP310</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WIP320-AS</td>
      <td>Wireless-G Skype Phone</td>
      <td>WIP320</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WIP320-NA</td>
      <td>Wireless-G Skype Phone</td>
      <td>WIP320</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WIP320-SG</td>
      <td>Wireless-G Skype Phone</td>
      <td>WIP320</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WIP320-UK</td>
      <td>Wireless-G Skype Phone</td>
      <td>WIP320</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WIX200-EU</td>
      <td>Wireless Internet Communication System</td>
      <td>WIX200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WKPC11</td>
      <td>Wireless-B PC Card Kit</td>
      <td>WKPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WKPC11-BP</td>
      <td>WKPC11-BP PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WKPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WKPC54G</td>
      <td>Wireless-G Network Kit Router + Notebook Adapter</td>
      <td>WKPC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKPC54G-AU</td>
      <td>WKPC54G-AU PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WKPC54G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKPC54G-CA</td>
      <td>Wireless-G Network Kit Router + Notebook Adapter</td>
      <td>WKPC54G</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WKPC54G-DE</td>
      <td>Wireless-G Network Kit Router + Notebook Adapter</td>
      <td>WKPC54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKPC54G-EU</td>
      <td>Wireless-G Network Kit Router + Notebook Adapter</td>
      <td>WKPC54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKPC54G-FR</td>
      <td>Wireless-G Network Kit Router + Notebook Adapter</td>
      <td>WKPC54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKPC54G-JP</td>
      <td>Wireless-G Network Kit Router + Notebook Adapter</td>
      <td>WKPC54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKPC54G-UK</td>
      <td>Wireless-G Network Kit Router + Notebook Adapter</td>
      <td>WKPC54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKPC54G-WM</td>
      <td>Wireless-G Network Kit Router + Notebook Adapter</td>
      <td>WKPC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKPC54GR</td>
      <td>Dummy SKU, WlessG Kit w/Range Expansion</td>
      <td>WKPC54GR</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKUSB11</td>
      <td>Wireless-B USB Kit</td>
      <td>WKUSB11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WKUSB11-BP</td>
      <td>WKUSB11-BP PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WKUSB11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WKUSB110-CA</td>
      <td>RangePlus Wireless Network Kit for USB</td>
      <td>WKUSB110</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WKUSB120N</td>
      <td>WlessN Starter Kit -- Home Rtr w/USB Adapter</td>
      <td>WKUSB120N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WKUSB120N-DE</td>
      <td>WLess-N Starter Kit -- Home Rtr with USB Adapter</td>
      <td>WKUSB120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKUSB120N-EU</td>
      <td>WLess-N Starter Kit -- Home Rtr with USB Adapter</td>
      <td>WKUSB120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKUSB120N-UK</td>
      <td>WLess-N Starter Kit -- Home Rtr with USB Adapter</td>
      <td>WKUSB120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKUSB160N</td>
      <td>WlessN Starter Kit -- Broadband Rtr w/USB Adapter</td>
      <td>WKUSB160N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WKUSB160N-DE</td>
      <td>WLess-N Starter Kit -- Broadband Rtr w/USB Adapter</td>
      <td>WKUSB160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKUSB160N-EU</td>
      <td>WLess-N Starter Kit -- Broadband Rtr w/USB Adapter</td>
      <td>WKUSB160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKUSB160N-UK</td>
      <td>WLess-N Starter Kit -- Broadband Rtr w/USB Adapter</td>
      <td>WKUSB160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKUSB54-BP</td>
      <td>Wireless-G USB Kit</td>
      <td>WKUSB54</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WKUSB54G-BP</td>
      <td>WKUSB54G-BP PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WKUSB54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WKUSB54GC</td>
      <td>Compact Wireless-G Network Kit for USB</td>
      <td>WKUSB54</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WKUSB54GC-BC</td>
      <td>Compact Wireless-G Network Kit for USB</td>
      <td>WKUSB54GC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WKUSB54GC-DE</td>
      <td>Compact Wireless-G Network Kit for USB</td>
      <td>WKUSB54GC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKUSB54GC-EU</td>
      <td>Compact Wireless-G Network Kit for USB</td>
      <td>WKUSB54GC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKUSB54GC-FR</td>
      <td>Compact Wireless-G Network Kit for USB</td>
      <td>WKUSB54GC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKUSB54GC-UK</td>
      <td>Wireless-G Compact Broadband Rtr with USB Adapter</td>
      <td>WKUSB54GC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WKUSB54GS</td>
      <td>Wireless-G USB Kit with SpeedBooster</td>
      <td>WKUSB54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WKUSB54GS-WM</td>
      <td>Wireless-G USB Kit with SpeedBooster</td>
      <td>WKUSB54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMA11B</td>
      <td>Wireless-B Media Adapter</td>
      <td>WMA11B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMA11B-AU</td>
      <td>Wireless-B Media Adapter</td>
      <td>WMA11B</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMA11B-CA</td>
      <td>Wireless-B Media Adapter</td>
      <td>WMA11B</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMA11B-DE</td>
      <td>Wireless-B Media Adapter</td>
      <td>WMA11B</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMA11B-EU</td>
      <td>Wireless-B Media Adapter</td>
      <td>WMA11B</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMA11B-FR</td>
      <td>Wireless-B Media Adapter</td>
      <td>WMA11B</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMA11B-UK</td>
      <td>Wireless-B Media Adapter</td>
      <td>WMA11B</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMB54G</td>
      <td>Wireless-G Music Bridge</td>
      <td>WMB54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMB54G-AS</td>
      <td>Wireless-G Music Bridge</td>
      <td>WMB54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMB54G-CA</td>
      <td>Wireless-G Music Bridge</td>
      <td>WMB54G</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMB54G-KR</td>
      <td>Wireless-G Music Bridge</td>
      <td>WMB54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMB54G-SG</td>
      <td>Wireless-G Music Bridge</td>
      <td>WMB54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMCE54AG</td>
      <td>Dual-Band Wireless A/G Media Center Extender</td>
      <td>WMCE54AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMCE54AG-CA</td>
      <td>Dual-Band Wireless A/G Media Center Extender</td>
      <td>WMCE54AG</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMCE54AG-EU</td>
      <td>Dual-Band Wireless A/G Media Center Extender</td>
      <td>WMCE54AG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMCE54G</td>
      <td>WMCE54G PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WMCE54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WML11B</td>
      <td>Dummy SKU, Wireless-B MusicLink without Speaker</td>
      <td>WML11B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMLD54G</td>
      <td>DVD Player w/WlessG Media Link for Media</td>
      <td>WMLD54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMLS11B</td>
      <td>Wireless-B Music System</td>
      <td>WMLS11B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMLS11B-AU</td>
      <td>WMLS11B-AU PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WMLS11B</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMLS11B-BR</td>
      <td>WMLS11B-BR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WMLS11B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMLS11B-EU</td>
      <td>WMLS11B-EU PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WMLS11B</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMLS11B-IN</td>
      <td>WMLS11B-IN PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WMLS11B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMLS11B-UK</td>
      <td>Wireless-B Music System</td>
      <td>WMLS11B</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMLS11B-WM</td>
      <td>Wireless-B Music System</td>
      <td>WMLS11B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMLV54G</td>
      <td>Dummy SKU Wireless-G Digital Media Link, HDMI</td>
      <td>WMLV54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMLV54G-AS</td>
      <td>SKU Wireless-G Digital Media Link, HDMI</td>
      <td>WMLV54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WMLV54G-EU</td>
      <td>SKU Wireless-G, Digital Media Link, Scart</td>
      <td>WMLV54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WMLV54G-SG</td>
      <td>SKU Wireless-G Digital Media Link, HDMI</td>
      <td>WMLV54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WMP100-AS</td>
      <td>Wireless PCI Adapter</td>
      <td>WMP100</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP100-EU</td>
      <td>Wireless PCI Adapter</td>
      <td>WMP100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP11</td>
      <td>Wireless PCI Card (include a mini-PCI card)</td>
      <td>WMP11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP11-BP</td>
      <td>Wireless PCI Card (include a mini-PCI card)</td>
      <td>WMP11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP11-CA</td>
      <td>Wireless PCI Card (Canada)</td>
      <td>WMP11</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP11-CC</td>
      <td>Wireless PCI Card</td>
      <td>WMP11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP11-CN</td>
      <td>Wireless PCI Card (include a mini-PCI card)</td>
      <td>WMP11</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP11-CX</td>
      <td>Wireless PCI Card (include a mini-PCI card)</td>
      <td>WMP11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP11-DE</td>
      <td>Wireless PCI Card (include a mini-PCI card)</td>
      <td>WMP11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP11-EU</td>
      <td>Wireless PCI Card (include a mini-PCI card)</td>
      <td>WMP11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP11-FR</td>
      <td>Wireless PCI Card (include a mini-PCI card)</td>
      <td>WMP11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP11-KR</td>
      <td>WMP11-KR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WMP11</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP11-LA</td>
      <td>Wireless PCI Card (include a mini-PCI card)</td>
      <td>WMP11</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP11-TW</td>
      <td>WMP11-TW PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WMP11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP11-UK</td>
      <td>Wireless PCI Card (include a mini-PCI card)</td>
      <td>WMP11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP11-VN</td>
      <td>Wireless PCI Card (for Verizon)</td>
      <td>WMP11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP11-WM</td>
      <td>Wireless PCI Card (include a mini-PCI card)</td>
      <td>WMP11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP110</td>
      <td>RangePlus Wireless PCI Adapter</td>
      <td>WMP110</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP110-4A</td>
      <td>RangePlus Wireless PCI Adapter</td>
      <td>WMP110</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP110-AS</td>
      <td>RangePlus Wireless PCI Adapter</td>
      <td>WMP110</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP110-CA</td>
      <td>RangePlus Wireless PCI Adapter</td>
      <td>WMP110</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP110-DE</td>
      <td>RangePlus Wireless PCI Adapter</td>
      <td>WMP110</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP110-EU</td>
      <td>RangePlus Wireless PCI Adapter</td>
      <td>WMP110</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP110-UK</td>
      <td>RangePlus Wireless PCI Adapter</td>
      <td>WMP110</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP300N</td>
      <td>Wireless-N PCI Adapter</td>
      <td>WMP300N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP300N-4A</td>
      <td>Wireless-N PCI Adapter</td>
      <td>WMP300N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP300N-AS</td>
      <td>Wireless-N PCI Adapter</td>
      <td>WMP300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP300N-AU</td>
      <td>Wireless-N PCI Adapter</td>
      <td>WMP300N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP300N-CA</td>
      <td>Wireless-N PCI Adapter</td>
      <td>WMP300N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP300N-CN</td>
      <td>Wireless-N PCI Adapter</td>
      <td>WMP300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP300N-DE</td>
      <td>Wireless-N PCI Adapter</td>
      <td>WMP300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP300N-EU</td>
      <td>Wireless-N PCI Adapter</td>
      <td>WMP300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP300N-FR</td>
      <td>Wireless-N PCI Adapter</td>
      <td>WMP300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP300N-LA</td>
      <td>Wireless-N PCI Adapter</td>
      <td>WMP300N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP300N-SG</td>
      <td>Wireless-N PCI Adapter</td>
      <td>WMP300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP300N-UK</td>
      <td>Wireless-N PCI Adapter</td>
      <td>WMP300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP51AB</td>
      <td>Dual-Band Wireless A+B PCI Adapter</td>
      <td>WMP51AB</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54G</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WMP54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54G-4A</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WMP54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54G-AR</td>
      <td>WMP54G-AR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WMP54G</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP54G-AS</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WMP54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td>19-Oct-2017</td>
      <td>18-Oct-2022</td>
    </tr>
    <tr>
      <td>WMP54G-CA</td>
      <td>Wireless-G PCI Adapter (Canada)</td>
      <td>WMP54G</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54G-CB</td>
      <td>WMP54G-CB PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WMP54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP54G-CC</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WMP54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54G-CN</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WMP54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54G-CU</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WMP54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54G-DE</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WMP54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54G-EU</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WMP54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54G-FR</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WMP54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54G-JP</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WMP54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54G-KR</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WMP54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54G-LA</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WMP54G</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54G-SG</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WMP54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54G-TA</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WMP54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54G-UK</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WMP54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54G-WM</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WMP54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GR</td>
      <td>WlessG PCI Adapter w/RangeBooster</td>
      <td>WMP54GR</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GR-AS</td>
      <td>WlessG PCI Adapter w/RangeBooster</td>
      <td>WMP54GR</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GR-AU</td>
      <td>Wireless-G PCI Adapter with RangeBooster</td>
      <td>WMP54GR</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP54GR-DE</td>
      <td>Wireless-G PCI Adapter with RangeBooster</td>
      <td>WMP54GR</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GR-EU</td>
      <td>Wireless-G PCI Adapter with RangeBooster</td>
      <td>WMP54GR</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GR-FR</td>
      <td>Wireless-G PCI Adapter with RangeBooster</td>
      <td>WMP54GR</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GR-UK</td>
      <td>Wireless-G PCI Adapter with RangeBooster</td>
      <td>WMP54GR</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GS</td>
      <td>Wireless-G PCI Card with SpeedBooster</td>
      <td>WMP54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GS-AR</td>
      <td>WMP54GS-AR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WMP54GS</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP54GS-AS</td>
      <td>Wireless-G PCI Card with SpeedBooster</td>
      <td>WMP54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td>19-Oct-2017</td>
      <td>18-Oct-2022</td>
    </tr>
    <tr>
      <td>WMP54GS-CA</td>
      <td>Wireless-G PCI Adapter with SpeedBooster</td>
      <td>WMP54GS</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GS-CN</td>
      <td>Wireless-G PCI Card with SpeedBooster</td>
      <td>WMP54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GS-DE</td>
      <td>Wireless-G PCI Card with SpeedBooster</td>
      <td>WMP54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GS-EU</td>
      <td>Wireless-G PCI Card with SpeedBooster</td>
      <td>WMP54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GS-FR</td>
      <td>Wireless-G PCI Card with SpeedBooster</td>
      <td>WMP54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GS-JP</td>
      <td>Wireless-G PCI Adapter with SpeedBooster</td>
      <td>WMP54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GS-KR</td>
      <td>WMP54GS-KR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WMP54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP54GS-UK</td>
      <td>Wireless-G PCI Card with SpeedBooster</td>
      <td>WMP54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GS-WM</td>
      <td>Wireless-G PCI Adapter with SpeedBooster</td>
      <td>WMP54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GV4</td>
      <td>Specifications, WMP54G v4</td>
      <td>WMP54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP54GV4.1</td>
      <td>Specification, WMP54Gv4.1</td>
      <td>WMP54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP54GX</td>
      <td>Wireless-G PCI Adapter with SRX</td>
      <td>WMP54GX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GX-AS</td>
      <td>Wireless-G PCI Adapter with SRX</td>
      <td>WMP54GX</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GX-CA</td>
      <td>WMP54GX-CA PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WMP54GX</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GX-DE</td>
      <td>Wireless-G PCI Adapter with SRX</td>
      <td>WMP54GX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GX-EU</td>
      <td>Wireless-G PCI Adapter with SRX</td>
      <td>WMP54GX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GX-FR</td>
      <td>Wireless-G PCI Adapter with SRX</td>
      <td>WMP54GX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GX-SG</td>
      <td>WMP54GX-SG PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WMP54GX</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP54GX-UK</td>
      <td>Wireless-G PCI Adapter with SRX</td>
      <td>WMP54GX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP54GX4</td>
      <td>Wireless-G PCI Adapter with SRX400</td>
      <td>WMP54GX4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP55AG</td>
      <td>Dual-Band Wireless A+G PCI Adapter</td>
      <td>WMP55AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP55AG-AS</td>
      <td>Dual-Band Wireless A+G PCI Adapter</td>
      <td>WMP55AG</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP55AG-CA</td>
      <td>Dual-Band Wireless A+G PCI Adapter</td>
      <td>WMP55AG</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP55AG-EU</td>
      <td>Dual-Band Wireless A+G PCI Adapter</td>
      <td>WMP55AG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP55AG-KR</td>
      <td>Dual-Band Wireless A+G PCI Adapter</td>
      <td>WMP55AG</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP55AG-TA</td>
      <td>Dual-Band Wireless A+G PCI Adapter</td>
      <td>WMP55AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP55AG-UK</td>
      <td>Dual-Band Wireless A+G PCI Adapter</td>
      <td>WMP55AG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP600N</td>
      <td>Wireless-N PCI Adapter with Dual-Band</td>
      <td>WMP600N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP600N-4A</td>
      <td>Wireless-N PCI Adapter with Dual-Band</td>
      <td>WMP600N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP600N-AS</td>
      <td>Wireless-N PCI Adapter with Dual-Band</td>
      <td>WMP600N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP600N-AU</td>
      <td>Wireless-N Dual Band PCI Adapter</td>
      <td>WMP600N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP600N-CA</td>
      <td>Wireless-N PCI Adapter with Dual-Band</td>
      <td>WMP600N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP600N-DE</td>
      <td>Wireless-N Dual Band PCI Adapter</td>
      <td>WMP600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP600N-EU</td>
      <td>Wireless-N PCI Adapter with Dual-Band</td>
      <td>WMP600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WMP600N-FR</td>
      <td>Wireless-N Dual Band PCI Adapter</td>
      <td>WMP600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP600N-LA</td>
      <td>Wireless-N PCI Adapter with Dual-Band</td>
      <td>WMP600N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMP600N-UK</td>
      <td>Wireless-N Dual Band PCI Adapter</td>
      <td>WMP600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMR200</td>
      <td>Wireless-G Broadband Router with MoCA Connectivity</td>
      <td>WMR200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WMR550G</td>
      <td>Second Generation Broadband Home Router</td>
      <td>WMR550G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WMV54G</td>
      <td>WMV54G PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WMV54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100</td>
      <td>LINKSYS, WNC100, HD WI-FI CAMERA</td>
      <td>WNC100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100-4A</td>
      <td>LINKSYS, WNC100-4A, HD WI-FI CAMERA</td>
      <td>WNC100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100-AP</td>
      <td>LINKSYS, WNC100-AP, HD WI-FI CAMERA</td>
      <td>WNC100</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100-AR</td>
      <td>LINKSYS, WNC100-AR, HD WI-FI CAMERA</td>
      <td>WNC100</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100-AU</td>
      <td>LINKSYS, WNC100-AU, HD WI-FI CAMERA</td>
      <td>WNC100</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100-BR</td>
      <td>LINKSYS, WNC100-BR, HD WI-FI CAMERA</td>
      <td>WNC100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100-CA</td>
      <td>LINKSYS, WNC100-CA, HD WI-FI CAMERA</td>
      <td>WNC100</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100-EE</td>
      <td>LINKSYS, WNC100-EE, HD WI-FI CAMERA</td>
      <td>WNC100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100-EJ</td>
      <td>LINKSYS, WNC100-EJ, HD WI-FI CAMERA</td>
      <td>WNC100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100-EK</td>
      <td>LINKSYS, WNC100-EK, HD WI-FI CAMERA</td>
      <td>WNC100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100-EU</td>
      <td>LINKSYS, WNC100-EU, HD WI-FI CAMERA</td>
      <td>WNC100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100-LA</td>
      <td>LINKSYS, WNC100-LA, HD WI-FI CAMERA</td>
      <td>WNC100</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100-ME</td>
      <td>LINKSYS, WNC100-ME, HD WI-FI CAMERA</td>
      <td>WNC100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WNC100-UK</td>
      <td>LINKSYS, WNC100-UK, HD WI-FI CAMERA</td>
      <td>WNC100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100P</td>
      <td>Linksys WNC100P, WLess Network Camera w/Pan/Tilt</td>
      <td>WNC100P</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100P-AP</td>
      <td>Linksys WNC100P-AP, WLess Net Camera w/Pan/Tilt</td>
      <td>WNC100P</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100P-AU</td>
      <td>Linksys WNC100P-AU, WLess Net Camera w/Pan/Tilt</td>
      <td>WNC100P</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100P-CA</td>
      <td>Linksys WNC100P-CA, WLess Net Camera w/Pan/Tilt</td>
      <td>WNC100P</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100P-EE</td>
      <td>Linksys WNC100P-EE, WLess Net Camera w/Pan/Tilt</td>
      <td>WNC100P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100P-EU</td>
      <td>Linksys WNC100P-EU, WLess Net Camera w/Pan/Tilt</td>
      <td>WNC100P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100P-ME</td>
      <td>Linksys WNC100P-ME, WLess Net Camera w/Pan/Tilt</td>
      <td>WNC100P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WNC100P-UK</td>
      <td>Linksys WNC100P-UK, WLess Net Camera w/Pan/Tilt</td>
      <td>WNC100P</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC100</td>
      <td>RangePlus Wireless Notebook Adapter</td>
      <td>WPC100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC100-4A</td>
      <td>RangePlus Wireless Notebook Adapter</td>
      <td>WPC100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC100-AS</td>
      <td>RangePlus Wireless Notebook Adapter</td>
      <td>WPC100</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC100-CA</td>
      <td>RangePlus Wireless Notebook Adapter</td>
      <td>WPC100</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC100-DE</td>
      <td>RangePlus Wireless Notebook Adapter</td>
      <td>WPC100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC100-EU</td>
      <td>RangePlus Wireless Notebook Adapter</td>
      <td>WPC100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC100-UK</td>
      <td>RangePlus Wireless Notebook Adapter</td>
      <td>WPC100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC11</td>
      <td>Wireless Network PC Card</td>
      <td>WPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-32</td>
      <td>Wireless Network PC Card</td>
      <td>WPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-AT</td>
      <td>Wireless Network Access Point for AT&amp;T</td>
      <td>WPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-BG</td>
      <td>Wireless Network PC Card, 802.11b</td>
      <td>WPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-BP</td>
      <td>Wireless Network PC Card</td>
      <td>WPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-BR</td>
      <td>WPC11-BR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC11-BT</td>
      <td>Wireless Network PC Card</td>
      <td>WPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-CA</td>
      <td>Wireless Network PC Card (Canada)</td>
      <td>WPC11</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-CC</td>
      <td>Wireless PC Card</td>
      <td>WPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-CN</td>
      <td>Wireless Network PC Card</td>
      <td>WPC11</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-CP</td>
      <td>Wireless Network PC Card</td>
      <td>WPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-CX</td>
      <td>Wireless Network PC Card</td>
      <td>WPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-DE</td>
      <td>Wireless Network PC Card</td>
      <td>WPC11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-EU</td>
      <td>Wireless Network PC Card</td>
      <td>WPC11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-FR</td>
      <td>Wireless Network PC Card</td>
      <td>WPC11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-KR</td>
      <td>WPC11-KR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WPC11</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC11-LA</td>
      <td>Wireless Network PC Card</td>
      <td>WPC11</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-TW</td>
      <td>WPC11-TW PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC11-UK</td>
      <td>Wireless Network PC Card</td>
      <td>WPC11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-VN</td>
      <td>Wireless Network PC Card (for Verizon)</td>
      <td>WPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC11-WM</td>
      <td>Wireless Network PC Card</td>
      <td>WPC11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC300N</td>
      <td>Wireless-N Notebook Adapter</td>
      <td>WPC300N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC300N-4A</td>
      <td>Wireless-N Notebook Adapter</td>
      <td>WPC300N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC300N-AS</td>
      <td>Wireless-N Notebook Adapter</td>
      <td>WPC300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC300N-AU</td>
      <td>Wireless-N Notebook Adapter</td>
      <td>WPC300N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC300N-BP</td>
      <td>WPC300N, Wireless-N Notebook Adapter</td>
      <td>WPC300N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC300N-CA</td>
      <td>Wireless-N Notebook Adapter</td>
      <td>WPC300N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC300N-CN</td>
      <td>Wireless-N Notebook Adapter</td>
      <td>WPC300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC300N-DE</td>
      <td>Wireless-N Notebook Adapter</td>
      <td>WPC300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC300N-E1</td>
      <td>Wireless-N Notebook Adapter</td>
      <td>WPC300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC300N-EU</td>
      <td>Wireless-N Notebook Adapter</td>
      <td>WPC300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC300N-FR</td>
      <td>Wireless-N Notebook Adapter</td>
      <td>WPC300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC300N-KR</td>
      <td>Wireless-N Notebook Adapter</td>
      <td>WPC300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC300N-LA</td>
      <td>Wireless-N Notebook Adapter</td>
      <td>WPC300N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC300N-SG</td>
      <td>Wireless-N Notebook Adapter</td>
      <td>WPC300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC300N-UK</td>
      <td>Wireless-N Notebook Adapter</td>
      <td>WPC300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC51AB</td>
      <td>CQ Dual-Band Wireless Network PC Card (a+b)</td>
      <td>WPC51AB</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54-WB</td>
      <td>Wireless-G Notebook Adapter</td>
      <td>WPC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC54A</td>
      <td>Wireless Network PC Card (IEEE802.11a)</td>
      <td>WPC54A</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54G</td>
      <td>Wireless-G Notebook Adapter</td>
      <td>WPC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54G-4A</td>
      <td>Wireless-G Notebook Adapter</td>
      <td>WPC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54G-AG</td>
      <td>WPC54G-AG PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WPC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC54G-AS</td>
      <td>Wireless-G Notebook Adapter</td>
      <td>WPC54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC54G-AU</td>
      <td>WPC54G-AU PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WPC54G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC54G-BR</td>
      <td>WPC54G-BR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WPC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC54G-CA</td>
      <td>Wireless-G Notebook Adapter (Canada)</td>
      <td>WPC54G</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54G-CC</td>
      <td>Wireless-G Notebook Adapter</td>
      <td>WPC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54G-CN</td>
      <td>Wireless-G Notebook Adapter</td>
      <td>WPC54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54G-D2</td>
      <td>Wireless-G Notebook Adapter</td>
      <td>WPC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54G-DE</td>
      <td>Wireless-G Notebook Adapter</td>
      <td>WPC54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54G-EU</td>
      <td>Wireless-G Notebook Adapter</td>
      <td>WPC54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54G-FR</td>
      <td>Wireless-G Notebook Adapter</td>
      <td>WPC54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54G-JP</td>
      <td>Wireless-G Notebook Adapter</td>
      <td>WPC54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54G-KR</td>
      <td>WPC54G-KR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WPC54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC54G-LA</td>
      <td>Wireless-G Notebook Adapter</td>
      <td>WPC54G</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54G-TA</td>
      <td>Wireless-G Notebook Adapter</td>
      <td>WPC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54G-TW</td>
      <td>WPC54G-TW PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WPC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC54G-UK</td>
      <td>Wireless-G Notebook Adapter</td>
      <td>WPC54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54G-WB</td>
      <td>Wireless-G Notebook Adapter</td>
      <td>WPC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54G-WM</td>
      <td>Wireless-G Notebook Adapter</td>
      <td>WPC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GR</td>
      <td>Wireless-G Notebook Adapter with RangeBooster</td>
      <td>WPC54GR</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GR-AS</td>
      <td>Wireless-G Notebook Adapter with RangeBooster</td>
      <td>WPC54GR</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GR-AU</td>
      <td>Wireless-G Notebook Adapter with RangeBooster</td>
      <td>WPC54GR</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC54GR-DE</td>
      <td>Wireless-G Notebook Adapter with RangeBooster</td>
      <td>WPC54GR</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GR-EU</td>
      <td>Wireless-G Notebook Adapter with RangeBooster</td>
      <td>WPC54GR</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GR-FR</td>
      <td>Wireless-G Notebook Adapter with RangeBooster</td>
      <td>WPC54GR</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GR-UK</td>
      <td>Wireless-G Notebook Adapter with RangeBooster</td>
      <td>WPC54GR</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GS</td>
      <td>Wireless-G Notebook Adapter with SpeedBooster</td>
      <td>WPC54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GS-4A</td>
      <td>Wireless-G Notebook Adapter with Speed Booster</td>
      <td>WPC54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GS-AS</td>
      <td>Wireless-G Notebook Adapter with SpeedBooster</td>
      <td>WPC54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC54GS-CA</td>
      <td>Wireless-G Notebook Adapter with SpeedBooster</td>
      <td>WPC54GS</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GS-CN</td>
      <td>Wireless-G Notebook Adapter with SpeedBooster</td>
      <td>WPC54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GS-DE</td>
      <td>Wireless-G Notebook Adapter with SpeedBooster</td>
      <td>WPC54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GS-EU</td>
      <td>Wireless-G Notebook Adapter with SpeedBooster</td>
      <td>WPC54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GS-FR</td>
      <td>Wireless-G Notebook Adapter with SpeedBooster</td>
      <td>WPC54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GS-JP</td>
      <td>Wireless-G Notebook Adapter with SpeedBooster</td>
      <td>WPC54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GS-KR</td>
      <td>WPC54GS-KR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WPC54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC54GS-UK</td>
      <td>Wireless-G Notebook Adapter with SpeedBooster</td>
      <td>WPC54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GS-WM</td>
      <td>Wireless-G Notebook Adapter with SpeedBooster</td>
      <td>WPC54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GX</td>
      <td>Wireless-G Notebook Adapter with SRX</td>
      <td>WPC54GX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GX-AS</td>
      <td>Wireless-G Notebook Adapter with SRX</td>
      <td>WPC54GX</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GX-CA</td>
      <td>Wireless-G Notebook Adapter with SRX</td>
      <td>WPC54GX</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GX-DE</td>
      <td>Wireless-G Notebook Adapter with SRX</td>
      <td>WPC54GX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GX-EU</td>
      <td>Wireless-G Notebook Adapter with SRX</td>
      <td>WPC54GX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GX-FR</td>
      <td>Wireless-G Notebook Adapter with SRX</td>
      <td>WPC54GX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GX-SG</td>
      <td>Wireless-G Notebook Adapter with SRX</td>
      <td>WPC54GX</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GX-UK</td>
      <td>Wireless-G Notebook Adapter with SRX</td>
      <td>WPC54GX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GX2</td>
      <td>WPC54GX2 PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WPC54GX2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC54GX4</td>
      <td>Wireless-G Notebook Adapter with SRX400</td>
      <td>WPC54GX4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GX4-AS</td>
      <td>Wireless-G Notebook Adapter with SRX400</td>
      <td>WPC54GX4</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GX4-CA</td>
      <td>Wireless-G Notebook Adapter with SRX400</td>
      <td>WPC54GX4</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GX4-DE</td>
      <td>Wireless-G Notebook Adapter with SRX400</td>
      <td>WPC54GX4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GX4-EU</td>
      <td>Wireless-G Notebook Adapter with SRX400</td>
      <td>WPC54GX4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GX4-FR</td>
      <td>Wireless-G Notebook Adapter with SRX400</td>
      <td>WPC54GX4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC54GX4-UK</td>
      <td>Wireless-G Notebook Adapter with SRX400</td>
      <td>WPC54GX4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC55AG</td>
      <td>Dual-Band Wireless A+G Notebook Adapter</td>
      <td>WPC55AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC55AG-AS</td>
      <td>Dual-Band Wireless A+G Notebook Adapter</td>
      <td>WPC55AG</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC55AG-CA</td>
      <td>Dual-Band Wireless A+G Notebook Adapter</td>
      <td>WPC55AG</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC55AG-CU</td>
      <td>Dual-Band Wireless A+G Notebook Adapter</td>
      <td>WPC55AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC55AG-E</td>
      <td>WPC55AG-E PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WPC55AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC55AG-EU</td>
      <td>Dual-Band Wireless A+G Notebook Adapter</td>
      <td>WPC55AG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC55AG-JP</td>
      <td>WPC55AG-JP PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WPC55AG</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC55AG-KR</td>
      <td>Dual-Band Wireless A+G Notebook Adapter</td>
      <td>WPC55AG</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC55AG-TA</td>
      <td>Dual-Band Wireless A+G Notebook Adapter</td>
      <td>WPC55AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC55AG-UK</td>
      <td>Dual-Band Wireless A+G Notebook Adapter</td>
      <td>WPC55AG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC600N</td>
      <td>Wireless-N Dual Band Notebook Adapter</td>
      <td>WPC600N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC600N-4A</td>
      <td>Wireless-N Dual Band Notebook Adapter</td>
      <td>WPC600N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC600N-AS</td>
      <td>Wireless-N Dual Band Notebook Adapter</td>
      <td>WPC600N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC600N-AU</td>
      <td>Wireless-N Dual Band Notebook Adapter</td>
      <td>WPC600N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC600N-CA</td>
      <td>Dual-Band Wireless-N Notebook Adapter</td>
      <td>WPC600N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPC600N-DE</td>
      <td>Wireless-N Dual Band Notebook Adapter</td>
      <td>WPC600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC600N-EU</td>
      <td>Wireless-N Dual Band Notebook Adapter</td>
      <td>WPC600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC600N-FR</td>
      <td>Wireless-N Dual Band Notebook Adapter</td>
      <td>WPC600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPC600N-UK</td>
      <td>Wireless-N Dual Band Notebook Adapter</td>
      <td>WPC600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPCI54G</td>
      <td>Wireless-G PCI Adapter</td>
      <td>WPCI54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPG11</td>
      <td>Wireless Presentation Gateway</td>
      <td>WPG11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WPG11-EU</td>
      <td>Wireless Presentation Gateway</td>
      <td>WPG11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WPG11-TH</td>
      <td>Wireless Presentation Gateway</td>
      <td>WPG11</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WPG11-UK</td>
      <td>Wireless Presentation Gateway</td>
      <td>WPG11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WPG12</td>
      <td>Wireless Presentation Player</td>
      <td>WPG12</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPG12-CN</td>
      <td>Wireless Presentation Player</td>
      <td>WPG12</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPG12-TH</td>
      <td>Wireless Presentation Player</td>
      <td>WPG12</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPG54G</td>
      <td>Wireless-G Presentation Player</td>
      <td>WPG54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPG54G-AU</td>
      <td>Wireless-G Presentation Player</td>
      <td>WPG54G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPG54G-EU</td>
      <td>Wireless-G Presentation Player</td>
      <td>WPG54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPG54G-UK</td>
      <td>Wireless-G Presentation Player</td>
      <td>WPG54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS11</td>
      <td>Wireless Print Server</td>
      <td>WPS11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS11-AU</td>
      <td>Wireless Print Server</td>
      <td>WPS11</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS11-CA</td>
      <td>Wireless Print Server (Canada)</td>
      <td>WPS11</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS11-CN</td>
      <td>Wireless Print Server</td>
      <td>WPS11</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS11-EU</td>
      <td>Wireless Print Server</td>
      <td>WPS11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS11-JP</td>
      <td>WPS11-JP PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WPS11</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPS11-KR</td>
      <td>WPS11-KR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WPS11</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WPS11-UK</td>
      <td>Wireless Print Server</td>
      <td>WPS11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54G</td>
      <td>Wireless-G Print Server</td>
      <td>WPS54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54G-AS</td>
      <td>Wireless-G Print Server</td>
      <td>WPS54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54G-AU</td>
      <td>Wireless-G Print Server</td>
      <td>WPS54G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54G-CA</td>
      <td>Wireless-G Print Server</td>
      <td>WPS54G</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54G-DE</td>
      <td>Wireless-G Print Server</td>
      <td>WPS54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54G-EU</td>
      <td>Wireless-G Print Server</td>
      <td>WPS54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54G-FR</td>
      <td>Wireless-G Print Server</td>
      <td>WPS54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54G-KR</td>
      <td>Wireless-G Print Server</td>
      <td>WPS54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54G-SG</td>
      <td>Wireless-G Print Server</td>
      <td>WPS54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54G-UK</td>
      <td>Wireless-G Print Server</td>
      <td>WPS54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54G-WM</td>
      <td>Wireless-G Print Server</td>
      <td>WPS54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54GU2</td>
      <td>Wireless-G PrintServer for USB 2.0</td>
      <td>WPS54GU2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54GU2-AU</td>
      <td>Wireless-G PrintServer for USB 2.0</td>
      <td>WPS54GU2</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54GU2-BP</td>
      <td>Wireless-G PrintServer for USB 2.0 Blister Pack</td>
      <td>WPS54GU2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54GU2-CA</td>
      <td>Wireless-G PrintServer for USB 2.0</td>
      <td>WPS54GU2</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54GU2-CN</td>
      <td>Wireless-G PrintServer for USB 2.0</td>
      <td>WPS54GU2</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54GU2-EU</td>
      <td>Wireless-G PrintServer for USB 2.0</td>
      <td>WPS54GU2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54GU2-SG</td>
      <td>Wireless-G PrintServer for USB 2.0</td>
      <td>WPS54GU2</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td>30-Mar-2015</td>
      <td>28-Mar-2020</td>
    </tr>
    <tr>
      <td>WPS54GU2-TA</td>
      <td>Wireless-G PrintServer for USB 2.0</td>
      <td>WPS54GU2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54GU2-UK</td>
      <td>Wireless-G PrintServer for USB 2.0</td>
      <td>WPS54GU2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPS54GU2-WM</td>
      <td>Wireless-G PrintServer for USB 2.0</td>
      <td>WPS54GU2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPSM300N</td>
      <td>Wireless-N Multifunction Print Server</td>
      <td>WPSM300N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WPSM300N-AU</td>
      <td>Wireless-N Multifunction Print Server</td>
      <td>WPSM300N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WPSM300N-CA</td>
      <td>Wireless-N Multifunction Print Server</td>
      <td>WPSM300N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WPSM300N-DE</td>
      <td>Wireless-N Multifunction Print Server</td>
      <td>WPSM300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WPSM300N-EU</td>
      <td>Wireless-N Multifunction Print Server</td>
      <td>WPSM300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WPSM300N-SG</td>
      <td>Wireless-N Multifunction Print Server</td>
      <td>WPSM300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td>26-Mar-2015</td>
      <td>24-Mar-2020</td>
    </tr>
    <tr>
      <td>WPSM300N-UK</td>
      <td>Wireless-N Multifunction Print Server</td>
      <td>WPSM300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WPSM54G-AS</td>
      <td>Wireless-G PrintServer with Multifunction Printer</td>
      <td>WPSM54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WPSM54G-CA</td>
      <td>Wireless-G PrintServer</td>
      <td>WPSM54G</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WPSM54G-SG</td>
      <td>Wireless-G PrintServer with Multifunction Printer</td>
      <td>WPSM54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WRE54AG</td>
      <td>Dummy SKU, Dual Band Wireless Range Expander</td>
      <td>WRE54AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRE54G</td>
      <td>Wireless-G Range Expander</td>
      <td>WRE54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRE54G-AR</td>
      <td>WRE54G-AR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRE54G</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRE54G-AS</td>
      <td>Wireless-G Range Expander</td>
      <td>WRE54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td>26-Mar-2015</td>
      <td>24-Mar-2020</td>
    </tr>
    <tr>
      <td>WRE54G-AU</td>
      <td>Wireless-G Range Expander</td>
      <td>WRE54G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRE54G-BR</td>
      <td>WRE54G-BR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRE54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRE54G-CA</td>
      <td>Wireless-G Range Expander</td>
      <td>WRE54G</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRE54G-CB</td>
      <td>WRE54G-CB PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRE54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRE54G-CN</td>
      <td>Wireless-G Range Expander</td>
      <td>WRE54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRE54G-DE</td>
      <td>Wireless-G Range Expander</td>
      <td>WRE54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRE54G-EU</td>
      <td>Wireless-G Range Expander</td>
      <td>WRE54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRE54G-FR</td>
      <td>Wireless-G Range Expander</td>
      <td>WRE54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRE54G-JP</td>
      <td>Wireless-G Range Expander</td>
      <td>WRE54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRE54G-SG</td>
      <td>WRE54G-SG PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRE54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRE54G-UK</td>
      <td>Wireless-G Range Expander</td>
      <td>WRE54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRE54G-WM</td>
      <td>Wireless-G Range Expander</td>
      <td>WRE54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRH54G</td>
      <td>Wireless-G Home Router</td>
      <td>WRH54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRH54G-CA</td>
      <td>Wireless-G Home Router</td>
      <td>WRH54G</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRH54G-CN</td>
      <td>Wireless-G Home Router</td>
      <td>WRH54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRH54G-IN</td>
      <td>Wireless-G Home Router</td>
      <td>WRH54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRK54G</td>
      <td>Wireless-G 4 Port Router</td>
      <td>WRK54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRK54G-AU</td>
      <td>WRK54G-AU PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRK54G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRK54G-CA</td>
      <td>WRK54G-CA PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRK54G</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRK54G-EU</td>
      <td>WRK54G-EU PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRK54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRK54G-FR</td>
      <td>WRK54G-FR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRK54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT002ANT</td>
      <td>HIGH GAIN ANTENNA KIT, 2 PACK</td>
      <td>WRTANT7</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT002ANT-AP</td>
      <td>HIGH GAIN ANTENNA KIT, 2 PACK</td>
      <td>WRT002ANT</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT002ANT-CA</td>
      <td>HIGH GAIN ANTENNA KIT, 2 PACK</td>
      <td>WRT002ANT</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT002ANT-EU</td>
      <td>HIGH GAIN ANTENNA KIT, 2 PACK</td>
      <td>WRT002ANT</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT004ANT</td>
      <td>HIGH GAIN ANTENNA KIT, 4 PACK</td>
      <td>WRTANT7</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT004ANT-AP</td>
      <td>HIGH GAIN ANTENNA KIT, 4 PACK</td>
      <td>WRT004ANT</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT004ANT-CA</td>
      <td>HIGH GAIN ANTENNA KIT, 4 PACK</td>
      <td>WRT004ANT</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT004ANT-EU</td>
      <td>HIGH GAIN ANTENNA KIT, 4 PACK</td>
      <td>WRT004ANT</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT100</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT100-AU</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT100</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT100-CA</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT100</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT100-DE</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT100-EU</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT100-SG</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT100</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT100-UK</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT110</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT110</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT110-4A</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT110</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT110-AS</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT110</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT110-AU</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT110</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT110-BP</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT110</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT110-CA</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT110</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT110-CN</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT110</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT110-DE</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT110</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT110-EU</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT110</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT110-IN</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT110</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT110-KR</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT110</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT110-LA</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT110</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT110-SG</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT110</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT110-UK</td>
      <td>RangePlus Wireless Router</td>
      <td>WRT110</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT1200AC</td>
      <td>LINKSYS WRT1200AC WIFI ROUTER,AC1200</td>
      <td>WRT1200AC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1200AC-AR</td>
      <td>LINKSYS WRT1200AC WIFI ROUTER,AC1200</td>
      <td>WRT1200AC</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1200AC-AU</td>
      <td>LINKSYS WRT1200AC WIFI ROUTER,AC1200</td>
      <td>WRT1200AC</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1200AC-BR</td>
      <td>LINKSYS WRT1200AC WIFI ROUTER,AC1200</td>
      <td>WRT1200AC</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1200AC-CA</td>
      <td>LINKSYS WRT1200AC WIFI ROUTER,AC1200</td>
      <td>WRT1200AC</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1200AC-LA</td>
      <td>LINKSYS WRT1200AC WIFI ROUTER,AC1200</td>
      <td>WRT1200AC</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1200AC-PH</td>
      <td>LINKSYS WRT1200AC WIFI ROUTER,AC1200</td>
      <td>WRT1200AC</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT120N</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT120N-4A</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT120N-AR</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT120N-AU</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT120N-BC</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT120N-BP</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT120N-BR</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT120N-CA</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT120N-CN</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT120N-DE</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT120N-EE</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT120N-EN</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT120N-EW</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT120N-EZ</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT120N-LA</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT120N-ME</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT120N-SG</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT120N-UK</td>
      <td>Wireless-N Home Router</td>
      <td>WRT120N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT150-AS</td>
      <td>Wireless-N Home Router</td>
      <td>WRT150</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT150N</td>
      <td>Wireless-N Home Router</td>
      <td>WRT150N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT150N-4A</td>
      <td>Wireless-N Home Router</td>
      <td>WRT150N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT150N-AR</td>
      <td>Wireless-N Home Router</td>
      <td>WRT150N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT150N-AS</td>
      <td>Wireless-N Home Router</td>
      <td>WRT150N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT150N-AU</td>
      <td>Wireless-N Home Router</td>
      <td>WRT150N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT150N-BR</td>
      <td>Wireless-N Home Router</td>
      <td>WRT150N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT150N-CA</td>
      <td>Wireless-N Home Router</td>
      <td>WRT150N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT150N-CN</td>
      <td>Wireless-N Home Router</td>
      <td>WRT150N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT150N-DE</td>
      <td>Wireless-N Home Router</td>
      <td>WRT150N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT150N-EU</td>
      <td>Wireless-N Home Router</td>
      <td>WRT150N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT150N-KR</td>
      <td>Wireless-N Home Router</td>
      <td>WRT150N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT150N-LA</td>
      <td>Wireless-N Home Router</td>
      <td>WRT150N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT150N-SG</td>
      <td>Wireless-N Home Router</td>
      <td>WRT150N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT150N-TA</td>
      <td>Wireless-N Home Router</td>
      <td>WRT150N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT150N-UK</td>
      <td>Wireless-N Home Router</td>
      <td>WRT150N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-4A</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-AR</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-AS</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WRT160N-AU</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-BP</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-BR</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-CA</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-CN</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-DE</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-EE</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-EN</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-EU</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-EW</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-EZ</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-GC</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-HD</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-HP</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-ID</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WRT160N-IN</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WRT160N-KR</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT160N-LA</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-ME</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-PC</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-PV</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WRT160N-SG</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160N-TH</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WRT160N-UK</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT160N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160NL</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRT160NL</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160NL-AP</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRT160NL</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160NL-CA</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRT160NL</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160NL-DE</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRT160NL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160NL-EE</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRT160NL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160NL-EN</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRT160NL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160NL-EW</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRT160NL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160NL-EZ</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRT160NL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160NL-M2</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRT160NL</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160NL-ME</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRT160NL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT160NL-UK</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRT160NL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT1900AC</td>
      <td>LINKSYS WRT1900AC WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1900AC-2A</td>
      <td>LINKSYS WRT1900AC WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1900AC-AP</td>
      <td>LINKSYS WRT1900AC WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1900AC-AU</td>
      <td>LINKSYS WRT1900AC WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1900AC-BR</td>
      <td>LINKSYS WRT1900AC WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1900AC-CA</td>
      <td>LINKSYS WRT1900AC WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1900AC-CO</td>
      <td>LINKSYS WRT1900AC WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1900AC-EJ</td>
      <td>LINKSYS WRT1900AC WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1900AC-EK</td>
      <td>LINKSYS WRT1900AC WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1900AC-FFP</td>
      <td>LINKSYS WRT1900AC WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1900AC-ME</td>
      <td>LINKSYS WRT1900AC WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1900AC-PH</td>
      <td>LINKSYS WRT1900AC WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT1900AC-TG</td>
      <td>LINKSYS WRT1900AC WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1900AC-TG2</td>
      <td>LINKSYS WRT1900AC WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1900AC-TTB</td>
      <td>LINKSYS WRT1900AC WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1900AC-UK</td>
      <td>LINKSYS WRT1900AC WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1900ACS-2A</td>
      <td>LINKSYS WRT1900ACS WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT1900ACS-AH</td>
      <td>LINKSYS WRT1900ACS WIFI ROUTER,AC1900</td>
      <td>WRT1900AC</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT300-CN</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT300-LA</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT300N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT300N</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT300N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT300N-4A</td>
      <td>WRT300N, Wireless-N Broadband Router</td>
      <td>WRT300N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT300N-AS</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT300N-AU</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT300N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT300N-BP</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT300N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT300N-CA</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT300N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT300N-CN</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT300N-DE</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT300N-EU</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT300N-FR</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT300N-KR</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT300N-LA</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT300N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT300N-SG</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT300N-UK</td>
      <td>Wireless-N Broadband Router</td>
      <td>WRT300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT310N</td>
      <td>WIRELESS-N GIGABIT ROUTER</td>
      <td>WRT310N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT310N-4A</td>
      <td>WIRELESS-N GIGABIT ROUTER</td>
      <td>WRT310N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT310N-AS</td>
      <td>WIRELESS-N GIGABIT ROUTER</td>
      <td>WRT310N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT310N-AU</td>
      <td>WIRELESS-N GIGABIT ROUTER</td>
      <td>WRT310N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT310N-BP</td>
      <td>WIRELESS-N GIGABIT ROUTER</td>
      <td>WRT310N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT310N-CA</td>
      <td>WIRELESS-N GIGABIT ROUTER</td>
      <td>WRT310N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT310N-CC</td>
      <td>WIRELESS-N GIGABIT ROUTER</td>
      <td>WRT310N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT310N-LA</td>
      <td>WIRELESS-N GIGABIT ROUTER</td>
      <td>WRT310N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT310N-NA</td>
      <td>WIRELESS-N GIGABIT ROUTER</td>
      <td>WRT310N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT310N-SG</td>
      <td>WIRELESS-N GIGABIT ROUTER</td>
      <td>WRT310N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT3200ACM-AH</td>
      <td>LINKSYS WRT3200ACM WIFI ROUTER DB 160MHZ MU-MIMO</td>
      <td>WRT3200ACM</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT320N</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT320N-4A</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT320N-AU</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT320N-BC</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT320N-BP</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT320N-CA</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT320N-CN</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT320N-DE</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT320N-EE</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT320N-EN</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT320N-EW</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT320N-EZ</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT320N-HD</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT320N-LA</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT320N-ME</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT320N-SG</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT320N-UK</td>
      <td>Dual-Band Wireless-N Gigabit Router</td>
      <td>WRT320N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT330N</td>
      <td>Wireless-N Gigabit Gaming Router</td>
      <td>WRT330N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT350N</td>
      <td>Wireless-N Gigabit Router with Storage Link</td>
      <td>WRT350N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT350N-AS</td>
      <td>Wireless-N Broadband Router with Gigabit Port</td>
      <td>WRT350N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT350N-AU</td>
      <td>Wireless-N Broadband Router with Gigabit Port</td>
      <td>WRT350N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT350N-CA</td>
      <td>Wireless-N Gigabit Router with StorageLink</td>
      <td>WRT350N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT350N-DE</td>
      <td>Wireless-N Broadband Router with Gigabit Port</td>
      <td>WRT350N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT350N-EU</td>
      <td>Wireless-N Gigabit Router with Storage Link</td>
      <td>WRT350N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT350N-FR</td>
      <td>Wireless-N Broadband Router with Gigabit Port</td>
      <td>WRT350N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT350N-SG</td>
      <td>Wireless-N Gigabit Router with Storage Link</td>
      <td>WRT350N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT350N-UK</td>
      <td>Wireless-N Gigabit Router with Storage Link</td>
      <td>WRT350N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT400N</td>
      <td>Simultaneous Dual-Band Wireless-N Router</td>
      <td>WRT400N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT400N-4A</td>
      <td>Simultaneous Dual-Band Wireless-N Router</td>
      <td>WRT400N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT400N-CA</td>
      <td>Simultaneous Dual-Band Wireless-N Router</td>
      <td>WRT400N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT41G-CN</td>
      <td>Wireless-G Home Router</td>
      <td>WRT41G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT45AG</td>
      <td>WRT45AG PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRT45AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT51AB</td>
      <td>CH Cual-Band Wireless Router (a+b)</td>
      <td>WRT51AB</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54AG</td>
      <td>Dual-Band Wireless A/G Broadband Router</td>
      <td>WRT54AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54AG-EU</td>
      <td>Dual-Band Wireless A+G Broadband Router</td>
      <td>WRT54AG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-4A</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-4P</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54G-AR</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-AS</td>
      <td>WRT54G-AS PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRT54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54G-AU</td>
      <td>Wireless-G Router</td>
      <td>WRT54G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-BP</td>
      <td>Wireless-G Broadband Router Blister Pack</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-BR</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-CA</td>
      <td>Wireless-G Broadband Router (Canada)</td>
      <td>WRT54G</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-CB</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-CH</td>
      <td>WRT54G-CH PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54G-CN</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-CX</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-D2</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-DE</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-EU</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-FR</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-HU</td>
      <td>WRT54G-HU PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54G-IN</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-JP</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-KR</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-LA</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-NA</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-RG</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-SG</td>
      <td>WRT54G-SG PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRT54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54G-SH</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-TA</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-TH</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-TM</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRT54G-TW</td>
      <td>WRT54G-TW PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54G-UK</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G-WM</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G/P-JP</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G/P</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2-4A</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2-4T</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2-AR</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2-AS</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54G2-AU</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2-BR</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2-CA</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2-CN</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2-DE</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2-EE</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2-EN</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2-EU</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2-EW</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2-EZ</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2-ID</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54G2-IN</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54G2-KR</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WRT54G2-LA</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2-PV</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54G2-SG</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G2-TH</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54G2-UK</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54G2</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54G3G-AT</td>
      <td>Wireless-G Router for Mobile Broadband</td>
      <td>WRT54G3G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRT54G3G-AU</td>
      <td>Wireless-G Router for 3G/UMTS Broadband</td>
      <td>WRT54G3G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRT54G3G-DE</td>
      <td>WRT54G3G-DE PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRT54G3G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54G3G-EM</td>
      <td>Wireless-G Router for 3G/UMTS Broadband</td>
      <td>WRT54G3G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRT54G3G-EU</td>
      <td>Wireless-G Router for 3G/UMTS Broadband</td>
      <td>WRT54G3G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRT54G3G-NA</td>
      <td>Wireless-G Router for Mobile Broadband</td>
      <td>WRT54G3G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRT54G3G-ST</td>
      <td>Wireless-G Router for Mobile Broadband</td>
      <td>WRT54G3G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRT54G3G-UK</td>
      <td>Wireless G Router for 3G/UMTS Broadband</td>
      <td>WRT54G3G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRT54G3G-VN</td>
      <td>Wireless-G Router for Mobile Broadband</td>
      <td>WRT54G3G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRT54G3GV2-9C</td>
      <td>Wireless-G Router for 3G/UMTS Broadband, V2</td>
      <td>WRT54G3GV2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54G3GV2-ST</td>
      <td>WRT54G3GV2-ST,V2.0,WLessG Rtr for Mobile Broadband</td>
      <td>WRT54G3GV2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRT54G3GV2-VF</td>
      <td>Wireless-G Router for 3G/UMTS Broadband</td>
      <td>WRT54G3GV2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRT54GC</td>
      <td>Compact Wireless-G Broadband Router</td>
      <td>WRT54GC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GC-AR</td>
      <td>Compact Wireless-G Broadband Router</td>
      <td>WRT54GC</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GC-AS</td>
      <td>Compact Wireless-G Broadband Router</td>
      <td>WRT54GC</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GC-AU</td>
      <td>Compact Wireless-G Broadband Router</td>
      <td>WRT54GC</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GC-CA</td>
      <td>Compact Wireless-G Broadband Router</td>
      <td>WRT54GC</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GC-CN</td>
      <td>Compact Wireless-G Broadband Router</td>
      <td>WRT54GC</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GC-DE</td>
      <td>Compact Wireless-G Broadband Router</td>
      <td>WRT54GC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GC-EU</td>
      <td>Compact Wireless-G Broadband Router</td>
      <td>WRT54GC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GC-FR</td>
      <td>Compact Wireless-G Broadband Router</td>
      <td>WRT54GC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GC-JP</td>
      <td>Compact Wireless-G Broadband Router</td>
      <td>WRT54GC</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GC-JP-YZ</td>
      <td>Compact Wireless-G Broadband Router</td>
      <td>WRT54GC</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GC-KR</td>
      <td>Compact Wireless-G Broadband Router</td>
      <td>WRT54GC</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GC-LA</td>
      <td>Wireless-G Compact Router</td>
      <td>WRT54GC</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GC-SG</td>
      <td>Compact Wireless-G Broadband Router</td>
      <td>WRT54GC</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GC-TA</td>
      <td>Compact Wireless-G Broadband Router</td>
      <td>WRT54GC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GC-UK</td>
      <td>Compact Wireless-G Broadband Router</td>
      <td>WRT54GC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GC/P-JP</td>
      <td>Wireless Compact Broadband Router Kit</td>
      <td>WRT54GC/P</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GH-AS</td>
      <td>Wireless-G Home Router with SpeedBurst</td>
      <td>WRT54GH</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54GH-BR</td>
      <td>Wireless-G Home Router with SpeedBurst</td>
      <td>WRT54GH</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GH-EU</td>
      <td>Wireless-G Home Router with SpeedBurst</td>
      <td>WRT54GH</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GH-LA</td>
      <td>Wireless-G Home Router with SpeedBurst</td>
      <td>WRT54GH</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54GH-SG</td>
      <td>Wireless-G Home Router with SpeedBurst</td>
      <td>WRT54GH</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GH-TH</td>
      <td>Wireless-G Home Router with SpeedBurst</td>
      <td>WRT54GH</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GL-AS</td>
      <td>LINKSYS WRT54GL WIFI ROUTER,G</td>
      <td>WRT54GL</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GL-AU</td>
      <td>LINKSYS WRT54GL WIFI ROUTER,G</td>
      <td>WRT54GL</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GL-DE</td>
      <td>LINKSYS WRT54GL WIFI ROUTER,G</td>
      <td>WRT54GL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GL-EU</td>
      <td>LINKSYS WRT54GL WIFI ROUTER,G</td>
      <td>WRT54GL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GL-ID</td>
      <td>Wireless-G Broadband Router</td>
      <td>WRT54GL</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WRT54GL-M2</td>
      <td>LINKSYS WRT54GL WIFI ROUTER,G</td>
      <td>WRT54GL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54GL-SG</td>
      <td>LINKSYS WRT54GL WIFI ROUTER,G</td>
      <td>WRT54GL</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GL-UK</td>
      <td>LINKSYS WRT54GL WIFI ROUTER,G</td>
      <td>WRT54GL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>27-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GP2A-PS</td>
      <td>Wireless-G Broadband Router with 2 Phone Ports</td>
      <td>WRT54GP2A</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WRT54GR</td>
      <td>Wireless-G Broadband Router with RangeBooster</td>
      <td>WRT54GR</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GR-AU</td>
      <td>Wirelsss-G Broadband Router with RangeBooster</td>
      <td>WRT54GR</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GR-DE</td>
      <td>Wirelsss-G Broadband Router with RangeBooster</td>
      <td>WRT54GR</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GR-EU</td>
      <td>Wirelsss-G Broadband Router with RangeBooster</td>
      <td>WRT54GR</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GR-FR</td>
      <td>Wirelsss-G Broadband Router with RangeBooster</td>
      <td>WRT54GR</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GR-UK</td>
      <td>Wirelsss-G Broadband Router with RangeBooster</td>
      <td>WRT54GR</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS</td>
      <td>WLess-G Broadband Rtr with SpeedBooster Technology</td>
      <td>WRT54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS-4A</td>
      <td>Wireless-G Broadband Router with Speed Booster</td>
      <td>WRT54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS-9US</td>
      <td>WLess-G Broadband Rtr with SpeedBooster Technology</td>
      <td>WRT54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS-AS</td>
      <td>WRT54GS-AS PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRT54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54GS-AU</td>
      <td>WLess-G Broadband Rtr with SpeedBooster Technology</td>
      <td>WRT54GS</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS-BP</td>
      <td>WLess-G Broadband Rtr with SpeedBooster Technology</td>
      <td>WRT54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS-BR</td>
      <td>WRT54GS-BR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRT54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54GS-CA</td>
      <td>WLess-G Broadband Rtr with SpeedBooster Technology</td>
      <td>WRT54GS</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS-CH</td>
      <td>WRT54GS-CH PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRT54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT54GS-CN</td>
      <td>WLess-G Broadband Rtr with SpeedBooster Technology</td>
      <td>WRT54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS-DE</td>
      <td>WLess-G Broadband Rtr with SpeedBooster Technology</td>
      <td>WRT54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS-EU</td>
      <td>WLess-G Broadband Rtr with SpeedBooster Technology</td>
      <td>WRT54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS-FR</td>
      <td>WLess-G Broadband Rtr with SpeedBooster Technology</td>
      <td>WRT54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS-JP</td>
      <td>WLess-G Broadband Rtr with SpeedBooster Technology</td>
      <td>WRT54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS-KR</td>
      <td>WLess-G Broadband Rtr with SpeedBooster Technology</td>
      <td>WRT54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS-PC</td>
      <td>WLess-G Broadband Rtr with SpeedBooster Technology</td>
      <td>WRT54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS-SG</td>
      <td>Wireless-G Broadband Router with Speedbooster</td>
      <td>WRT54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS-UK</td>
      <td>WLess-G Broadband Rtr with SpeedBooster Technology</td>
      <td>WRT54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS-WM</td>
      <td>WLess-G Broadband Rtr with SpeedBooster Technology</td>
      <td>WRT54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS/P-JP</td>
      <td>Wireless-G Router + PC Card Kit</td>
      <td>WRT54GS/P</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS2</td>
      <td>Wireless-G Broadband Router with Speed Booster</td>
      <td>WRT54GS2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GS2-4A</td>
      <td>Wireless-G Broadband Router with Speed Booster</td>
      <td>WRT54GS2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX</td>
      <td>Wireless-G Broadband Router with SRX</td>
      <td>WRT54GX</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX-AS</td>
      <td>Wireless-G Broadband Router with SRX</td>
      <td>WRT54GX</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX-AU</td>
      <td>Wireless-G Broadband Router with SRX</td>
      <td>WRT54GX</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX-CA</td>
      <td>Wireless-G Broadband Router with SRX</td>
      <td>WRT54GX</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX-DE</td>
      <td>Wireless-G Broadband Router with SRX</td>
      <td>WRT54GX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX-EU</td>
      <td>Wireless-G Broadband Router with SRX</td>
      <td>WRT54GX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX-FR</td>
      <td>Wireless-G Broadband Router with SRX</td>
      <td>WRT54GX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX-KR</td>
      <td>Wireless-G Broadband Router with SRX</td>
      <td>WRT54GX</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX-SG</td>
      <td>Wireless-G Broadband Router with SRX</td>
      <td>WRT54GX</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX-UK</td>
      <td>Wireless-G Broadband Router with SRX</td>
      <td>WRT54GX</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX2</td>
      <td>Wireless-G Broadband Router with SRX200</td>
      <td>WRT54GX2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX2-AU</td>
      <td>Wireless-G Broadband Router with SRX200</td>
      <td>WRT54GX2</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX2-CA</td>
      <td>Wireless-G Broadband Router with SRX200</td>
      <td>WRT54GX2</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX4</td>
      <td>Wireless-G Broadband Router with SRX400</td>
      <td>WRT54GX4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX4-AS</td>
      <td>Wireless-G Broadband Router with SRX400</td>
      <td>WRT54GX4</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX4-AU</td>
      <td>Wireless-G Broadband Router with SRX400</td>
      <td>WRT54GX4</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX4-CA</td>
      <td>Wireless-G Broadband Router with SRX400</td>
      <td>WRT54GX4</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX4-DE</td>
      <td>Wireless-G Broadband Router with SRX400</td>
      <td>WRT54GX4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX4-EU</td>
      <td>Wireless-G Broadband Router with SRX400</td>
      <td>WRT54GX4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX4-FR</td>
      <td>Wireless-G Broadband Router with SRX400</td>
      <td>WRT54GX4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX4-SG</td>
      <td>Wireless-G Broadband Router with SRX400</td>
      <td>WRT54GX4</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54GX4-UK</td>
      <td>Wireless-G Broadband Router with SRX400</td>
      <td>WRT54GX4</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT54X-DE</td>
      <td>WRT54X-DE PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRT54X</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT55AG</td>
      <td>Dual-Band Wireless A+G Broadband Router</td>
      <td>WRT55AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT55AG-AU</td>
      <td>Dual-Band Wireless A+G Broadband Router</td>
      <td>WRT55AG</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT55AG-CA</td>
      <td>Dual-Band Wireless A+G Broadband Router</td>
      <td>WRT55AG</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT55AG-CN</td>
      <td>Dual-Band Wireless A+G Broadband Router</td>
      <td>WRT55AG</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT55AG-E</td>
      <td>WRT55AG-E PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRT55AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT55AG-EU</td>
      <td>Dual-Band Wireless A+G Broadband Router</td>
      <td>WRT55AG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT55AG-TA</td>
      <td>Dual-Band Wireless A+G Broadband Router</td>
      <td>WRT55AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT55AG-TH</td>
      <td>Dual-Band Wireless A+G Broadband Router</td>
      <td>WRT55AG</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT55AG-UK</td>
      <td>Dual-Band Wireless A+G Broadband Router</td>
      <td>WRT55AG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT600N</td>
      <td>Dual-Band Wireless-N Gigabit Rtr with Storage Link</td>
      <td>WRT600N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT600N-AS</td>
      <td>Wireless-N Dual Band Broadband Router</td>
      <td>WRT600N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT600N-AU</td>
      <td>Wireless-N Dual Band Broadband Router</td>
      <td>WRT600N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT600N-CA</td>
      <td>Wireless-N Dual Band Broadband Router</td>
      <td>WRT600N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT600N-DE</td>
      <td>Wireless-N Dual Band Broadband Router</td>
      <td>WRT600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT600N-EU</td>
      <td>Wireless-N Dual Band Broadband Router</td>
      <td>WRT600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT600N-FR</td>
      <td>Wireless-N Dual Band Broadband Router</td>
      <td>WRT600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT600N-UK</td>
      <td>Wireless-N Dual Band Broadband Router</td>
      <td>WRT600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRT610N</td>
      <td>Dual-Band Wireless-N Gigabit Rtr with Storage Link</td>
      <td>WRT610N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT610N-4A</td>
      <td>Simultaneous DualBand Rtr w/Giga and StorageLink</td>
      <td>WRT610N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT610N-AU</td>
      <td>Dual-Band Wireless-N Gigabit Rtr with Storage Link</td>
      <td>WRT610N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT610N-CA</td>
      <td>Simultaneous Dual-N Band Wireless Router</td>
      <td>WRT610N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT610N-DE</td>
      <td>Dual-Band Wireless-N Gigabit Rtr with Storage Link</td>
      <td>WRT610N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT610N-EU</td>
      <td>Dual-Band Wireless-N Gigabit Rtr with Storage Link</td>
      <td>WRT610N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT610N-SG</td>
      <td>Simultaneous Dual-N Band Wireless Router</td>
      <td>WRT610N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRT610N-UK</td>
      <td>Dual-Band Wireless-N Gigabit Rtr with Storage Link</td>
      <td>WRT610N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRTA54G</td>
      <td>WRTA54G PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WRTA54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTANT7</td>
      <td>HIGH GAIN ANTENNA KIT</td>
      <td>WRTANT7</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRTANT7-EJ</td>
      <td>HIGH GAIN ANTENNA KIT</td>
      <td>WRTANT7</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRTANT7-EU</td>
      <td>HIGH GAIN ANTENNA KIT</td>
      <td>WRTANT7</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRTH54GS</td>
      <td>Dummy SKU, WLess-G High-Speed Rtr w/SpeedBooster</td>
      <td>WRTH54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTH54GS-KR</td>
      <td>Wireless-G High-Speed Router with SpeedBooster</td>
      <td>WRTH54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRTHDD2</td>
      <td>WRT HARD DRIVE ENCLOSURE</td>
      <td>WRTHDD2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL150NL</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRTSL150NL</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL150NL-AS</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRTSL150NL</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL150NL-AU</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRTSL150NL</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL150NL-CA</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRTSL150NL</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL150NL-DE</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRTSL150NL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL150NL-EU</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRTSL150NL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL150NL-SG</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRTSL150NL</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL150NL-UK</td>
      <td>Wireless-N Broadband Router with Storage Link</td>
      <td>WRTSL150NL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL54GL</td>
      <td>Wireless-G Broadband Router with Storage Link</td>
      <td>WRTSL54GL</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL54GL-AS</td>
      <td>Wireless-G Broadband Router with Storage Link</td>
      <td>WRTSL54GL</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL54GL-AU</td>
      <td>Wireless-G Broadband Router with Storage Link</td>
      <td>WRTSL54GL</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL54GL-CA</td>
      <td>Wireless-G Broadband Router with Storage Link</td>
      <td>WRTSL54GL</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL54GL-DE</td>
      <td>Wireless-G Broadband Router with Storage Link</td>
      <td>WRTSL54GL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL54GL-EU</td>
      <td>Wireless-G Broadband Router with Storage Link</td>
      <td>WRTSL54GL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL54GL-SG</td>
      <td>Wireless-G Broadband Router with Storage Link</td>
      <td>WRTSL54GL</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL54GL-UK</td>
      <td>Wireless-G Broadband Router with Storage Link</td>
      <td>WRTSL54GL</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL54GS</td>
      <td>WLess-G Media Storage Link Rtr with SpeedBooster</td>
      <td>WRTSL54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRTSL54GS-EU</td>
      <td>WLess-G Media Storage Link Rtr with SpeedBooster</td>
      <td>WRTSL54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL54GS-SG</td>
      <td>WLess-G Media Storage Link Rtr w/SpeedBooster</td>
      <td>WRTSL54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTSL54GS-UK</td>
      <td>WLess-G Media Storage Link Rtr with SpeedBooster</td>
      <td>WRTSL54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WRTU54G-TM</td>
      <td>Wireless-G Broadband Router with 2 Phone Ports</td>
      <td>WRTU54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WRTU54G-UK</td>
      <td>Wireless-G Broadband Router with 2 Phone Ports</td>
      <td>WRTU54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTU54GV2</td>
      <td>WlessG Broadband Rtr w/2 Phone Ports</td>
      <td>WRTU54GV2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WRTU54GV2-TM</td>
      <td>Wireless-G Broadband Router with 2 Phone Ports</td>
      <td>WRTU54GV2</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WSB24</td>
      <td>Wireless Signal Booster</td>
      <td>WSB24</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WSB24-CA</td>
      <td>Wireless Signal Booster (Canada)</td>
      <td>WSB24</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WSB24-CN</td>
      <td>Wireless Signal Booster</td>
      <td>WSB24</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WSB24-UK</td>
      <td>Wireless Signal Booster</td>
      <td>WSB24</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WSB54G</td>
      <td>Dummy SKU, Wireless-G Signal Booster</td>
      <td>WSB54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WSM54G-EU</td>
      <td>Wireless Security Monitor</td>
      <td>WSM54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WSM54G-UK</td>
      <td>Wireless Security Monitor</td>
      <td>WSM54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WTR54G</td>
      <td>Wireless-G Travel Router</td>
      <td>WTR54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WTR54GP</td>
      <td>Dummy SKU, Wireless-G Travel Rtr with 1 Phone Port</td>
      <td>WTR54GP</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WTR54GP-AU</td>
      <td>Wireless-G Travel Router with 1 Phone Port (ANZ)</td>
      <td>WTR54GP</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WTR54GP-EU</td>
      <td>Wireless-G Travel Rtr with 1 Phone Port (Europe)</td>
      <td>WTR54GP</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WTR54GP-NA</td>
      <td>WLess-G Travel Rtr w/1 Phone Port (North America)</td>
      <td>WTR54GP</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WTR54GP-UK</td>
      <td>WLess-G Travel Rtr w/1 Phone Port (United Kingdom)</td>
      <td>WTR54GP</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WTR54GS</td>
      <td>Wireless-G Travel Rtr with SpeedBooster Technology</td>
      <td>WTR54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WTR54GS-AS</td>
      <td>Wireless-G Travel Rtr with SpeedBooster Technology</td>
      <td>WTR54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WTR54GS-AU</td>
      <td>Wireless-G Travel Rtr with SpeedBooster Technology</td>
      <td>WTR54GS</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WTR54GS-CA</td>
      <td>Wireless-G Travel Rtr with SpeedBooster Technology</td>
      <td>WTR54GS</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WTR54GS-DE</td>
      <td>Wireless-G Travel Rtr with SpeedBooster Technology</td>
      <td>WTR54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WTR54GS-EU</td>
      <td>Wireless-G Travel Rtr with SpeedBooster Technology</td>
      <td>WTR54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WTR54GS-FR</td>
      <td>Wireless-G Travel Rtr with SpeedBooster Technology</td>
      <td>WTR54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WTR54GS-JP</td>
      <td>Wireless-G Travel Rtr with SpeedBooster Technology</td>
      <td>WTR54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WTR54GS-KR</td>
      <td>Wireless-G Travel Rtr with SpeedBooster Technology</td>
      <td>WTR54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WTR54GS-SG</td>
      <td>Wireless-G Travel Router with SpeedBooster</td>
      <td>WTR54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WTR54GS-UK</td>
      <td>Wireless-G Travel Rtr with SpeedBooster Technology</td>
      <td>WTR54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>WUMC710</td>
      <td>WIRELESS UNIVERSAL MEDIA CONNECTOR</td>
      <td>WUMC710</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUMC710-4A</td>
      <td>WIRELESS UNIVERSAL MEDIA CONNECTOR</td>
      <td>WUMC710</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUMC710-AP</td>
      <td>WIRELESS UNIVERSAL MEDIA CONNECTOR</td>
      <td>WUMC710</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUMC710-AU</td>
      <td>WIRELESS UNIVERSAL MEDIA CONNECTOR</td>
      <td>WUMC710</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUMC710-CA</td>
      <td>WIRELESS UNIVERSAL MEDIA CONNECTOR</td>
      <td>WUMC710</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUMC710-EU</td>
      <td>WIRELESS UNIVERSAL MEDIA CONNECTOR</td>
      <td>WUMC710</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUMC710-HE</td>
      <td>WIRELESS UNIVERSAL MEDIA CONNECTOR</td>
      <td>WUMC710</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUMC710-ME</td>
      <td>WIRELESS UNIVERSAL MEDIA CONNECTOR</td>
      <td>WUMC710</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUMC710-UK</td>
      <td>WIRELESS UNIVERSAL MEDIA CONNECTOR</td>
      <td>WUMC710</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB100</td>
      <td>Wireless Network USB Adapter</td>
      <td>WUSB100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB100-4A</td>
      <td>Wireless Network USB Adapter</td>
      <td>WUSB100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB100-AS</td>
      <td>Wireless Network USB Adapter</td>
      <td>WUSB100</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB100-BP</td>
      <td>Wireless USB Network Adapter</td>
      <td>WUSB100</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB100-CA</td>
      <td>RangePlus Wireless Network USB Adapter</td>
      <td>WUSB100</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB100-EU</td>
      <td>Wireless Network USB Adapter</td>
      <td>WUSB100</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB100-LA</td>
      <td>RangePlus Wireless Network USB Adapter</td>
      <td>WUSB100</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11</td>
      <td>Wireless USB Network Adapter</td>
      <td>WUSB11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11-AT</td>
      <td>Wireless USB Network Adapter (AT&amp;T)</td>
      <td>WUSB11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11-BG</td>
      <td>Wireless USB Network Adapter</td>
      <td>WUSB11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11-BP</td>
      <td>Wireless USB Network Adapter</td>
      <td>WUSB11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11-BT</td>
      <td>Wireless USB Network Adapter</td>
      <td>WUSB11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11-CA</td>
      <td>Wireless USB Network Adapter (Canda)</td>
      <td>WUSB11</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11-CC</td>
      <td>Wireless USB Adapter</td>
      <td>WUSB11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11-CN</td>
      <td>Wireless USB Network Adapter</td>
      <td>WUSB11</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11-CX</td>
      <td>Wireless USB Network Adapter</td>
      <td>WUSB11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11-DE</td>
      <td>Wireless USB Network Adapter</td>
      <td>WUSB11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11-EF</td>
      <td>Wireless USB Network Adapter</td>
      <td>WUSB11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11-EU</td>
      <td>Wireless USB Network Adapter</td>
      <td>WUSB11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11-FR</td>
      <td>Wireless USB Network Adapter</td>
      <td>WUSB11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11-IN</td>
      <td>WUSB11-IN PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WUSB11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB11-LA</td>
      <td>Wireless USB Network Adapter</td>
      <td>WUSB11</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11-TW</td>
      <td>WUSB11-TW PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WUSB11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB11-UK</td>
      <td>Wireless USB Adapter</td>
      <td>WUSB11</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11-VN</td>
      <td>Wireless USB Network Adapter (for Verizon)</td>
      <td>WUSB11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB11-WM</td>
      <td>Wireless USB Network Adapter</td>
      <td>WUSB11</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB12</td>
      <td>Wireless Compact USB Adapter</td>
      <td>WUSB12</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB12-CA</td>
      <td>Wireless Compact USB Adapter</td>
      <td>WUSB12</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB12-CN</td>
      <td>Wireless Compact USB Adapter</td>
      <td>WUSB12</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB12-EU</td>
      <td>WUSB12-EU PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WUSB12</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB12-UK</td>
      <td>WUSB12-UK PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WUSB12</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB12-WM</td>
      <td>Wireless Compact USB Adapter</td>
      <td>WUSB12</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB300N</td>
      <td>Wireless-N USB Network Adapter</td>
      <td>WUSB300N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB300N-4A</td>
      <td>Wireless-N USB Network Adapter</td>
      <td>WUSB300N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB300N-AS</td>
      <td>Wireless-N USB Adapter</td>
      <td>WUSB300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB300N-AU</td>
      <td>Wireless-N USB Adapter</td>
      <td>WUSB300N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB300N-BP</td>
      <td>Wireless-N USB Network Adapter</td>
      <td>WUSB300N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB300N-CA</td>
      <td>Wireless-N USB Adapter</td>
      <td>WUSB300N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB300N-CN</td>
      <td>Wireless-N USB Network Adapter</td>
      <td>WUSB300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB300N-DE</td>
      <td>Wireless-N USB Adapter</td>
      <td>WUSB300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB300N-E1</td>
      <td>Wireless-N USB Adapter</td>
      <td>WUSB300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB300N-EU</td>
      <td>Wireless-N USB Adapter</td>
      <td>WUSB300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB300N-FR</td>
      <td>Wireless-N USB Adapter</td>
      <td>WUSB300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB300N-KR</td>
      <td>Wireless-N USB Adapter</td>
      <td>WUSB300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB300N-LA</td>
      <td>Wireless-N USB Network Adapter</td>
      <td>WUSB300N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB300N-SG</td>
      <td>Wireless-N USB Adapter</td>
      <td>WUSB300N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB300N-UK</td>
      <td>Wireless-N USB Adapter</td>
      <td>WUSB300N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB54AG</td>
      <td>Dual-Band Wireless A/G USB Network Adapter</td>
      <td>WUSB54AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54AG-AS</td>
      <td>Dual-Band Wireless A/G USB Network Adapter</td>
      <td>WUSB54AG</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54AG-CA</td>
      <td>WUSB54AG-CA PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WUSB54AG</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB54AG-E</td>
      <td>WUSB54AG-E PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WUSB54AG</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB54AG-EU</td>
      <td>Dual-Band Wireless A/G USB Network Adapter</td>
      <td>WUSB54AG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54AG-UK</td>
      <td>Dual-Band Wireless A/G USB Network Adapter</td>
      <td>WUSB54AG</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54AGP</td>
      <td>Dual-Band Wireless A/G Portable USB Adapter</td>
      <td>WUSB54AGP</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54AGP-EU</td>
      <td>WUSB54AGP-EU PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WUSB54AGP</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB54AGP-UK</td>
      <td>WUSB54AGP-UK PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WUSB54AGP</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB54G</td>
      <td>WIRELESS-G USB ADAPTER</td>
      <td>WUSB54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54G-AR</td>
      <td>WUSB54G-AR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WUSB54G</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB54G-AS</td>
      <td>WIRELESS-G USB ADAPTER</td>
      <td>WUSB54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td>19-Oct-2017</td>
      <td>18-Oct-2022</td>
    </tr>
    <tr>
      <td>WUSB54G-CA</td>
      <td>WIRELESS-G USB ADAPTER</td>
      <td>WUSB54G</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54G-CB</td>
      <td>WUSB54G-CB PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WUSB54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB54G-CC</td>
      <td>Wireless-G USB Network Adapter</td>
      <td>WUSB54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54G-CN</td>
      <td>WIRELESS-G USB ADAPTER</td>
      <td>WUSB54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54G-DE</td>
      <td>WIRELESS-G USB ADAPTER</td>
      <td>WUSB54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54G-EU</td>
      <td>WIRELESS-G USB ADAPTER</td>
      <td>WUSB54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54G-FR</td>
      <td>WIRELESS-G USB ADAPTER</td>
      <td>WUSB54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54G-JP</td>
      <td>WIRELESS-G USB ADAPTER</td>
      <td>WUSB54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54G-KR</td>
      <td>WIRELESS-G USB ADAPTER</td>
      <td>WUSB54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54G-LA</td>
      <td>Wireless-G USB Network Adapter</td>
      <td>WUSB54G</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54G-TA</td>
      <td>Wireless-G USB Network Adapter</td>
      <td>WUSB54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54G-TW</td>
      <td>WUSB54G-TW PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WUSB54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB54G-UK</td>
      <td>WIRELESS-G USB ADAPTER</td>
      <td>WUSB54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54G-WM</td>
      <td>WIRELESS-G USB ADAPTER</td>
      <td>WUSB54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GC</td>
      <td>Compact Wireless-G USB Adapter</td>
      <td>WUSB54GC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GC-4A</td>
      <td>Compact Wireless-G USB Adapter</td>
      <td>WUSB54GC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GC-AS</td>
      <td>Compact Wireless-G USB Adapter</td>
      <td>WUSB54GC</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GC-BP</td>
      <td>Compact Wireless-G USB Adapter</td>
      <td>WUSB54GC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GC-CA</td>
      <td>Compact Wireless-G USB Adapter</td>
      <td>WUSB54GC</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GC-CN</td>
      <td>Compact Wireless-G USB Adapter</td>
      <td>WUSB54GC</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GC-DE</td>
      <td>Compact Wireless-G USB Adapter</td>
      <td>WUSB54GC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GC-EU</td>
      <td>Compact Wireless-G USB Adapter</td>
      <td>WUSB54GC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GC-FR</td>
      <td>Compact Wireless-G USB Adapter</td>
      <td>WUSB54GC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GC-LA</td>
      <td>Compact Wireless-G USB Adapter</td>
      <td>WUSB54GC</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GC-UK</td>
      <td>Compact Wireless-G USB Adapter</td>
      <td>WUSB54GC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GF</td>
      <td>WUSB54GF PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WUSB54GF</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB54GP</td>
      <td>Wireless-G USB 2.0 Pen-type Network Adapter</td>
      <td>WUSB54GP</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GP-AR</td>
      <td>WUSB54GP-AR PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WUSB54GP</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB54GP-BP</td>
      <td>Wireless-G USB 2.0 Pen-type Network Adapter</td>
      <td>WUSB54GP</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GP-CA</td>
      <td>WUSB54GP-CA PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WUSB54GP</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB54GP-CB</td>
      <td>WUSB54GP-CB PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WUSB54GP</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB54GP-DE</td>
      <td>Wireless-G USB 2.0 Pen-type Network Adapter</td>
      <td>WUSB54GP</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GP-EU</td>
      <td>Wireless-G USB 2.0 Pen-type Network Adapter</td>
      <td>WUSB54GP</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GP-FR</td>
      <td>Wireless-G USB 2.0 Pen-type Network Adapter</td>
      <td>WUSB54GP</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GP-SG</td>
      <td>Wireless-G USB 2.0 Pen-type Network Adapter</td>
      <td>WUSB54GP</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GP-UK</td>
      <td>Wireless-G USB 2.0 Pen-type Network Adapter</td>
      <td>WUSB54GP</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GP-WM</td>
      <td>Wireless-G USB 2.0 Pen-type Network Adapter</td>
      <td>WUSB54GP</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GR</td>
      <td>Wireless-G USB Network Adapter with RangeBooster</td>
      <td>WUSB54GR</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GR-AS</td>
      <td>Wireless-G USB Network Adapter with RangeBooster</td>
      <td>WUSB54GR</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GR-AU</td>
      <td>Wireless-G USB Network Adapter with RangeBooster</td>
      <td>WUSB54GR</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB54GR-DE</td>
      <td>Wireless-G USB Network Adapter with RangeBooster</td>
      <td>WUSB54GR</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GR-EU</td>
      <td>Wireless-G USB Network Adapter with RangeBooster</td>
      <td>WUSB54GR</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GR-FR</td>
      <td>Wireless-G USB Network Adapter with RangeBooster</td>
      <td>WUSB54GR</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GR-UK</td>
      <td>Wireless-G USB Network Adapter with RangeBooster</td>
      <td>WUSB54GR</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GS</td>
      <td>Wireless-G USB Network Adapter with SpeedBooster</td>
      <td>WUSB54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GS-AS</td>
      <td>Wireless-G USB Network Adapter with SpeedBooster</td>
      <td>WUSB54GS</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GS-CA</td>
      <td>Wireless-G USB Network Adapter with SpeedBooster</td>
      <td>WUSB54GS</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GS-DE</td>
      <td>Wireless-G USB Network Adapter with SpeedBooster</td>
      <td>WUSB54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GS-EU</td>
      <td>Wireless-G USB Network Adapter with SpeedBooster</td>
      <td>WUSB54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GS-FR</td>
      <td>Wireless-G USB Network Adapter with SpeedBooster</td>
      <td>WUSB54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GS-UK</td>
      <td>Wireless-G USB Network Adapter with SpeedBooster</td>
      <td>WUSB54GS</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GS-WM</td>
      <td>Wireless-G USB Network Adapter with SpeedBooster</td>
      <td>WUSB54GS</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GSC</td>
      <td>Compact Wireless-G USB Adapter with SpeedBooster</td>
      <td>WUSB54GSC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GSC-4A</td>
      <td>Compact Wireless-G USB Adapter with SpeedBooster</td>
      <td>WUSB54GSC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GSC-BP</td>
      <td>Compact Wireless-G USB Adapter with SpeedBooster</td>
      <td>WUSB54GSC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GSC-CA</td>
      <td>Compact WLessG USB Network Adapter w/SpeedBooster</td>
      <td>WUSB54GSC</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB54GSC-EU</td>
      <td>Compact Wireless-G USB Adapter with SpeedBooster</td>
      <td>WUSB54GSC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB54GX4</td>
      <td>Wireless-G USB Network Adapter with SRX400</td>
      <td>WUSB54GX4</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB600N</td>
      <td>Wireless-N USB Network Adapter with Dual-Band</td>
      <td>WUSB600N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB600N-4A</td>
      <td>Wireless-N USB Network Adapter with Dual-Band</td>
      <td>WUSB600N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB600N-AS</td>
      <td>Wireless-N USB Network Adapter with Dual-Band</td>
      <td>WUSB600N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB600N-AU</td>
      <td>Wireless-N USB Network Adapter with Dual-Band</td>
      <td>WUSB600N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB600N-BC</td>
      <td>Wireless-N USB Network Adapter with Dual-Band</td>
      <td>WUSB600N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB600N-BP</td>
      <td>Wireless-N USB Network Adapter with Dual-Band</td>
      <td>WUSB600N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB600N-CA</td>
      <td>Wireless-N USB Network Adapter with Dual-Band</td>
      <td>WUSB600N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB600N-DE</td>
      <td>Wireless-N USB Network Adapter with Dual-Band</td>
      <td>WUSB600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB600N-EU</td>
      <td>Wireless-N USB Network Adapter with Dual-Band</td>
      <td>WUSB600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB600N-FR</td>
      <td>Wireless-N USB Network Adapter with Dual-Band</td>
      <td>WUSB600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB600N-LA</td>
      <td>Wireless-N USB Network Adapter with Dual-Band</td>
      <td>WUSB600N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSB600N-UK</td>
      <td>Wireless-N USB Network Adapter with Dual-Band</td>
      <td>WUSB600N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB6200</td>
      <td>Linksys, WUSB6200, Dual Band Wireless-AC USB Adapt</td>
      <td>WUSB6200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WUSB6200-CA</td>
      <td>Linksys, WUSB6200, Dual Band Wireless-AC USB Adapt</td>
      <td>WUSB6200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WUSBF54</td>
      <td>WUSBF54 PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WUSBF54</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSBF54G</td>
      <td>Wireless-G USB Adapter with Wi Fi Finder</td>
      <td>WUSBF54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSBF54G-AS</td>
      <td>Wireless-G USB Adapter with Wi Fi Finder</td>
      <td>WUSBF54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSBF54G-EU</td>
      <td>Wireless-G USB Adapter with Wi Fi Finder</td>
      <td>WUSBF54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WUSBF54G-UK</td>
      <td>Wireless-G USB Adapter with Wi Fi Finder</td>
      <td>WUSBF54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>2-Aug-2022</td>
    </tr>
    <tr>
      <td>WVBR0-25</td>
      <td>MoCA Wireless Video Bridge</td>
      <td>WVBR0</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVBR0-25-T</td>
      <td>MoCA Wireless Video Bridge, AT&amp;T</td>
      <td>WVBR0</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVBR0BP-25</td>
      <td>DIRECTV WIRELESS VIDEO BRIDGE BULK PACKAGE</td>
      <td>WVBR0BP</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVC100N</td>
      <td>WLess-N Day/Night Internet Home Monitoring Camera</td>
      <td>WVC100N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVC100N-CA</td>
      <td>WLess-N Day/Night Internet Home Monitoring Camera</td>
      <td>WVC100N</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVC100N-EU</td>
      <td>WLess-N Day/Night Internet Home Monitoring Camera</td>
      <td>WVC100N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVC11B</td>
      <td>Wireless-B Internet Video Camera</td>
      <td>WVC11B</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC11B-AU</td>
      <td>Wireless-B Internet Video Camera</td>
      <td>WVC11B</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC11B-CA</td>
      <td>Wireless-B Internet Video Camera</td>
      <td>WVC11B</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td>6-Aug-2013</td>
      <td>5-Aug-2018</td>
    </tr>
    <tr>
      <td>WVC11B-DE</td>
      <td>Wireless-B Internet Video Camera</td>
      <td>WVC11B</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td>6-Aug-2013</td>
      <td>5-Aug-2018</td>
    </tr>
    <tr>
      <td>WVC11B-EU</td>
      <td>Wireless-B Internet Video Camera</td>
      <td>WVC11B</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVC11B-FR</td>
      <td>Wireless-B Internet Video Camera</td>
      <td>WVC11B</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td>6-Aug-2013</td>
      <td>5-Aug-2018</td>
    </tr>
    <tr>
      <td>WVC11B-UK</td>
      <td>Wireless-B Internet Video Camera</td>
      <td>WVC11B</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td>6-Aug-2013</td>
      <td>5-Aug-2018</td>
    </tr>
    <tr>
      <td>WVC54G</td>
      <td>Wireless-G Internet Video Camera</td>
      <td>WVC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVC54G-AS</td>
      <td>Wireless-G Internet Video Camera</td>
      <td>WVC54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVC54G-AU</td>
      <td>Wireless-G Internet Video Camera</td>
      <td>WVC54G</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td>6-Aug-2013</td>
      <td>5-Aug-2018</td>
    </tr>
    <tr>
      <td>WVC54G-CA</td>
      <td>Wireless-G Internet Video Camera</td>
      <td>WVC54G</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC54G-DE</td>
      <td>Wireless-G Internet Video Camera</td>
      <td>WVC54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td>6-Aug-2013</td>
      <td>5-Aug-2018</td>
    </tr>
    <tr>
      <td>WVC54G-EU</td>
      <td>Wireless-G Internet Video Camera</td>
      <td>WVC54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td>6-Aug-2013</td>
      <td>5-Aug-2018</td>
    </tr>
    <tr>
      <td>WVC54G-FR</td>
      <td>Wireless-G Internet Video Camera</td>
      <td>WVC54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC54G-PT</td>
      <td>WVC54G-PT PROTOTYPE, DESCRIPTION PENDING</td>
      <td>WVC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVC54G-SG</td>
      <td>Wireless-G Internet Video Camera</td>
      <td>WVC54G</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC54G-TE</td>
      <td>Wireless-G Internet Video Camera</td>
      <td>WVC54G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC54G-UK</td>
      <td>Wireless-G Internet Video Camera</td>
      <td>WVC54G</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC54GC</td>
      <td>Compact Wireless-G Internet Video Camera</td>
      <td>WVC54GC</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC54GC-AS</td>
      <td>Compact Wireless-G Internet Video Camera</td>
      <td>WVC54GC</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC54GC-AU</td>
      <td>Compact Wireless-G Internet Video Camera</td>
      <td>WVC54GC</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC54GC-CA</td>
      <td>Compact Wireless-G Internet Video Camera</td>
      <td>WVC54GC</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC54GC-DE</td>
      <td>Compact Wireless-G Internet Video Camera</td>
      <td>WVC54GC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVC54GC-EU</td>
      <td>Compact Wireless-G Internet Video Camera</td>
      <td>WVC54GC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC54GC-FR</td>
      <td>Compact Wireless-G Internet Video Camera</td>
      <td>WVC54GC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC54GC-SG</td>
      <td>Compact Wireless-G Internet Video Camera</td>
      <td>WVC54GC</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC54GC-UK</td>
      <td>Compact Wireless-G Internet Video Camera</td>
      <td>WVC54GC</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC54GCA</td>
      <td>Wireless-G Internet Home Monitoring Camera</td>
      <td>WVC54GCA</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVC54GCA-4A</td>
      <td>Wireless-G Internet Home Monitoring Camera</td>
      <td>WVC54GCA</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC54GCA-AU</td>
      <td>Wireless-G Internet Home Monitoring Camera</td>
      <td>WVC54GCA</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC54GCA-CA</td>
      <td>Wireless-G Internet Home Monitoring Camera</td>
      <td>WVC54GCA</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVC54GCA-EU</td>
      <td>Wireless-G Internet Home Monitoring Camera</td>
      <td>WVC54GCA</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVC54GCA-SG</td>
      <td>Wireless-G Internet Home Monitoring Camera</td>
      <td>WVC54GCA</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC54GCA-UK</td>
      <td>Wireless-G Internet Home Monitoring Camera</td>
      <td>WVC54GCA</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC80N</td>
      <td>Wireless-N Internet Home Monitoring Camera</td>
      <td>WVC80N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td>3-Feb-2015</td>
      <td>2-Feb-2020</td>
    </tr>
    <tr>
      <td>WVC80N-4A</td>
      <td>Wireless-N Internet Home Monitoring Camera</td>
      <td>WVC80N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC80N-AP</td>
      <td>Wireless-N Internet Home Monitoring Camera</td>
      <td>WVC80N</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVC80N-AU</td>
      <td>Wireless-N Internet Home Monitoring Camera</td>
      <td>WVC80N</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVC80N-EU</td>
      <td>Wireless-N Internet Home Monitoring Camera</td>
      <td>WVC80N</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>3-Nov-2023</td>
    </tr>
    <tr>
      <td>WVC80N-LA</td>
      <td>Wireless-N Internet Home Monitoring Camera</td>
      <td>WVC80N</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WVC80N-NP</td>
      <td>Wireless-N Internet Home Monitoring Camera</td>
      <td>WVC80N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td>3-Feb-2015</td>
      <td>2-Feb-2020</td>
    </tr>
    <tr>
      <td>WVG310G</td>
      <td>Wireless-G VDSL2 Gateway with VoIP</td>
      <td>WVG310G</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>WVG310N</td>
      <td>Wireless-N VDSL2 Gateway with VoIP</td>
      <td>WVG310N</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>X1000</td>
      <td>LINKSYS X1000 MODEM ROUTER,DSL,N300</td>
      <td>X1000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X1000-AP</td>
      <td>LINKSYS X1000 MODEM ROUTER,DSL,N300</td>
      <td>X1000</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X1000-AR</td>
      <td>LINKSYS X1000 MODEM ROUTER,DSL,N300</td>
      <td>X1000</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X1000-AU</td>
      <td>LINKSYS X1000 MODEM ROUTER,DSL,N300</td>
      <td>X1000</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X1000-BR</td>
      <td>LINKSYS X1000 MODEM ROUTER,DSL,N300</td>
      <td>X1000</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X1000-E1</td>
      <td>LINKSYS X1000 MODEM ROUTER,DSL,N300</td>
      <td>X1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X1000-EE</td>
      <td>LINKSYS X1000 MODEM ROUTER,DSL,N300</td>
      <td>X1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X1000-EW</td>
      <td>LINKSYS X1000 MODEM ROUTER,DSL,N300</td>
      <td>X1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X1000-EZ</td>
      <td>LINKSYS X1000 MODEM ROUTER,DSL,N300</td>
      <td>X1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X1000-LA</td>
      <td>LINKSYS X1000 MODEM ROUTER,DSL,N300</td>
      <td>X1000</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X1000-M2</td>
      <td>LINKSYS X1000 MODEM ROUTER,DSL,N300</td>
      <td>X1000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X2000</td>
      <td>Wireless-N ADSL2+ Modem Router</td>
      <td>X2000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X2000-AP</td>
      <td>Wireless-N ADSL2+ Modem Router</td>
      <td>X2000</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X2000-AU</td>
      <td>Wireless-N ADSL2+ Modem Router</td>
      <td>X2000</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X2000-CA</td>
      <td>Wireless-N ADSL2+ Modem Router</td>
      <td>X2000</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X2000-DE</td>
      <td>Wireless-N ADSL2+ Modem Router</td>
      <td>X2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X2000-E1</td>
      <td>Wireless-N ADSL2+ Modem Router</td>
      <td>X2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X2000-EE</td>
      <td>Wireless-N ADSL2+ Modem Router</td>
      <td>X2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X2000-EN</td>
      <td>Wireless-N ADSL2+ Modem Router</td>
      <td>X2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X2000-EW</td>
      <td>Wireless-N ADSL2+ Modem Router</td>
      <td>X2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X2000-EZ</td>
      <td>Wireless-N ADSL2+ Modem Router</td>
      <td>X2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X2000-ME</td>
      <td>Wireless-N ADSL2+ Modem Router</td>
      <td>X2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X2000-NP</td>
      <td>Wireless-N ADSL2+ Modem Router</td>
      <td>X2000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X2000-UK</td>
      <td>Wireless-N ADSL2+ Modem Router</td>
      <td>X2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X3000-AP</td>
      <td>Advanced Wireless-N ADSL2+ Modem Router</td>
      <td>X3000</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X3000-AU</td>
      <td>Advanced Wireless-N ADSL2+ Modem Router</td>
      <td>X3000</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X3000-DE</td>
      <td>Advanced Wireless-N ADSL2+ Modem Router</td>
      <td>X3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X3000-E1</td>
      <td>Advanced Wireless-N ADSL2+ Modem Router</td>
      <td>X3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X3000-EE</td>
      <td>Advanced Wireless-N ADSL2+ Modem Router</td>
      <td>X3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X3000-EN</td>
      <td>Advanced Wireless-N ADSL2+ Modem Router</td>
      <td>X3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X3000-EW</td>
      <td>Advanced Wireless-N ADSL2+ Modem Router</td>
      <td>X3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X3000-EZ</td>
      <td>Advanced Wireless-N ADSL2+ Modem Router</td>
      <td>X3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X3000-M2</td>
      <td>Advanced Wireless-N ADSL2+ Modem Router</td>
      <td>X3000</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X3000-ME</td>
      <td>Advanced Wireless-N ADSL2+ Modem Router</td>
      <td>X3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X3000-UK</td>
      <td>Advanced Wireless-N ADSL2+ Modem Router</td>
      <td>X3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>29-Jul-2022</td>
    </tr>
    <tr>
      <td>X3500</td>
      <td>LINKSYS X3500 MODEM ROUTER,DSL,N750</td>
      <td>X3500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X3500-AP</td>
      <td>LINKSYS X3500 MODEM ROUTER,DSL,N750</td>
      <td>X3500</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X3500-AU</td>
      <td>LINKSYS X3500 MODEM ROUTER,DSL,N750</td>
      <td>X3500</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X3500-E1</td>
      <td>LINKSYS X3500 MODEM ROUTER,DSL,N750</td>
      <td>X3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X3500-EE</td>
      <td>LINKSYS X3500 MODEM ROUTER,DSL,N750</td>
      <td>X3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X3500-EW</td>
      <td>LINKSYS X3500 MODEM ROUTER,DSL,N750</td>
      <td>X3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X3500-EZ</td>
      <td>LINKSYS X3500 MODEM ROUTER,DSL,N750</td>
      <td>X3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X3500-M2</td>
      <td>LINKSYS X3500 MODEM ROUTER,DSL,N750</td>
      <td>X3500</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X3500-ME</td>
      <td>LINKSYS X3500 MODEM ROUTER,DSL,N750</td>
      <td>X3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X3500-UK</td>
      <td>LINKSYS X3500 MODEM ROUTER,DSL,N750</td>
      <td>X3500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X6200</td>
      <td>LINKSYS X6200 MODEM ROUTER, VDSL, AC750</td>
      <td>X6200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>X6200-LA</td>
      <td>LINKSYS X6200 MODEM ROUTER, VDSL, AC750</td>
      <td>X6200</td>
      <td>Latin America and South America</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1200</td>
      <td>LINKSYS XAC1200 MODEM ROUTER,DSL,AC1200</td>
      <td>XAC1200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1200-A2</td>
      <td>LINKSYS SMART WI-FI MODEM ROUTER AC1200</td>
      <td>XAC1200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>8-Jan-2024</td>
    </tr>
    <tr>
      <td>XAC1200-AP</td>
      <td>LINKSYS XAC1200 MODEM ROUTER,DSL,AC1200</td>
      <td>XAC1200</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1200-AU</td>
      <td>LINKSYS XAC1200 MODEM ROUTER,DSL,AC1200</td>
      <td>XAC1200</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1200-E1</td>
      <td>LINKSYS XAC1200 MODEM ROUTER,DSL,AC1200</td>
      <td>XAC1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1200-EJ</td>
      <td>LINKSYS XAC1200 MODEM ROUTER,DSL,AC1200</td>
      <td>XAC1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1200-EK</td>
      <td>LINKSYS XAC1200 MODEM ROUTER,DSL,AC1200</td>
      <td>XAC1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1200-M2</td>
      <td>LINKSYS XAC1200 MODEM ROUTER,DSL,AC1200</td>
      <td>XAC1200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1200-ME</td>
      <td>LINKSYS XAC1200 MODEM ROUTER,DSL,AC1200</td>
      <td>XAC1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1200-UK</td>
      <td>LINKSYS XAC1200 MODEM ROUTER,DSL,AC1200</td>
      <td>XAC1200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1900</td>
      <td>LINKSYS XAC1900 MODEM ROUTER,DSL,AC1900</td>
      <td>XAC1900</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1900-AP</td>
      <td>LINKSYS XAC1900 MODEM ROUTER,DSL,AC1900</td>
      <td>XAC1900</td>
      <td>Asia</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1900-AU</td>
      <td>LINKSYS XAC1900 MODEM ROUTER,DSL,AC1900</td>
      <td>XAC1900</td>
      <td>Australia and New Zealand</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1900-E1</td>
      <td>LINKSYS XAC1900 MODEM ROUTER,DSL,AC1900</td>
      <td>XAC1900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1900-EJ</td>
      <td>LINKSYS XAC1900 MODEM ROUTER,DSL,AC1900</td>
      <td>XAC1900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1900-EK</td>
      <td>LINKSYS XAC1900 MODEM ROUTER,DSL,AC1900</td>
      <td>XAC1900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1900-M2</td>
      <td>LINKSYS XAC1900 MODEM ROUTER,DSL,AC1900</td>
      <td>XAC1900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>XAC1900-UK</td>
      <td>LINKSYS XAC1900 MODEM ROUTER,DSL,AC1900</td>
      <td>XAC1900</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>ZWE200</td>
      <td>Z-Wave to Ethernet Bridge</td>
      <td>ZWE200</td>
      <td>USA</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>ZWE200-CA</td>
      <td>Z-Wave to Ethernet Bridge</td>
      <td>ZWE200</td>
      <td>Canada</td>
      <td>End of Support</td>
      <td></td>
      <td>4-Dec-2023</td>
    </tr>
    <tr>
      <td>WUSB6300</td>
      <td>LINKSYS WUSB6300 WIFI ADAPTER,AC1200</td>
      <td>WUSB6300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>WUSB6300-4A</td>
      <td>LINKSYS WUSB6300 WIFI ADAPTER,AC1200</td>
      <td>WUSB6300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>WUSB6300-4C</td>
      <td>LINKSYS WUSB6300 WIFI ADAPTER,AC1200</td>
      <td>WUSB6300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>WUSB6300-AMZ</td>
      <td>LINKSYS WUSB6300 WIFI ADAPTER,AC1200</td>
      <td>WUSB6300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>WUSB6300-CA</td>
      <td>LINKSYS WUSB6300 WIFI ADAPTER,AC1200</td>
      <td>WUSB6300</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5500</td>
      <td>LINKSYS MX5500 VELOP AX5400</td>
      <td>MX5500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5501</td>
      <td>LINKSYS MX5500 VELOP AX5400 1PK</td>
      <td>MX5501</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5501-AMZ</td>
      <td>LINKSYS MX5500 VELOP AX5400 1PK FOR AMZ</td>
      <td>MX5501</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5501-CN</td>
      <td>LINKSYS MX5500 VELOP AX5400 1PK</td>
      <td>MX5501</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5501-JP</td>
      <td>LINKSYS MX5500 VELOP AX5400 1PK</td>
      <td>MX5501</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5501-KR</td>
      <td>LINKSYS MX5500 VELOP AX5400 1PK</td>
      <td>MX5501</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5501ST</td>
      <td>LINKSYS MX5500 VELOP AX5400 1PK</td>
      <td>MX5501ST</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5502</td>
      <td>LINKSYS MX5500 VELOP AX5400 2PK</td>
      <td>MX5502</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5502-AMZ</td>
      <td>LINKSYS MX5500 VELOP AX5400 2PK FOR AMZ</td>
      <td>MX5502</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5502-CA</td>
      <td>LINKSYS MX5500 VELOP AX5400 2PK</td>
      <td>MX5502</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5502-CN</td>
      <td>LINKSYS MX5500 VELOP AX5400 2PK</td>
      <td>MX5502</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5502-JP</td>
      <td>LINKSYS MX5500 VELOP AX5400 2PK</td>
      <td>MX5502</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5502-KR</td>
      <td>LINKSYS MX5500 VELOP AX5400 2PK</td>
      <td>MX5502</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5503</td>
      <td>LINKSYS MX5500 VELOP AX5400 3PK</td>
      <td>MX5503</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5503-AMZ</td>
      <td>LINKSYS MX5500 VELOP AX5400 3PK FOR AMZ</td>
      <td>MX5503</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5503-CA</td>
      <td>LINKSYS MX5500 VELOP AX5400 3PK</td>
      <td>MX5503</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5503-CN</td>
      <td>LINKSYS MX5500 VELOP AX5400 3PK</td>
      <td>MX5503</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5503-JP</td>
      <td>LINKSYS VELOP AX5400 3PK</td>
      <td>MX5503</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5503-KR</td>
      <td>LINKSYS VELOP AX5400 3PK</td>
      <td>MX5503</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX55EC3</td>
      <td>LINKSYS MX55EC VELOP AX5300 3PK</td>
      <td>MX55EC3</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX10600-AMZ</td>
      <td>LINKSYS VELOP MX10600 AX5300 2PK</td>
      <td>MX10600</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX12600</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX12600-AH</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX12600-AMZ</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX12600-CA</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX12600-CN</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX12600-EU</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX12600-JP</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX12600-KR</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX12600-ME</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX12600-UK</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX4200</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX4200-AH</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX4200-AMZ</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX4200-CN</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX4200-EU</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX4200-JP</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX4200-KR</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX4200-ME</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX4200-UK</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX5300-AMZ</td>
      <td>LINKSYS VELOP MX5300 AX5300 1PK</td>
      <td>MX5300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8000</td>
      <td>LINKSYS VELOP MX8000 AX4000 2PK</td>
      <td>MX8000</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8000-AMZ</td>
      <td>LINKSYS VELOP MX8000 AX4000 2PK</td>
      <td>MX8000</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8400-AH</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8400-CA</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8400-CN</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8400-EU</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8400-JP</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8400-KR</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8400-ME</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8400-UK</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8400C</td>
      <td>LINKSYS VELOP MX8400C AX4200 2PK</td>
      <td>MX8400C</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8501</td>
      <td>LINKSYS VELOP MX8500 AX8400 1PK</td>
      <td>MX8501</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8501-AMZ</td>
      <td>LINKSYS VELOP MX8500 AX8400 1PK FOR AMZ</td>
      <td>MX8501</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8502</td>
      <td>LINKSYS VELOP MX8500 AX8400 2PK</td>
      <td>MX8502</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8502-AMZ</td>
      <td>LINKSYS VELOP MX8500 AX8400 2PK FOR AMZ</td>
      <td>MX8502</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8503</td>
      <td>LINKSYS VELOP MX8500 AX8400 3PK</td>
      <td>MX8503</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX8503-AMZ</td>
      <td>LINKSYS VELOP MX8500 AX8400 2PK FOR AMZ</td>
      <td>MX8503</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>FGW5500-KE</td>
      <td>LINKSYS FGW5500, 5G GATEWAY, LTE 5G, AX5400</td>
      <td>FGW5500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS108P-AMZ</td>
      <td>SWITCH, POE, GIGABIT, UNMANAGED, 8-PORT</td>
      <td>LGS108P</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN2116</td>
      <td>SWITCH, GIGABIT, UNMANAGED, 16-PORT, (Best-Buy)</td>
      <td>LN2116</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX4301</td>
      <td>LINKSYS HOMEWRK FOR BUSINESS 1PK</td>
      <td>MX4301</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>SE3005-AMZ</td>
      <td>LINKSYS 5-PORT GIGABIT SWITCH</td>
      <td>SE3005</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>SE3005-CA</td>
      <td>LINKSYS 5-PORT GIGABIT SWITCH</td>
      <td>SE3005</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>SE3008-AMZ</td>
      <td>LINKSYS SE3008 WIRED SWITCH,8PORT,GIGABIT,METAL</td>
      <td>SE3008</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>SE3008-CA</td>
      <td>LINKSYS SE3008 WIRED SWITCH,8PORT,GIGABIT,METAL</td>
      <td>SE3008</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN3101-AMZ</td>
      <td>LINKSYS CLASSIC MICRO ROUTER 5</td>
      <td>LN3101</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN3101-CA</td>
      <td>LINKSYS CLASSIC MICRO ROUTER 5</td>
      <td>LN3101</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN3111</td>
      <td>LINKSYS CLASSIC MICRO ROUTER 6</td>
      <td>LN3111</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN3111-AMZ</td>
      <td>LINKSYS CLASSIC MICRO ROUTER 6</td>
      <td>LN3111</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN3111-CA</td>
      <td>LINKSYS CLASSIC MICRO ROUTER 6</td>
      <td>LN3111</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN3121-AMZ</td>
      <td>LINKSYS CLASSIC MICRO ROUTER PRO 6</td>
      <td>LN3121</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN3121-CA</td>
      <td>LINKSYS CLASSIC MICRO ROUTER PRO 6</td>
      <td>LN3121</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS105-CN</td>
      <td>SWITCH, GIGABIT, UNMANAGED, 5-PORT</td>
      <td>LGS105</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS105-JP</td>
      <td>SWITCH, GIGABIT, UNMANAGED, 5-PORT</td>
      <td>LGS105</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS105-KR</td>
      <td>SWITCH, GIGABIT, UNMANAGED, 5-PORT</td>
      <td>LGS105</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS108-CN</td>
      <td>SWITCH, GIGABIT, UNMANAGED, 8-PORT</td>
      <td>LGS108</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS108-JP</td>
      <td>SWITCH, GIGABIT, UNMANAGED, 8-PORT</td>
      <td>LGS108</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS108-KR</td>
      <td>SWITCH, GIGABIT, UNMANAGED, 8-PORT</td>
      <td>LGS108</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS108P-CN</td>
      <td>SWITCH, POE, GIGABIT, UNMANAGED, 8-PORT</td>
      <td>LGS108P</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS108P-JP</td>
      <td>SWITCH, POE, GIGABIT, UNMANAGED, 8-PORT</td>
      <td>LGS108P</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS116-AMZ</td>
      <td>SWITCH, GIGABIT, UNMANAGED, 16-PORT</td>
      <td>LGS116</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS116-CN</td>
      <td>SWITCH, GIGABIT, UNMANAGED, 16-PORT</td>
      <td>LGS116</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS116-JP</td>
      <td>SWITCH, GIGABIT, UNMANAGED, 16-PORT</td>
      <td>LGS116</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS116-KR</td>
      <td>SWITCH, GIGABIT, UNMANAGED, 16-PORT</td>
      <td>LGS116</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS116P-AMZ</td>
      <td>SWITCH, POE, GIGABIT, UNMANAGED, 16-PORT</td>
      <td>LGS116P</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS116P-CN</td>
      <td>SWITCH, POE, GIGABIT, UNMANAGED, 16-PORT</td>
      <td>LGS116P</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS116P-JP</td>
      <td>SWITCH, POE, GIGABIT, UNMANAGED, 16-PORT</td>
      <td>LGS116P</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS124-AMZ</td>
      <td>SWITCH, GIGABIT, UNMANAGED, 24-PORT</td>
      <td>LGS124</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS124-CN</td>
      <td>SWITCH, GIGABIT, UNMANAGED, 24-PORT</td>
      <td>LGS124</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS124-JP</td>
      <td>SWITCH, GIGABIT, UNMANAGED, 24-PORT</td>
      <td>LGS124</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS124-KR</td>
      <td>SWITCH, GIGABIT, UNMANAGED, 24-PORT</td>
      <td>LGS124</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS124P-AMZ</td>
      <td>SWITCH, POE, GIGABIT, UNMANAGED, 24-PORT</td>
      <td>LGS124P</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS124P-CN</td>
      <td>SWITCH, POE, GIGABIT, UNMANAGED, 24-PORT</td>
      <td>LGS124P</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS124P-JP</td>
      <td>SWITCH, POE, GIGABIT, UNMANAGED, 24-PORT</td>
      <td>LGS124P</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS310C-KR</td>
      <td>8-PORT MANAGED GIGABIT SWITCH 2 1G SFP TAA</td>
      <td>LGS310C</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS310C-TW</td>
      <td>8-PORT MANAGED GIGABIT SWITCH 2 1G SFP TAA</td>
      <td>LGS310C</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS310MPC-KR</td>
      <td>8-PORT MANAGED POE+ GE SWITCH 2 1G SFP 110W TAA</td>
      <td>LGS310MPC</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS310MPC-TW</td>
      <td>8-PORT MANAGED POE+ GE SWITCH 2 1G SFP 110W TAA</td>
      <td>LGS310MPC</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS328C-TW</td>
      <td>24-PORT MANAGED GIGABIT SWITCH 4 10G SFP+ TAA</td>
      <td>LGS328C</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS328MPC-CN</td>
      <td>24-PORT MANAGED POE+ GE SWITCH 4 10G SFP+ 410W TAA</td>
      <td>LGS328MPC</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS328MPC-KR</td>
      <td>24-PORT MANAGED POE+ GE SWITCH 4 10G SFP+ 410W TAA</td>
      <td>LGS328MPC</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS328MPC-TW</td>
      <td>24-PORT MANAGED POE+ GE SWITCH 4 10G SFP+ 410W TAA</td>
      <td>LGS328MPC</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS352C-KR</td>
      <td>48-PORT MANAGED GIGABIT SWITCH 4 10G SFP+ TAA</td>
      <td>LGS352C</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS352C-TW</td>
      <td>48-PORT MANAGED GIGABIT SWITCH 4 10G SFP+ TAA</td>
      <td>LGS352C</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS352MPC-CN</td>
      <td>48-PORT MANAGED POE+ GE SWITCH 4 10G SFP+ 740W TAA</td>
      <td>LGS352MPC</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS352MPC-KR</td>
      <td>48-PORT MANAGED POE+ GE SWITCH 4 10G SFP+ 740W TAA</td>
      <td>LGS352MPC</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LGS352MPC-TW</td>
      <td>48-PORT MANAGED POE+ GE SWITCH 4 10G SFP+ 740W TAA</td>
      <td>LGS352MPC</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX2001SH-SG</td>
      <td>LINKSYS MX2000 VELOP AX3000 1PK</td>
      <td>MX2001SH</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX4200AB-UK</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200AB</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>RE7350</td>
      <td>LINKSYS RE7350 WIFI 6 RANGE EXTENDER, AX1800</td>
      <td>RE7350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>RE7350-AMZ</td>
      <td>LINKSYS RE7350 WIFI 6 RANGE EXTENDER, AX1800</td>
      <td>RE7350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>RE7350-CA</td>
      <td>LINKSYS RE7350 WIFI 6 RANGE EXTENDER, AX1800</td>
      <td>RE7350</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>SPNMX55CTF-UK</td>
      <td>LINKSYS SPNMX55 VELOP AX5400 1PK</td>
      <td>SPNMX55CTF</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E5350</td>
      <td>LINKSYS E5350 WIFI ROUTER, AC1000</td>
      <td>E5350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E5350-AMZ</td>
      <td>LINKSYS E5350 WIFI ROUTER, AC1000</td>
      <td>E5350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E5350-CA</td>
      <td>LINKSYS E5350 WIFI ROUTER, AC1000</td>
      <td>E5350</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E5350-EU</td>
      <td>LINKSYS E5350 WIFI ROUTER, AC1000</td>
      <td>E5350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E5350-ME</td>
      <td>LINKSYS E5350 WIFI ROUTER, AC1000</td>
      <td>E5350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E5400</td>
      <td>LINKSYS E5400 WIFI ROUTER, AC1200</td>
      <td>E5400</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E5400-AMZ</td>
      <td>LINKSYS E5400 WIFI ROUTER, AC1200</td>
      <td>E5400</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E5400-CA</td>
      <td>LINKSYS E5400 WIFI ROUTER, AC1200</td>
      <td>E5400</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E5400-EU</td>
      <td>LINKSYS E5400 WIFI ROUTER, AC1200</td>
      <td>E5400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E5400-ME</td>
      <td>LINKSYS E5400 WIFI ROUTER, AC1200</td>
      <td>E5400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E5600</td>
      <td>LINKSYS MAX-STREAM AC1200 MU-MIMO GIGABIT ROUTER</td>
      <td>E5600</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E5600-AH</td>
      <td>LINKSYS MAX-STREAM AC1200 MU-MIMO GIGABIT ROUTER</td>
      <td>E5600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E5600-AMZ</td>
      <td>LINKSYS MAX-STREAM AC1200 MU-MIMO GIGABIT ROUTER</td>
      <td>E5600</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E7350</td>
      <td>LINKSYS, E7350, WIFI ROUTER, AX1800, GIGABIT</td>
      <td>E7350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E7350-AH</td>
      <td>LINKSYS, E7350-AH, WIFI ROUTER, AX1800, GIGABIT</td>
      <td>E7350</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E7350-AMZ</td>
      <td>LINKSYS, E7350, WIFI ROUTER, AX1800, GIGABIT</td>
      <td>E7350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E7350-CA</td>
      <td>LINKSYS, E7350-CA, WIFI ROUTER, AX1800, GIGABIT</td>
      <td>E7350</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E7350-JP</td>
      <td>LINKSYS, E7350-JP, WIFI ROUTER, AX1800, GIGABIT</td>
      <td>E7350</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E7350-KR</td>
      <td>LINKSYS, E7350-KR, WIFI ROUTER, AX1800, GIGABIT</td>
      <td>E7350</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E7351-AMZ</td>
      <td>LINKSYS, E7350, WIFI ROUTER, AX1800, GIGABIT</td>
      <td>E7351</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E8450</td>
      <td>LINKSYS E8450 AX3200 DUAL BAND GIGABIT WIFI 6 ROUTER</td>
      <td>E8450</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E9450-AH</td>
      <td>LINKSYS E9450 DUAL-BAND MESH WIFI 6 ROUTER, AX5400</td>
      <td>E9450</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E9450-CN</td>
      <td>LINKSYS E9450 DUAL-BAND MESH WIFI 6 ROUTER, AX5400</td>
      <td>E9450</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>E9450-SG</td>
      <td>LINKSYS E9450 DUAL-BAND MESH WIFI 6 ROUTER, AX5400</td>
      <td>E9450</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>EA7500V3-EU</td>
      <td>LINKSYS MAX-STREAM AC1900 MU-MIMO GIGABIT ROUTER</td>
      <td>EA7500V3</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>EA8100</td>
      <td>LINKSYS MAX-STREAM AC2600 MU-MIMO GIGABIT ROUTER</td>
      <td>EA8100</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>EA8100-AMZ</td>
      <td>LINKSYS MAX-STREAM AC2600 MU-MIMO GIGABIT ROUTER</td>
      <td>EA8100</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>EA9350-HK</td>
      <td>LINKSYS EA9350 WIFI ROUTER, DUAL-BAND, AX4500</td>
      <td>EA9350</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR7310</td>
      <td>LINKSYS MR7310 DUAL-BAND MESH WIFI 6 ROUTER,AX1500</td>
      <td>MR7310</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR7310-AMZ</td>
      <td>LINKSYS MR7310 DUAL-BAND MESH WIFI 6 ROUTER,AX1500</td>
      <td>MR7310</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR7350</td>
      <td>LINKSYS MR7350 DUAL-BAND MESH WIFI 6 ROUTER,AX1800</td>
      <td>MR7350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR7350-2A</td>
      <td>LINKSYS MR7350 DUAL-BAND MESH WIFI 6 ROUTER,AX1800</td>
      <td>MR7350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR7350-AH</td>
      <td>LINKSYS MR7350 DUAL-BAND MESH WIFI 6 ROUTER,AX1800</td>
      <td>MR7350</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR7350-AMZ</td>
      <td>LINKSYS MR7350 DUAL-BAND MESH WIFI 6 ROUTER,AX1800</td>
      <td>MR7350</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR7350-CA</td>
      <td>LINKSYS MR7350 DUAL-BAND MESH WIFI 6 ROUTER,AX1800</td>
      <td>MR7350</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR7350-JP</td>
      <td>LINKSYS MR7350 DUAL-BAND MESH WIFI 6 ROUTER,AX1800</td>
      <td>MR7350</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR7500</td>
      <td>LINKSYS MR7500 MESH WIFI 6E ROUTER, AX6600</td>
      <td>MR7500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR7500-AMZ</td>
      <td>LINKSYS MR7500 MESH WIFI 6E ROUTER, AX6600</td>
      <td>MR7500</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR7500-HK</td>
      <td>LINKSYS MR7500 MESH WIFI 6E ROUTER, AX6600</td>
      <td>MR7500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR7502</td>
      <td>2 LINKSYS MR7500 MESH WIFI 6E ROUTERS, AX6600</td>
      <td>MR7502</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR75MS</td>
      <td>LINKSYS MR75MS MESH WIFI 6E ROUTER, AXE5400</td>
      <td>MR75MS</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR75WH</td>
      <td>LINKSYS MR75WH MESH WIFI 6E ROUTER, AX6600</td>
      <td>MR75WH</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR8300-AMZ</td>
      <td>LINKSYS MR8300 MESH WIFI ROUTER,AC2200,MU-MIMO</td>
      <td>MR8300</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR9000-AMZ</td>
      <td>LINKSYS MR9000 TRI-BAND MESH WIFI 5 ROUTER,AC3000,MU-MIMO</td>
      <td>MR9000</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>4GHS1000</td>
      <td>LINKSYS 4GHS1000 4G MOBILE HOTSPOT</td>
      <td>4GHS1000</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>BKE-500</td>
      <td>LINKSYS BKE-500 PORTABLE HOTSPOT, LTE 5G, AX1800</td>
      <td>BKE-500</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>FGHSAX1800-AH</td>
      <td>LINKSYS FGHSAX1800-AH M-HOTSPOT, LTE 5G, AX1800</td>
      <td>FGHSAX1800</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>FGHSAX1800-CN</td>
      <td>LINKSYS FGHSAX1800-CN M-HOTSPOT, LTE 5G, AX1800</td>
      <td>FGHSAX1800</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>FGHSAX1800-ME</td>
      <td>LINKSYS FGHSAX1800-ME M-HOTSPOT, LTE 5G, AX1800</td>
      <td>FGHSAX1800</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>FGMM1000-HK</td>
      <td>LINKSYS FGMM1000, 5G GATEWAY, SUB6, MMWAVE, AX1800</td>
      <td>FGMM1000</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>FGMM601-HK</td>
      <td>LINKSYS FGMM601-HK,5G GATEWAY,SUB6,MMWAVE,OUTDOOR</td>
      <td>FGMM601</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>FGW3000-AH</td>
      <td>LINKSYS FGW3000 5G GATEWAY, LTE, 5G, AX3000</td>
      <td>FGW3000</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>FGW3000-HK</td>
      <td>LINKSYS FGW3000-HK, 5G GATEWAY, LTE 5G, AX3000</td>
      <td>FGW3000</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>FGW3000-ME</td>
      <td>LINKSYS FGW3000, 5G GATEWAY, LTE 5G, AX3000</td>
      <td>FGW3000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN1101</td>
      <td>LINKSYS VELOP MICRO-ROUTER 6</td>
      <td>LN1101</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN1101-AMZ</td>
      <td>LINKSYS VELOP MICRO-ROUTER 6</td>
      <td>LN1101</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN1101-CA</td>
      <td>LINKSYS VELOP MICRO-ROUTER 6</td>
      <td>LN1101</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN11011201-AMZ</td>
      <td>LINKSYS VELOP MICRO-ROUTER & MICRO-MESH 6</td>
      <td>LN11011201</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN11011201-CA</td>
      <td>LINKSYS VELOP MICRO-ROUTER & MICRO-MESH POINT 6</td>
      <td>LN11011201</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN11011202-AMZ</td>
      <td>LINKSYS VELOP MICRO-ROUTER & 2X MICRO-MESH 6</td>
      <td>LN11011202</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN11011202-CA</td>
      <td>LINKSYS VELOP MICRO-ROUTER & 2X MICRO-MESH 6</td>
      <td>LN11011202</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN1201</td>
      <td>LINKSYS VELOP MICRO-MESH 6</td>
      <td>LN1201</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN1201-CA</td>
      <td>LINKSYS VELOP MICRO-MESH POINT 6</td>
      <td>LN1201</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>LN6001</td>
      <td>LINKSYS VELOP WRT PRO 7</td>
      <td>LN6001</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MBE7001</td>
      <td>LINKSYS VELOP MBE7000 BE11000 1PK</td>
      <td>MBE7001</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MBE7001-AMZ</td>
      <td>LINKSYS VELOP MBE7000 BE11000 1PK</td>
      <td>MBE7001</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MBE7001-CA</td>
      <td>LINKSYS VELOP MBE7000 BE11000 1PK</td>
      <td>MBE7001</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MBE7002-CA</td>
      <td>LINKSYS VELOP MBE7000 BE11000 2PK</td>
      <td>MBE7002</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MBE7003</td>
      <td>LINKSYS VELOP MBE7000 BE11000 3PK</td>
      <td>MBE7003</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MBE7003-AMZ</td>
      <td>LINKSYS VELOP MBE7000 BE11000 3PK</td>
      <td>MBE7003</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MBE7003-CA</td>
      <td>LINKSYS VELOP MBE7000 BE11000 3PK</td>
      <td>MBE7003</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX6201G</td>
      <td>LINKSYS VELOP MX6200 AXE5400 1PK GREY</td>
      <td>MX6201G</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX6201G-AMZ</td>
      <td>LINKSYS VELOP MX6200 AXE5400 1PK GREY</td>
      <td>MX6201G</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR2000</td>
      <td>LINKSYS MR2000 DUAL-BAND MESH WIFI 6 ROUTER,AX3000</td>
      <td>MR2000</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR2000-CA</td>
      <td>LINKSYS MR2000 DUAL-BAND MESH WIFI 6 ROUTER,AX3000</td>
      <td>MR2000</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR20EC</td>
      <td>LINKSYS MR20EC DUAL-BAND MESH WIFI 6 ROUTER,AX3000</td>
      <td>MR20EC</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR20EC-AMZ</td>
      <td>LINKSYS MR20EC DUAL-BAND MESH WIFI 6 ROUTER,AX3000</td>
      <td>MR20EC</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR20MS</td>
      <td>LINKSYS MR20MS DUAL-BAND MESH WIFI 6 ROUTER, AX2200</td>
      <td>MR20MS</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MR55EC-AMZ</td>
      <td>LINKSYS AX5400TPY MESH WIFI ROUTER, DB, AX5400</td>
      <td>MR55EC</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX2000</td>
      <td>LINKSYS MX2000 VELOP AX3000</td>
      <td>MX2000</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX2001</td>
      <td>LINKSYS MX2000 VELOP AX3000 1PK</td>
      <td>MX2001</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX2001-CN</td>
      <td>LINKSYS MX2000 VELOP AX3000 1PK</td>
      <td>MX2001</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX2001-KR</td>
      <td>LINKSYS MX2000 VELOP AX3000 1PK</td>
      <td>MX2001</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX2002</td>
      <td>LINKSYS MX2000 VELOP AX3000 2PK</td>
      <td>MX2002</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX2002-CA</td>
      <td>LINKSYS MX2000 VELOP AX3000 2PK</td>
      <td>MX2002</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX2002-CN</td>
      <td>LINKSYS MX2000 VELOP AX3000 2PK</td>
      <td>MX2002</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX2002-KR</td>
      <td>LINKSYS MX2000 VELOP AX3000 2PK</td>
      <td>MX2002</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX2003</td>
      <td>LINKSYS MX2000 VELOP AX3000 3PK</td>
      <td>MX2003</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX2003-CA</td>
      <td>LINKSYS MX2000 VELOP AX3000 3PK</td>
      <td>MX2003</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX2003-CN</td>
      <td>LINKSYS MX2000 VELOP AX3000 3PK</td>
      <td>MX2003</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX2003-KR</td>
      <td>LINKSYS MX2000 VELOP AX3000 3PK</td>
      <td>MX2003</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX20EC3</td>
      <td>LINKSYS MX2000 VELOP AX2900 3PK</td>
      <td>MX20EC3</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX20MS1-AMZ</td>
      <td>LINKSYS MX2000 VELOP AX3000 1PK</td>
      <td>MX20MS1</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX20MS2-AMZ</td>
      <td>LINKSYS MX2000 VELOP AX3000 2PK</td>
      <td>MX20MS2</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX20MS3-AMZ</td>
      <td>LINKSYS MX2000 VELOP AX3000 3PK</td>
      <td>MX20MS3</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX20WH2</td>
      <td>LINKSYS MX20WH VELOP AX2200 2PK</td>
      <td>MX20WH2</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>11-Dec-2024</td>
      <td>11-Dec-2029</td>
    </tr>
    <tr>
      <td>MX12600-APL</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX12600-APL-AH</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX12600-APL-AU</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX12600-APL-CA</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX12600-APL-CN</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX12600-APL-EU</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX12600-APL-JP</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX12600-APL-KR</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX12600-APL-ME</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX12600-APL-UK</td>
      <td>LINKSYS VELOP MX12600 AX4200 3PK</td>
      <td>MX12600</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX4200-APL</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX4200-APL-AH</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX4200-APL-AU</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX4200-APL-CA</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX4200-APL-CN</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX4200-APL-EU</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX4200-APL-JP</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX4200-APL-KR</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX4200-APL-ME</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX4200-APL-UK</td>
      <td>LINKSYS VELOP MX4200 AX4200 1PK</td>
      <td>MX4200</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX8400-APL</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>USA</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX8400-APL-AH</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX8400-APL-AU</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Australia and New Zealand</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX8400-APL-CA</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Canada</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX8400-APL-CN</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX8400-APL-EU</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX8400-APL-JP</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX8400-APL-KR</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX8400-APL-ME</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MX8400-APL-UK</td>
      <td>LINKSYS VELOP MX8400 AX4200 2PK</td>
      <td>MX8400</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>7-Apr-25</td>
      <td>7-Apr-30</td>
    </tr>
    <tr>
      <td>MR2000-KE</td>
      <td>LINKSYS MR2000 DUAL-BAND MESH WIFI 6 ROUTER,AX3000</td>
      <td>MR2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MR2000-ME</td>
      <td>LINKSYS MR2000 DUAL-BAND MESH WIFI 6 ROUTER,AX3000</td>
      <td>MR2000</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MR5500-KE</td>
      <td>LINKSYS MR5500 MESH WIFI ROUTER, DB, AX5400</td>
      <td>MR5500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MR5500-ME</td>
      <td>LINKSYS MR5500 MESH WIFI ROUTER, DB, AX5400</td>
      <td>MR5500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MR7350-EU</td>
      <td>LINKSYS MR7350 DUAL-BAND MESH WIFI 6 ROUTER,AX1800</td>
      <td>MR7350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MR7350-ME</td>
      <td>LINKSYS MR7350 DUAL-BAND MESH WIFI 6 ROUTER,AX1800</td>
      <td>MR7350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MR7350-UK</td>
      <td>LINKSYS MR7350 DUAL-BAND MESH WIFI 6 ROUTER,AX1800</td>
      <td>MR7350</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MR7500-EU</td>
      <td>LINKSYS MR7500 MESH WIFI 6E ROUTER, AX6600</td>
      <td>MR7500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MR7500-ME</td>
      <td>LINKSYS MR7500 MESH WIFI 6E ROUTER, AX6600</td>
      <td>MR7500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MR7500-UK</td>
      <td>LINKSYS MR7500 MESH WIFI 6E ROUTER, AX6600</td>
      <td>MR7500</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MX4050-HK</td>
      <td>LINKSYS VELOP MX4050 PCCW 1PK</td>
      <td>MX4050</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MX5501-AH</td>
      <td>LINKSYS MX5500 VELOP AX5400 1PK</td>
      <td>MX5501</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MX5501-KE</td>
      <td>LINKSYS MX5500 VELOP AX5400 1PK</td>
      <td>MX5501</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MX5501-ME</td>
      <td>LINKSYS MX5500 VELOP AX5400 1PK</td>
      <td>MX5501</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MX5502-AH</td>
      <td>LINKSYS MX5500 VELOP AX5400 2PK</td>
      <td>MX5502</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MX5502-KE</td>
      <td>LINKSYS MX5500 VELOP AX5400 2PK</td>
      <td>MX5502</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MX5502-ME</td>
      <td>LINKSYS MX5500 VELOP AX5400 2PK</td>
      <td>MX5502</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MX5503-AH</td>
      <td>LINKSYS MX5500 VELOP AX5400 3PK</td>
      <td>MX5503</td>
      <td>Asia</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MX5503-KE</td>
      <td>LINKSYS MX5500 VELOP AX5400 3PK</td>
      <td>MX5503</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>MX5503-ME</td>
      <td>LINKSYS MX5500 VELOP AX5400 3PK</td>
      <td>MX5503</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>SPNMX42AB-UK</td>
      <td>LINKSYS VELOP SPNMX42 AX4200 1PK</td>
      <td>SPNMX42AB-UK</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>SPNMX42BF-UK</td>
      <td>LINKSYS VELOP SPNMX42 AX4200 1PK</td>
      <td>SPNMX42BF-UK</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>SPNMX42CF-UK</td>
      <td>LINKSYS VELOP SPNMX42 AX4200 1PK</td>
      <td>SPNMX42CF-UK</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>SPNMX42CTF-UK</td>
      <td>LINKSYS VELOP SPNMX42 AX4200 1PK</td>
      <td>SPNMX42CTF-UK</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>SPNMX42HF-UK</td>
      <td>LINKSYS VELOP SPNMX42 AX4200 1PK</td>
      <td>SPNMX42HF-UK</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>SPNMX42K9-UK</td>
      <td>LINKSYS VELOP SPNMX42 AX4200 1PK</td>
      <td>SPNMX42K9-UK</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>SPNMX42TS-UK</td>
      <td>LINKSYS VELOP SPNMX42 AX4200 1PK</td>
      <td>SPNMX42TS-UK</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>SPNMX55CF-UK</td>
      <td>LINKSYS SPNMX55 VELOP AX5400 1PK</td>
      <td>SPNMX55CF-UK</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
    <tr>
      <td>WUSB6300-EJ</td>
      <td>LINKSYS WUSB6300 WIFI ADAPTER,AC1200</td>
      <td>WUSB6300</td>
      <td>Europe, UK, Middle East and Africa</td>
      <td>End of Life</td>
      <td>30-Apr-25</td>
      <td>30-Apr-30</td>
    </tr>
  </tbody>
</table>`;

function appendProductTable() {
  const container = document.querySelector(".product-table__container");
  if (container) {
    container.innerHTML = productTable;
    setupSearchFunctionality();
  } else {
    console.error("Product table container not found");
  }
}

function setupSearchFunctionality() {
  const searchInput = document.getElementById("productEOLSearch");
  const table = document.getElementById("productEOLTable");
  const tableBody = document.getElementById("productEOLTableBody");
  const rows = Array.from(tableBody.getElementsByTagName("tr"));

  searchInput.addEventListener("input", () => {
    const searchTerm = searchInput.value.toLowerCase();
    console.log(`Search term: ${searchTerm}`); // Debugging line

    if (searchTerm.length >= 3) {
      let anyRowVisible = false; // To check if any row matches the search

      rows.forEach((row) => {
        const sku = row.cells[0].textContent.toLowerCase();
        const description = row.cells[1].textContent.toLowerCase();
        const model = row.cells[2].textContent.toLowerCase();
        if (
          sku.includes(searchTerm) ||
          description.includes(searchTerm) ||
          model.includes(searchTerm)
        ) {
          row.style.display = "";
          anyRowVisible = true;
        } else {
          row.style.display = "none";
        }
      });

      if (anyRowVisible) {
        table.style.display = "block"; // Show the table if at least one row matches
      } else {
        table.style.display = "none"; // Hide the table if no rows match
      }
    } else {
      table.style.display = "none"; // Hide the table if search term is less than 3 characters
      rows.forEach((row) => {
        row.style.display = "";
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", appendProductTable);
